export interface GetSupportersForActionAssignmentInput {
    actionId: string;

    skip: number;

    limit: number;

    filter?: SupporterViewFilterInput | null;
}

export interface SupporterViewFilterInput {
    searchFilter?: SupporterSearchFilterInput | null;

    actionTakenFilter?: SupporterActionTakenFilterInput | null;

    supporterJoinedDateFilter?: SupporterJoinedFilterInput | null;

    actionFilter?: SupporterActionFilterInput | null;

    groupFilter?: SupporterGroupFilterInput | null;

    appNotificationFilter?: SupporterAppNotificationFilterInput | null;

    aliasFilter?: SupporterAliasFilterInput | null;

    supporterStatusFilter?: SupporterStatusFilterInput | null;

    lastEmailStatusFilter?: SupporterLastEmailStatusFilterInput | null;

    supporterEmailSubscriptionFilter?: SupporterEmailSubscriptionFilterInput | null;

    stateFilter?: SupporterStateFilterInput | null;
}

export interface SupporterSearchFilterInput {
    firstName?: string | null;

    lastName?: string | null;

    emailAddress?: string | null;

    phoneNumber?: string | null;

    nameOrEmail?: string | null;
}

export interface SupporterActionTakenFilterInput {
    minimum?: number | null;

    maximum?: number | null;
}

export interface SupporterJoinedFilterInput {
    from: Date;

    to: Date;

    isExclude: boolean;
}

export interface SupporterActionFilterInput {
    all: boolean;

    actionIds?: string[] | null;

    isExclude: boolean;
}

export interface SupporterGroupFilterInput {
    all: boolean;

    groupIds?: string[] | null;

    isExclude: boolean;
}

export interface SupporterAppNotificationFilterInput {
    appNotificationEnabled: boolean;
}

export interface SupporterAliasFilterInput {
    all: boolean;

    aliasIds?: string[] | null;

    isExclude: boolean;
}

export interface SupporterStatusFilterInput {
    isExclude: boolean;

    currentSupporter?: SupporterStatus[] | null;
}

export interface SupporterLastEmailStatusFilterInput {
    emailStatusList: LastEmailStatus[];

    isExclude: boolean;
}

export interface SupporterEmailSubscriptionFilterInput {
    isUnsubscribed?: boolean | null;
}

export interface SupporterStateFilterInput {
    all?: boolean | null;

    states: string[];

    isExclude: boolean;
}

export interface GetAssignedMembersForActionInput {
    actionId: string;

    pagination: PaginationInput;

    searchKey?: string | null;
}

export interface PaginationInput {
    skip: number;

    limit: number;
}

export interface ContentForSendingToRecipientBySupporterInput {
    actionId: string;

    outreachChannel: OutreachChannel;

    recipientId: string;
}

export interface MemberFormFieldValidationsInput {
    actionId: string;

    memberId: string;
}

export interface ActionExistsInput {
    actionName: string;

    outreachCircleId: string;
}

export interface DateFilter {
    startDate: Date;

    endDate: Date;
}

export interface OrganizationFilterInput {
    outreachCircleIds?: string[] | null;

    organizationFilterId?: string | null;
}

export interface GetActionPreviewByGroupInput {
    groupId: string;

    skip: number;

    limit: number;
}

export interface GetActionsPreviewForSupporterInput {
    supporterId: string;

    skip: number;

    limit: number;
}

export interface ActionsForOutreachCircleInput {
    outreachCircleId: string;

    skip: number;

    limit: number;

    sortBy?: ActionsSortInput[] | null;

    filter?: ActionViewFilterInput | null;
}

export interface ActionsSortInput {
    sortField: ActionsSortBy;

    isAscending: boolean;
}

export interface ActionViewFilterInput {
    actionStatusFilter?: ActionStatusFilterInput | null;

    searchFilter?: ActionSearchFilterInput | null;

    typeFilter?: ActionTypeFilterInput | null;

    groupFilter?: ActionGroupFilterInput | null;

    actionOrganizationTagFilter?: ActionOrganizationTagFilterInput | null;
}

export interface ActionStatusFilterInput {
    status?: ActionStatus[] | null;

    isExclude: boolean;
}

export interface ActionSearchFilterInput {
    name?: string | null;

    title?: string | null;
}

export interface ActionTypeFilterInput {
    actionType?: ActionType[] | null;

    isExclude: boolean;
}

export interface ActionGroupFilterInput {
    groupIds?: string[] | null;

    isExclude: boolean;
}

export interface ActionOrganizationTagFilterInput {
    ids?: string[] | null;

    isExclude: boolean;
}

export interface ActionsForOrgActionInput {
    orgActionId: string;

    actionStatus?: ActionStatus | null;

    skip: number;

    limit: number;

    sortBy?: ActionsSortInput[] | null;
}

export interface PublicActionForEmbedInput {
    alias: string;

    skip: number;

    limit: number;
}

export interface PublicActionForOutreachCircleInput {
    outreachCircleId: string;

    supporterId?: string | null;

    alias?: string | null;

    skip: number;

    limit: number;
}

export interface PublicActionForSupporterInput {
    skip: number;

    limit: number;

    appCode?: string | null;

    organizationId?: string | null;
}

export interface SupporterActionInput {
    actionId: string;

    supporterId: string;

    contactSourceId?: string | null;
}

export interface FacebookRequestInput {
    url: string;

    params: Json;

    method?: string | null;
}

export interface GetContactsForAffinityTextingInput {
    skip: number;

    limit: number;

    actionId: string;

    supporterId: string;

    filter?: AffinityTextingFilter | null;
}

export interface AffinityTextingFilter {
    name: string;
}

export interface GetTextContentForAffinityTextingInput {
    supporterId: string;

    actionId: string;

    memberId: string;

    mobileNumber: string;
}

export interface SupporterTextContentForTextingSupporterInput {
    supporterId: string;

    actionId: string;

    mobileNumber: string;
}

export interface TextSupporterSetInput {
    skip: number;

    limit: number;

    actionId: string;

    searchKey?: string | null;
}

export interface EligibleSupporterForSupporterTextingInput {
    outreachCircleId: string;

    selectedSupporterIds?: string[] | null;

    hasAllSelected: boolean;

    excludeSupporterIds?: string[] | null;

    filter?: SupporterViewFilterInput | null;
}

export interface GetEligibleActionForAssigningToGroupInput {
    groupId: string;

    outreachCircleId: string;

    searchText?: string | null;
}

export interface GetAssignedSupportersForActionInput {
    actionId: string;

    skip?: number | null;

    limit?: number | null;
}

export interface FetchAssignedSupportersToActionInput {
    actionId: string;

    skip: number;

    limit: number;

    sortBy: AssignedSupportersSortInput[];

    searchFilter?: AssignedSupportersSearchInput | null;
}

export interface AssignedSupportersSortInput {
    sortField: AssignedSupportersSortBy;

    isAscending: boolean;
}

export interface AssignedSupportersSearchInput {
    nameOrEmail?: string | null;
}

export interface PublicActionByAliasInput {
    actionAlias: string;

    outreachCircleAlias: string;
}

export interface GetActionsLinkedToAudienceActionInput {
    audienceActionId: string;

    pagination?: PaginationInput | null;

    status: ActionStatus[];
}

export interface ActionEmailNotificationPreviewInput {
    actionId: string;

    code: SupporterEmailTemplateCode;

    body: string;

    fromNameAlias: string;

    subject: string;
}

export interface FetchGroupsAssignedToActionInput {
    actionId: string;

    pagination: PaginationInput;

    sortBy: GroupsAssignedToActionSortInput[];
}

export interface GroupsAssignedToActionSortInput {
    sortField: AssignedGroupsToActionSortBy;

    isAscending: boolean;
}

export interface GetMemberNotesInput {
    actionId: string;

    memberId: string;
}

export interface GetHouseholdsBasedonCurrentLocationInput {
    actionId: string;

    location: LocationCoOrdinateInput;

    rangeInMiles?: number | null;
}

export interface LocationCoOrdinateInput {
    latitude: number;

    longitude: number;
}

export interface CreateSearchAndSurveyContactInput {
    contact: SearchAndSurveyContactInput;

    actionId: string;
}

export interface SearchAndSurveyContactInput {
    first_name?: string | null;

    middle_name?: string | null;

    last_name?: string | null;

    emails?: (ContactEmailInput | null)[] | null;

    mobiles?: (ContactMobileInput | null)[] | null;

    street_number?: string | null;

    street_name?: string | null;

    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;

    full_address?: string | null;

    dob?: Date | null;

    apt_number?: string | null;
}

export interface ContactEmailInput {
    type: ContactEmailTypeEnum;

    value: string;
}

export interface ContactMobileInput {
    type: ContactMobileTypeEnum;

    value: string;
}

export interface AudienceActionUrlRequestInput {
    fileName: string;

    fileType: string;

    audienceId: string;
}

export interface MemberSearchByNameInput {
    name: string;

    audienceId: string;
}

export interface GetAudienceActionsForOutreachCircleByIntegrationTypeInput {
    outreachCircleId: string;

    type: AllowedIntegrationDatabaseType;

    listType: ListType;
}

export interface GetAudienceActionsForActionByIntegrationTypeInput {
    actionId: string;

    type: AllowedIntegrationDatabaseType;

    listType: ListType;
}

export interface GetAudienceInfoByListTypeInput {
    outreachCircleId: string;

    listType: ListType;
}

export interface GetLiveActionsByAudienceActionInput {
    audienceActionId: string;

    skip?: number | null;

    limit?: number | null;
}

export interface GetMappingsByAudienceIdInput {
    audienceId: string;

    skip: number;

    limit: number;
}

export interface GetSearchAndSurveyMemberInput {
    actionId: string;

    memberId: string;
}

export interface SearchAndSurveyMemberInput {
    searchFilter: SearchAndSurveyMemberFilter;

    actionId: string;
}

export interface SearchAndSurveyMemberFilter {
    firstName?: string | null;

    lastName?: string | null;

    city?: string | null;

    zip?: string | null;

    phoneNumber?: string | null;
}

export interface GetBroadcastTextingDeliveryRecipientsInput {
    actionId: string;

    pagination: PaginationInput;
}

export interface SupporterContactInput {
    contactId: string;

    supporterId: string;

    actionId: string;
}

export interface MappedContactsInput {
    supporterId: string;

    actionId: string;

    skip: number;

    limit: number;

    searchText?: string | null;

    contactSourceId?: string | null;
}

export interface TextRecipientInput {
    contactId: string;

    supporterId: string;

    memberId: string;

    actionId: string;

    mobileNumber: string;
}

export interface GetContactsForActionInput {
    supporterId: string;

    actionId: string;

    skip: number;

    limit: number;

    searchText?: string | null;

    isCanvassedContact?: boolean | null;
}

export interface DuplicateEmailRecipientInput {
    supporterId: string;

    skip?: number | null;

    limit?: number | null;
}

export interface GetMatchesForContactInput {
    contactId: string;

    actionId: string;
}

export interface ContactFileUrlInput {
    fileName: string;

    fileType: string;
}

export interface ContactQueryInput {
    search?: ContactSearch | null;

    filter?: ContactFilter | null;

    skip: number;

    limit: number;
}

export interface ContactSearch {
    name: string;
}

export interface ContactFilter {
    contactSourceId: string;
}

export interface ContactQueryForOutreachMode {
    searchText?: string | null;

    actionId: string;

    skip: number;

    limit: number;

    supporterId: string;

    contactSourceId?: string | null;
}

export interface OutreachCircleDashboardFilterInput {
    outreachCircleId: string;

    dateFilter?: DateFilter | null;
}

export interface SupporterEmailTemplateInput {
    emailTemplateId: string;

    supporterId: string;

    actionId: string;
}

export interface EmailTemplateForOutreachCircleInput {
    outreachCircleId: string;

    actionId: string;

    searchKey?: string | null;

    pagination?: PaginationInput | null;
}

export interface UpdateEmailTemplateWithRecruitmentLinkInput {
    emailTemplateId: string;

    content: string;

    linkText: string;

    code?: string | null;
}

export interface UpdateEmailContentWithSurveyDetailsInput {
    actionId: string;

    content: string;
}

export interface ValidateEmailTemplateNameForActionInput {
    name: string;

    actionId: string;
}

export interface EmailTemplatesForOrganization {
    organizationId: string;

    organizationActionId?: string | null;

    searchKey?: string | null;
}

export interface ValidateOrganizationEmailTemplateNameInput {
    name: string;

    organizationId: string;
}

export interface SurveysByOutreachCircleIdInput {
    outreachCircleId: string;

    searchKey?: string | null;

    responseCountFilter?: ResponseCountFilter | null;

    integrationTypes: (AllowedIntegrationDatabaseType | null)[];
}

export interface ResponseCountFilter {
    ignoreWithoutResponses?: boolean | null;

    dateFilter?: DateFilter | null;
}

export interface GetSurveysEligibleForForActionByIntegrationInput {
    outreachCircleId: string;

    integrationType: AllowedIntegrationDatabaseType;

    searchKey?: string | null;
}

export interface SearchExternalLinkInput {
    outreachCircleId: string;

    searchKey: string;

    skip: number;

    limit: number;
}

export interface SurveyExistsInput {
    surveyName: string;

    outreachCircleId: string;
}

export interface SurveysForOrganizationInput {
    organizationId: string;

    skip: number;

    limit: number;

    sortBy: SurveySortByInput;

    responseCountFilter?: ResponseCountFilter | null;

    outreachCircleIds?: string[] | null;

    organizationFilterId?: string | null;
}

export interface SurveySortByInput {
    sortField: SurveySortBy;

    isAscending: boolean;
}

export interface GroSurveyFormsByOutreachCircleInput {
    outreachCircleId: string;

    searchKey?: string | null;

    integrationTypes: (GroSurveyFormIntegrationType | null)[];
}

export interface ValidateGroSurveyFormNameInput {
    name: string;

    groSurveyFormId?: string | null;

    outreachCircleId: string;
}

export interface GetGroSurveyResponseForMemberInput {
    actionId: string;

    memberId: string;
}

export interface GetPastGroSurveyResponseInput {
    actionId: string;

    memberId: string;

    pagination: PaginationInput;
}

export interface GetGroupsInput {
    outreachCircleId: string;

    skip?: number | null;

    limit?: number | null;

    sortBy?: GroupsSortInput[] | null;

    searchKey?: string | null;
}

export interface GroupsSortInput {
    sortField: GroupsSortBy;

    isAscending: boolean;
}

export interface GetActionsForGroupInput {
    groupId: string;

    filter?: GetActionsForGroupFilter | null;

    skip?: number | null;

    limit?: number | null;
}

export interface GetActionsForGroupFilter {
    status?: ActionStatus | null;
}

export interface GetAllGroupsForActionInput {
    actionId: string;

    pagination: PaginationInput;

    searchKey?: string | null;
}

export interface TestNgpIntegrationInput {
    appName: string;

    apiKey: string;

    outreachCircleId: string;

    database: AudienceActionDatabase;
}

export interface OnTheGoAssignmentsInput {
    actionId: string;

    location: LocationCoordinateInput;
}

export interface LocationCoordinateInput {
    latitude: number;

    longitude: number;
}

export interface GetQuestionsFromPdiInput {
    outreachCircleId: string;

    skip: number;

    limit: number;
}

export interface ValidateSoqlInput {
    outreachCircleId: string;

    soql: string;
}

export interface GetTcrBrandApplicableUsecasesInput {
    outreachCircleId: string;

    brandId: string;
}

export interface GetLatestNativeAppVersionInput {
    bundleId: string;

    platform: DeviceTypeEnum;

    version: string;

    buildNumber: number;
}

export interface ActionsForOrganizationInput {
    organizationId: string;

    skip: number;

    limit: number;
}

export interface DoesOrganizationActionWithSameNameExistInput {
    organizationActionName: string;

    organizationId: string;
}

export interface GetOutreachCirclesByOrganizationInput {
    organizationId: string;

    sortBy?: (OutreachCircleSortInput | null)[] | null;

    skip: number;

    limit: number;

    filter?: OutreachCirclesByOrganizationFilter | null;
}

export interface OutreachCircleSortInput {
    sortField: OutreachCircleSortBy;

    isAscending: boolean;
}

export interface OutreachCirclesByOrganizationFilter {
    searchFilter?: OutreachCirclesByOrganizationSearchFilter | null;

    stateFilter?: OutreachCirclesByOrganizationStateFilter | null;
}

export interface OutreachCirclesByOrganizationSearchFilter {
    outreachCircleName?: string | null;

    candidateFirstName?: string | null;

    candidateLastName?: string | null;
}

export interface OutreachCirclesByOrganizationStateFilter {
    states: (string | null)[];

    isExclude: boolean;
}

export interface GetOrganizationDashboardDataInput {
    organizationFilterId?: string | null;

    outreachCircleIds?: string[] | null;

    dateFilter?: DateFilter | null;

    organizationId: string;

    skip?: number | null;

    limit?: number | null;
}

export interface PublicOutreachCircleByOrganizationInput {
    organizationId: string;

    skip?: number | null;

    limit?: number | null;
}

export interface DoesOutreachCircleUserEmailTemplateExistsInput {
    id?: string | null;

    organizationId: string;

    name: string;

    code: OutreachCircleUserEmailTemplateCode;
}

export interface GetOutreachCircleUserEmailTemplatesForOrganizationInput {
    organizationId: string;

    code: OutreachCircleUserEmailTemplateCode;

    searchKey?: string | null;
}

export interface GetPreviewForOutreachCircleUserEmailTemplateInput {
    outreachCircleUserEmailTemplateId: string;

    content: string;

    organizationActionId?: string | null;
}

export interface GetUpdatedContentForOutreachCircleUserEmailTemplateWithActionLinkTextInput {
    outreachCircleUserEmailTemplateId: string;

    content: string;

    actionLinkText: string;

    organizationActionId: string;
}

export interface GetEligibleCountForOrganizationSendActionNotificationInput {
    organizationActionId: string;

    outreachCircleIds?: (string | null)[] | null;
}

export interface GetEligibleCountForNotifyOcAdminsForOrganizationInput {
    organizationId: string;

    outreachCircleIds?: (string | null)[] | null;

    selectAll: boolean;

    filter?: OutreachCirclesByOrganizationFilter | null;
}

export interface PublicOutreachCircleByAliasOrNameInput {
    aliasOrName: string;

    skip: number;

    limit: number;
}

export interface SearchPublicOutreachCircleInput {
    searchKey: string;

    skip: number;

    limit: number;

    organizationId?: string | null;
}

export interface AllPublicOutreachCirclesInput {
    skip: number;

    limit: number;
}

export interface GetOutreachCirclePhoneNumberList {
    outreachCircleId: string;

    filter?: OutreachCirclePhoneNumberFilter | null;

    pagination: PaginationInput;
}

export interface OutreachCirclePhoneNumberFilter {
    unassignedPhoneNumbers?: boolean | null;

    areaCodes?: number[] | null;

    statuses?: PurchasedPhoneNumberStatus[] | null;
}

export interface GetAreaCodesOfPhoneNumbersInput {
    outreachCircleId: string;

    filter?: AreaCodeFilter | null;
}

export interface AreaCodeFilter {
    unassigned?: boolean | null;

    statuses?: PurchasedPhoneNumberStatus[] | null;
}

export interface GetOutreachCirclePhoneNumberLogsInput {
    reservedPhoneNumberId: string;

    outreachCircleId: string;
}

export interface P2PInboxFilterInput {
    actionId: string;

    skip: number;

    limit: number;

    searchKey?: string | null;

    showClosedConversations?: boolean | null;

    showUnreadOnly?: boolean | null;
}

export interface EligibleSupporterForP2PReplyAssignmentInput {
    supporterId: string;

    actionId: string;

    skip: number;

    limit: number;

    searchText?: string | null;
}

export interface P2PScriptSurveyQuestionsByOutreachCircleInput {
    outreachCircleId: string;

    p2pScriptSurveyQuestionType: P2PScriptSurveyQuestionType;

    searchKey?: string | null;
}

export interface ValidateP2PScriptSurveyQuestionNameInput {
    name: string;

    p2pScriptSurveyQuestionId?: string | null;

    outreachCircleId: string;

    p2pScriptSurveyQuestionType?: P2PScriptSurveyQuestionType | null;
}

export interface RecipientsForP2PTextingInput {
    actionId: string;

    limit?: number | null;

    sessionId: string;
}

export interface P2PWorkspacesByOutreachCircleInput {
    outreachCircleId: string;

    integrationType: AllowedIntegrationDatabaseType;

    searchKey?: string | null;

    skip: number;

    limit: number;
}

export interface ValidateP2PWorkspaceNameInput {
    name: string;

    p2pWorkspaceId?: string | null;

    outreachCircleId: string;
}

export interface SearchAndSurveyFormsByOutreachCircleInput {
    outreachCircleId: string;

    searchKey?: string | null;

    integrationTypes: (SearchAndSurveyFormIntegrationType | null)[];
}

export interface ValidateSearchAndSurveyFormNameInput {
    name: string;

    searchAndSurveyFormId?: string | null;

    outreachCircleId: string;
}

export interface GetSocialTextContentForPreviewInput {
    editorContent: string;

    socialTemplateId: string;

    actionId: string;
}

export interface ValidateSocialTemplateNameInput {
    name: string;

    outreachCircleId: string;
}

export interface ValidateOrganizationSocialTemplateNameInput {
    name: string;

    organizationId: string;
}

export interface GetOrganizationSocialTextContentForPreviewInput {
    editorContent: string;

    organizationSocialTemplateId: string;
}

export interface GetSourcingLinkInput {
    skip: number;

    limit: number;

    outreachCircleId: string;
}

export interface UpdateReminderContentInput {
    actionId: string;

    content: string;

    linkText: string;
}

export interface SupporterEmailTemplateForOutreachCircle {
    outreachCircleId: string;

    code: SupporterEmailTemplateCode;

    searchKey?: string | null;

    pagination?: PaginationInput | null;
}

export interface UpdateSupporterEmailTemplateWithRecruitmentLinkInput {
    supporterEmailTemplateId: string;

    content: string;

    linkText: string;

    code?: string | null;
}

export interface ValidateSupporterEmailTemplateNameInput {
    name: string;

    outreachCircleId: string;
}

export interface DefaultSupporterEmailTemplateInput {
    code: SupporterEmailTemplateCode;

    actionId: string;
}

export interface SupporterFormsByOutreachCircleInput {
    outreachCircleId: string;

    searchKey?: string | null;

    responseCountFilter?: ResponseCountFilter | null;
}

export interface ValidateSupporterFormNameInput {
    name: string;

    supporterFormId?: string | null;

    outreachCircleId: string;
}

export interface GetSupporterFormsForOrganizationInput {
    organizationId: string;

    skip: number;

    limit: number;

    sortBy: SupporterFormSortByInput;

    responseCountFilter?: ResponseCountFilter | null;

    outreachCircleIds?: string[] | null;

    organizationFilterId?: string | null;
}

export interface SupporterFormSortByInput {
    sortField: SupporterFormSortBy;

    isAscending: boolean;
}

export interface GetSupporterViewFilterStatesInput {
    skip: number;

    limit: number;

    outreachCircleId: string;

    searchKey?: string | null;
}

export interface DoesSupporterViewFilterStateExistsInput {
    outreachCircleId: string;

    name: string;
}

export interface SupporterListInput {
    sortBy: SupporterSummarySortBy;

    isAscending: boolean;

    skip: number;

    limit: number;

    outreachCircleId: string;
}

export interface GetSupporterViewFilterInput {
    sortBy: SupporterViewSortInput[];

    skip: number;

    limit: number;

    outreachCircleId: string;

    filter?: SupporterViewFilterInput | null;
}

export interface SupporterViewSortInput {
    sortField: SupporterViewSortBy;

    isAscending: boolean;
}

export interface InvitedSupporterFileUrlInput {
    invitedSupporterSourceId: string;

    fileName: string;

    fileType: string;
}

export interface InvitedSupporterInformationInput {
    outreachCircleId: string;

    invitedSupporterId: string;
}

export interface ActionSummaryInput {
    actionId: string;

    skip?: number | null;

    limit?: number | null;
}

export interface SupporterFilterForPushNotificationInput {
    includeCampaignLogo: boolean;

    includeRecentlyNotifiedSupporter: boolean;

    outreachCircleId: string;

    selectedSupporterIds?: string[] | null;

    hasAllSelected: boolean;

    excludeSupporterIds?: string[] | null;

    supporterFilter?: SupporterViewFilterInput | null;
}

export interface SupporterEmailFilterInput {
    supporterIds?: (string | null)[] | null;

    excludeSupporterIds?: (string | null)[] | null;

    sendToAll: boolean;

    supporterEmailTemplateId?: string | null;

    outreachCircleId?: string | null;

    filter?: SupporterViewFilterInput | null;
}

export interface BlockFilteredSupportersInput {
    supporterIds?: (string | null)[] | null;

    excludeSupporterIds?: (string | null)[] | null;

    blockAll: boolean;

    outreachCircleId: string;

    filter?: SupporterViewFilterInput | null;
}

export interface IsSupportingOutreachCircleInput {
    outreachCircleId: string;

    email: string;
}

export interface SupporterTextTemplateInput {
    textTemplateId: string;

    supporterId: string;

    actionId: string;
}

export interface TextTemplateForOutreachCircleInput {
    outreachCircleId: string;

    actionId?: string | null;

    searchKey?: string | null;
}

export interface ValidateOrganizationTextTemplateNameInput {
    name: string;

    organizationId: string;
}

export interface GetTextContentForPreviewInput {
    editorContent: string;

    textTemplateId: string;

    actionId: string;
}

export interface ValidateTextTemplateNameInput {
    name: string;

    outreachCircleId: string;

    actionId: string;
}

export interface GetOrganizationTextContentForPreviewInput {
    editorContent: string;

    textTemplateId: string;
}

export interface ValidateResetCodeInput {
    resetCode: string;

    userId: string;
}

export interface AllOutreachCirclesInput {
    skip: number;

    limit: number;

    filter?: AllOutreachCirclesFilterInput | null;
}

export interface AllOutreachCirclesFilterInput {
    searchFilter?: OutreachCircleSearchFilterInput | null;

    stateFilter?: OutreachCircleStateFilterInput | null;
}

export interface OutreachCircleSearchFilterInput {
    name?: string | null;

    adminFirstName?: string | null;

    adminLastName?: string | null;
}

export interface OutreachCircleStateFilterInput {
    all?: boolean | null;

    stateCodes?: (string | null)[] | null;

    isExclude?: boolean | null;
}

export interface CreateActionViewFilterStateInput {
    outreachCircleId: string;

    name: string;

    state: ActionViewFilterInput;
}

export interface UpdateActionViewFilterStateInput {
    id: string;

    name: string;

    filter: ActionViewFilterInput;
}

export interface GetActionViewFilterStateInput {
    skip: number;

    limit: number;

    outreachCircleId: string;

    searchKey?: string | null;
}

export interface MarkAssignedMemberAsContactedInput {
    actionId: string;

    outreachChannel: OutreachChannel;

    memberId: string;

    outreachChannelDetail?: string | null;

    script?: string | null;
}

export interface MarkAssignedContactAsContactedInput {
    actionId: string;

    outreachChannel: OutreachChannel;

    contactId: string;

    outreachChannelDetail?: string | null;

    script?: string | null;
}

export interface SaveGroSupporterEmailTemplateInput {
    actionId: string;

    subject?: string | null;

    body?: string | null;
}

export interface SaveGroSupporterTextTemplateInput {
    actionId: string;

    content: string;
}

export interface SaveGroSupporterCallOrVisitTemplateInput {
    actionId: string;

    content: string;
}

export interface UpdateGroMemberInput {
    actionId: string;

    assignedContactUpdates?: AssignedContactUpdatesInput | null;
}

export interface AssignedContactUpdatesInput {
    assignedContact?: AssignedContactInput | null;

    customFields?: (CustomFieldInput | null)[] | null;
}

export interface AssignedContactInput {
    id?: string | null;

    member_id: string;

    first_name?: string | null;

    middle_name?: string | null;

    last_name?: string | null;

    emails?: (ContactEmailInput | null)[] | null;

    mobiles?: (ContactMobileInput | null)[] | null;

    apt_number?: string | null;

    street_name?: string | null;

    street_number?: string | null;

    street_type?: string | null;

    full_address?: string | null;

    city?: string | null;

    state?: string | null;

    zip?: string | null;
}

export interface CustomFieldInput {
    key: string;

    value?: string | null;
}

export interface AssignSupporterToActionInput {
    supporterId: string;

    actionId: string;

    audienceActionId?: string | null;
}

export interface ActionInput {
    type: ActionType;

    name: string;

    outreachCircleId: string;

    title: string;

    description?: string | null;

    link?: string | null;

    endDate?: Date | null;

    startDate?: Date | null;

    outreachChannels?: (OutreachChannel | null)[] | null;

    postActionText?: string | null;

    callToActionText?: string | null;

    engagementId?: string | null;

    additionalDetails?: ActionAdditionalDetailsInput | null;

    isOutreachMode?: boolean | null;

    allowNonMappedContacts?: boolean | null;

    eligibleSupporterForSupporterTextingInput?: EligibleSupporterForSupporterTextingInput | null;

    mediaInput?: ActionMediaInput | null;

    supporterFormId?: string | null;

    audienceActionFilter?: AudienceActionFilterInput | null;

    tagIds?: (string | null)[] | null;

    p2pWorkspaceId?: string | null;

    integrationTypeForAffinityAction?: AllowedIntegrationDatabaseType | null;

    searchAndSurveyNewContactsAudienceActionId?: string | null;

    matchWithSearchAndSurveyLists?: boolean | null;

    searchAndSurveyAudienceActionFilter?: SearchAndSurveyAudienceActionFilterInput | null;

    searchAndSurveyFormId?: string | null;

    groSurveyFormId?: string | null;

    takenConfirmationText?: string | null;

    canSkipTakenConfirmation?: boolean | null;
}

export interface ActionAdditionalDetailsInput {
    isTreatmentEnabled?: boolean | null;

    treatment?: number | null;

    everyActionFormId?: string | null;

    everyActionFormHasRedirect?: boolean | null;

    eventLink?: string | null;

    allowContactImport?: boolean | null;

    eventName?: string | null;

    isEmbeddable?: boolean | null;

    playVideoInAppEnabled?: boolean | null;

    isSharingEnabled?: boolean | null;

    shareButtonText?: string | null;

    facebookConfig?: FacebookConfigInput | null;

    groConfig?: ActionGroConfigInput | null;

    contactTypeLabel?: ContactTypeLabelInput | null;

    isAnonymousSearchAndSurveyEnabled?: boolean | null;
}

export interface FacebookConfigInput {
    pageUrl?: string | null;

    postId?: string | null;
}

export interface ActionGroConfigInput {
    turfingStrategy?: TurfingStrategyEnum | null;

    supporterIdFieldInList?: string | null;

    supporterEmailFieldInList?: string | null;
}

export interface ContactTypeLabelInput {
    matched?: ContactTypeLabelInfoInput | null;

    unmatched?: ContactTypeLabelInfoInput | null;

    ambiguous?: ContactTypeLabelInfoInput | null;
}

export interface ContactTypeLabelInfoInput {
    position?: number | null;

    title?: string | null;

    description?: string | null;
}

export interface ActionMediaInput {
    fileName: string;

    fileSize: number;

    mediaId?: string | null;

    crop?: CropInput | null;
}

export interface CropInput {
    left: number;

    top: number;

    width: number;

    orientation: number;

    height: number;

    scale: number;

    originalWidth: number;

    originalHeight: number;
}

export interface AudienceActionFilterInput {
    hasAllSelected: boolean;

    integrationType: AllowedIntegrationDatabaseType;

    audienceActionIds?: (string | null)[] | null;
}

export interface SearchAndSurveyAudienceActionFilterInput {
    hasAllSelected: boolean;

    audienceActionIds: (string | null)[];
}

export interface ActionDatesUpdateInput {
    id: string;

    endDate?: Date | null;

    startDate?: Date | null;
}

export interface ActionEmailTemplateInput {
    emailTemplateId: string;

    actionId: string;
}

export interface ActionTextTemplateInput {
    textTemplateId: string;

    actionId: string;
}

export interface UpdateActionTitleAndDescription {
    actionId: string;

    title: string;

    description?: string | null;

    additionalDetails?: ActionAdditionalDetailsInput | null;

    organizationTagId?: string | null;
}

export interface UpdateActionLinkInput {
    link: string;

    actionId: string;

    additionalDetails?: ActionAdditionalDetailsInput | null;
}

export interface UpdateActionNameInput {
    actionId: string;

    name: string;
}

export interface SendActionEmailInput {
    supporterId: string;

    actionId: string;
}

export interface UpdateOutreachChannelsInput {
    actionId: string;

    outreachChannels: (OutreachChannel | null)[];
}

export interface AudienceActionFilterUpdateInput {
    audienceActionFilterInput: AudienceActionFilterInput;

    actionId: string;
}

export interface ActionImpressionInput {
    actionId: string;

    deviceType: DeviceTypeEnum;
}

export interface ActionStatusUpdateInput {
    actionId: string;

    supporterId: string;

    channel?: OutreachChannel | null;
}

export interface UpdateCallToActionTextInput {
    actionId: string;

    callToActionText: string;
}

export interface UpdatePostActionTextInput {
    actionId: string;

    postActionText: string;
}

export interface UpdateActionOutreachModeInput {
    actionId: string;

    isOutreachMode: boolean;
}

export interface UpdateAllowNonMappedContactsInput {
    actionId: string;

    allowNonMappedContacts: boolean;
}

export interface ActionSurveyLinkInput {
    surveyId: string;

    actionId: string;
}

export interface UpdateActionPositionInput {
    actionId: string;

    position: number;
}

export interface ActionImageInput {
    mediaId?: string | null;

    actionId: string;

    fileName?: string | null;

    fileSize?: number | null;

    crop?: CropInput | null;
}

export interface UpdateIsEngagementRequiredInput {
    actionId: string;

    isEngagementRequired: boolean;
}

export interface TextSentToSupporterInput {
    actionId: string;

    supporterId: string;

    mobileNumber: string;
}

export interface UpdateTreatmentForActionInput {
    actionId: string;

    isTreatmentEnabled: boolean;

    treatment?: number | null;
}

export interface UpdateContactImportPermissionInput {
    actionId: string;

    allowContactImport: boolean;
}

export interface ActionCampaignInput {
    actionId: string;

    campaignId: string;
}

export interface UpdateShareActionButtonTextInput {
    actionId: string;

    shareButtonText: string;
}

export interface RemoveReviewWarningInput {
    actionId: string;

    reviewKey?: ReviewWarningKey | null;
}

export interface AssignSupportersToActionInput {
    selectedSupporterIds?: string[] | null;

    hasAllSelected?: boolean | null;

    excludeSupporterIds?: string[] | null;

    actionId: string;

    filter?: SupporterViewFilterInput | null;
}

export interface AssignSupportersFromGroupToActionInput {
    actionId: string;

    groupId: string;
}

export interface SearchAndSurveyAudienceActionFilterUpdateInput {
    searchAndSurveyAudienceActionFilterUpdateInput: SearchAndSurveyAudienceActionFilterInput;

    actionId: string;
}

export interface UpdateSearchAndSurveyNewContactsListForActionInput {
    actionId: string;

    newContactsListId: string;
}

export interface CustomFieldForSearchAndSurveyActionInput {
    actionId: string;

    audienceCustomFieldId: string;

    displayType: SearchAndSurveyDisplayType;
}

export interface UpdateActionConfirmationInput {
    actionId: string;

    takenConfirmationText?: string | null;

    canSkipTakenConfirmation: boolean;
}

export interface UpdateCallOrVisitTemplate {
    actionId: string;

    callTemplate?: string | null;

    visitTemplate?: string | null;
}

export interface RemoveTemplateFromActionForOutreachChannelInput {
    outreachChannel: OutreachChannel;

    actionId: string;
}

export interface SendEmailNotificationForActionInput {
    actionId: string;

    code: SupporterEmailTemplateCode;
}

export interface SendPushNotificationForActionInput {
    actionId: string;

    code: SupporterPushNotificationTemplateCode;
}

export interface AssignGroupToActionInput {
    actionId: string;

    selectedGroupIds: string[];

    unSelectedGroupIds: string[];
}

export interface UpdateGroConfigInput {
    actionId: string;

    groConfig: ActionGroConfigInput;
}

export interface UpdateAddressBasedCanvassingConfigInput {
    actionId: string;

    config: ActionAddresBasedConfigInput;
}

export interface ActionAddresBasedConfigInput {
    maxMemberAssignmentForSupporter?: number | null;

    turfingRangeInMiles?: number | null;
}

export interface UpdatePdiOnTheGoCanvassingConfigInput {
    actionId: string;

    config: PdiOnTheGoCanvassingConfigInput;
}

export interface PdiOnTheGoCanvassingConfigInput {
    pdiProject?: PdiProjectInput | null;

    allowAddingMembers?: boolean | null;

    allowCensusBlocks?: boolean | null;
}

export interface PdiProjectInput {
    pdiProjectId?: string | null;

    pdiProjectName?: string | null;
}

export interface UpdateContactTypeLabelInput {
    actionId: string;

    contactTypeLabel: ContactTypeLabelInput;
}

export interface CreateMemberNoteInput {
    actionId: string;

    memberId: string;

    note: string;
}

export interface AssignOutreachCirclePhoneNumberToActionInput {
    actionId: string;

    phoneNumberId: string;
}

export interface UnassignOutreachCirclePhoneNumberFromActionInput {
    actionId: string;

    phoneNumberId: string;
}

export interface UpdateP2PConfigForActionInput {
    actionId: string;

    allowUninterruptedTexting?: boolean | null;

    disableManageReplies?: boolean | null;

    disableEditMessage?: boolean | null;
}

export interface PurchasePhoneNumberForP2PActionInput {
    areaCode: number;

    actionId: string;
}

export interface P2PScheduleInput {
    actionId: string;

    startTime: P2PTimeInput;

    endTime: P2PTimeInput;
}

export interface P2PTimeInput {
    hour: number;

    minute: number;

    timezone: string;
}

export interface UpdateIsAnonymousSearchAndSurveyForActionInput {
    actionId: string;

    isAnonymousSearchAndSurveyEnabled: boolean;
}

export interface AddMemberToHouseHoldInput {
    searchAndSurveyMemberId: string;

    householdId: string;

    actionId: string;
}

export interface RecordTagForHouseholdInput {
    householdId: string;

    actionId: string;

    tagId: string;
}

export interface RecordTagForSearchAndSurveyMemberInput {
    householdId: string;

    searchAndSurveyMemberId: string;

    actionId: string;

    tagId: string;
}

export interface CreateSearchAndSurveyListInput {
    name: string;

    outreachCircleId: string;
}

export interface AudienceActionInput {
    audienceId: string;

    audienceActionId: string;

    key?: string | null;

    mapping: Mapping;

    fileName?: string | null;

    delimiter?: string | null;

    customfields?: (string | null)[] | null;

    listType: ListType;

    source?: AudienceActionSource | null;

    database?: AudienceActionDatabase | null;

    migrate?: boolean | null;

    salesforceInput?: SalesforceInput | null;
}

export interface Mapping {
    mappingData: Json;

    name: string;
}

export interface SalesforceInput {
    soql?: string | null;

    schedule: SoqlScheduleInput;
}

export interface SoqlScheduleInput {
    frequency?: Frequency | null;

    dayOfWeek?: number | null;

    dayOfMonth?: number | null;
}

export interface DeleteAudienceByListTypeInput {
    audienceId: string;

    listType: ListType;
}

export interface BlockMemberInput {
    memberId: string;

    audienceId: string;
}

export interface UpdateAudienceActionInput {
    id: string;

    operation: AudienceActionOperation;
}

export interface ActionOnMembersFromBlackbaudImportInput {
    outreachCircleId: string;

    constituentListId: string;

    audienceMappingName: string;

    database?: AudienceActionDatabase | null;
}

export interface CreateBroadcastTextingScriptInput {
    outreachCircleId: string;

    name: string;

    body: string;

    attachments: (MediaInput | null)[];
}

export interface MediaInput {
    mediaId: string;

    fileName: string;

    fileSize: number;
}

export interface UpdateBroadcastTextingScriptInput {
    id: string;

    name: string;

    body: string;

    attachments?: (MediaInput | null)[] | null;
}

export interface DuplicateBroadcastTextingScriptInput {
    name: string;

    outreachCircleId: string;

    broadcastTextingScriptId: string;
}

export interface SendSampleTextInput {
    outreachCircleId: string;

    toPhoneNumber: string;

    attachments: (MediaInput | null)[];

    body: string;
}

export interface UpdateCandidateInput {
    id: string;

    firstName?: string | null;

    lastName?: string | null;

    enabled: boolean;
}

export interface AddCandidateInput {
    firstName?: string | null;

    lastName?: string | null;

    enabled: boolean;

    outreachCircleId: string;
}

export interface CandidateImageInput {
    candidateId: string;

    mediaId: string;

    fileName: string;

    fileSize: number;

    crop?: CropInput | null;
}

export interface SetEmailRecipientInput {
    contactId: string;

    supporterId: string;

    memberId: string;

    isEmailRecipient: boolean;

    actionId: string;
}

export interface ResolveAmbiguousMappedContactInput {
    supporterId: string;

    contactId: string;

    memberId: string;

    resolve: boolean;
}

export interface CreateMatchingJobInput {
    actionId?: string | null;

    supporterId: string;
}

export interface MarkEligibleContactAsEmailRecipientInput {
    actionId: string;

    supporterId: string;

    contactId: string;

    isEmailRecipient: boolean;
}

export interface ToggleA1CRecipientMappedInput {
    actionId: string;

    supporterId: string;

    contactId: string;

    memberId: string;

    isA1CRecipient: boolean;
}

export interface ToggleAllA1CRecipientInput {
    actionId: string;

    supporterId: string;

    isSet: boolean;
}

export interface ToggleA1CRecipientNonMappedInput {
    actionId: string;

    supporterId: string;

    contactId: string;

    isA1CRecipient: boolean;
}

export interface ToggleAmbiguousA1CRecipientInput {
    actionId: string;

    supporterId: string;

    contactId: string;

    memberId?: string | null;

    isA1CRecipient: boolean;
}

export interface DeleteMappedContactInput {
    contactId: string;

    actionId: string;
}

export interface ContactUsInput {
    name: string;

    emailId: string;

    phone?: string | null;

    message: string;

    deviceDetails: DeviceDetails;

    outreachCircleId?: string | null;

    messageSource?: string | null;

    outreachCircleAlias?: string | null;

    actionId?: string | null;
}

export interface DeviceDetails {
    browserName?: string | null;

    browserVersion?: string | null;

    currentRoute?: string | null;

    platform: string;

    phoneModelName?: string | null;

    phoneOSVersion?: string | null;

    appVersion?: string | null;

    phoneOS?: string | null;

    screenResolution?: string | null;
}

export interface ContactFileImportInput {
    fileName: string;

    key: string;

    mapping?: Json | null;

    delimiter?: string | null;

    fileType: string;

    platform?: ContactSourcePlatform | null;
}

export interface CreateContactInput {
    firstName?: string | null;

    middleName?: string | null;

    lastName?: string | null;

    emails?: (ContactEmailInput | null)[] | null;

    mobiles?: (ContactMobileInput | null)[] | null;

    streetNumber?: string | null;

    streetName?: string | null;

    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;
}

export interface UpdateContactInput {
    id: string;

    firstName?: string | null;

    lastName?: string | null;

    emails?: (ContactEmailInput | null)[] | null;

    mobiles?: (ContactMobileInput | null)[] | null;

    streetNumber?: string | null;

    streetName?: string | null;

    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;
}

export interface UpdatePrimaryEmailInput {
    primaryEmail: string;

    contactId: string;
}

export interface ResolveDuplicateEmailContactInput {
    email: string;

    contactId: string;
}

export interface CreateEmailTemplateInput {
    name: string;

    subject: string;

    body?: string | null;

    actionId: string;

    fromNameAlias?: string | null;
}

export interface DuplicateEmailTemplateInput {
    actionId: string;

    name: string;

    emailTemplateId: string;
}

export interface UpdateEmailTemplateInput {
    id: string;

    name: string;

    subject: string;

    body: string;

    actionId: string;

    fromNameAlias?: string | null;
}

export interface UpdateEmailTemplateForSupporterInput {
    id: string;

    subject: string;

    body: string;

    supporterId: string;

    actionId: string;
}

export interface EditedEmailPreviewInput {
    body: string;

    subject: string;

    outreachCircleId: string;

    emailTemplateId: string;
}

export interface CreateOrganizationEmailTemplateInput {
    name: string;

    subject: string;

    body?: string | null;

    organizationId: string;

    organizationActionId: string;

    fromNameAlias?: string | null;
}

export interface UpdateOrganizationEmailTemplateInput {
    id: string;

    name: string;

    subject: string;

    body: string;

    organizationActionId: string;

    fromNameAlias?: string | null;
}

export interface UpdateEmailTemplateForOrgWithRecruitmentLinkInput {
    emailTemplateId: string;

    content: string;

    linkText: string;
}

export interface EditedOrganizationTemplateEmailPreviewInput {
    body: string;

    subject: string;

    organizationId: string;

    emailTemplateId: string;
}

export interface SurveyEngagementInput {
    id?: string | null;

    name: string;

    description?: string | null;

    outreachCircleId: string;

    addSupporterToInviterSupporterGroups?: boolean | null;

    questions?: (EngagementQuestionInput | null)[] | null;

    integrationType?: AllowedIntegrationDatabaseType | null;
}

export interface EngagementQuestionInput {
    id?: string | null;

    questionText: string;

    ngpSurveyQuestionId?: number | null;

    pdiQuestionId?: string | null;

    questionType: EngagementQuestionType;

    isMandatory: boolean;

    isMultipleOptionsAllowed: boolean;

    hasResponseLogic?: boolean | null;

    position: number;

    options?: EngagementOptionInput[] | null;
}

export interface EngagementOptionInput {
    id?: string | null;

    optionText: string;

    position: number;

    linkedEngagement?: DefaultEngagementInput | null;

    ngpSurveyResponseId?: number | null;

    pdiAnswerId?: string | null;

    linkedNgpActivistCode?: NgpActivistCodeInput | null;

    type?: EngagementOptionType | null;

    linkedQuestionPosition?: number | null;
}

export interface DefaultEngagementInput {
    name: string;

    type?: EngagementType | null;

    description?: string | null;

    outreachCircleId: string;

    url?: string | null;

    message?: string | null;

    id?: string | null;

    additionalDetails?: Json | null;
}

export interface NgpActivistCodeInput {
    activistCodeId?: number | null;

    type?: string | null;

    name?: string | null;

    mediumName?: string | null;

    shortName?: string | null;

    description?: string | null;

    scriptQuestion?: string | null;

    status?: string | null;

    isMultiAssign?: boolean | null;
}

export interface SaveSurveyResponseInput {
    responses: EngagementOptionResponseInput[];

    emailRecipientId?: string | null;

    textRecipientId?: string | null;
}

export interface EngagementOptionResponseInput {
    engagementOptionId: string;

    response?: FormResponse | null;
}

export interface FormResponse {
    text?: string | null;

    addressField?: AddressFields | null;
}

export interface AddressFields {
    address: string;

    cityAndState: string;

    zip: string;
}

export interface DuplicateSurveyEngagementInput {
    surveyId: string;

    name: string;
}

export interface UpdateGroSurveyFormInput {
    id: string;

    name: string;

    groSurveyFormQuestions: GroSurveyFormQuestionInput[];
}

export interface GroSurveyFormQuestionInput {
    id?: string | null;

    questionText: string;

    questionType: GroSurveyFormQuestionType;

    isMandatory: boolean;

    position: number;

    options?: GroSurveyFormOptionInput[] | null;

    questionIntegrationType: GroSurveyFormQuestionIntegrationType;

    pdiSurveyQuestionId?: string | null;

    ngpSurveyQuestionId?: number | null;
}

export interface GroSurveyFormOptionInput {
    id?: string | null;

    optionText: string;

    position: number;

    optionType?: GroSurveyFormOptionType | null;

    pdiAnswerId?: string | null;

    ngpSurveyResponseId?: number | null;

    linkedNgpActivistCode?: NgpActivistCodeInput | null;
}

export interface CreateGroSurveyFormInput {
    outreachCircleId: string;

    name: string;

    groSurveyFormIntegrationType?: GroSurveyFormIntegrationType | null;
}

export interface GroSurveyFormActionInput {
    actionId: string;

    groSurveyFormId: string;
}

export interface DuplicateGroSurveyFormInput {
    groSurveyFormId: string;

    name: string;
}

export interface SubmitGroSurveyFormQuestionResponseInput {
    supporterId: string;

    actionId: string;

    groSurveyFormQuestionId: string;

    responses: GroSurveyFormResponseInput[];

    memberId: string;
}

export interface GroSurveyFormResponseInput {
    groSurveyFormOptionId: string;

    response?: GroSurveyFormResponseDetails | null;
}

export interface GroSurveyFormResponseDetails {
    text?: string | null;

    addressField?: AddressFields | null;
}

export interface SubmitGroSurveyFormQuestionResponseForContactInput {
    supporterId: string;

    actionId: string;

    groSurveyFormQuestionId: string;

    responses: GroSurveyFormResponseInput[];

    contactId: string;
}

export interface CreateGroupInput {
    outreachCircleId: string;

    name: string;
}

export interface UpdateGroupInput {
    id: string;

    name: string;
}

export interface AssignActionToGroupInput {
    actionId: string;

    groupId: string;
}

export interface AssignAliasToGroupInput {
    groupId: string;

    aliasId: string;
}

export interface UnAssignActionFromGroupInput {
    actionId: string;

    groupId: string;
}

export interface UnAssignAliasForGroupInput {
    groupId: string;

    aliasId: string;
}

export interface AssignSupportersToGroupsInput {
    supporterIds?: (string | null)[] | null;

    assignAll: boolean;

    excludeSupporterIds?: (string | null)[] | null;

    groupIds: (string | null)[];

    filter?: SupporterViewFilterInput | null;
}

export interface UnAssignSupporterFromGroupInput {
    supporterId: string;

    groupId: string;
}

export interface FacebookPixelIntegrationInput {
    outreachCircleId: string;

    facebookPixelCode: string;
}

export interface CreateOrUpdateNationBuilderIntegrationInput {
    outreachCircleId: string;

    slug: string;

    apiToken: string;
}

export interface AddOrUpdateNationBuilderTagsForAliasInput {
    outreachCircleId: string;

    alias: string;

    peopleTags: (NationBuilderPeopleTagsInput | null)[];

    applyToAllCustomAliases: boolean;
}

export interface NationBuilderPeopleTagsInput {
    name: string;
}

export interface SaveNgpIntegrationInput {
    appName: string;

    apiKey: string;

    outreachCircleId: string;

    myVoter: boolean;

    myCampaign: boolean;
}

export interface ActionOnNgpMembersInput {
    outreachCircleId: string;

    savedListId: string;

    audienceMappingName: string;

    database?: AudienceActionDatabase | null;

    listType: ListType;
}

export interface AddNgpActivistCodesForAliasInput {
    aliasId: string;

    activistCode: NgpActivistCodeInput;
}

export interface RemoveNgpActivistCodesForAliasInput {
    aliasId: string;

    activistCodeId: number;
}

export interface UpdateApplyToAllCustomAliasesForNgpActivistCodeInput {
    outreachCircleId: string;

    applyToAllCustomAliases: boolean;
}

export interface AssignPdiZoneInput {
    actionId: string;

    zoneIds: number[];

    location: LocationCoordinateInput;
}

export interface CreateOrUpdatePdiIntegrationInput {
    outreachCircleId: string;

    username: string;

    password: string;

    apiToken: string;
}

export interface AddPdiFlagIdForAliasInput {
    aliasId: string;

    flagId: PdiFlagIdInput;
}

export interface PdiFlagIdInput {
    id: string;

    flagId: string;

    flagIdDescription: string;

    compile: string;

    isDefault?: boolean | null;
}

export interface RemovePdiFlagIdForAliasInput {
    aliasId: string;

    pdiFlagId: string;
}

export interface UpdateApplyPdiFlagsGloballyInput {
    outreachCircleId: string;

    applyGlobally: boolean;
}

export interface RegisterTcrBrandInput {
    organizationType: TcrBrandOrganizationType;

    companyName: string;

    ein: string;

    phone: string;

    street: string;

    city: string;

    state: string;

    postalCode: string;

    country: string;

    email: string;

    website: string;

    vertical: TcrBrandVertical;

    outreachCircleId: string;

    optInUrl: string;
}

export interface CreateTcrBrandPoliticalVettingInput {
    brandId: string;

    cvToken: string;

    outreachCircleId: string;
}

export interface RegisterTcrCampaignInput {
    brandId: string;

    usecase: string;

    subUsecaseList?: (string | null)[] | null;

    description: string;

    sample1: string;

    sample2: string;

    outreachCircleId: string;

    messageFlow: string;

    helpMessage: string;

    optoutMessage: string;

    termsAndConditions: boolean;
}

export interface MediaInputType {
    fileName: string;

    fileType: string;

    fileSize: number;

    outreachCircleId: string;

    mediaId?: string | null;
}

export interface OrgMediaInputType {
    fileName: string;

    fileType: string;

    fileSize: number;

    organizationId: string;

    mediaId?: string | null;
}

export interface PresignedP2PScriptMediaUploadRequestInput {
    outreachCircleId: string;

    media?: P2PScriptMediaInputType[] | null;
}

export interface P2PScriptMediaInputType {
    fileName: string;

    fileType: string;

    fileSize: number;

    mediaId?: string | null;
}

export interface OrganizationActionMediaInputType {
    fileName: string;

    fileType: string;

    fileSize: number;

    organizationId: string;

    mediaId?: string | null;
}

export interface EditorMediaInputType {
    fileName: string;

    fileType: string;

    fileSize: number;

    outreachCircleId: string;

    emailTemplateId?: string | null;

    supporterEmailTemplateId?: string | null;

    mediaId?: string | null;
}

export interface OrgEditorMediaInputType {
    fileName: string;

    fileType: string;

    fileSize: number;

    organizationId: string;

    emailTemplateId: string;

    mediaId?: string | null;
}

export interface OrganizationActionInput {
    type: OrganizationActionType;

    name: string;

    organizationId: string;

    title: string;

    description?: string | null;

    link?: string | null;

    isOutreachMode?: boolean | null;

    allowNonMappedContacts?: boolean | null;

    postActionText?: string | null;

    callToActionText?: string | null;

    mediaInput?: ActionMediaInput | null;

    additionalDetails?: OrganizationActionAdditionalDetailsInput | null;

    integrationType?: AllowedIntegrationDatabaseType | null;

    outreachChannels?: (OutreachChannel | null)[] | null;

    takenConfirmationText?: string | null;

    canSkipTakenConfirmation?: boolean | null;
}

export interface OrganizationActionAdditionalDetailsInput {
    eventLink?: string | null;

    eventName?: string | null;

    playVideoInAppEnabled?: boolean | null;

    isSharingEnabled?: boolean | null;

    shareButtonText?: string | null;

    facebookConfig?: FacebookConfigInput | null;
}

export interface UpdateOrganizationActionNameInput {
    organizationActionName: string;

    organizationActionId: string;
}

export interface UpdateOrganizationActionLinkInput {
    link: string;

    actionId: string;

    additionalDetails?: OrganizationActionAdditionalDetailsInput | null;
}

export interface UpdateOrganizationActionTitleAndDescriptionInput {
    actionId: string;

    title: string;

    description?: string | null;

    additionalDetails?: OrganizationActionAdditionalDetailsInput | null;
}

export interface UpdateCallToActionTextForOrganizationActionInput {
    actionId: string;

    callToActionText: string;
}

export interface UpdateShareActionButtonTextForOrgActionInput {
    organizationActionId: string;

    shareButtonText: string;
}

export interface UpdatePostActionTextForOrganizationActionInput {
    actionId: string;

    postActionText: string;
}

export interface OrganizationActionEmailTemplateInput {
    emailTemplateId: string;

    organizationActionId: string;
}

export interface OrganizationActionTextTemplateInput {
    textTemplateId: string;

    organizationActionId: string;
}

export interface PublishOrganizationActionInput {
    organizationActionId: string;

    organizationFilterId?: string | null;

    outreachCircleIds?: string[] | null;
}

export interface UpdateOrganizationActionAllowNonMappedContactsInput {
    organizationActionId: string;

    allowNonMappedContacts: boolean;
}

export interface UpdateOrganizationActionOutreachChannelsInput {
    organizationActionId: string;

    outreachChannels: (OutreachChannel | null)[];
}

export interface UpdateOrganizationActionIntegrationTypeInput {
    organizationActionId: string;

    integrationType?: AllowedIntegrationDatabaseType | null;
}

export interface UpdateOrganizationActionConfirmationInput {
    organizationActionId: string;

    takenConfirmationText?: string | null;

    canSkipTakenConfirmation: boolean;
}

export interface CreateOrganizationTagInput {
    organizationId: string;

    name: string;
}

export interface UpdateOrganizationTagInput {
    organizationTagId: string;

    name: string;
}

export interface ActionOrganizationTagLinkInput {
    organizationTagId: string;

    actionId: string;
}

export interface InviteOrganizationUserInput {
    email: string;

    organizationId: string;

    firstName: string;

    lastName?: string | null;

    readOnlyAccessToOutreachCircle: boolean;
}

export interface ResendInviteToOrgUserInput {
    organizationUserId: string;

    updatedEmail?: string | null;
}

export interface UpdateOrganizationUserInput {
    id: string;

    email: string;

    firstName: string;

    lastName: string;
}

export interface UpdateOcAccessForOrgUserInput {
    id: string;

    readOnlyAccessToOutreachCircle: boolean;
}

export interface UpdateOrganizationUserUiPreferenceInput {
    organizationUserId: string;

    key: OrganizationUserUiPreferences;

    value: Any;
}

export interface UpdateOrganizationInput {
    id: string;

    name: string;
}

export interface OrganizationDashboardFilterInput {
    outreachCircleIds?: string[] | null;

    dateFilter?: DateFilter | null;

    organizationId: string;

    name: string;
}

export interface UpdateOrganizationDashboardFilterInput {
    outreachCircleIds?: string[] | null;

    organizationId: string;

    id: string;
}

export interface MainOutreachCircleInput {
    organizationId: string;

    outreachCircleId: string;

    mainOCButtonText?: string | null;
}

export interface OrgIntroductionInput {
    organizationId: string;

    introductionText: string;
}

export interface OrgLogoInput {
    organizationId: string;

    mediaId: string;

    fileName: string;

    fileSize: number;

    crop?: CropInput | null;
}

export interface OrgDisclaimerInput {
    organizationId: string;

    disclaimer?: string | null;
}

export interface UpdateOrganizationAliasInput {
    organizationId: string;

    aliasValue: string;
}

export interface CreateOutreachCircleUserEmailTemplateInput {
    organizationId: string;

    name: string;

    code: OutreachCircleUserEmailTemplateCode;
}

export interface UpdateOutreachCircleUserEmailTemplateInput {
    id: string;

    name: string;

    subject: string;

    content: string;

    fromNameAlias?: string | null;
}

export interface DuplicateOutreachCircleUserEmailTemplateInput {
    outreachCircleUserEmailTemplateId: string;

    name: string;
}

export interface NotifyOutreachCircleAdminsForOrganizationActionInput {
    outreachCircleIds?: (string | null)[] | null;

    organizationActionId: string;

    outreachCircleUserEmailTemplateId: string;
}

export interface NotifyOutreachCircleAdminsForOrganizationInput {
    outreachCircleUserEmailTemplateId: string;

    notificationFilter: OrganizationNotificationFilter;
}

export interface OrganizationNotificationFilter {
    outreachCircleIds?: (string | null)[] | null;

    selectAll: boolean;

    filter?: OutreachCirclesByOrganizationFilter | null;
}

export interface OutreachCircleUserInput {
    email: string;

    outreachCircleId: string;

    firstName: string;

    lastName: string;
}

export interface UpdateOutreachCircleUserInput {
    id: string;

    email: string;

    firstName: string;

    lastName: string;
}

export interface OutreachCircleAdminEmailUnsubscribeInput {
    emailRecipientId: string;

    emailTemplateId: string;

    outreachCircleId: string;
}

export interface OutreachCircleInput {
    name: string;

    industry: string;

    category?: string | null;

    paymentToken?: string | null;

    plan: string;

    coupon?: string | null;

    platformDetails?: PlatformDetails | null;
}

export interface PlatformDetails {
    screenResolution: string;

    osName: string;

    osVersion: string;

    currentRoute?: string | null;

    browserName?: string | null;

    browserVersion?: string | null;

    phoneModelName?: string | null;

    appVersion?: string | null;
}

export interface UpdateOutreachCircleBasicInfoInput {
    id: string;

    name: string;

    industry: string;

    category?: string | null;
}

export interface UpdateOutreachCircleContactAndLocationInput {
    city: string;

    state: string;

    country: string;

    zip: string;

    phoneNumber?: string | null;

    outreachCircleId: string;

    headquarterInfo?: HeadquarterInfoInput | null;
}

export interface HeadquarterInfoInput {
    latitude: number;

    longitude: number;
}

export interface OutreachCircleLogoInput {
    outreachCircleId: string;

    mediaId: string;

    fileName: string;

    fileSize: number;

    crop?: CropInput | null;
}

export interface BlockedDomainsInput {
    outreachCircleId: string;

    blockedDomains: string[];
}

export interface DisclaimerOutreachCircleInput {
    outreachCircleId: string;

    disclaimer?: string | null;
}

export interface OutreachCircleEmailUnsubscribeInput {
    outreachCircleId: string;

    emailRecipientId: string;

    emailTemplateId: string;

    userType: string;
}

export interface ReferredByOutreachCircleInput {
    outreachCircleId: string;

    referredBy?: string | null;
}

export interface VisibilityOutreachCircleInput {
    outreachCircleId: string;

    isVisible: boolean;
}

export interface OutreachCircleAliasInput {
    outreachCircleId: string;

    name: string;

    isRapidOnboardingEnabled?: boolean | null;

    description: string;

    isLandingPage?: boolean | null;

    logo?: AliasLogoInput | null;
}

export interface AliasLogoInput {
    mediaId: string;

    fileName: string;

    fileSize: number;

    crop?: CropInput | null;
}

export interface EditOutreachCircleAliasInput {
    aliasId: string;

    name: string;

    description: string;

    isRapidOnboardingEnabled?: boolean | null;

    isLandingPage?: boolean | null;

    logo?: AliasLogoInput | null;

    isAppOnly?: boolean | null;

    languagePreference?: LanguagePreferenceType | null;
}

export interface IncrementOutreachCircleImpressionsInput {
    alias: string;

    deviceType: DeviceTypeEnum;
}

export interface OutreachCircleEmailAliasInput {
    outreachCircleId: string;

    name: string;
}

export interface SupporterReplyToEmailOutreachCircleInput {
    outreachCircleId: string;

    supporterReplyToEmail: string;
}

export interface SupporterFromNameEmailOutreachCircleInput {
    outreachCircleId: string;

    supporterAutoEmailsFromName?: string | null;
}

export interface ArchiveSurveyResponseInput {
    outreachCircleId: string;

    userId: string;

    archiveSurveyResponseData: ArchiveSurveyResponseDataInput;
}

export interface ArchiveSurveyResponseDataInput {
    reasonToArchiveOutreachCircle?: string | null;

    otherReasonText?: string | null;

    netPromoterScore?: number | null;

    thingsToImprove?: string | null;

    hasWonElection?: string | null;

    personalEmail?: string | null;
}

export interface UpdateKeyDateInput {
    outreachCircleId: string;

    keyDates?: KeyDateInput[] | null;
}

export interface KeyDateInput {
    id?: string | null;

    date?: Date | null;

    name: string;

    isApplicable: boolean;
}

export interface PurchasePhoneNumberForOutreachCircleInput {
    areaCode: number;

    outreachCircleId: string;
}

export interface UpdatePaymentSourceInput {
    outreachCircleId: string;

    sourceId: string;

    data: PaymentSourceDataInput;
}

export interface PaymentSourceDataInput {
    name?: string | null;

    exp_month?: number | null;

    exp_year?: number | null;

    address_city?: string | null;

    address_country?: string | null;

    address_line1?: string | null;

    address_line2?: string | null;

    address_state?: string | null;

    address_zip?: string | null;
}

export interface ChangePlanInput {
    outreachCircleId: string;

    plan: string;

    cardToken?: string | null;

    coupon?: string | null;

    existingCardId?: string | null;
}

export interface CancelAutoRenewForOutreachCircleInput {
    outreachCircleId: string;

    setToPrivateConfirmation: boolean;

    surveyActionDeactivateConfirmation: boolean;

    emailTextActionWithMatchingDeactivateConfirmation: boolean;

    recruitmentLinkDeactivateConfirmation: boolean;
}

export interface CreateP2PConversationItemInput {
    conversationId: string;

    latestScriptId: string;

    message?: string | null;

    tagIds?: string[] | null;

    questionResponses?: P2PQuestionResponseList[] | null;
}

export interface P2PQuestionResponseList {
    p2pScriptSurveyQuestionId: string;

    p2pScriptSurveyQuestionOptionId: string;
}

export interface ReassignP2PConversationsInput {
    oldSupporterId: string;

    newSupporterId: string;

    actionId: string;
}

export interface UnTagP2PConversationInput {
    tagIds: string[];

    conversationId: string;
}

export interface P2PScriptSurveyQuestionInput {
    id?: string | null;

    name: string;

    questionText: string;

    outreachCircleId: string;

    ngpSurveyQuestionId?: number | null;

    pdiQuestionId?: string | null;

    integrationType?: AllowedIntegrationDatabaseType | null;

    p2pScriptSurveyQuestionType: P2PScriptSurveyQuestionType;

    options: P2PScriptSurveyQuestionOptionInput[];
}

export interface P2PScriptSurveyQuestionOptionInput {
    id?: string | null;

    optionText: string;

    position: number;

    ngpSurveyResponseId?: number | null;

    pdiAnswerId?: string | null;

    linkedNgpActivistCode?: NgpActivistCodeInput | null;

    type?: EngagementOptionType | null;
}

export interface SendInitialP2PTextInput {
    actionId: string;

    textBody: string;

    recipientId: string;
}

export interface UpdateInitialP2PTextInput {
    actionId: string;

    textBody: string;
}

export interface SendBulkInitialP2PTextsInput {
    actionId: string;

    p2pTextItemList: P2pTextItemInput[];
}

export interface P2pTextItemInput {
    textBody: string;

    recipientId: string;
}

export interface P2PWorkspaceInput {
    id?: string | null;

    name: string;

    outreachCircleId: string;

    firstP2PScriptId: string;

    integrationType: AllowedIntegrationDatabaseType;

    p2pScripts: P2PScriptInput[];

    tags?: P2PWorkspaceTagInput[] | null;

    linkedP2PScripts?: LinkedP2PScriptInput[] | null;
}

export interface P2PScriptInput {
    id?: string | null;

    name: string;

    p2pScriptSurveyQuestionId?: string | null;

    message: string;

    p2pScriptType: P2PScriptType;

    attachments?: MediaInput[] | null;
}

export interface P2PWorkspaceTagInput {
    tagId: string;

    p2pScriptId?: string | null;

    position?: number | null;
}

export interface LinkedP2PScriptInput {
    p2pScriptId: string;

    p2pScriptSurveyQuestionOptionId: string;

    nextP2PScriptId: string;
}

export interface DuplicateP2PWorkspaceInput {
    p2pWorkspaceId: string;

    name: string;
}

export interface RequestReport {
    outreachCircleId: string;

    reportCode: ReportCode;

    actionIds?: string[] | null;

    supporterFormResponseReportFilter?: SupporterFormResponseReportFilter | null;

    surveyResponseReportFilter?: SurveyResponseReportFilter | null;

    reportName?: string | null;
}

export interface SupporterFormResponseReportFilter {
    supporterFormIds: string[];

    fromDate?: Date | null;

    toDate?: Date | null;
}

export interface SurveyResponseReportFilter {
    surveyIds: string[];

    fromDate?: Date | null;

    toDate?: Date | null;
}

export interface OrganizationReportInput {
    organizationId: string;

    outreachCircleIds?: string[] | null;

    code: ReportCode;
}

export interface UpdateSearchAndSurveyFormInput {
    id: string;

    name: string;

    searchAndSurveyFormQuestions: SearchAndSurveyFormQuestionInput[];
}

export interface SearchAndSurveyFormQuestionInput {
    id?: string | null;

    questionText: string;

    questionType: SearchAndSurveyFormQuestionType;

    isMandatory: boolean;

    position: number;

    options?: SearchAndSurveyFormOptionInput[] | null;

    questionIntegrationType: SearchAndSurveyFormQuestionIntegrationType;

    ngpSurveyQuestionId?: number | null;

    pdiSurveyQuestionId?: string | null;
}

export interface SearchAndSurveyFormOptionInput {
    id?: string | null;

    optionText: string;

    position: number;

    optionType?: SearchAndSurveyFormOptionType | null;

    ngpSurveyResponseId?: number | null;

    linkedNgpActivistCode?: NgpActivistCodeInput | null;

    assignedGroupId?: string | null;

    pdiAnswerId?: string | null;
}

export interface CreateSearchAndSurveyFormInput {
    outreachCircleId: string;

    name: string;

    searchAndSurveyFormIntegrationType?: SearchAndSurveyFormIntegrationType | null;
}

export interface SearchAndSurveyFormActionInput {
    actionId: string;

    searchAndSurveyFormId: string;
}

export interface DuplicateSearchAndSurveyFormInput {
    searchAndSurveyFormId: string;

    name: string;
}

export interface SubmitSearchAndSurveyFormQuestionResponseInput {
    supporterId: string;

    actionId: string;

    searchAndSurveyFormQuestionId: string;

    responses: SearchAndSurveyFormResponseInput[];

    memberId: string;
}

export interface SearchAndSurveyFormResponseInput {
    searchAndSurveyFormOptionId: string;

    response?: SearchAndSurveyFormResponseDetails | null;
}

export interface SearchAndSurveyFormResponseDetails {
    text?: string | null;

    addressField?: AddressFields | null;
}

export interface CreateSocialTemplateInput {
    name: string;

    description: string;

    outreachCircleId: string;

    actionId: string;
}

export interface UpdateSocialTemplateInput {
    id: string;

    name: string;

    description: string;

    actionId: string;
}

export interface CreateOrganizationSocialTemplateInput {
    name: string;

    description: string;

    organizationId: string;
}

export interface UpdateOrganizationSocialTemplateInput {
    id: string;

    name: string;

    description: string;
}

export interface SourcingLinkInput {
    name: string;

    link: string;

    useShortLink: boolean;

    outreachCircleId: string;
}

export interface CreateSupporterEmailTemplateInput {
    outreachCircleId: string;

    subject: string;

    content: string;

    name: string;

    code: SupporterEmailTemplateCode;

    fromNameAlias?: string | null;

    actionId?: string | null;
}

export interface UpdateSupporterEmailTemplateInput {
    supporterEmailTemplateId: string;

    subject: string;

    content: string;

    name: string;

    fromNameAlias?: string | null;
}

export interface DuplicateSupporterEmailTemplateInput {
    supporterEmailTemplateId: string;

    name: string;
}

export interface UpdateSupporterFormInput {
    id: string;

    name: string;

    supporterFormQuestions: SupporterFormQuestionInput[];
}

export interface SupporterFormQuestionInput {
    id?: string | null;

    questionText: string;

    questionType: SupporterFormQuestionType;

    isMandatory: boolean;

    position: number;

    options?: SupporterFormOptionInput[] | null;

    questionIntegrationType: SupporterFormQuestionIntegrationType;

    ngpSurveyQuestionId?: number | null;
}

export interface SupporterFormOptionInput {
    id?: string | null;

    optionText: string;

    position: number;

    optionType?: SupporterFormOptionType | null;

    ngpSurveyResponseId?: number | null;

    linkedNgpActivistCode?: NgpActivistCodeInput | null;

    assignedGroupId?: string | null;
}

export interface CreateSupporterFormInput {
    outreachCircleId: string;

    name: string;

    supporterFormIntegrationType?: SupporterFormIntegrationType | null;
}

export interface SubmitSupporterFormQuestionResponseInput {
    supporterId: string;

    actionId: string;

    supporterFormQuestionId: string;

    responses: SupporterFormResponseInput[];
}

export interface SupporterFormResponseInput {
    supporterFormOptionId: string;

    response?: FormResponse | null;
}

export interface SupporterFormActionInput {
    actionId: string;

    supporterFormId: string;
}

export interface DuplicateSupporterFormInput {
    supporterFormId: string;

    name: string;
}

export interface CreateSupporterPushNotificationTemplateInput {
    actionId: string;

    code: SupporterPushNotificationTemplateCode;

    title: string;

    body: string;
}

export interface UpdateSupporterPushNotificationTemplateInput {
    supporterPushNotificationTemplateId: string;

    title: string;

    body: string;
}

export interface CreateSupporterViewFilterStateInput {
    outreachCircleId: string;

    name: string;

    state: SupporterViewFilterStateInput;
}

export interface SupporterViewFilterStateInput {
    actionTakenFilter?: SupporterActionTakenFilterInput | null;

    supporterJoinedDateFilter?: SupporterJoinedFilterInput | null;

    actionFilter?: SupporterActionFilterInput | null;

    groupFilter?: SupporterGroupFilterInput | null;

    appNotificationFilter?: SupporterAppNotificationFilterInput | null;

    aliasFilter?: SupporterAliasFilterInput | null;

    supporterStatusFilter?: SupporterStatusFilterInput | null;

    lastEmailStatusFilter?: SupporterLastEmailStatusFilterInput | null;

    supporterEmailSubscriptionFilter?: SupporterEmailSubscriptionFilterInput | null;
}

export interface UpdateSupporterViewFilterStateInput {
    filterId: string;

    name: string;

    state: SupporterViewFilterStateInput;
}

export interface SupportOutreachCircleInput {
    outreachCircleId: string;

    origin: Origin;

    sourceAlias: string;

    supporterId?: string | null;

    inviterUserId?: string | null;

    addSupporterToInviterSupporterGroups?: boolean | null;

    queryParams?: Json | null;
}

export interface CreateInvitedSupporterSourceInput {
    outreachCircleId: string;

    supporterEmailTemplateId: string;
}

export interface ImportInvitedSupporterFromFileInput {
    invitedSupporterSourceId: string;

    mapping: Json;

    delimiter?: string | null;

    customFields?: (string | null)[] | null;
}

export interface InviteSupporterInput {
    outreachCircleId: string;

    supporters: CreateSupporterInput[];

    supporterEmailTemplateId: string;

    hasEmailConsent: boolean;

    suppressExistingSupporterException?: boolean | null;
}

export interface CreateSupporterInput {
    email: string;

    externalId?: string | null;

    firstName?: string | null;

    lastName?: string | null;

    addressLine1?: string | null;

    city?: string | null;

    state?: string | null;

    zip?: string | null;

    primaryLanguage?: string | null;

    phone?: string | null;

    customFieldData?: (CreateSupporterCustomFieldDataInput | null)[] | null;
}

export interface CreateSupporterCustomFieldDataInput {
    key?: string | null;

    value?: string | null;
}

export interface UpdateSupporterInput {
    supporterId: string;

    firstName?: string | null;

    lastName?: string | null;

    addressLine1?: string | null;

    externalId?: string | null;

    city?: string | null;

    state?: string | null;

    zip?: string | null;

    primaryLanguage?: string | null;

    phone?: string | null;

    customFieldData?: (CreateSupporterCustomFieldDataInput | null)[] | null;
}

export interface EligibleSupporterForSendingPushNotificationInput {
    notificationTitle: string;

    notificationDescription?: string | null;

    filter: SupporterFilterForPushNotificationInput;
}

export interface TagRecipientInput {
    supporterId: string;

    actionId: string;

    tagId: string;

    memberId?: string | null;

    contactId?: string | null;

    tagResource: TagResourceType;

    tagAction: TagActionType;
}

export interface CreateTagInput {
    name: string;

    outreachCircleId: string;
}

export interface UpdateTagInput {
    id: string;

    name: string;

    integrations?: (TagIntegrationInput | null)[] | null;
}

export interface TagIntegrationInput {
    type: IntegrationType;

    data?: TagIntegrationDataInput | null;
}

export interface TagIntegrationDataInput {
    ngpActivistCodes?: (NgpActivistCodeInput | null)[] | null;

    pdiFlagIds?: (PdiFlagIdInput | null)[] | null;
}

export interface ApplyTagToAffinityTextRecipient {
    memberId: string;

    supporterId: string;

    actionId: string;

    tagId: string;
}

export interface ApplyTagToRelationalTextRecipient {
    contactId: string;

    supporterId: string;

    memberId?: string | null;

    actionId: string;

    tagId: string;
}

export interface ApplyTagToAmbiguousTextRecipient {
    contactId: string;

    supporterId: string;

    memberId: string;

    actionId: string;

    tagId: string;
}

export interface ActionTagLinkInput {
    actionId: string;

    tagId: string;

    cannedResponseText?: string | null;

    cannedResponseId?: string | null;
}

export interface CannedResponseInput {
    response?: string | null;

    tagId: string;

    actionId: string;
}

export interface CreateTextTemplateInput {
    name: string;

    content?: string | null;

    outreachCircleId: string;

    actionId: string;
}

export interface UpdateTextTemplateInput {
    id: string;

    name: string;

    content: string;

    actionId: string;
}

export interface UpdateTextTemplateForSupporterInput {
    id: string;

    content: string;

    supporterId: string;

    actionId: string;
}

export interface CreateOrganizationTextTemplateInput {
    name: string;

    content?: string | null;

    organizationId: string;
}

export interface UpdateOrganizationTextTemplateInput {
    id: string;

    name: string;

    content: string;
}

export interface SignupOrLoginInput {
    username: string;

    password: string;
}

export interface RapidOnboardingLoginInput {
    firstName?: string | null;

    lastName?: string | null;

    username: string;

    zip?: string | null;

    phoneNumber?: string | null;

    aliasValue: string;
}

export interface NameInput {
    firstName: string;

    lastName: string;
}

export interface PreferenceInput {
    key: string;

    value: Any;
}

export interface ContactDetailsInput {
    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;

    phoneNumber?: string | null;

    optInForText?: boolean | null;
}

export interface UpdatePasswordInput {
    resetCode: string;

    userId: string;

    password: string;
}

export interface SignupWithDetailsInput {
    firstName: string;

    lastName: string;

    username: string;

    password: string;

    verifyEmail: boolean;
}

export interface SignupWithDetailsFromAdsInput {
    firstName: string;

    lastName: string;

    username: string;

    password: string;
}

export interface VerifyUserWithCardOrCouponInput {
    coupon?: string | null;

    plan?: string | null;

    cardToken?: string | null;
}

export interface EmailVerificationInput {
    verificationCode: string;

    userId: string;
}

export interface UserEmailUnsubscribeInput {
    emailRecipientId: string;

    emailTemplateId: string;
}

export interface PushNotificationTokenInput {
    registrationToken?: string | null;

    additionalDetails: PushNotificationAdditionalDetails;
}

export interface PushNotificationAdditionalDetails {
    deviceId: string;

    deviceType: DeviceTypeEnum;

    mobileAppBundleId?: string | null;
}

export interface UserNameAndContactDetailsInput {
    name: NameInput;

    contact: ContactDetailsInput;

    password?: string | null;
}

export interface SendSupportEmailForLeadFromAdLandingScreenInput {
    userEmail: string;

    adLandingScreen: string;

    adLandingPageLink: string;
}

export interface AmbiguousMappedContactInput {
    contactId: string;

    supporterId: string;
}

export interface AudienceCustomfieldInput {
    audienceId: string;

    name: string;
}

export interface EmailTemplateEngagementInput {
    emailTemplateId: string;

    htmlBody: string;
}

export interface GetDefaultContentForOutreachCircleUserEmailTemplateInput {
    code: OutreachCircleUserEmailTemplateCode;

    organizationId: string;
}

export interface MappedContactInput {
    contactId: string;

    supporterId: string;

    memberId: string;
}

export interface MarkActionAsCompletedInput {
    supporterId: string;

    actionId: string;
}

export interface OnboardOutreachCircleUserInput {
    outreachCircleUserId: string;

    userId: string;
}

export interface PdiAnswerOptionInput {
    id: string;

    flagId: string;

    flagIdDescription?: string | null;

    displayCode?: string | null;
}

export interface PdiQuestionInput {
    id: string;

    organizationName: string;

    question: string;

    questionLabel?: string | null;

    questionDescription?: string | null;

    type?: string | null;

    category?: string | null;

    candidate?: string | null;

    default?: boolean | null;
}

export interface PresignedBroadcastTextingScriptMediaUploadRequestInput {
    outreachCircleId: string;

    media?: P2PScriptMediaInputType[] | null;
}

export interface UpdateOutreachCircleIntroductionInput {
    introduction: string;

    outreachCircleId: string;
}

export interface UpdateTextTemplateWithRecruitmentLinkInput {
    textTemplateId: string;

    content: string;

    linkText: string;
}

export enum OutreachChannel {
    EMAIL = 'EMAIL',
    TEXT = 'TEXT',
    SOCIAL = 'SOCIAL',
    CALL = 'CALL',
    VISIT = 'VISIT',
}

export enum SupporterStatus {
    Yes = 'Yes',
    No = 'No',
    Blocked = 'Blocked',
    Invited = 'Invited',
}

export enum LastEmailStatus {
    Opened = 'Opened',
    Delivered = 'Delivered',
    Bounced = 'Bounced',
    Sent = 'Sent',
    Unsubscribed = 'Unsubscribed',
}

export enum ContactEmailTypeEnum {
    WORK = 'WORK',
    HOME = 'HOME',
    OTHER = 'OTHER',
}

export enum ContactMobileTypeEnum {
    WORK = 'WORK',
    HOME = 'HOME',
    MOBILE = 'MOBILE',
    OTHER = 'OTHER',
}

export enum ActionStatus {
    INACTIVE = 'INACTIVE',
    READY = 'READY',
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    INCOMPLETE = 'INCOMPLETE',
    TERMINATED = 'TERMINATED',
}

export enum ActionType {
    FACEBOOK_SOCIAL_SHARE = 'FACEBOOK_SOCIAL_SHARE',
    FACEBOOK_EVENT_SHARE = 'FACEBOOK_EVENT_SHARE',
    SEND_UPDATE = 'SEND_UPDATE',
    EMAIL = 'EMAIL',
    ATTENDANCE_CHECKIN = 'ATTENDANCE_CHECKIN',
    DONATION = 'DONATION',
    TASK = 'TASK',
    PETITION = 'PETITION',
    EVENT = 'EVENT',
    REDIRECT_LINK = 'REDIRECT_LINK',
    WATCH_VIDEO = 'WATCH_VIDEO',
    SURVEY = 'SURVEY',
    AFFINITY_TEXTING = 'AFFINITY_TEXTING',
    TEXT_SUPPORTER_TASK = 'TEXT_SUPPORTER_TASK',
    PHONE_2_ACTION_FORM = 'PHONE_2_ACTION_FORM',
    EVERY_ACTION_FORM = 'EVERY_ACTION_FORM',
    SUPPORTER_FORM = 'SUPPORTER_FORM',
    P2P_TEXTING = 'P2P_TEXTING',
    SEARCH_AND_SURVEY = 'SEARCH_AND_SURVEY',
    GRASS_ROOT_ORGANIZING = 'GRASS_ROOT_ORGANIZING',
    GRASS_ROOT_ORGANIZING_RELATIONAL = 'GRASS_ROOT_ORGANIZING_RELATIONAL',
    ADDRESS_BASED_CANVASSING = 'ADDRESS_BASED_CANVASSING',
    PDI_ON_THE_GO_CANVASSING = 'PDI_ON_THE_GO_CANVASSING',
    CLICK_TO_CONNECT = 'CLICK_TO_CONNECT',
    BROADCAST_TEXTING = 'BROADCAST_TEXTING',
}

export enum AllowedIntegrationDatabaseType {
    OUTREACH_CIRCLE = 'OUTREACH_CIRCLE',
    NGP_MY_VOTER = 'NGP_MY_VOTER',
    NGP_MY_CAMPAIGN = 'NGP_MY_CAMPAIGN',
    PDI = 'PDI',
    SALESFORCE = 'SALESFORCE',
}

export enum P2PPauseReason {
    ACCOUNT_SUSPENDED = 'ACCOUNT_SUSPENDED',
    MESSAGE_FILTERED = 'MESSAGE_FILTERED',
    US_A2P_10DLC_RATE_LIMIT_EXCEEDED = 'US_A2P_10DLC_RATE_LIMIT_EXCEEDED',
    US_A2P_10DLC_DAILY_MESSAGE_CAP_REACHED = 'US_A2P_10DLC_DAILY_MESSAGE_CAP_REACHED',
    UNABLE_TO_BUY_NUMBER = 'UNABLE_TO_BUY_NUMBER',
    USE_CASE_REGISTRATION_FAILED = 'USE_CASE_REGISTRATION_FAILED',
    USE_CASE_REGISTRATION_IN_PROGRESS = 'USE_CASE_REGISTRATION_IN_PROGRESS',
    US_A2P_10DLC_INVALID_TAG_DATA = 'US_A2P_10DLC_INVALID_TAG_DATA',
    ACCOUNT_BLOCKED_BY_SPECIFIC_CARRIER = 'ACCOUNT_BLOCKED_BY_SPECIFIC_CARRIER',
    CONSECUTIVE_ERRORS = 'CONSECUTIVE_ERRORS',
}

export enum TurfingStrategyEnum {
    ZIP_CODE = 'ZIP_CODE',
    GEO_RADIUS = 'GEO_RADIUS',
    MANUAL = 'MANUAL',
    SUPPORTER_ID = 'SUPPORTER_ID',
    SUPPORTER_EMAIL = 'SUPPORTER_EMAIL',
}

export enum AudienceActionDatabase {
    VOTER = 'VOTER',
    VOLUNTEER = 'VOLUNTEER',
}

export enum AudienceActionSource {
    NGP = 'NGP',
    PDI = 'PDI',
    CATALYST = 'CATALYST',
    TARGET_SMART = 'TARGET_SMART',
    BLACKBAUD = 'BLACKBAUD',
    NATION_BUILDER = 'NATION_BUILDER',
    SALESFORCE = 'SALESFORCE',
    OTHER = 'OTHER',
}

export enum IntegrationType {
    EVERY_ACTION_GHOST_FORM = 'EVERY_ACTION_GHOST_FORM',
    BLACKBAUD = 'BLACKBAUD',
    NGP_MY_CAMPAIGN = 'NGP_MY_CAMPAIGN',
    NGP_MY_VOTER = 'NGP_MY_VOTER',
    NATION_BUILDER = 'NATION_BUILDER',
    FACEBOOK_PIXEL = 'FACEBOOK_PIXEL',
    EVERY_ACTION = 'EVERY_ACTION',
    PHONE_2_ACTION = 'PHONE_2_ACTION',
    OUTREACH_CIRCLE = 'OUTREACH_CIRCLE',
    PDI = 'PDI',
    TCR = 'TCR',
    BLUELINK = 'BLUELINK',
    SALESFORCE = 'SALESFORCE',
    GOOGLE_BIGQUERY = 'GOOGLE_BIGQUERY',
}

export enum AudienceActionTransaction {
    ADD = 'ADD',
    DELETE = 'DELETE',
    UPDATE = 'UPDATE',
}

export enum AudienceActionFormat {
    FILE_UPLOAD = 'FILE_UPLOAD',
    API = 'API',
}

export enum ListType {
    MEMBER_LIST = 'MEMBER_LIST',
    ASSIGNED_CONTACT_LIST = 'ASSIGNED_CONTACT_LIST',
    P2P_CONTACT_LIST = 'P2P_CONTACT_LIST',
    SEARCH_AND_SURVEY_LIST = 'SEARCH_AND_SURVEY_LIST',
    ADDRESS_BASED_CANVASSING_LIST = 'ADDRESS_BASED_CANVASSING_LIST',
    SALESFORCE_LIST = 'SALESFORCE_LIST',
    BROADCAST_TEXTING_LIST = 'BROADCAST_TEXTING_LIST',
}

export enum Frequency {
    ONCE = 'ONCE',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
}

export enum SupporterFormQuestionType {
    SINGLE_CHOICE = 'SINGLE_CHOICE',
    MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
    CONTACT_INFO = 'CONTACT_INFO',
    TEXT = 'TEXT',
    SINGLE_CHOICE_GROUP_ASSIGNMENT = 'SINGLE_CHOICE_GROUP_ASSIGNMENT',
    MULTIPLE_CHOICE_GROUP_ASSIGNMENT = 'MULTIPLE_CHOICE_GROUP_ASSIGNMENT',
}

export enum SupporterFormOptionType {
    CHOICE = 'CHOICE',
    CONTACT_EMAIL_ADDRESS = 'CONTACT_EMAIL_ADDRESS',
    CONTACT_PHONE_NUMBER = 'CONTACT_PHONE_NUMBER',
    CONTACT_ADDRESS = 'CONTACT_ADDRESS',
    TEXT = 'TEXT',
}

export enum SupporterFormQuestionIntegrationType {
    VAN_SURVEY_QUESTION = 'VAN_SURVEY_QUESTION',
    OUTREACHCIRCLE = 'OUTREACHCIRCLE',
    VAN_ACTIVIST_CODES = 'VAN_ACTIVIST_CODES',
}

export enum SupporterFormIntegrationType {
    OUTREACH_CIRCLE = 'OUTREACH_CIRCLE',
    NGP_MY_CAMPAIGN = 'NGP_MY_CAMPAIGN',
}

export enum P2PMessagingServiceArchitecture {
    ISV1 = 'ISV1',
    ISV3 = 'ISV3',
}

export enum TagType {
    CUSTOM = 'CUSTOM',
    DISPOSITION = 'DISPOSITION',
}

export enum EngagementType {
    SURVEY = 'SURVEY',
    VOLUNTEER_ACTION = 'VOLUNTEER_ACTION',
    EXTERNAL_LINK = 'EXTERNAL_LINK',
    RECRUITMENT_LINK = 'RECRUITMENT_LINK',
    THANK_YOU = 'THANK_YOU',
}

export enum EngagementOptionType {
    CHOICE = 'CHOICE',
    CONTACT_EMAIL_ADDRESS = 'CONTACT_EMAIL_ADDRESS',
    CONTACT_PHONE_NUMBER = 'CONTACT_PHONE_NUMBER',
    CONTACT_ADDRESS = 'CONTACT_ADDRESS',
    TEXT = 'TEXT',
}

export enum EngagementQuestionType {
    VAN_SURVEY_QUESTION = 'VAN_SURVEY_QUESTION',
    OUTREACHCIRCLE = 'OUTREACHCIRCLE',
    VAN_ACTIVIST_CODES = 'VAN_ACTIVIST_CODES',
    PDI_QUESTION = 'PDI_QUESTION',
    CONTACT_INFO = 'CONTACT_INFO',
    TEXT = 'TEXT',
}

export enum P2PScriptSurveyQuestionType {
    VAN_SURVEY_QUESTION = 'VAN_SURVEY_QUESTION',
    OUTREACHCIRCLE = 'OUTREACHCIRCLE',
    VAN_ACTIVIST_CODES = 'VAN_ACTIVIST_CODES',
    PDI_QUESTION = 'PDI_QUESTION',
}

export enum P2PScriptType {
    INITIAL = 'INITIAL',
    ALTERNATE_RESPONSE = 'ALTERNATE_RESPONSE',
    CANNED_RESPONSE = 'CANNED_RESPONSE',
}

export enum SearchAndSurveyFormQuestionType {
    SINGLE_CHOICE = 'SINGLE_CHOICE',
    MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
    CONTACT_INFO = 'CONTACT_INFO',
    TEXT = 'TEXT',
}

export enum SearchAndSurveyFormOptionType {
    CHOICE = 'CHOICE',
    CONTACT_EMAIL_ADDRESS = 'CONTACT_EMAIL_ADDRESS',
    CONTACT_PHONE_NUMBER = 'CONTACT_PHONE_NUMBER',
    CONTACT_ADDRESS = 'CONTACT_ADDRESS',
    TEXT = 'TEXT',
}

export enum SearchAndSurveyFormQuestionIntegrationType {
    VAN_SURVEY_QUESTION = 'VAN_SURVEY_QUESTION',
    OUTREACH_CIRCLE = 'OUTREACH_CIRCLE',
    VAN_ACTIVIST_CODES = 'VAN_ACTIVIST_CODES',
    PDI_QUESTION = 'PDI_QUESTION',
}

export enum SearchAndSurveyFormIntegrationType {
    OUTREACH_CIRCLE = 'OUTREACH_CIRCLE',
    NGP_MY_CAMPAIGN = 'NGP_MY_CAMPAIGN',
    NGP_MY_VOTER = 'NGP_MY_VOTER',
    PDI = 'PDI',
}

export enum GroSurveyFormQuestionType {
    SINGLE_CHOICE = 'SINGLE_CHOICE',
    MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
    CONTACT_INFO = 'CONTACT_INFO',
    TEXT = 'TEXT',
}

export enum GroSurveyFormOptionType {
    CHOICE = 'CHOICE',
    CONTACT_EMAIL_ADDRESS = 'CONTACT_EMAIL_ADDRESS',
    CONTACT_PHONE_NUMBER = 'CONTACT_PHONE_NUMBER',
    CONTACT_ADDRESS = 'CONTACT_ADDRESS',
    TEXT = 'TEXT',
}

export enum GroSurveyFormQuestionIntegrationType {
    OUTREACH_CIRCLE = 'OUTREACH_CIRCLE',
    PDI_QUESTION = 'PDI_QUESTION',
    VAN_SURVEY_QUESTION = 'VAN_SURVEY_QUESTION',
    VAN_ACTIVIST_CODES = 'VAN_ACTIVIST_CODES',
}

export enum GroSurveyFormIntegrationType {
    OUTREACH_CIRCLE = 'OUTREACH_CIRCLE',
    PDI = 'PDI',
    NGP_MY_CAMPAIGN = 'NGP_MY_CAMPAIGN',
    NGP_MY_VOTER = 'NGP_MY_VOTER',
}

export enum SupporterPushNotificationTemplateCode {
    SUPPORTER_NOTIFY_ON_ACTION_LIVE_PN = 'SUPPORTER_NOTIFY_ON_ACTION_LIVE_PN',
    SUPPORTER_REMINDER_FOR_ACTION_PN = 'SUPPORTER_REMINDER_FOR_ACTION_PN',
}

export enum SupporterEmailTemplateCode {
    SUPPORTER_WELCOME = 'SUPPORTER_WELCOME',
    SUPPORTER_NOTIFY_ON_ACTION_LIVE = 'SUPPORTER_NOTIFY_ON_ACTION_LIVE',
    SUPPORTER_REMINDER_FOR_ACTION = 'SUPPORTER_REMINDER_FOR_ACTION',
    INVITE_OUTREACH_CIRCLE_CONTACTS_TO_JOIN_AS_SUPPORTER = 'INVITE_OUTREACH_CIRCLE_CONTACTS_TO_JOIN_AS_SUPPORTER',
    THANK_YOU_ON_COMPLETE_FIRST_ACTION_SUPPORTER_EMAIL = 'THANK_YOU_ON_COMPLETE_FIRST_ACTION_SUPPORTER_EMAIL',
    SUPPORTER_EMAIL_NOTIFICATION = 'SUPPORTER_EMAIL_NOTIFICATION',
}

export enum PurchasedPhoneNumberStatus {
    ACTIVE = 'ACTIVE',
    ACTIVATING = 'ACTIVATING',
    INACTIVE = 'INACTIVE',
}

export enum LanguagePreferenceType {
    EN = 'EN',
    ES = 'ES',
    FR = 'FR',
}

export enum ActionsSortBy {
    Name = 'Name',
    Position = 'Position',
    Updated = 'Updated',
    Created = 'Created',
}

export enum AssignedSupportersSortBy {
    supporterName = 'supporterName',
    textsSent = 'textsSent',
    pendingReplies = 'pendingReplies',
    emailsSent = 'emailsSent',
    currentSupporter = 'currentSupporter',
    canvassedCount = 'canvassedCount',
    callCount = 'callCount',
    visitCount = 'visitCount',
    assignedContactsCount = 'assignedContactsCount',
    groEmailsSent = 'groEmailsSent',
    groTextsSent = 'groTextsSent',
}

export enum AssignedGroupsToActionSortBy {
    groupName = 'groupName',
    actionsTakenCount = 'actionsTakenCount',
    emailsSentCount = 'emailsSentCount',
    textsSentCount = 'textsSentCount',
}

export enum AddressBasedCanvassStatus {
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
}

export enum BroadcastTextingStatus {
    Ready = 'Ready',
    Sending = 'Sending',
    Aborted = 'Aborted',
    Completed = 'Completed',
    Paused = 'Paused',
}

export enum ContactSourcePlatform {
    web = 'web',
    android = 'android',
    ios = 'ios',
}

export enum DuplicateStatus {
    RESOLVED = 'RESOLVED',
    REJECTED = 'REJECTED',
    PENDING = 'PENDING',
}

export enum Origin {
    ORGANIC = 'ORGANIC',
    OUTREACH = 'OUTREACH',
    INVITED = 'INVITED',
    Phone2Action = 'Phone2Action',
    WEBSITE_EMBED = 'WEBSITE_EMBED',
}

export enum MatchingJobStatusEnum {
    MATCHING_JOB_NOT_STARTED = 'MATCHING_JOB_NOT_STARTED',
    MATCHING_JOB_IN_PROGRESS = 'MATCHING_JOB_IN_PROGRESS',
    MATCHING_JOB_FAILED = 'MATCHING_JOB_FAILED',
    MATCHING_JOB_SUCCESSFUL = 'MATCHING_JOB_SUCCESSFUL',
}

export enum SurveySortBy {
    Name = 'Name',
    Responses = 'Responses',
    Created = 'Created',
}

export enum GroupsSortBy {
    Name = 'Name',
    Updated = 'Updated',
}

export enum NgpIntegrationType {
    NGP_MY_CAMPAIGN = 'NGP_MY_CAMPAIGN',
    NGP_MY_VOTER = 'NGP_MY_VOTER',
}

export enum TcrBrandOrganizationType {
    NON_PROFIT = 'NON_PROFIT',
    PUBLIC_PROFIT = 'PUBLIC_PROFIT',
    PRIVATE_PROFIT = 'PRIVATE_PROFIT',
    GOVERNMENT = 'GOVERNMENT',
    SOLE_PROPRIETOR = 'SOLE_PROPRIETOR',
}

export enum TcrBrandVertical {
    POLITICAL = 'POLITICAL',
    NGO = 'NGO',
    GOVERNMENT = 'GOVERNMENT',
}

export enum TcrBrandIdentityStatus {
    SELF_DECLARED = 'SELF_DECLARED',
    UNVERIFIED = 'UNVERIFIED',
    VERIFIED = 'VERIFIED',
    VETTED_VERIFIED = 'VETTED_VERIFIED',
}

export enum TcrVettingStatus {
    PENDING = 'PENDING',
    UNSCORE = 'UNSCORE',
    ACTIVE = 'ACTIVE',
    FAILED = 'FAILED',
    EXPIRED = 'EXPIRED',
}

export enum TcrCampaignStatus {
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED',
}

export enum TcrCampaignUsecase {
    ACCOUNT_NOTIFICATION = 'ACCOUNT_NOTIFICATION',
    AGENTS_FRANCHISES = 'AGENTS_FRANCHISES',
    CARRIER_EXEMPT = 'CARRIER_EXEMPT',
    CHARITY = 'CHARITY',
    CUSTOMER_CARE = 'CUSTOMER_CARE',
    DELIVERY_NOTIFICATION = 'DELIVERY_NOTIFICATION',
    EMERGENCY = 'EMERGENCY',
    FRAUD_ALERT = 'FRAUD_ALERT',
    HIGHER_EDUCATION = 'HIGHER_EDUCATION',
    K12_EDUCATION = 'K12_EDUCATION',
    LOW_VOLUME = 'LOW_VOLUME',
    MARKETING = 'MARKETING',
    MIXED = 'MIXED',
    POLITICAL = 'POLITICAL',
    POLLING_VOTING = 'POLLING_VOTING',
    PROXY = 'PROXY',
    PUBLIC_SERVICE_ANNOUNCEMENT = 'PUBLIC_SERVICE_ANNOUNCEMENT',
    SECURITY_ALERT = 'SECURITY_ALERT',
    SOCIAL = 'SOCIAL',
    SOLE_PROPRIETOR = 'SOLE_PROPRIETOR',
    SWEEPSTAKE = 'SWEEPSTAKE',
    TRIAL = 'TRIAL',
    UCAAS_HIGH = 'UCAAS_HIGH',
    UCAAS_LOW = 'UCAAS_LOW',
}

export enum DeviceTypeEnum {
    DESKTOP = 'DESKTOP',
    MOBILE_WEB = 'MOBILE_WEB',
    IOS_NATIVE = 'IOS_NATIVE',
    ANDROID_NATIVE = 'ANDROID_NATIVE',
}

export enum OrganizationActionStatus {
    UNPUBLISHED = 'UNPUBLISHED',
    PUBLISHED = 'PUBLISHED',
    TERMINATED = 'TERMINATED',
}

export enum OutreachCircleSortBy {
    Created = 'Created',
    Name = 'Name',
}

export enum OutreachCircleUserEmailTemplateCode {
    OC_ADMIN_NOTIFY_FOR_ORGANIZATION_ACTION = 'OC_ADMIN_NOTIFY_FOR_ORGANIZATION_ACTION',
    OC_ADMIN_NOTIFICATION = 'OC_ADMIN_NOTIFICATION',
}

export enum SubscriptionStatus {
    incomplete = 'incomplete',
    incomplete_expired = 'incomplete_expired',
    trialing = 'trialing',
    active = 'active',
    past_due = 'past_due',
    canceled = 'canceled',
    unpaid = 'unpaid',
}

export enum P2PConversationLogSentBy {
    SUPPORTER = 'SUPPORTER',
    RECIPIENT = 'RECIPIENT',
}

export enum ReportType {
    RELATIONAL = 'RELATIONAL',
    PEER_TO_PEER = 'PEER_TO_PEER',
    ORGANIZATION = 'ORGANIZATION',
}

export enum ReportCode {
    supporter_report = 'supporter_report',
    email_performance_report = 'email_performance_report',
    action_report = 'action_report',
    survey_response_report = 'survey_response_report',
    texting_report = 'texting_report',
    email_messages_to_supporters = 'email_messages_to_supporters',
    supporter_form_report = 'supporter_form_report',
    campaign_report = 'campaign_report',
    tag_report = 'tag_report',
    p2p_message_log_report = 'p2p_message_log_report',
    p2p_recipient_summary_report = 'p2p_recipient_summary_report',
    p2p_action_summary_report = 'p2p_action_summary_report',
    p2p_survey_response_report = 'p2p_survey_response_report',
    p2p_tag_report = 'p2p_tag_report',
    canvassing_person_report = 'canvassing_person_report',
    canvass_survey_response_report = 'canvass_survey_response_report',
    admin_report = 'admin_report',
    action_tag_report = 'action_tag_report',
    weekly_app_statistics = 'weekly_app_statistics',
    achievement_report_by_supporter = 'achievement_report_by_supporter',
    response_report_by_person = 'response_report_by_person',
    a1c_members_assignment_report = 'a1c_members_assignment_report',
    network_report = 'network_report',
}

export enum SupporterFormSortBy {
    Name = 'Name',
    Responses = 'Responses',
    Created = 'Created',
}

export enum SupporterSummarySortBy {
    FullName = 'FullName',
    Email = 'Email',
    PhoneNumber = 'PhoneNumber',
    ZipCode = 'ZipCode',
    JoinLink = 'JoinLink',
    Location = 'Location',
    Origin = 'Origin',
    InvitedOn = 'InvitedOn',
    JoinedOn = 'JoinedOn',
    TotalActionCompleted = 'TotalActionCompleted',
    TotalActionInProgress = 'TotalActionInProgress',
    TotalUniqueContactsInvited = 'TotalUniqueContactsInvited',
    TotalUniqueContactsJoined = 'TotalUniqueContactsJoined',
}

export enum SupporterViewSortBy {
    FullName = 'FullName',
    ActionsCompleted = 'ActionsCompleted',
    Email = 'Email',
    Source = 'Source',
    JoinedOn = 'JoinedOn',
    PhoneNumber = 'PhoneNumber',
    Zip = 'Zip',
    Location = 'Location',
    MessagesSentBySupporter = 'MessagesSentBySupporter',
    RecruitmentLink = 'RecruitmentLink',
    StatusOfLastEmailSentToSupporter = 'StatusOfLastEmailSentToSupporter',
    Groups = 'Groups',
    RecruitedBy = 'RecruitedBy',
    CurrentSupporter = 'CurrentSupporter',
}

export enum ReviewWarningKey {
    emailTemplate = 'emailTemplate',
    textTemplate = 'textTemplate',
    socialTextTemplate = 'socialTextTemplate',
}

export enum SearchAndSurveyDisplayType {
    SEARCH = 'SEARCH',
    SURVEY = 'SURVEY',
}

export enum AudienceActionOperation {
    ENABLE = 'ENABLE',
    DISABLE = 'DISABLE',
}

export enum OrganizationActionType {
    FACEBOOK_SOCIAL_SHARE = 'FACEBOOK_SOCIAL_SHARE',
    SEND_UPDATE = 'SEND_UPDATE',
    EMAIL = 'EMAIL',
    ATTENDANCE_CHECKIN = 'ATTENDANCE_CHECKIN',
    DONATION = 'DONATION',
    TASK = 'TASK',
    PETITION = 'PETITION',
    EVENT = 'EVENT',
    REDIRECT_LINK = 'REDIRECT_LINK',
    WATCH_VIDEO = 'WATCH_VIDEO',
}

export enum OrganizationUserUiPreferences {
    HideSectionForHiddenAndTerminatedActions = 'HideSectionForHiddenAndTerminatedActions',
}

export enum TagResourceType {
    MatchedTextRecipient = 'MatchedTextRecipient',
    MatchedEmailRecipient = 'MatchedEmailRecipient',
    AmbiguousTextRecipient = 'AmbiguousTextRecipient',
    AmbiguousEmailRecipient = 'AmbiguousEmailRecipient',
    NVFMTextRecipient = 'NVFMTextRecipient',
    NVFMEmailRecipient = 'NVFMEmailRecipient',
    AffinityTextingRecipient = 'AffinityTextingRecipient',
    P2PRecipient = 'P2PRecipient',
}

export enum TagActionType {
    TAG = 'TAG',
    UNTAG = 'UNTAG',
}

export enum ActionUpdateUseCase {
    TURFING_IN_PROGRESS = 'TURFING_IN_PROGRESS',
    TURFING_COMPLETE = 'TURFING_COMPLETE',
    P2P_LIST_PROGRESS = 'P2P_LIST_PROGRESS',
    EMAIL_TEMPLATE_UPDATED = 'EMAIL_TEMPLATE_UPDATED',
    TEXT_TEMPLATE_UPDATED = 'TEXT_TEMPLATE_UPDATED',
}

export enum PublicActionUpdateUseCase {
    HOUSE_HOLD_CANVASSING_COMPLETED = 'HOUSE_HOLD_CANVASSING_COMPLETED',
    HOUSE_HOLD_CANVASSING_STARTED = 'HOUSE_HOLD_CANVASSING_STARTED',
    MEMBER_CANVASS_IN_PROGRESS = 'MEMBER_CANVASS_IN_PROGRESS',
    MEMBER_CANVASS_COMPLETED = 'MEMBER_CANVASS_COMPLETED',
}

export enum AudienceImportStatusEvent {
    IMPORT_STARTED = 'IMPORT_STARTED',
    IMPORT_COMPLETED = 'IMPORT_COMPLETED',
    IMPORT_FAILED = 'IMPORT_FAILED',
}

export enum TcrEntityType {
    BRAND_UPDATED = 'BRAND_UPDATED',
    VETTING_UPDATED = 'VETTING_UPDATED',
    CAMPAIGN_UPDATED = 'CAMPAIGN_UPDATED',
}
/** NOT_STARTED - on integration creationBRAND_REGISTRATION_IN_PROGRESS - on submission of brand registration formBRAND_VERIFIED - on receiving BRAND_ADD status from webhookBRAND_ERROR - on any error/failure state related to brandVETTING_IN_PROGRESS - on manually/automatic triggering of vettingVETTING_VERIFIED - on receiving VETTED_VERIFIED/VERIFIED status from webhookVETTING_ERROR - on any error/failure state related to vettingCAMPAIGN_REGISTRATION_IN_PROGRESS - on submission of campaign registration formCAMPAIGN_SHARED_WITH_TEXTING_PROVIDER - on receiving CAMPAIGN_ADD status fromwebhook and sharing campaign with texting providerCAMPAIGN_DCA_IN_PROGRESS - after texting provider has verified campaign and campaign has been shared with DCACAMPAIGN_READY_TO_USE - on receiving approval from DCACAMPAIGN_ERROR - on any error/failure state related to campaign */
export enum TcrCurrentStatus {
    NOT_STARTED = 'NOT_STARTED',
    BRAND_REGISTRATION_IN_PROGRESS = 'BRAND_REGISTRATION_IN_PROGRESS',
    BRAND_VERIFIED = 'BRAND_VERIFIED',
    BRAND_ERROR = 'BRAND_ERROR',
    VETTING_IN_PROGRESS = 'VETTING_IN_PROGRESS',
    VETTING_VERIFIED = 'VETTING_VERIFIED',
    VETTING_ERROR = 'VETTING_ERROR',
    CAMPAIGN_REGISTRATION_IN_PROGRESS = 'CAMPAIGN_REGISTRATION_IN_PROGRESS',
    CAMPAIGN_SHARED_WITH_TEXTING_PROVIDER = 'CAMPAIGN_SHARED_WITH_TEXTING_PROVIDER',
    CAMPAIGN_DCA_IN_PROGRESS = 'CAMPAIGN_DCA_IN_PROGRESS',
    CAMPAIGN_READY_TO_USE = 'CAMPAIGN_READY_TO_USE',
    CAMPAIGN_ERROR = 'CAMPAIGN_ERROR',
}

export enum OutreachCircleUpdateResponseType {
    PLAN_UPDATED = 'PLAN_UPDATED',
    ADMIN_CHANGES = 'ADMIN_CHANGES',
}

export enum SupporterSubscriptionResponseEvent {
    MATCHING_JOB_STARTED = 'MATCHING_JOB_STARTED',
    CONTACT_IMPORT_COMPLETED = 'CONTACT_IMPORT_COMPLETED',
    CONTACT_IMPORT_STARTED = 'CONTACT_IMPORT_STARTED',
    MATCHING_JOB_UPDATE = 'MATCHING_JOB_UPDATE',
    NEW_P2P_MESSAGE = 'NEW_P2P_MESSAGE',
    P2P_CONVERSATION_MARKED_AS_READ = 'P2P_CONVERSATION_MARKED_AS_READ',
}

export enum InvitedSupporterImportProgressState {
    ImportStarted = 'ImportStarted',
    CleaningCompleted = 'CleaningCompleted',
    MergingDuplicateContactsCompleted = 'MergingDuplicateContactsCompleted',
    ContactsSaved = 'ContactsSaved',
    ImportCompleted = 'ImportCompleted',
    ImportFailed = 'ImportFailed',
}

export enum ContactSourceType {
    Google = 'Google',
    Apple = 'Apple',
    Yahoo = 'Yahoo',
    Microsoft = 'Microsoft',
    AOL = 'AOL',
    File = 'File',
    Manual = 'Manual',
    Phone = 'Phone',
    PreviouslyTexted = 'PreviouslyTexted',
}

export enum ErrorCodes {
    ACCESS_DENIED = 'ACCESS_DENIED',
    ACTION_ALIAS_DOES_NOT_EXIST = 'ACTION_ALIAS_DOES_NOT_EXIST',
    ACTION_ALLOW_CONTACT_IMPORT_DISABLED = 'ACTION_ALLOW_CONTACT_IMPORT_DISABLED',
    ACTION_ALREADY_ASSIGNED_TO_SUPPORTER = 'ACTION_ALREADY_ASSIGNED_TO_SUPPORTER',
    ACTION_ALREADY_COMPLETED = 'ACTION_ALREADY_COMPLETED',
    ACTION_ALREADY_EXISTS = 'ACTION_ALREADY_EXISTS',
    ACTION_ALREADY_EXPIRED = 'ACTION_ALREADY_EXPIRED',
    ACTION_ASSIGNMENT_ERROR = 'ACTION_ASSIGNMENT_ERROR',
    ACTION_CANNOT_BE_ACTIVATED = 'ACTION_CANNOT_BE_ACTIVATED',
    ACTION_CANNOT_BE_ARCHIVED = 'ACTION_CANNOT_BE_ARCHIVED',
    ACTION_CANNOT_BE_DEACTIVATED = 'ACTION_CANNOT_BE_DEACTIVATED',
    ACTION_CANNOT_BE_EMBEDDED = 'ACTION_CANNOT_BE_EMBEDDED',
    ACTION_CANNOT_BE_LINKED_TO_GROUP = 'ACTION_CANNOT_BE_LINKED_TO_GROUP',
    ACTION_CANNOT_BE_PAUSED = 'ACTION_CANNOT_BE_PAUSED',
    ACTION_CANNOT_BE_UPDATED = 'ACTION_CANNOT_BE_UPDATED',
    ACTION_CANNOT_GO_LIVE = 'ACTION_CANNOT_GO_LIVE',
    ACTION_ENGAGEMENT_AND_AUDIENCE_FILTER_MISMATCH = 'ACTION_ENGAGEMENT_AND_AUDIENCE_FILTER_MISMATCH',
    ACTION_INTEGRATION_TYPE_MISMATCH = 'ACTION_INTEGRATION_TYPE_MISMATCH',
    ACTION_MAXIMUM_CUSTOM_FIELD_LIMIT_REACHED = 'ACTION_MAXIMUM_CUSTOM_FIELD_LIMIT_REACHED',
    ACTION_NOT_ALLOWED = 'ACTION_NOT_ALLOWED',
    ACTION_NOT_ASSIGNED_TO_SUPPORTER = 'ACTION_NOT_ASSIGNED_TO_SUPPORTER',
    ACTION_NOT_AVAILABLE = 'ACTION_NOT_AVAILABLE',
    ACTION_NOT_FOUND = 'ACTION_NOT_FOUND',
    ACTION_NOT_IN_LIVE_OR_PAUSED_STATE = 'ACTION_NOT_IN_LIVE_OR_PAUSED_STATE',
    ACTION_NOT_IN_LIVE_STATE = 'ACTION_NOT_IN_LIVE_STATE',
    ACTION_NOT_IN_READY_STATE = 'ACTION_NOT_IN_READY_STATE',
    ACTION_PARTIALLY_COMPLETED = 'ACTION_PARTIALLY_COMPLETED',
    ACTION_TAG_WITH_SAME_NAME_EXISTS = 'ACTION_TAG_WITH_SAME_NAME_EXISTS',
    ACTION_TEXT_ALREADY_SENT_TO_SUPPORTER = 'ACTION_TEXT_ALREADY_SENT_TO_SUPPORTER',
    ACTION_TREATMENT_IS_MANDATORY = 'ACTION_TREATMENT_IS_MANDATORY',
    ACTION_VIEW_FILTER_STATE_ALREADY_EXIST = 'ACTION_VIEW_FILTER_STATE_ALREADY_EXIST',
    ADD_CARD_FAILED = 'ADD_CARD_FAILED',
    AFFINITY_VOTER_FILE_LIMIT_EXCEEDED = 'AFFINITY_VOTER_FILE_LIMIT_EXCEEDED',
    ALIAS_DOES_NOT_EXIST = 'ALIAS_DOES_NOT_EXIST',
    ALIAS_NAME_ALREADY_EXISTS = 'ALIAS_NAME_ALREADY_EXISTS',
    ALIAS_NOT_ASSOCIATED_TO_OUTREACH_CIRCLE = 'ALIAS_NOT_ASSOCIATED_TO_OUTREACH_CIRCLE',
    ALIAS_NOT_EMBEDDABLE = 'ALIAS_NOT_EMBEDDABLE',
    AMBIGUOUS_MAPPED_CONTACT_NOT_FOUND = 'AMBIGUOUS_MAPPED_CONTACT_NOT_FOUND',
    ARCHIVE_FEEDBACK_TEXT_EXCEEDS_ALLOWED_LENGTH_LIMIT = 'ARCHIVE_FEEDBACK_TEXT_EXCEEDS_ALLOWED_LENGTH_LIMIT',
    ASSIGNMENT_NOT_FOUND = 'ASSIGNMENT_NOT_FOUND',
    AUDIENCE_ACTION_ALREADY_EXISTS = 'AUDIENCE_ACTION_ALREADY_EXISTS',
    AUDIENCE_ACTION_WITH_SAME_NAME_ALREADY_EXISTS = 'AUDIENCE_ACTION_WITH_SAME_NAME_ALREADY_EXISTS',
    AUDIENCE_ALREADY_EXISTS = 'AUDIENCE_ALREADY_EXISTS',
    AUDIENCE_NOT_FOUND = 'AUDIENCE_NOT_FOUND',
    AUDIENCE_VERSION_BLOCKED = 'AUDIENCE_VERSION_BLOCKED',
    BLACKBAUD_ACCESS_TOKEN_EXPIRED = 'BLACKBAUD_ACCESS_TOKEN_EXPIRED',
    BLACKBAUD_INTEGRATION_NOT_FOUND = 'BLACKBAUD_INTEGRATION_NOT_FOUND',
    BLACKBAUD_LIST_DOES_NOT_EXIST = 'BLACKBAUD_LIST_DOES_NOT_EXIST',
    BROADCAST_TEXTING_ACTION_NOT_ENABLED_FOR_OUTREACH_CIRCLE = 'BROADCAST_TEXTING_ACTION_NOT_ENABLED_FOR_OUTREACH_CIRCLE',
    BROADCAST_TEXTING_ALREADY_TRIGGERED = 'BROADCAST_TEXTING_ALREADY_TRIGGERED',
    BROADCAST_TEXTING_DELIVERY_ID_DOES_NOT_EXIST = 'BROADCAST_TEXTING_DELIVERY_ID_DOES_NOT_EXIST',
    BROADCAST_TEXTING_SCRIPT_CANNOT_BE_LINKED = 'BROADCAST_TEXTING_SCRIPT_CANNOT_BE_LINKED',
    BROADCAST_TEXTING_SCRIPT_CANNOT_BE_UNLINKED = 'BROADCAST_TEXTING_SCRIPT_CANNOT_BE_UNLINKED',
    BROADCAST_TEXTING_SCRIPT_NAME_ALREADY_EXISTS = 'BROADCAST_TEXTING_SCRIPT_NAME_ALREADY_EXISTS',
    BROADCAST_TEXTING_SETUP_NOT_COMPLETE = 'BROADCAST_TEXTING_SETUP_NOT_COMPLETE',
    CALL_TEMPLATE_CONTENT_CANNOT_BE_EMPTY = 'CALL_TEMPLATE_CONTENT_CANNOT_BE_EMPTY',
    CALL_TO_ACTION_IN_NON_OUTREACH_MODE = 'CALL_TO_ACTION_IN_NON_OUTREACH_MODE',
    CAMPAIGN_UNSUPPORTED = 'CAMPAIGN_UNSUPPORTED',
    CANDIDATE_ALREADY_EXISTS = 'CANDIDATE_ALREADY_EXISTS',
    CANDIDATE_DOES_NOT_EXIST = 'CANDIDATE_DOES_NOT_EXIST',
    CANDIDATE_IMAGE_ALREADY_EXISTS = 'CANDIDATE_IMAGE_ALREADY_EXISTS',
    CANNED_RESPONSE_NOT_FOUND = 'CANNED_RESPONSE_NOT_FOUND',
    CANNOT_ASSIGN_PHONE_NUMBER_TO_TERMINATED_ACTION = 'CANNOT_ASSIGN_PHONE_NUMBER_TO_TERMINATED_ACTION',
    CANNOT_ASSIGN_SUPPORTERS_AS_ACTION_IS_PART_OF_GROUP = 'CANNOT_ASSIGN_SUPPORTERS_AS_ACTION_IS_PART_OF_GROUP',
    CANNOT_CHANGE_LINKED_AUDIENCE_ACTION = 'CANNOT_CHANGE_LINKED_AUDIENCE_ACTION',
    CANNOT_CHANGE_LIST_DATABASE = 'CANNOT_CHANGE_LIST_DATABASE',
    CANNOT_CREATE_EMPTY_P2P_CONVERSATION_ITEM = 'CANNOT_CREATE_EMPTY_P2P_CONVERSATION_ITEM',
    CANNOT_DELETE_OUTREACH_CIRCLE_USER = 'CANNOT_DELETE_OUTREACH_CIRCLE_USER',
    CANNOT_DISABLE_AUDIENCE_ACTION = 'CANNOT_DISABLE_AUDIENCE_ACTION',
    CANNOT_DISABLE_OUTREACH_MODE = 'CANNOT_DISABLE_OUTREACH_MODE',
    CANNOT_REMOVE_LAST_ORGANIZATION_USER = 'CANNOT_REMOVE_LAST_ORGANIZATION_USER',
    CANNOT_RESEND_INVIT_FOR_E_OUTREACH_CIRCLE_USER = 'CANNOT_RESEND_INVIT_FOR_E_OUTREACH_CIRCLE_USER',
    CANNOT_SEND_P2P_TEXT_MESSAGES_OUTSIDE_THE_ALLOTTED_TIME_PERIOD = 'CANNOT_SEND_P2P_TEXT_MESSAGES_OUTSIDE_THE_ALLOTTED_TIME_PERIOD',
    CANNOT_TOGGLE_ALLOW_NON_MAPPED_CONTACTS = 'CANNOT_TOGGLE_ALLOW_NON_MAPPED_CONTACTS',
    CANNOT_TOGGLE_OUTREACH_MODE = 'CANNOT_TOGGLE_OUTREACH_MODE',
    CANNOT_UNASSIGN_PHONE_NUMBER_FROM_LIVE_ACTION = 'CANNOT_UNASSIGN_PHONE_NUMBER_FROM_LIVE_ACTION',
    CANNOT_UPDATE_ORGANIZATION_USER = 'CANNOT_UPDATE_ORGANIZATION_USER',
    CANNOT_UPDATE_OUTREACH_CIRCLE_USER = 'CANNOT_UPDATE_OUTREACH_CIRCLE_USER',
    CANNOT_UPDATE_START_DATE_FOR_LIVE_ACTION = 'CANNOT_UPDATE_START_DATE_FOR_LIVE_ACTION',
    CANNOT_UPDATE_TAG_DATABASE = 'CANNOT_UPDATE_TAG_DATABASE',
    CANNOT_UPDATE_TAG_NAME = 'CANNOT_UPDATE_TAG_NAME',
    CANT_REMOVE_LAST_OUTREACH_CIRCLE_USER = 'CANT_REMOVE_LAST_OUTREACH_CIRCLE_USER',
    CANT_REMOVE_LOGGED_IN_OUTREACH_CIRCLE_USER = 'CANT_REMOVE_LOGGED_IN_OUTREACH_CIRCLE_USER',
    CARD_ALREADY_EXISTS = 'CARD_ALREADY_EXISTS',
    CONTACT_ALREADY_SUPPORTER = 'CONTACT_ALREADY_SUPPORTER',
    CONTACT_NOT_FOUND = 'CONTACT_NOT_FOUND',
    CONTACT_SOURCE_NOT_FOUND = 'CONTACT_SOURCE_NOT_FOUND',
    CONTACT_WITH_EMAIL_ALREADY_EXISTS = 'CONTACT_WITH_EMAIL_ALREADY_EXISTS',
    CONTACT_WITH_PHONE_NUMBER_ALREADY_EXISTS = 'CONTACT_WITH_PHONE_NUMBER_ALREADY_EXISTS',
    COUPON_HAS_EXPIRED = 'COUPON_HAS_EXPIRED',
    COUPON_NOT_APPLICABLE = 'COUPON_NOT_APPLICABLE',
    CREATE_CUSTOMER_FAILED = 'CREATE_CUSTOMER_FAILED',
    CREATE_SUBSCRIPTION_FAILED = 'CREATE_SUBSCRIPTION_FAILED',
    CV_TOKEN_ALREADY_IN_USE = 'CV_TOKEN_ALREADY_IN_USE',
    DANGLING_QUESTIONS_ARE_NOT_ALLOWED = 'DANGLING_QUESTIONS_ARE_NOT_ALLOWED',
    DATABASE_NOT_UPDATED_FOR_DEFAULT_TAGS = 'DATABASE_NOT_UPDATED_FOR_DEFAULT_TAGS',
    DATE_CANNOT_BE_NULL_FOR_KEY_DATE = 'DATE_CANNOT_BE_NULL_FOR_KEY_DATE',
    DB_INTEGRATION_CANNOT_BE_CHANGED = 'DB_INTEGRATION_CANNOT_BE_CHANGED',
    DEFAULT_ALIAS_CANNOT_BE_LINKED_TO_GROUP = 'DEFAULT_ALIAS_CANNOT_BE_LINKED_TO_GROUP',
    DEFAULT_TAG_CANNOT_BE_DELETED = 'DEFAULT_TAG_CANNOT_BE_DELETED',
    DELETED_ORGANIZATION_USER_CANNOT_ONBOARD_WITH_OLD_INVITE = 'DELETED_ORGANIZATION_USER_CANNOT_ONBOARD_WITH_OLD_INVITE',
    DELETED_OUTREACH_CIRCLE_USER_CANNOT_ONBOARD_WITH_OLD_INVITE = 'DELETED_OUTREACH_CIRCLE_USER_CANNOT_ONBOARD_WITH_OLD_INVITE',
    DUPLICATES_IN_BLOCK_DOMAINS = 'DUPLICATES_IN_BLOCK_DOMAINS',
    EMAIL_OR_PHONE_IS_MANDATORY = 'EMAIL_OR_PHONE_IS_MANDATORY',
    EMAIL_OUTREACH_CHANNEL_NOT_FOUND = 'EMAIL_OUTREACH_CHANNEL_NOT_FOUND',
    EMAIL_RECIPIENT_NOT_FOUND = 'EMAIL_RECIPIENT_NOT_FOUND',
    EMAIL_TEMPLATE_IN_ARCHIVED_STATE = 'EMAIL_TEMPLATE_IN_ARCHIVED_STATE',
    EMAIL_TEMPLATE_NAME_CANNOT_BE_EMPTY = 'EMAIL_TEMPLATE_NAME_CANNOT_BE_EMPTY',
    EMAIL_TEMPLATE_NOT_FOUND = 'EMAIL_TEMPLATE_NOT_FOUND',
    EMAIL_TEMPLATE_NOT_IN_READY_STATE = 'EMAIL_TEMPLATE_NOT_IN_READY_STATE',
    EMAIL_TEMPLATE_NOT_LINKED = 'EMAIL_TEMPLATE_NOT_LINKED',
    EMAIL_TEMPLATE_WITH_SAME_ACTION_AND_CODE_EXISTS = 'EMAIL_TEMPLATE_WITH_SAME_ACTION_AND_CODE_EXISTS',
    EMAIL_TEMPLATE_WITH_SAME_NAME_EXISTS = 'EMAIL_TEMPLATE_WITH_SAME_NAME_EXISTS',
    END_DATE_BEFORE_START_DATE = 'END_DATE_BEFORE_START_DATE',
    ENGAGEMENT_NAME_ALREADY_EXIST = 'ENGAGEMENT_NAME_ALREADY_EXIST',
    ENGAGEMENT_NOT_FOUND = 'ENGAGEMENT_NOT_FOUND',
    ENGAGEMENT_OPTION_NOT_FOUND = 'ENGAGEMENT_OPTION_NOT_FOUND',
    ENGAGEMENT_QUESTION_NOT_FOUND = 'ENGAGEMENT_QUESTION_NOT_FOUND',
    ERROR_ALLOWING_ACCESS_TO_ORGANIZATION = 'ERROR_ALLOWING_ACCESS_TO_ORGANIZATION',
    ERROR_SAVING_SURVEY_QUESTION_RESPONSE = 'ERROR_SAVING_SURVEY_QUESTION_RESPONSE',
    EXPIRED_ACTION_CANNOT_BE_LINKED_TO_GROUP = 'EXPIRED_ACTION_CANNOT_BE_LINKED_TO_GROUP',
    FAILED_TO_FETCH_TAGS_FROM_NATION_BUILDER = 'FAILED_TO_FETCH_TAGS_FROM_NATION_BUILDER',
    FIRST_NAME_ALLOWED_LENGTH_EXCEEDS_LIMIT = 'FIRST_NAME_ALLOWED_LENGTH_EXCEEDS_LIMIT',
    GRASS_ROOT_ORGANIZING_ACTION_NOT_ENABLED_FOR_OUTREACH_CIRCLE = 'GRASS_ROOT_ORGANIZING_ACTION_NOT_ENABLED_FOR_OUTREACH_CIRCLE',
    GROUPS_CANNOT_BE_EMPTY = 'GROUPS_CANNOT_BE_EMPTY',
    GROUP_CANNOT_BE_DELETED = 'GROUP_CANNOT_BE_DELETED',
    GROUP_NAME_ALREADY_EXISTS = 'GROUP_NAME_ALREADY_EXISTS',
    GRO_RELATIONAL_ACTION_NOT_ENABLED_FOR_OUTREACH_CIRCLE = 'GRO_RELATIONAL_ACTION_NOT_ENABLED_FOR_OUTREACH_CIRCLE',
    GRO_SURVEY_FORM_NOT_FOUND = 'GRO_SURVEY_FORM_NOT_FOUND',
    GRO_SURVEY_FORM_OPTION_NOT_FOUND = 'GRO_SURVEY_FORM_OPTION_NOT_FOUND',
    GRO_SURVEY_FORM_QUESTION_NOT_FOUND = 'GRO_SURVEY_FORM_QUESTION_NOT_FOUND',
    GRO_SURVEY_FORM_QUESTION_TEXT_LENGTH_EXCEEDED = 'GRO_SURVEY_FORM_QUESTION_TEXT_LENGTH_EXCEEDED',
    GRO_SURVEY_FORM_WITH_SAME_NAME_EXISTS = 'GRO_SURVEY_FORM_WITH_SAME_NAME_EXISTS',
    INACTIVE_OUTREACH_CIRCLE = 'INACTIVE_OUTREACH_CIRCLE',
    INTEGRATION_NOT_FOUND = 'INTEGRATION_NOT_FOUND',
    INTEGRATION_TYPE_CANNOT_BE_NULL = 'INTEGRATION_TYPE_CANNOT_BE_NULL',
    INVALID_ACTION = 'INVALID_ACTION',
    INVALID_ACTION_CONFIRMATION_TEXT = 'INVALID_ACTION_CONFIRMATION_TEXT',
    INVALID_ACTION_DESCRIPTION = 'INVALID_ACTION_DESCRIPTION',
    INVALID_ACTION_FOR_SMS = 'INVALID_ACTION_FOR_SMS',
    INVALID_ACTION_LINK = 'INVALID_ACTION_LINK',
    INVALID_ACTION_NAME = 'INVALID_ACTION_NAME',
    INVALID_ACTION_POSITION = 'INVALID_ACTION_POSITION',
    INVALID_ACTION_TAG_NAME = 'INVALID_ACTION_TAG_NAME',
    INVALID_ACTION_TITLE = 'INVALID_ACTION_TITLE',
    INVALID_ACTION_TYPE = 'INVALID_ACTION_TYPE',
    INVALID_ALIAS_DESCRIPTION = 'INVALID_ALIAS_DESCRIPTION',
    INVALID_ALIAS_NAME = 'INVALID_ALIAS_NAME',
    INVALID_ALIAS_OR_NAME = 'INVALID_ALIAS_OR_NAME',
    INVALID_API_TOKEN_FOR_NATION_BUILDER_INTEGRATION = 'INVALID_API_TOKEN_FOR_NATION_BUILDER_INTEGRATION',
    INVALID_APPLY_TO_ALL_CUSTOM_ALIASES_OPTION = 'INVALID_APPLY_TO_ALL_CUSTOM_ALIASES_OPTION',
    INVALID_AREA_CODE = 'INVALID_AREA_CODE',
    INVALID_AUDIENCE_ACTION = 'INVALID_AUDIENCE_ACTION',
    INVALID_AUDIENCE_ACTION_FILTER = 'INVALID_AUDIENCE_ACTION_FILTER',
    INVALID_AUDIENCE_ACTION_INPUT = 'INVALID_AUDIENCE_ACTION_INPUT',
    INVALID_AUDIENCE_MAPPING_NAME = 'INVALID_AUDIENCE_MAPPING_NAME',
    INVALID_AUTH_TOKEN = 'INVALID_AUTH_TOKEN',
    INVALID_BRAND = 'INVALID_BRAND',
    INVALID_CALL_TO_ACTION_TEXT = 'INVALID_CALL_TO_ACTION_TEXT',
    INVALID_CANCEL_AUTO_RENEW_CONFIRMATION = 'INVALID_CANCEL_AUTO_RENEW_CONFIRMATION',
    INVALID_CANDIDATE_IMAGE = 'INVALID_CANDIDATE_IMAGE',
    INVALID_CANNED_RESPONSE_FOR_TAG = 'INVALID_CANNED_RESPONSE_FOR_TAG',
    INVALID_CATEGORY_INPUT = 'INVALID_CATEGORY_INPUT',
    INVALID_CONTACT_FILE = 'INVALID_CONTACT_FILE',
    INVALID_CONTACT_FILE_input = 'INVALID_CONTACT_FILE_input',
    INVALID_COUPON = 'INVALID_COUPON',
    INVALID_CV_TOKEN = 'INVALID_CV_TOKEN',
    INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
    INVALID_DOMAIN = 'INVALID_DOMAIN',
    INVALID_EMAIL_ID = 'INVALID_EMAIL_ID',
    INVALID_EMAIL_INPUT = 'INVALID_EMAIL_INPUT',
    INVALID_EMAIL_MESSAGE = 'INVALID_EMAIL_MESSAGE',
    INVALID_END_DATE = 'INVALID_END_DATE',
    INVALID_ENGAGEMENT_INPUT = 'INVALID_ENGAGEMENT_INPUT',
    INVALID_EVERY_ACTION_FORM_ID = 'INVALID_EVERY_ACTION_FORM_ID',
    INVALID_GROUP_ID = 'INVALID_GROUP_ID',
    INVALID_GRO_SURVEY_FORM_QUESTION = 'INVALID_GRO_SURVEY_FORM_QUESTION',
    INVALID_GRO_SURVEY_FORM_QUESTION_TYPE = 'INVALID_GRO_SURVEY_FORM_QUESTION_TYPE',
    INVALID_INDUSTRY_INPUT = 'INVALID_INDUSTRY_INPUT',
    INVALID_INPUT_FOR_SAVE_NGP_CONFIGURATION = 'INVALID_INPUT_FOR_SAVE_NGP_CONFIGURATION',
    INVALID_KEY_DATE = 'INVALID_KEY_DATE',
    INVALID_LINK_TEXT = 'INVALID_LINK_TEXT',
    INVALID_LOCATION_DETAILS = 'INVALID_LOCATION_DETAILS',
    INVALID_MEMBER_ID = 'INVALID_MEMBER_ID',
    INVALID_MERGE_FIELDS_IN_TEMPLATE = 'INVALID_MERGE_FIELDS_IN_TEMPLATE',
    INVALID_MOBILE_NUMBER = 'INVALID_MOBILE_NUMBER',
    INVALID_NAME_FOR_SUPPORTER_VIEW_FILTER_STATE = 'INVALID_NAME_FOR_SUPPORTER_VIEW_FILTER_STATE',
    INVALID_NAME_FOR_URL = 'INVALID_NAME_FOR_URL',
    INVALID_NAME_INPUT = 'INVALID_NAME_INPUT',
    INVALID_NATION_BUILDER_CREDENTIALS = 'INVALID_NATION_BUILDER_CREDENTIALS',
    INVALID_NEW_PASSWORD = 'INVALID_NEW_PASSWORD',
    INVALID_NGP_ACTIVIST_CODE_ID = 'INVALID_NGP_ACTIVIST_CODE_ID',
    INVALID_NGP_CREDENTIALS = 'INVALID_NGP_CREDENTIALS',
    INVALID_NGP_SAVED_LIST_ID = 'INVALID_NGP_SAVED_LIST_ID',
    INVALID_OAUTH_PROVIDER = 'INVALID_OAUTH_PROVIDER',
    INVALID_OPTIONS_INPUT_FOR_SEARCH_AND_SURVEY_FORM_QUESTION = 'INVALID_OPTIONS_INPUT_FOR_SEARCH_AND_SURVEY_FORM_QUESTION',
    INVALID_OPTIONS_INPUT_FOR_SUPPORTER_FORM_QUESTION = 'INVALID_OPTIONS_INPUT_FOR_SUPPORTER_FORM_QUESTION',
    INVALID_OPTION_SELECTED_FOR_QUESTION = 'INVALID_OPTION_SELECTED_FOR_QUESTION',
    INVALID_ORGANIZATION_ALIAS_VALUE = 'INVALID_ORGANIZATION_ALIAS_VALUE',
    INVALID_ORGANIZATION_FILTER_NAME = 'INVALID_ORGANIZATION_FILTER_NAME',
    INVALID_ORGANIZATION_NAME = 'INVALID_ORGANIZATION_NAME',
    INVALID_ORIGIN = 'INVALID_ORIGIN',
    INVALID_OUTREACH_CHANNEL = 'INVALID_OUTREACH_CHANNEL',
    INVALID_OUTREACH_CHANNEL_TEMPLATE_TEXT = 'INVALID_OUTREACH_CHANNEL_TEMPLATE_TEXT',
    INVALID_OUTREACH_CIRCLE_LOGO = 'INVALID_OUTREACH_CIRCLE_LOGO',
    INVALID_OUTREACH_CIRCLE_USER = 'INVALID_OUTREACH_CIRCLE_USER',
    INVALID_OUTREACH_CIRCLE_USER_EMAIL_TEMPLATE = 'INVALID_OUTREACH_CIRCLE_USER_EMAIL_TEMPLATE',
    INVALID_OUTREACH_CIRLCE_LOCATION = 'INVALID_OUTREACH_CIRLCE_LOCATION',
    INVALID_P2P_SCRIPT_SURVEY_QUESTION_INPUT = 'INVALID_P2P_SCRIPT_SURVEY_QUESTION_INPUT',
    INVALID_P2P_TEXT_CONTENT = 'INVALID_P2P_TEXT_CONTENT',
    INVALID_PASSWORD = 'INVALID_PASSWORD',
    INVALID_PASSWORD_RESET_CODE = 'INVALID_PASSWORD_RESET_CODE',
    INVALID_PDI_CREDENTIALS = 'INVALID_PDI_CREDENTIALS',
    INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
    INVALID_PLAN = 'INVALID_PLAN',
    INVALID_POST_ACTION_TEXT = 'INVALID_POST_ACTION_TEXT',
    INVALID_PUSH_NOTIFICATION_DESCRIPTION = 'INVALID_PUSH_NOTIFICATION_DESCRIPTION',
    INVALID_PUSH_NOTIFICATION_REGISTRATION_TOKEN = 'INVALID_PUSH_NOTIFICATION_REGISTRATION_TOKEN',
    INVALID_PUSH_NOTIFICATION_TEMPLATE_BODY = 'INVALID_PUSH_NOTIFICATION_TEMPLATE_BODY',
    INVALID_PUSH_NOTIFICATION_TEMPLATE_TITLE = 'INVALID_PUSH_NOTIFICATION_TEMPLATE_TITLE',
    INVALID_PUSH_NOTIFICATION_TITLE = 'INVALID_PUSH_NOTIFICATION_TITLE',
    INVALID_QUESTION_TYPE_FOR_GRO_SURVEY_FORM_QUESTION_INTEGRATION = 'INVALID_QUESTION_TYPE_FOR_GRO_SURVEY_FORM_QUESTION_INTEGRATION',
    INVALID_QUESTION_TYPE_FOR_SEARCH_AND_SURVEY_FORM_QUESTION_INTEGRATION = 'INVALID_QUESTION_TYPE_FOR_SEARCH_AND_SURVEY_FORM_QUESTION_INTEGRATION',
    INVALID_QUESTION_TYPE_FOR_SUPPORTER_FORM_QUESTION_INTEGRATION = 'INVALID_QUESTION_TYPE_FOR_SUPPORTER_FORM_QUESTION_INTEGRATION',
    INVALID_RESPONSE_FOR_MANDATORY_QUESTION = 'INVALID_RESPONSE_FOR_MANDATORY_QUESTION',
    INVALID_SEARCH_AND_SURVEY_FORM_QUESTION = 'INVALID_SEARCH_AND_SURVEY_FORM_QUESTION',
    INVALID_SEARCH_AND_SURVEY_FORM_QUESTION_TYPE = 'INVALID_SEARCH_AND_SURVEY_FORM_QUESTION_TYPE',
    INVALID_SEARCH_AND_SURVEY_LIST_NAME = 'INVALID_SEARCH_AND_SURVEY_LIST_NAME',
    INVALID_SEARCH_AND_SURVEY_NEW_CONTACTS_AUDIENCE_ACTION_ID = 'INVALID_SEARCH_AND_SURVEY_NEW_CONTACTS_AUDIENCE_ACTION_ID',
    INVALID_SEARCH_KEY = 'INVALID_SEARCH_KEY',
    INVALID_SHARE_BUTTON_TEXT = 'INVALID_SHARE_BUTTON_TEXT',
    INVALID_SLUG_FOR_NATION_BUILDER_INTEGRATION = 'INVALID_SLUG_FOR_NATION_BUILDER_INTEGRATION',
    INVALID_SOCIAL_TEMPLATE_IMAGE = 'INVALID_SOCIAL_TEMPLATE_IMAGE',
    INVALID_SOQL = 'INVALID_SOQL',
    INVALID_SOQL_SCHEDULE = 'INVALID_SOQL_SCHEDULE',
    INVALID_SOURCE_ALIAS = 'INVALID_SOURCE_ALIAS',
    INVALID_SOURCING_LINK = 'INVALID_SOURCING_LINK',
    INVALID_SUPPORTER_FORM_QUESTION = 'INVALID_SUPPORTER_FORM_QUESTION',
    INVALID_SUPPORTER_FORM_QUESTION_TYPE = 'INVALID_SUPPORTER_FORM_QUESTION_TYPE',
    INVALID_SURVEY_RESPONSE_INPUT = 'INVALID_SURVEY_RESPONSE_INPUT',
    INVALID_SURVEY_TEXT_RECIPIENT = 'INVALID_SURVEY_TEXT_RECIPIENT',
    INVALID_TAG_APPLICATION = 'INVALID_TAG_APPLICATION',
    INVALID_TAG_INPUT = 'INVALID_TAG_INPUT',
    INVALID_TAG_NAME = 'INVALID_TAG_NAME',
    INVALID_TCR_CURRENT_STATUS = 'INVALID_TCR_CURRENT_STATUS',
    INVALID_TCR_INPUT = 'INVALID_TCR_INPUT',
    INVALID_TEXT_SUPPORTER_SET = 'INVALID_TEXT_SUPPORTER_SET',
    INVALID_TURFING_STRATEGY = 'INVALID_TURFING_STRATEGY',
    INVALID_UPDATE_USER_INPUT = 'INVALID_UPDATE_USER_INPUT',
    INVALID_USERNAME = 'INVALID_USERNAME',
    INVALID_VERIFICATION_CODE = 'INVALID_VERIFICATION_CODE',
    INVALID_ZIP_CODE = 'INVALID_ZIP_CODE',
    INVITED_SUPPORTERS_ALREADY_IMPORTED = 'INVITED_SUPPORTERS_ALREADY_IMPORTED',
    INVITED_SUPPORTERS_IMPORT_IN_PROGRESS = 'INVITED_SUPPORTERS_IMPORT_IN_PROGRESS',
    INVITED_SUPPORTER_INFORMATION_NOT_FOUND = 'INVITED_SUPPORTER_INFORMATION_NOT_FOUND',
    INVITED_SUPPORTER_SOURCE_NOT_FOUND = 'INVITED_SUPPORTER_SOURCE_NOT_FOUND',
    INVITED_USER_CONSENT = 'INVITED_USER_CONSENT',
    INVITE_ALREADY_EXISTS = 'INVITE_ALREADY_EXISTS',
    LABEL_EMPTY_FOR_CUSTOM_TAG_ERROR = 'LABEL_EMPTY_FOR_CUSTOM_TAG_ERROR',
    LABEL_EMPTY_FOR_TAG_WITH_PDI_INTEGRATION = 'LABEL_EMPTY_FOR_TAG_WITH_PDI_INTEGRATION',
    LAST_NAME_ALLOWED_LENGTH_EXCEEDS_LIMIT = 'LAST_NAME_ALLOWED_LENGTH_EXCEEDS_LIMIT',
    MAPPED_CONTACT_NOT_FOUND = 'MAPPED_CONTACT_NOT_FOUND',
    MATCHING_JOB_IN_PROGRESS = 'MATCHING_JOB_IN_PROGRESS',
    MATCHING_JOB_NOT_FOUND = 'MATCHING_JOB_NOT_FOUND',
    MAXIMUM_DATE_RANGE_EXCEEDED_FOR_P2P_ACTION = 'MAXIMUM_DATE_RANGE_EXCEEDED_FOR_P2P_ACTION',
    MISSING_PLAN_INPUT = 'MISSING_PLAN_INPUT',
    MULTIPLE_SELECTIONS_NOT_ALLOWED = 'MULTIPLE_SELECTIONS_NOT_ALLOWED',
    NAME_CANNOT_BE_EMPTY_FOR_KEY_DATE = 'NAME_CANNOT_BE_EMPTY_FOR_KEY_DATE',
    NAME_CANNOT_BE_UPDATED_FOR_SYSTEM_ADDED_KEY_DATE = 'NAME_CANNOT_BE_UPDATED_FOR_SYSTEM_ADDED_KEY_DATE',
    NATION_BUILDER_INTEGRATION_NOT_FOUND = 'NATION_BUILDER_INTEGRATION_NOT_FOUND',
    NGP_CREDENTIALS_NOT_FOUND = 'NGP_CREDENTIALS_NOT_FOUND',
    NGP_MY_CAMPAIGN_INTEGRATION_NOT_FOUND = 'NGP_MY_CAMPAIGN_INTEGRATION_NOT_FOUND',
    NGP_SURVEY_NOT_FOUND = 'NGP_SURVEY_NOT_FOUND',
    NOT_ABLE_TO_DELETE_CONTACTS = 'NOT_ABLE_TO_DELETE_CONTACTS',
    NOT_ABLE_TO_DELETE_P2P_SCRIPT_SURVEY_QUESTION_OPTION_WITH_CANNED_RESPONSE = 'NOT_ABLE_TO_DELETE_P2P_SCRIPT_SURVEY_QUESTION_OPTION_WITH_CANNED_RESPONSE',
    NOT_ABLE_TO_DELETE_P2P_SCRIPT_SURVEY_QUESTION_WITH_CANNED_RESPONSE = 'NOT_ABLE_TO_DELETE_P2P_SCRIPT_SURVEY_QUESTION_WITH_CANNED_RESPONSE',
    NOT_ABLE_TO_FETCH_CONTACT_SOURCES = 'NOT_ABLE_TO_FETCH_CONTACT_SOURCES',
    NOT_ABLE_TO_IMPORT_FILE = 'NOT_ABLE_TO_IMPORT_FILE',
    NOT_ABLE_TO_REQUEST_REPORT = 'NOT_ABLE_TO_REQUEST_REPORT',
    NOT_ABLE_UPDATE_ACTION_TO_EXPIRED = 'NOT_ABLE_UPDATE_ACTION_TO_EXPIRED',
    NOT_ABLE_UPDATE_ACTION_TO_LIVE = 'NOT_ABLE_UPDATE_ACTION_TO_LIVE',
    NOT_AUTHORIZED_DELETE_CONTACT_SOURCE = 'NOT_AUTHORIZED_DELETE_CONTACT_SOURCE',
    NO_CALL_TO_ACTION_IN_OUTREACH_MODE = 'NO_CALL_TO_ACTION_IN_OUTREACH_MODE',
    NO_CARD_ADDED = 'NO_CARD_ADDED',
    NO_CONTACT_FOUND = 'NO_CONTACT_FOUND',
    NO_ELIGIBLE_SUPPORTERS_AVAILABLE_FOR_NOTIFICATION = 'NO_ELIGIBLE_SUPPORTERS_AVAILABLE_FOR_NOTIFICATION',
    NO_ELIGIBLE_SUPPORTERS_FOR_PUSH_NOTIFICATION = 'NO_ELIGIBLE_SUPPORTERS_FOR_PUSH_NOTIFICATION',
    NO_ELIGIBLE_SUPPORTERS_FOUND = 'NO_ELIGIBLE_SUPPORTERS_FOUND',
    NO_EMAIL_FROM_OAUTH_PROVIDER = 'NO_EMAIL_FROM_OAUTH_PROVIDER',
    NO_EMAIL_RECIPIENTS_FOUND = 'NO_EMAIL_RECIPIENTS_FOUND',
    NO_EMAIL_TEMPLATE_LINKED_TO_ACTION = 'NO_EMAIL_TEMPLATE_LINKED_TO_ACTION',
    NO_OUTREACH_CHANNEL_IS_SELECTED_FOR_SHARING_ACTION = 'NO_OUTREACH_CHANNEL_IS_SELECTED_FOR_SHARING_ACTION',
    NO_P2P_RECIPIENTS_AVAILABLE_RIGHT_NOW_TO_SEND_INITIAL_TEXT = 'NO_P2P_RECIPIENTS_AVAILABLE_RIGHT_NOW_TO_SEND_INITIAL_TEXT',
    NO_PERSONAL_EMAIL_FOUND_TO_SEND_COUPON_CODE = 'NO_PERSONAL_EMAIL_FOUND_TO_SEND_COUPON_CODE',
    NO_PHONE_NUMBER_FOUND_FOR_AREA_CODE = 'NO_PHONE_NUMBER_FOUND_FOR_AREA_CODE',
    NO_PHONE_NUMBER_TO_SEND_P2P_TEXT = 'NO_PHONE_NUMBER_TO_SEND_P2P_TEXT',
    NO_SUPPORTER_CONTACT_FOUND = 'NO_SUPPORTER_CONTACT_FOUND',
    NO_SUPPORTER_ELIGIBLE_TO_SEND_REMINDER = 'NO_SUPPORTER_ELIGIBLE_TO_SEND_REMINDER',
    NO_SURVEY_LINKED_TO_ACTION = 'NO_SURVEY_LINKED_TO_ACTION',
    NO_TEXT_TEMPLATE_LINKED_TO_ACTION = 'NO_TEXT_TEMPLATE_LINKED_TO_ACTION',
    ORGANIZATION_ACTION_CANNOT_BE_PUBLISHED = 'ORGANIZATION_ACTION_CANNOT_BE_PUBLISHED',
    ORGANIZATION_ADMIN_INVITE_ALREADY_EXISTS = 'ORGANIZATION_ADMIN_INVITE_ALREADY_EXISTS',
    ORGANIZATION_ALIAS_ALREADY_EXIST = 'ORGANIZATION_ALIAS_ALREADY_EXIST',
    ORGANIZATION_ALIAS_DOES_NOT_EXIST = 'ORGANIZATION_ALIAS_DOES_NOT_EXIST',
    ORGANIZATION_FILTER_NOT_FOUND = 'ORGANIZATION_FILTER_NOT_FOUND',
    ORGANIZATION_FILTER_WITH_SAME_NAME_EXISTS = 'ORGANIZATION_FILTER_WITH_SAME_NAME_EXISTS',
    ORGANIZATION_LOGO_DOES_NOT_EXIST = 'ORGANIZATION_LOGO_DOES_NOT_EXIST',
    ORGANIZATION_NOT_FOUND = 'ORGANIZATION_NOT_FOUND',
    ORGANIZATION_TEXTING_ACCOUNT_DOES_NOT_EXIST = 'ORGANIZATION_TEXTING_ACCOUNT_DOES_NOT_EXIST',
    ORGANIZATION_USER_ALREADY_ONBOARDED = 'ORGANIZATION_USER_ALREADY_ONBOARDED',
    OUTREACH_CHANNEL_DETAIL_IS_REQUIRED = 'OUTREACH_CHANNEL_DETAIL_IS_REQUIRED',
    OUTREACH_CHANNEL_NOT_ADDED = 'OUTREACH_CHANNEL_NOT_ADDED',
    OUTREACH_CIRCLES_CANNOT_BE_EMPTY = 'OUTREACH_CIRCLES_CANNOT_BE_EMPTY',
    OUTREACH_CIRCLES_MISMATCH = 'OUTREACH_CIRCLES_MISMATCH',
    OUTREACH_CIRCLE_ALREADY_ARCHIVED = 'OUTREACH_CIRCLE_ALREADY_ARCHIVED',
    OUTREACH_CIRCLE_ARCHIVED = 'OUTREACH_CIRCLE_ARCHIVED',
    OUTREACH_CIRCLE_DEFAULT_ALIAS_LOGO_DOES_NOT_EXIST = 'OUTREACH_CIRCLE_DEFAULT_ALIAS_LOGO_DOES_NOT_EXIST',
    OUTREACH_CIRCLE_DEFAULT_ALIAS_LOGO_EXISTS = 'OUTREACH_CIRCLE_DEFAULT_ALIAS_LOGO_EXISTS',
    OUTREACH_CIRCLE_EMAIL_ALIAS_EXISTS = 'OUTREACH_CIRCLE_EMAIL_ALIAS_EXISTS',
    OUTREACH_CIRCLE_IS_NOT_PRESENT_IN_ORGANIZATION = 'OUTREACH_CIRCLE_IS_NOT_PRESENT_IN_ORGANIZATION',
    OUTREACH_CIRCLE_NOT_FOUND = 'OUTREACH_CIRCLE_NOT_FOUND',
    OUTREACH_CIRCLE_USER_ALREADY_ONBOARDED = 'OUTREACH_CIRCLE_USER_ALREADY_ONBOARDED',
    OUTREACH_CIRCLE_USER_DOES_NOT_EXIST = 'OUTREACH_CIRCLE_USER_DOES_NOT_EXIST',
    OUTREACH_CIRCLE_USER_EMAIL_TEMPALTE_ALREADY_EXISTS = 'OUTREACH_CIRCLE_USER_EMAIL_TEMPALTE_ALREADY_EXISTS',
    P2P_ACTION_IS_PAUSED = 'P2P_ACTION_IS_PAUSED',
    P2P_ACTION_NOT_ENABLED_FOR_OUTREACH_CIRCLE = 'P2P_ACTION_NOT_ENABLED_FOR_OUTREACH_CIRCLE',
    P2P_CANNED_RESPONSE_CANNOT_HAVE_PUBLIC_SHORT_LINK = 'P2P_CANNED_RESPONSE_CANNOT_HAVE_PUBLIC_SHORT_LINK',
    P2P_CONTACT_FILE_LIMIT_EXCEEDED = 'P2P_CONTACT_FILE_LIMIT_EXCEEDED',
    P2P_CONVERSATION_UNSUBSCRIBED = 'P2P_CONVERSATION_UNSUBSCRIBED',
    P2P_INITIAL_TEXT_CAN_NOT_HAVE_URL = 'P2P_INITIAL_TEXT_CAN_NOT_HAVE_URL',
    P2P_MAXIMUM_PHONE_NUMBER_CAMPAIGN_REGISTRATION_LIMIT_REACHED = 'P2P_MAXIMUM_PHONE_NUMBER_CAMPAIGN_REGISTRATION_LIMIT_REACHED',
    P2P_REPLIES_ALREADY_REASSIGNED = 'P2P_REPLIES_ALREADY_REASSIGNED',
    P2P_REPLIES_CANNOT_BE_REASSIGNED = 'P2P_REPLIES_CANNOT_BE_REASSIGNED',
    P2P_REPLY_REASSIGNMENT_NOT_FOUND = 'P2P_REPLY_REASSIGNMENT_NOT_FOUND',
    P2P_SCRIPT_HAS_INVALID_MEDIA = 'P2P_SCRIPT_HAS_INVALID_MEDIA',
    P2P_SCRIPT_HAS_SURVEY_QUESTION_FROM_INVALID_OUTREACH_CIRCLE = 'P2P_SCRIPT_HAS_SURVEY_QUESTION_FROM_INVALID_OUTREACH_CIRCLE',
    P2P_SCRIPT_INVALID_OPTOUT_TEXT = 'P2P_SCRIPT_INVALID_OPTOUT_TEXT',
    P2P_SCRIPT_MISSING = 'P2P_SCRIPT_MISSING',
    P2P_SCRIPT_SURVEY_QUESTION_HAS_INVALID_NAME = 'P2P_SCRIPT_SURVEY_QUESTION_HAS_INVALID_NAME',
    P2P_SCRIPT_SURVEY_QUESTION_HAS_INVALID_QUESTION_TEXT = 'P2P_SCRIPT_SURVEY_QUESTION_HAS_INVALID_QUESTION_TEXT',
    P2P_SCRIPT_SURVEY_QUESTION_NAME_ALREADY_EXISTS = 'P2P_SCRIPT_SURVEY_QUESTION_NAME_ALREADY_EXISTS',
    P2P_SCRIPT_SURVEY_QUESTION_NOT_FOUND = 'P2P_SCRIPT_SURVEY_QUESTION_NOT_FOUND',
    P2P_SCRIPT_SURVEY_QUESTION_OPTION_HAS_INVALID_OPTION_TEXT = 'P2P_SCRIPT_SURVEY_QUESTION_OPTION_HAS_INVALID_OPTION_TEXT',
    P2P_WORKSPACE_HAS_INVALID_LINKED_NEXT_P2P_SCRIPT = 'P2P_WORKSPACE_HAS_INVALID_LINKED_NEXT_P2P_SCRIPT',
    P2P_WORKSPACE_HAS_INVALID_LINKED_SURVEY_QUESTION_OPTION = 'P2P_WORKSPACE_HAS_INVALID_LINKED_SURVEY_QUESTION_OPTION',
    P2P_WORKSPACE_HAS_INVALID_NAME = 'P2P_WORKSPACE_HAS_INVALID_NAME',
    P2P_WORKSPACE_INVALID_INITIAL_SCRIPT = 'P2P_WORKSPACE_INVALID_INITIAL_SCRIPT',
    P2P_WORKSPACE_INVALID_INITIAL_SCRIPT_MESSAGE = 'P2P_WORKSPACE_INVALID_INITIAL_SCRIPT_MESSAGE',
    P2P_WORKSPACE_NAME_ALREADY_EXISTS = 'P2P_WORKSPACE_NAME_ALREADY_EXISTS',
    P2P_WORKSPACE_NOT_FOUND = 'P2P_WORKSPACE_NOT_FOUND',
    P2P_WORKSPACE_NOT_LINKED_TO_ACTION = 'P2P_WORKSPACE_NOT_LINKED_TO_ACTION',
    P2P_WORKSPACE_TAG_HAS_INVALID_CANNED_RESPONSE_P2P_SCRIPT = 'P2P_WORKSPACE_TAG_HAS_INVALID_CANNED_RESPONSE_P2P_SCRIPT',
    P2P_WORKSPACE_TAG_HAS_INVALID_POSITION = 'P2P_WORKSPACE_TAG_HAS_INVALID_POSITION',
    PDI_INTEGRATION_NOT_FOUND = 'PDI_INTEGRATION_NOT_FOUND',
    PDI_QUESTION_NOT_FOUND = 'PDI_QUESTION_NOT_FOUND',
    PENDING_SEND_EMAIL_JOB_EXISTS = 'PENDING_SEND_EMAIL_JOB_EXISTS',
    PUSH_NOTIFICATION_TEMPLATE_DOES_NOT_EXIST = 'PUSH_NOTIFICATION_TEMPLATE_DOES_NOT_EXIST',
    PUSH_NOTIFICATION_TEMPLATE_EXISTS_FOR_ACTION = 'PUSH_NOTIFICATION_TEMPLATE_EXISTS_FOR_ACTION',
    RAPID_ONBOARDING_NOT_ALLOWED = 'RAPID_ONBOARDING_NOT_ALLOWED',
    REMOVE_CARD_FAILED = 'REMOVE_CARD_FAILED',
    REPORT_NOT_FOUND = 'REPORT_NOT_FOUND',
    RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED',
    RESPONSE_LOGIC_CANNOT_BE_BLANK_FOR_OPTIONS = 'RESPONSE_LOGIC_CANNOT_BE_BLANK_FOR_OPTIONS',
    SEARCH_AND_SURVEY_FORM_NOT_FOUND = 'SEARCH_AND_SURVEY_FORM_NOT_FOUND',
    SEARCH_AND_SURVEY_FORM_OPTION_NOT_FOUND = 'SEARCH_AND_SURVEY_FORM_OPTION_NOT_FOUND',
    SEARCH_AND_SURVEY_FORM_QUESTION_NOT_FOUND = 'SEARCH_AND_SURVEY_FORM_QUESTION_NOT_FOUND',
    SEARCH_AND_SURVEY_FORM_QUESTION_TEXT_LENGTH_EXCEEDED = 'SEARCH_AND_SURVEY_FORM_QUESTION_TEXT_LENGTH_EXCEEDED',
    SEARCH_AND_SURVEY_FORM_WITH_SAME_NAME_EXISTS = 'SEARCH_AND_SURVEY_FORM_WITH_SAME_NAME_EXISTS',
    SEARCH_EXCEEDS_MAXIMUM_RESULTS_WITH_INCOMPLETE_DATA = 'SEARCH_EXCEEDS_MAXIMUM_RESULTS_WITH_INCOMPLETE_DATA',
    SOCIAL_TEMPLATE_DOES_NOT_EXIST = 'SOCIAL_TEMPLATE_DOES_NOT_EXIST',
    SOCIAL_TEMPLATE_IMAGE_ALREADY_EXISTS = 'SOCIAL_TEMPLATE_IMAGE_ALREADY_EXISTS',
    SOCIAL_TEMPLATE_IN_ARCHIVED_STATE = 'SOCIAL_TEMPLATE_IN_ARCHIVED_STATE',
    SOCIAL_TEMPLATE_NOT_FOUND = 'SOCIAL_TEMPLATE_NOT_FOUND',
    SOCIAL_TEMPLATE_NOT_IN_READY_STATE = 'SOCIAL_TEMPLATE_NOT_IN_READY_STATE',
    SOCIAL_TEMPLATE_NOT_LINKED = 'SOCIAL_TEMPLATE_NOT_LINKED',
    SOCIAL_TEMPLATE_WITH_SAME_NAME_EXISTS = 'SOCIAL_TEMPLATE_WITH_SAME_NAME_EXISTS',
    SOURCING_LINK_NAME_TOO_LONG = 'SOURCING_LINK_NAME_TOO_LONG',
    SOURCING_LINK_WITH_SAME_NAME_EXISTS = 'SOURCING_LINK_WITH_SAME_NAME_EXISTS',
    SPECIAL_ACTION_NOT_ENABLED = 'SPECIAL_ACTION_NOT_ENABLED',
    SUPPORTER_ALREADY_EXISTS = 'SUPPORTER_ALREADY_EXISTS',
    SUPPORTER_CANNOT_BE_EMPTY = 'SUPPORTER_CANNOT_BE_EMPTY',
    SUPPORTER_EMAIL_IS_SUPPRESSED = 'SUPPORTER_EMAIL_IS_SUPPRESSED',
    SUPPORTER_EMAIL_MAPPING_IS_MANDATORY = 'SUPPORTER_EMAIL_MAPPING_IS_MANDATORY',
    SUPPORTER_FORM_NOT_FOUND = 'SUPPORTER_FORM_NOT_FOUND',
    SUPPORTER_FORM_OPTION_NOT_FOUND = 'SUPPORTER_FORM_OPTION_NOT_FOUND',
    SUPPORTER_FORM_QUESTION_NOT_FOUND = 'SUPPORTER_FORM_QUESTION_NOT_FOUND',
    SUPPORTER_FORM_QUESTION_TEXT_LENGTH_EXCEEDED = 'SUPPORTER_FORM_QUESTION_TEXT_LENGTH_EXCEEDED',
    SUPPORTER_FORM_WITH_SAME_NAME_EXISTS = 'SUPPORTER_FORM_WITH_SAME_NAME_EXISTS',
    SUPPORTER_ID_MAPPING_IS_MANDATORY = 'SUPPORTER_ID_MAPPING_IS_MANDATORY',
    SUPPORTER_IS_BLOCKED_FOR_OUTREACH_CIRCLE = 'SUPPORTER_IS_BLOCKED_FOR_OUTREACH_CIRCLE',
    SUPPORTER_NOT_FOUND = 'SUPPORTER_NOT_FOUND',
    SUPPORTER_VIEW_FILTER_STATE_ALREADY_EXISTS = 'SUPPORTER_VIEW_FILTER_STATE_ALREADY_EXISTS',
    SURVEY_NOT_FOUND = 'SURVEY_NOT_FOUND',
    SUSPICIOUS_MATCHING_FOUND = 'SUSPICIOUS_MATCHING_FOUND',
    TAG_ALREADY_LINKED_TO_ACTION = 'TAG_ALREADY_LINKED_TO_ACTION',
    TAG_LINKED_TO_LIVE_ACTION_CANNOT_BE_DELETED = 'TAG_LINKED_TO_LIVE_ACTION_CANNOT_BE_DELETED',
    TAG_MAXIMUM_LIMIT_REACHED = 'TAG_MAXIMUM_LIMIT_REACHED',
    TAG_NOT_FOUND = 'TAG_NOT_FOUND',
    TAG_NOT_LINKED_TO_ACTION = 'TAG_NOT_LINKED_TO_ACTION',
    TAG_WITH_SAME_NAME_EXISTS = 'TAG_WITH_SAME_NAME_EXISTS',
    TEXTING_ACCOUNT_10_DLC_SETUP_NOT_COMPLETE = 'TEXTING_ACCOUNT_10_DLC_SETUP_NOT_COMPLETE',
    TEXTING_ACCOUNT_ALREADY_EXISTS = 'TEXTING_ACCOUNT_ALREADY_EXISTS',
    TEXTING_ACCOUNT_NOT_FOUND = 'TEXTING_ACCOUNT_NOT_FOUND',
    TEXT_NOT_SENT = 'TEXT_NOT_SENT',
    TEXT_OUTREACH_CHANNEL_NOT_FOUND = 'TEXT_OUTREACH_CHANNEL_NOT_FOUND',
    TEXT_RECIPIENT_NOT_FOUND = 'TEXT_RECIPIENT_NOT_FOUND',
    TEXT_SUPPORTER_SET_NOT_FOUND = 'TEXT_SUPPORTER_SET_NOT_FOUND',
    TEXT_TEMPLATE_CONTENT_CANNOT_BE_EMPTY = 'TEXT_TEMPLATE_CONTENT_CANNOT_BE_EMPTY',
    TEXT_TEMPLATE_IN_ARCHIVED_STATE = 'TEXT_TEMPLATE_IN_ARCHIVED_STATE',
    TEXT_TEMPLATE_NAME_CANNOT_BE_EMPTY = 'TEXT_TEMPLATE_NAME_CANNOT_BE_EMPTY',
    TEXT_TEMPLATE_NOT_FOUND = 'TEXT_TEMPLATE_NOT_FOUND',
    TEXT_TEMPLATE_NOT_IN_READY_STATE = 'TEXT_TEMPLATE_NOT_IN_READY_STATE',
    TEXT_TEMPLATE_NOT_LINKED = 'TEXT_TEMPLATE_NOT_LINKED',
    TEXT_TEMPLATE_WITH_SAME_NAME_EXISTS = 'TEXT_TEMPLATE_WITH_SAME_NAME_EXISTS',
    UNABLE_TO_ADD_AUDIENCE_ACTION = 'UNABLE_TO_ADD_AUDIENCE_ACTION',
    UNABLE_TO_BLOCK_MEMBER = 'UNABLE_TO_BLOCK_MEMBER',
    UNABLE_TO_DELETE_AUDIENCE = 'UNABLE_TO_DELETE_AUDIENCE',
    UNABLE_TO_DELETE_AUDIENCE_ACTION = 'UNABLE_TO_DELETE_AUDIENCE_ACTION',
    UNABLE_TO_DELETE_AUDIENCE_AS_LIVE_ACTION_EXISTS = 'UNABLE_TO_DELETE_AUDIENCE_AS_LIVE_ACTION_EXISTS',
    UNABLE_TO_UNASSIGN_AS_REPLIES_NOT_REASSIGNED = 'UNABLE_TO_UNASSIGN_AS_REPLIES_NOT_REASSIGNED',
    UNABLE_TO_UNASSIGN_P2P_SUPPORTER_FROM_ACTION = 'UNABLE_TO_UNASSIGN_P2P_SUPPORTER_FROM_ACTION',
    UNAUTHORIZED = 'UNAUTHORIZED',
    UNSUPPORTED_TRANSFORMER_TYPE = 'UNSUPPORTED_TRANSFORMER_TYPE',
    UPGRADE_PLAN = 'UPGRADE_PLAN',
    USER_ALREADY_DELETED = 'USER_ALREADY_DELETED',
    USER_ALREADY_VERIFIED = 'USER_ALREADY_VERIFIED',
    USER_NAME_EXISTS = 'USER_NAME_EXISTS',
    USER_NOT_FOUND = 'USER_NOT_FOUND',
    USER_NOT_OCADMIN = 'USER_NOT_OCADMIN',
    USER_VERIFICATION_SENDING_FAILED = 'USER_VERIFICATION_SENDING_FAILED',
    USE_SOCIAL_LOGIN = 'USE_SOCIAL_LOGIN',
    VISIT_TEMPLATE_CONTENT_CANNOT_BE_EMPTY = 'VISIT_TEMPLATE_CONTENT_CANNOT_BE_EMPTY',
}

export enum NgpDbMode {
    NGP_MY_CAMPAIGN = 'NGP_MY_CAMPAIGN',
    NGP_MY_VOTER = 'NGP_MY_VOTER',
}

export enum TagIntegrationType {
    NGP_MY_CAMPAIGN = 'NGP_MY_CAMPAIGN',
    NGP_MY_VOTER = 'NGP_MY_VOTER',
    OUTREACH_CIRCLE = 'OUTREACH_CIRCLE',
}
/** READY # reuse & updateLIVE # reuse but cannot updateARCHIVED # no reuse obviously no update */
export enum TemplateStatus {
    READY = 'READY',
    LIVE = 'LIVE',
    ARCHIVED = 'ARCHIVED',
}

export type Date = any;

export type Json = any;

export type Any = any;

// ====================================================
// Scalars
// ====================================================

// ====================================================
// Types
// ====================================================

export interface Query {
    /** Get eligible supporters for action assignment based on action typeGet canvass summary for GRO action */
    getGROCanvassSummary: GroCanvassSummary;
    /** Get eligible supporters for action assignment based on action type */
    getSupportersForActionAssignment: SupporterViewList;
    /** Get members assigned to supporter for action */
    getAssignedMembers: AssignedMemberList;
    /** Get members canvassed by supporter for action */
    getCanvassedMembers: AssignedMemberList;
    /** Get content for sending to recipient by supporter */
    getContentForSendingToRecipientBySupporter: string;
    /** Get member field validation */
    getMemberFormFieldValidations: MemberFormFieldValidations[];
    /** Check whether action exists with given namethrows error:OUTREACH_CIRCLE_NOT_FOUND - When outreach circle is not found */
    doesActionExists: boolean;
    /** Get public details for an action to previewAction with any status is allowed to previewthrows error:ACTION_NOT_FOUND */
    getActionForPreview: PublicAction;
    /** Get actions for preview for a particular group */
    getActionsForPreviewByGroup: PublicActionList;
    /** Get actions for preview for a particular supporter */
    getActionsForPreviewForSupporter: PublicActionList;
    /** Get actions for outreach circlethrows error:OUTREACH_CIRCLE_NOT_FOUND - When outreach circle is not found */
    getActionsForOutreachCircle: ActionList;
    /** Get actions for a given organization action id */
    getActionsForOrganizationAction: ActionList;
    /** Get current actions for outreach circlethrows error:OUTREACH_CIRCLE_NOT_FOUND - When outreach circle is not found */
    getCurrentActionsForOutreachCircle: ActionList;
    /** Get p2p actions where at least 1 initial message is sent */
    getP2PActionsWhereInitialTextIsSent?: ActionList | null;
    /** Get inactive actions for outreach circle (actions which are not archived) */
    getInactiveUnarchivedActionsForOutreachCircle: ActionList;
    /** Get archived actions for outreach circle */
    getArchivedActionsForOutreachCircle: ActionList;
    /** Get public actions for outreach circleReturns only LIVE actionsthrows error:OUTREACH_CIRCLE_NOT_FOUND - When outreach circle is not foundALIAS_DOES_NOT_EXIST: Alias is not found */
    getPublicActionsForEmbed: PublicActionList;
    /** Get public actions for outreach circleReturns only LIVE actionsthrows error:OUTREACH_CIRCLE_NOT_FOUND - When outreach circle is not found */
    getPublicActionsForOutreachCircle: PublicActionList;
    /** Get public actions for supporter(Returns Public LIVE actions and the actions that are assigned to the supporter) */
    getPublicActionsForSupporter: PublicActionList;
    /** Get public actionthrows error:ACTION_NOT_FOUNDACTION_NOT_AVAILABLE - When the action is not active/available */
    getPublicAction: PublicAction;
    /** Get action by idthrows error:ACTION_NOT_FOUND */
    getAction: Action;
    /** Get supporter status for an action */
    getSupporterActionStatus?: SupporterActionStatus | null;
    /** Proxy for FB */
    getFacebookData: Json;
    /** Get contacts for affinity textingErrors thrown:ACTION_NOT_ASSIGNED_TO_SUPPORTER - Action is not assigned to the supporterINVALID_ACTION_TYPE - When action is not of type affinity textingACTION_NOT_IN_LIVE_STATE - Action is not in LIVE state */
    getContactsForAffinityTexting: TextingContactsList;
    /** Get contacts and the text content for affinity textingErrors thrown:ACTION_NOT_ASSIGNED_TO_SUPPORTER - Action is not assigned to the supporterINVALID_ACTION_TYPE - When action is not of type affinity textingACTION_NOT_IN_LIVE_STATE - Action is not in LIVE state */
    getContactsForAffinityTextingV1: TextingContactsList;
    /** Get Text content for sending sms for a member using affinity texting actionErrors thrown:ACTION_NOT_ASSIGNED_TO_SUPPORTER - Action is not assigned to the supporterINVALID_ACTION_TYPE - When action is not of type affinity textingACTION_NOT_IN_LIVE_STATE - Action is not in LIVE stateINVALID_MOBILE_NUMBER - Mobile number in the input is invalid */
    getTextContentForAffinityTexting: string;
    /** Get Text content for sending sms for a member using affinity texting actionErrors thrown:ACTION_NOT_ASSIGNED_TO_SUPPORTER - Action is not assigned to the supporterINVALID_ACTION_TYPE - When action is not of type affinity textingACTION_NOT_IN_LIVE_STATE - Action is not in LIVE stateINVALID_MOBILE_NUMBER - Mobile number in the input is invalid */
    getSupporterTextContentForTextingSupporter: string;
    /** Get actions for which emails sent by supporter */
    getActionsForWhichEmailsSentBySupporter: PublicActionList;
    /** Get actions for which text messages sent by supporter */
    getActionsForWhichTextMessagesSentBySupporter: PublicActionList;
    /** Get list of all actions taken by supporter */
    getActionsTakenBySupporter: PublicActionList;
    /** Get list of all supporters set linked to text supporter action */
    getTextSupporterSetList?: TextSupporterSetList | null;
    /** Get eligible supporter count for supporter texting. Excluding opt out and no phone numbers. */
    getEligibleSupporterCountForSupporterTexting: number;
    /** Get eligible actions for assigning to a group */
    getEligibleActionsForAssigningToGroup?: (Action | null)[] | null;
    /** Get the action for embedding in an iframe */
    getEmbedAction: PublicAction;
    /** Get the assigned supporters and the audience actions with pagination */
    getAssignedSupportersForAction?: ActionAudienceActionList | null;
    /** fetch assigned supporters to action default order by name */
    fetchAssignedSupportersToAction: ActionSupporterList;
    /** Get estimated cost acceptance info for action like when and by whom it got accepted */
    getEstimatedCostAcceptanceInfoForAction?: ActionEstimatedCostAck | null;
    /** Get custom audience custom field list for actions */
    getAudienceCustomFieldListForAction: (AudienceCustomField | null)[];
    /** Returns true when SMS from real mobile is sent for all eligible recipients else falseErrors thrown:INVALID_ACTION_FOR_SMS - When action type or its configuration is not eligible for sending SMS or its considered */
    hasSMSSentToAllEligibleRecipients: boolean;
    /** Get the public action by Alias(Returns action only if it is in active state)ErrorsALIAS_DOES_NOT_EXIST - outreachcircle alias does not existALIAS_NOT_ASSOCIATED_TO_OUTREACH_CIRCLE - Alias not associated to outreach circleACTION_ALIAS_DOES_NOT_EXIST - There is no alias by the key or no action associated to the aliasACTION_NOT_IN_LIVE_STATE - Action is not in active state - throw name in the error message */
    publicActionByAlias: PublicAction;
    /** Get the list of actions linked to audience action (Returns maximum 3 actions by default) */
    getActionsLinkedToAudienceAction: (Action | null)[];
    /** Send Action Preview Email to Admin */
    sendActionEmailNotificationPreview?: boolean | null;
    /** Get original action call template by action id */
    getOriginalActionCallTemplateForSupporter: string;
    /** Get original action visit template by action id */
    getOriginalActionVisitTemplateForSupporter: string;
    /** Fetch groups assigned to action */
    fetchGroupsAssignedToAction: ActionGroupList;
    /** Get Member Notes */
    getMemberNotes: MemberNoteList;
    /** Get households basedon supporters currentLocation */
    getHouseholdsBasedonCurrentLocation: AddressBasedCanvassingHouseHold[];
    /** Get matched members for the data given by the user */
    getMatchedMembersForAddressBasedCanvassing: SearchAndSurveyMemberList;
    /** Get mapping by audience action ids */
    getAudienceAction: AudienceAction;
    /** Get the presigned request fields for uploading audience file */
    presignedAudienceActionUploadUrl: AudienceActionFileUploadUrl;
    /** search for a member of audience by name */
    audienceMemberByName: MemberSearchResult;
    /** check if the audience mapping name already exists */
    doesAudienceMappingNameExist: boolean;
    /** Get the audience actions  by database that can be used to link to an action while creating */
    getAudienceActionsForOutreachCircleByIntegrationType: (AudienceAction | null)[];
    /** Get the audience actions  by database that can be used to link to an action while updating */
    getAudienceActionsForActionByIntegrationType: (AudienceAction | null)[];
    /** Get the data to be displayed for a particular listType */
    getAudienceInfoByListType?: AudienceInfo | null;
    /** Get the list of LIVE actions using the audience action in the input (Returns maximum 3 actions) */
    getLiveActionsByAudienceAction: (Action | null)[];
    /** Get mappings by audience id */
    getMappingsByAudienceId: AudienceMappingList;
    /** Will be used to show the member while taking the surveyErrors thrown:INVALID_MEMBER_ID */
    getSearchAndSurveyMemberById: SearchAndSurveyMember;
    /** get matched members for survey and survey actionErrors thrown:ACTION_NOT_IN_LIVE_STATESEARCH_EXCEEDS_MAXIMUM_RESULTS_WITH_INCOMPLETE_DATA */
    getMatchedMembersForSearchAndSurveyAction: SearchAndSurveyMemberList;
    /** Get the constituent lists from blackbaud */
    getBlackbaudConstituentLists?: (BlackbaudConstituentList | null)[] | null;
    /** Gets all broadcast texting scripts for the outreach circle */
    getBroadcastTextingScripts: (BroadcastTextingScript | null)[];
    /** Get broadcast texting script by ID */
    getBroadcastTextingScriptById: BroadcastTextingScript;
    /** Checks if OutreachCircle ready for broadcast texting */
    checkOutreachCircleReadyForBroadcastTexting: boolean;
    /** Gets broadcast texting stats */
    getBroadcastTextingDetails: BroadcastTextingDetails;
    /** Gets broadcast texting delivery recipients */
    getBroadcastTextingDeliveryRecipients: DeliveryRecipientsResponse;
    /** Get the details of a contactErrors thrown:ACTION_NOT_FOUND */
    supporterContact?: SupporterContact | null;
    /** Get matched contacts for the supporterReturns only the matched contacts for which user has not yet taken any action */
    mappedContacts?: MappedContactsList | null;
    /** Get matched contacts for the supporter for textingReturns only the matched contacts for which user has not yet taken any action */
    mappedContactsForText?: MappedContactsList | null;
    /** Get email recipients for the supporterErrors thrown:ACTION_NOT_FOUND */
    emailRecipients?: MappedContactsList | null;
    /** Get ambiguous mapped contacts for the supporterErrors thrown:ACTION_NOT_FOUND */
    ambiguousMappedContacts?: AmbiguousMappedContactList | null;
    /** Get ambiguous mapped contacts for texting for the supporterErrors thrown:ACTION_NOT_FOUND */
    ambiguousMappedContactsForText?: AmbiguousMappedContactList | null;
    /** Create the text recipient and content for sending a text messageErrors thrown:CONTACT_NOT_FOUNDINVALID_PHONE_NUMBERACTION_NOT_IN_LIVE_STATETEXT_TEMPLATE_NOT_LINKED */
    getContentForTextRecipient?: string | null;
    /** Mark text recipient as sentErrors thrown:INVALID_TEXT_RECIPIENT - Invalid text recipient */
    markTextRecipientAsSent?: boolean | null;
    /** Count for mapped contacts */
    mappedContactsCount: MappedContactsCountResponse;
    /** Count for mapped contacts for text */
    mappedContactsCountForText: MappedContactsCountResponseForText;
    /** Count for email recipients for outreach mode */
    mappedContactsCountForOutreachMode: MappedContactsCountResponseForOutreachMode;
    /** Count for text recipients for outreach mode */
    mappedContactsCountForTextOutreachMode: MappedContactsCountResponseForTextOutreachMode;
    /** Get matching job by id */
    matchingJob: MatchingJob;
    /** Contact sources with mapped contacts count */
    contactSourcesWithMappedContactCount: (ContactSource | null)[];
    /** Contact sources with ambiguous mapped contacts count */
    contactSourcesWithAmbiguousMappedContactCount: (ContactSource | null)[];
    /** Contact sources with mapped contacts count for text */
    contactSourcesWithMappedContactCountForText: (ContactSource | null)[];
    /** Contact sources with ambiguous mapped contacts count for text */
    contactSourcesWithAmbiguousMappedContactCountForText: (ContactSource | null)[];
    /** Get the non mapped contacts for email that are be added as recipients for VFM action with NVFM enabledErrors thrown:INVALID_ACTION - If actionId in input is not VFM with NVFM enabled */
    getSelectedNonMappedContactsForEmail: ContactEmailRecipientList;
    /** Get the non mapped contacts for text that are be added as recipients for VFM action with NVFM enabledErrors thrown:INVALID_ACTION - If actionId in input is not VFM with NVFM enabled */
    getSelectedNonMappedContactsForText: ContactTextRecipientList;
    /** Get the non mapped contacts for email that can be added as recipients for VFM action with NVFM enabledErrors thrown:INVALID_ACTION - If actionId in input is not VFM with NVFM enabled */
    getEligibleOutreachModeRecipientsForEmail: ContactEmailRecipientList;
    /** Get the non mapped contacts for text that can be added as recipients for VFM action with NVFM enabledErrors thrown:INVALID_ACTION - If actionId in input is not VFM with NVFM enabled */
    getEligibleOutreachModeRecipientsForText: ContactTextRecipientList;
    /** Contacts that cannot be recipients for email for NVFM flow */
    getUnavailableContactsForEmailOutreachMode: ContactList;
    /** Contacts that cannot be recipients for text for NVFM flow */
    getUnavailableContactsForTextOutreachMode: ContactList;
    /** Get matched contacts for the supporter - A1CR */
    getMappedContactsForAction: MappedContactsListForAction;
    /** Get unmatched contacts for the supporter - A1CR */
    getNonMappedContactsForAction: NonMappedContactList;
    /** Get ambiguous mapped contacts for the supporter - A1CR */
    getAmbiguousContactsForAction: AmbiguousMappedContactList;
    /** Errors thrown:ACTION_NOT_FOUND - If actionId in input is not validSUPPORTER_NOT_FOUND - If suppoterId in input is not validGet A1C Recipient List */
    getA1CRecipients: MappedContactsListForAction;
    /** Get Duplicate Email Recipients List */
    getDuplicateEmailRecipients: DuplicateEmailRecipientList;
    /** Get Matches for the contact */
    getMatchesForContact: MemberList;

    getContactFileUploadUrl: Json;

    contactSources?: (ContactSource | null)[] | null;
    /** Check if contact exists with given email in logged-in user's contact list */
    doesContactExistsForEmail: boolean;
    /** Check if contact exists with given phone number in logged-in user's contact list */
    doesContactExistsForPhoneNumber: boolean;
    /** Get contacts for logged in userAllows users to search contacts by normalized nameAllows users to filter contacts by contact sourceAllows pagination */
    getContacts: ContactList;
    /** Get contacts for logged in userAllows users to search contacts by normalized nameAllows users to filter contacts by contact sourceAllows pagination */
    getContactsWithEmail: ContactEmailRecipientList;
    /** Get contacts for logged in userAllows users to search contacts by normalized nameAllows users to filter contacts by contact sourceAllows pagination */
    getContactsWithPhone: ContactTextRecipientList;
    /** Get contact by idErrors Thrown:CONTACT_NOT_FOUND - No contact with this id exists for the logged in user */
    getContactById: Contact;
    /** Returns the count of supporters for the top 3 recruitment links for an outreach circle */
    getTotalSupportersByRecruitmentLink: SupporterCountByRecruitmentLink;
    /** Total actions taken for an outreach circle */
    totalActionsTaken: number;
    /** Total supporters for an outreach circle */
    totalSupporters: number;
    /** Action impressions for an outreach circle */
    totalActionImpressions: number;
    /** Return the most engaged supporters for an outreach circle */
    mostEngagedSupporters: MostEngagedSupportersResponse;
    /** Actions taken by supporters */
    actionsTakenBySupporters: ActionsTakenBySupportersResponse;
    /** Email summary for an outreach circle */
    emailSummary: EmailSummaryResponse;
    /** Get the total messages sent for an outreach circle */
    textMessagesSent: number;
    /** Action statistics by type for an outreach circle */
    actionsByType: ActionsByTypeResponse;
    /** Response summary for a survey */
    surveyResponseSummary: SurveyResponseSummary;
    /** Get original action email template subject by template id and supporter idErrors thrown:EMAIL_TEMPLATE_NOT_FOUND */
    getOriginalActionEmailTemplateSubjectForSupporter: string;
    /** Get original action email template content by template id and supporter idErrors thrown:EMAIL_TEMPLATE_NOT_FOUND */
    getOriginalActionEmailTemplateContentForSupporter: string;
    /** Get HTML for engagement by idErrors thrown:ENGAGEMENT_NOT_FOUND */
    editHtmlForEngagementById: string;
    /** Returns the preview html for the given editor content */
    getContentForPreview: string;
    /** Get email template by idErrors thrown:EMAIL_TEMPLATE_NOT_FOUND */
    emailTemplate: EmailTemplate;
    /** Get the email templates for an outreach circle in context of action */
    emailTemplatesByOutreachCircle?: EmailTemplateList | null;
    /** Returns default HTML for recruitment link */
    defaultEditHtmlForRecruitmentLink: string;
    /** Returns default HTML for action link */
    getDefaultEditorContentForActionLink: string;
    /** Returns HTML with updated recruitment link text */
    updatedEmailTemplateWithRecruitmentLink: string;
    /** Returns HTML with updated outreachcircle branding */
    updatedEmailTemplateWithOutreachCircleBranding: string;
    /** Returns HTML with disclaimer */
    editHtmlForDisclaimer: string;
    /** Returns HTML with updated disclaimer text */
    updatedEmailTemplateWithDisclaimer: string;
    /** Returns HTML with updated survey details */
    getEmailContentForUIEditorWithUpdatedSurvey: string;
    /** Returns true if the email template name is uniqueErrors thrown:EMAIL_TEMPLATE_WITH_SAME_NAME_EXISTS */
    validateEmailTemplateNameForAction: boolean;
    /** Get all email templates for an organization */
    emailTemplatesByOrganization?: EmailTemplateForOrganizationList | null;
    /** Returns default HTML for recruitment link email editor addon */
    defaultHtmlForRecruitmentLinkForOrgEmailTemplate: string;
    /** Returns default HTML for disclaimer email editor addon */
    defaultHtmlForDisclaimerForOrgEmailTemplate: string;
    /** Returns true if the email template name is uniqueErrors thrown:EMAIL_TEMPLATE_WITH_SAME_NAME_EXISTS */
    validateOrganizationEmailTemplateName?: boolean | null;
    /** Returns the preview html for the given editor content for organization */
    getContentForUIPreviewByUIEditorContentForOrganization: string;
    /** Get the survey engagement by idErrorsSURVEY_ENGAGEMENT_NOT_FOUND - Survey engagement not found */
    surveyById: Engagement;
    /** Get the surveys by outreachcircle id */
    surveysByOutreachCircleId: Engagement[];
    /** Get the surveys by outreachcircle id */
    getSurveysEligibleForForActionByIntegration: Engagement[];
    /** Get all external links for outreachcircle */
    searchExternalLinksByOutreachCircleId: ExternalLinkList;
    /** Get the survey engagement by idErrorsSURVEY_ENGAGEMENT_NOT_FOUND - Survey engagement not foundINVALID_SURVEY_TEXT_RECIPIENT - When text recipient id is not valid. */
    surveyByIdForTextRecipient: PublicEngagement;
    /** Get the survey engagement by idErrorsSURVEY_ENGAGEMENT_NOT_FOUND - Survey engagement not foundINVALID_SURVEY_TEXT_RECIPIENT - When text recipient id is not valid. */
    surveyByIdForEmailRecipient: PublicEngagement;
    /** Get preview for survey engagement */
    surveyEngagementForPreview: PublicEngagement;
    /** Get the preview data of a suvery engagment questionErrorsENGAGEMENT_QUESTION_NOT_FOUND - Survey engagement question is not found */
    getSupporterPreviewForSurveyQuestion: EngagementQuestion;
    /** Get the preview data for suvery engagmentErrorsSURVEY_ENGAGEMENT_NOT_FOUND - Survey engagement not found */
    getSupporterPreviewForSurvey: PublicEngagement;
    /** Checks whether survey with given name already exist for given outreachcircle */
    doesSurveyByNameAndOutreachCircleIdExist: boolean;
    /** Get surveys from all the outreachcircles that belong to organization */
    getSurveysForOrganization: EngagementList;
    /** Get all the gro survey forms of the outreach circle */
    groSurveyFormsByOutreachCircle?: GroSurveyFormList | null;
    /** Get the preview data of a gro survey form questionErrors thrown:GRO_SURVEY_FORM_QUESTION_NOT_FOUND */
    getSupporterPreviewForGroSurveyFormQuestion: GroSurveyFormQuestion;
    /** Get the preview data for gro survey formErrors thrown:GRO_SURVEY_FORM_NOT_FOUND */
    getSupporterPreviewForGroSurveyForm: GroSurveyForm;
    /** Get the gro survey form by idErrors thrown:GRO_SURVEY_FORM_NOT_FOUND */
    getGroSurveyFormById: GroSurveyForm;
    /** Returns true if the gro survey form name is uniqueErrors thrown:GRO_SURVEY_FORM_WITH_SAME_NAME_EXISTS */
    validateGroSurveyFormName?: boolean | null;
    /** Get the survey responses submitted by the member for a gro survey form */
    getGROSurveyResponseForMember: (GroSurveyFormResponse | null)[];
    /** Get list of gro survey form responses for a member */
    getPastGroSurveyResponsesForMember: GroSurveyFormResponseList;
    /** Get groups for an outreach circle */
    getGroupsByOutreachCircle: GroupList;
    /** Get actions for group */
    getActionsForGroup?: ActionList | null;
    /** Get group by id */
    group: Group;
    /** Get all eligible groups for a specific action */
    getEligibleGroupsForAction: GroupList;
    /** Get all groups for outreachCircle with isAssignedToAction information */
    getAllGroupsForAction: GroupList;
    /** Fetch all integrations for an outreach circle */
    fetchIntegrations: IntegrationList;
    /** Fetch NationBuilder people tagsErrors thrown:NATION_BUILDER_INTEGRATION_NOT_FOUND - When the OutreachCircle doesnot have a NationBuilder integrationINVALID_NATION_BUILDER_CREDENTIALS - When the NationBuilder credential is invalid */
    fetchNationBuilderPeopleTags: NationBuilderPeopleTagsList;
    /** Test NGP integration */
    testNgpIntegration: TestNgpResponse;
    /** Fetch NGP listsErrors thrown:INVALID_NGP_CREDENTIALS - NGP credentials are invalid */
    fetchNgpLists: NgpLists;
    /** Fetch NGP listsErrors thrown:INVALID_NGP_CREDENTIALS - NGP credentials are invalidINVALID_NGP_ACTIVIST_CODE_ID - NGP activist code is invalid */
    fetchNgpActivistCodes: NgpActivistCodeList;
    /** Fetch NGP listErrors thrown:INVALID_NGP_CREDENTIALS - NGP credentials are invalid */
    fetchNgpSurveyList: NgpSurveyList;
    /** Fetch NGP listsErrors thrown:INVALID_NGP_CREDENTIALS - NGP credentials are invalid */
    fetchNgpSurveyById: NgpSurveyQuestion;
    /** Get PDI On The Go AssignmentsErrors thrown:AssignmentNotFound */
    getPDIOnTheGoAssignments: PdiAssignmentResponse;
    /** Get PDI assignment zones */
    getPDIAssignmentZones: (PdiAssignmentZone | null)[];
    /** Get matched PDI members for the data given by the user */
    getMatchedPDIMembers: SearchAndSurveyMemberList;
    /** Get PDI QuestionsErrors thrown:PDI_INTEGRATION_NOT_FOUND - When the OutreachCircle doesnot have a PDI integration */
    getPDIQuestions: PdiQuestionList;
    /** Get Flag IDsErrors thrown:PDI_INTEGRATION_NOT_FOUND - When the OutreachCircle does not have a PDI integration */
    getPDIFlagIds?: (PdiFlagId | null)[] | null;
    /** Get PDI Projects for outreachcircle */
    getPdiProjectsForOutreachcircle: (PdiProjectInfo | null)[];
    /** Validate SOQLErrors thrown:INVALID_SOQL - When the soql contains any invalid keywords or salesforce soql query failsINTEGRATION_NOT_FOUND - When integration does not exist */
    validateSOQL: Json;
    /** Get TCR Registration details */
    getTCRRegistrationDetails: GetTcrRegistrationDetailsOutput;
    /** Get all applicable usecases for specific TCR Brand */
    getTCRBrandApplicableUsecases: TcrBrandApplicableUsecase[];
    /** Get base64 for image media */
    getBase64ForAnImage: string;
    /** Get Engagement and SearchAndSurveyForm for an outreach circle */
    memberSurveysByOutreachCircleId: MemberSurvey[];
    /** Get Engagement and SearchAndSurveyForm for an organization */
    memberSurveysByOrganizationId: MemberSurveyList;
    /** Get latest native app version information */
    getLatestNativeAppVersion?: NativeAppVersion | null;
    /** Get public details for an organization action to previewAction with any status is allowed to previewthrows error:ACTION_NOT_FOUND */
    getOrganizationActionForPreview: PublicOrganizationAction;
    /** Get action by idthrows error:ACTION_NOT_FOUND */
    getOrganizationAction: OrganizationAction;
    /** Get actions for organization */
    getActionsForOrganization: OrganizationActionList;
    /** Get all the outreach circles for which the organization action is published */
    getOutreachCirclesByOrganizationActionPublished: OutreachCircle[];
    /** Get list of organization actions that are on terminated status or hidden */
    getTerminatedAndHiddenOrganizationActions: OrganizationActionList;
    /** Get list of organization actions that are not on terminated status or hidden */
    getCurrentOrganizationActions: OrganizationActionList;
    /** Check whether organization action exists with given name */
    doesOrganizationActionWithSameNameExist: boolean;
    /** Get All action Tag */
    getActionOrganizationTagsForOutreachCircle: OrganizationTagList;
    /** Get all tags for an organization */
    getActionOrganizationTagsForOrganization: OrganizationTagList;
    /** Get the all orzanization usersErrors thrown:ORGANIZATION_NOT_FOUND: orzanization with given id not found */
    getAllOrganizationUsers?: OrganizationUser[] | null;
    /** Get organizations of the user */
    getAllOrganizations: OrganizationList;
    /** Get an organization by its ID */
    organizationById: Organization;
    /** Get the public organization by AliasReturns organization with default aliasErrorsORGANIZATION_ALIAS_DOES_NOT_EXIST - There is no alias by the key */
    publicOrganizationByAlias: PublicOrganization;
    /** Get all outreach circles of the organization */
    getOutreachCirclesByOrganization: OutreachCircleDataList;
    /** Get all outreach circles of the organization excluding the archived ones */
    getActiveOutreachCirclesByOrganization: OutreachCircleDataList;
    /** Get filters created by the user for the organization */
    getFiltersByOrganization: OrganizationDashboardFilter[];
    /** Total actions taken by all supporters in the organization */
    totalActionsTakenForOrganization: number;
    /** Actions taken by supporters */
    actionsTakenCountByOutreachcircleForOrganization: ActionsTakenCountByOutreachcircleForOrganization[];
    /** Most engaged supporters for organization */
    mostEngagedSupportersForOrganization: MostEngagedSupportersForOrganization[];
    /** Get count of supporters by recruitment link */
    getSupporterCountByOutreachcircleForOrganization: SupporterCountByOutreachcircleForOrganization[];
    /** Get counts of actions based on their type */
    actionsByTypeForOrganization: ActionsByTypeResponse;
    /** Get email summary for organization */
    emailSummaryForOrganization: EmailSummaryResponse;
    /** Get total texts sent for organization */
    textMessagesSentForOrganization: number;
    /** Get email open rate for organization */
    emailOpenRateForOrganization: number;
    /** Total supporters for organization */
    totalSupportersCountForOrganization: number;
    /** Get OutreachCircles for a user by organization */
    getOutreachCirclesForUserByOrganization?: OutreachCircle[] | null;
    /** Get public organization */
    publicOrganization: PublicOrganization;
    /** Get all public outreach circles of the organizationthrows error:ORGANIZATION_NOT_FOUND - Organization not found */
    getPublicOutreachCirclesByOrganization: PublicOutreachCircleList;
    /** Check whether there exists a template with same name, code and organization */
    doesOutreachCircleUserEmailTemplateExists: boolean;
    /** Get all organization email aliases */
    getAllEmailAliasesForOrganization: string[];
    /** Get the organization email templates for sendingfrom Organization to Outreach circle admins */
    getOutreachCircleUserEmailTemplatesForOrganization?: OutreachCircleUserEmailTemplateList | null;
    /** Get preview with the updated content */
    getPreviewForOutreachCircleUserEmailTemplate: string;
    /** Get the editor content after updating the action link text */
    getUpdatedContentForOutreachCircleUserEmailTemplateWithActionLinkText: string;
    /** Get the email template linked for the organization action */
    getEmailTemplateForOrganizationAction?: OutreachCircleUserEmailTemplate | null;
    /** Get the eligible recipients count for sending organization action notification email */
    getEligibleCountForOrganizationActionNotification: number;
    /** Get eligible count for notify admins for organization */
    getEligibleCountForNotifyOcAdminsForOrganization: number;
    /** Get the outreach circle userErrors thrown:INVALID_OUTREACH_CIRCLE_USER: Outreach circle user with the given id not found */
    outreachCircleUser?: OutreachCircleUser | null;
    /** TODO: Need to be deprecated in future and will be handeled by publicOutreachCircleByAliasOrNameGet the public outreachCircle by Alias(Returns outreachCircle only if it is in active state)ErrorsALIAS_DOES_NOT_EXIST - There is no alias by the keyALIAS_NOT_ASSOCIATED_TO_OUTREACH_CIRCLE - There is no outreach circle associated to the aliasINACTIVE_OUTREACH_CIRCLE - Outreach circle of the matching alias is in INACTIVE status */
    publicOutreachCircleByAlias: PublicOutreachCircle;
    /** Get the public outreachCircle by Alias or Name(Returns outreachCircle only if it is in active state)ErrorsALIAS_OR_NAME_DOES_NOT_EXIST - There is no alias by the keyALIAS_OR_NAME_NOT_ASSOCIATED_TO_OUTREACH_CIRCLE - There is no outreach circle associated to the alias or nameINACTIVE_OUTREACH_CIRCLE - Outreach circle of the matching alias is in INACTIVE status */
    publicOutreachCircleByAliasOrName: PublicOutreachCircleList;
    /** Public Outreach circle for embedded flowThrow Errors:ALIAS_NOT_EMBEDDABLE: Alias is not embeddedableALIAS_DOES_NOT_EXIST: Alias is not found */
    publicOutreachCircleForEmbed: PublicOutreachCircle;
    /** Get the public outreachCircle by Alias or Name or City or State or Zip(Returns outreachCircle only if it is in active state)ErrorsINVALID_SEARCH_KEY - Search Key is not specifiedOUTREACH_CIRCLE_NOT_FOUND - There is no outreach circle associated to the search key */
    searchPublicOutreachCircle: PublicOutreachCircleSearchResultList;
    /** Get the outreachCircle by AliasErrorsALIAS_DOES_NOT_EXIST - There is no alias by the keyALIAS_NOT_ASSOCIATED_TO_OUTREACH_CIRCLE - There is no outreach circle associated to the alias */
    outreachCircleByAlias: OutreachCircle;
    /** Get the outreachCircle by idErrorsOUTREACH_CIRCLE_NOT_FOUND - Outreach circle not found */
    outreachCircleById: OutreachCircle;
    /** Get all public active outreach circles */
    allPublicOutreachCircles: PublicOutreachCircleList;
    /** Get all aliases for outreachCircle */
    allAliasesForOutreachCircle: AliasList;
    /** Get all email aliases for outreachCircle */
    allEmailAliasesForOutreachCircle: OutreachCircleEmailAlias[];
    /** Fetch all campaigns for given outreachCircle */
    getAllCampaignsForOutreachCircle: (Campaign | null)[];
    /** Get OutreachCircle Access for logged in user */
    getOutreachCircleAccessInfo: OutreachCircleAccessInfo;
    /** Get public alias detailsErrors thrown:ALIAS_DOES_NOT_EXIST - When no alias exists with of that value */
    getPublicAliasDetails: PublicAlias;
    /** Get app logo associated with outreach circle of aliasErrors thrown:ALIAS_DOES_NOT_EXIST - When no alias exists with of that value */
    getAppLogoByAlias?: string | null;
    /** Get the archived public outreachCircle by idErrorsOUTREACH_CIRCLE_NOT_FOUND - Outreach circle not found */
    getArchivedPublicOutreachCircle: ArchivedPublicOutreachCircle;
    /** Get list of phone numbers of outreachCircle */
    getOutreachCirclePhoneNumberList?: OutreachCirclePhoneNumber[] | null;
    /** Refresh phone number status of outreachCircle */
    refreshOutreachCirclePhoneNumbersStatus: boolean;
    /** Get all area codes of phone numbers of outreach circle */
    getAreaCodesOfPhoneNumbers: number[];
    /** Get phone number action link logs */
    getOutreachCirclePhoneNumberLogs: (OutreachCirclePhoneNumberLogs | null)[];
    /** Fetch all billing cards for given outreachCircleId */
    billingCardsByOutreachCircleId: (BillingCardDetails | null)[];
    /** Get discounted amount for a plan using valid couponthrows error:INVALID_PLAN - Wrong plan inputINVALID_COUPON - Wrong coupon code inputCOUPON_HAS_EXPIRED - If redeem date is over or max redemptions are completedCOUPON_NOT_APPLICABLE - If coupon is not applicable to the outreachCircle */
    couponDiscountedAmount: number;
    /** Get upcoming invoice details for an outreach circle */
    upcomingInvoiceDetailsOfOutreachCircle: OutreachCircleUpcomingInvoiceDetails;
    /** Get old outreach circle invoices */
    oldInvoicesOfOutreachCircle?: (OutreachCircleInvoice | null)[] | null;
    /** Get filtered p2p inbox based on pagination and search key */
    getFilteredP2PInbox: P2PInbox;
    /** Get one conversation and its full details */
    getP2PConversation: P2PConversation;
    /** Get eligible supporters for assigning replies */
    getEligibleSupporterForP2PReplyAssignment: SupporterViewList;
    /** Get all the p2p script survey question by the outreach circle and search key for specific question type */
    getP2PScriptSurveyQuestionsByOutreachCircle: P2PScriptSurveyQuestionList;
    /** Get the p2p script survey question by idErrors thrown:P2P_SCRIPT_SURVEY_QUESTION_NOT_FOUND */
    getP2PScriptSurveyQuestionById: P2PScriptSurveyQuestion;
    /** Returns true if the p2p script survey question name is uniqueErrors thrown:P2P_SCRIPT_SURVEY_QUESTION_WITH_SAME_NAME_EXISTS */
    isValidP2PScriptSurveyQuestionName: boolean;
    /** Get recipients for p2p action */
    getRecipientsForP2PTexting: P2PRecipientsForTexting;
    /** Get number of recipients already p2p-texted by supporter for the action. */
    getNumberOfRecipientsP2PTexted: number;
    /** Get initial p2p item */
    getInitialP2PItem: InitialP2PItem;
    /** Get initial p2p text for restoring modified text by supporter */
    getInitialP2PTextForRestore: string;
    /** Returns true if supporter is allowed to send p2p text messageThrows error:CANNOT_SEND_P2P_TEXT_MESSAGES_OUTSIDE_THE_ALLOTTED_TIME_PERIODACTION_NOT_ASSIGNED_TO_SUPPORTERP2P_ACTION_IS_PAUSEDACTION_NOT_IN_LIVE_STATENO_RECIPIENTS_AVAILABLE_RIGHT_NOW_TO_SEND_INITIAL_TEXT */
    canSendP2PTextMessage: boolean;
    /** Get all the p2p workspace by the outreach circle and search key */
    getP2PWorkspacesByOutreachCircle: P2PWorkspaceList;
    /** Get the p2p workspace by idErrors thrown:P2P_WORKSPACE_NOT_FOUND */
    getP2PWorkspaceById: P2PWorkspace;
    /** Returns true if the p2p workspace name is unique */
    isValidP2PWorkspaceName: boolean;
    /** Returns true if the p2p workspace is linked to any Action and acknowledged estimated cost */
    isP2PWorkspaceLinkedToActionAndAcknowledgedCost: boolean;
    /** Get reports along with last created report data if available. */
    getReportsByOutreachCircle?: ReportInfo[] | null;
    /** Get reports along with last created report data if available. */
    getReportsByOrganization?: ReportInfo[] | null;
    /** Get all the search and survey forms of the outreach circle */
    searchAndSurveyFormsByOutreachCircle?: SearchAndSurveyFormList | null;
    /** Get the preview data of a search and survey form questionErrors thrown:SEARCH_AND_SURVEY_FORM_QUESTION_NOT_FOUND */
    getSupporterPreviewForSearchAndSurveyFormQuestion: SearchAndSurveyFormQuestion;
    /** Get the preview data for search and survey formErrors thrown:SEARCH_AND_SURVEY_FORM_NOT_FOUND */
    getSupporterPreviewForSearchAndSurveyForm: SearchAndSurveyForm;
    /** Get the search and survey form by idErrors thrown:SEARCH_AND_SURVEY_FORM_NOT_FOUND */
    getSearchAndSurveyFormById: SearchAndSurveyForm;
    /** Returns true if the search and survey form name is uniqueErrors thrown:SEARCH_AND_SURVEY_FORM_WITH_SAME_NAME_EXISTS */
    validateSearchAndSurveyFormName?: boolean | null;
    /** Returns default HTML for recruitment link for social templates */
    defaultEditHtmlForRecruitmentLinkForSocialText: string;
    /** Returns the preview html for the given editor content */
    getSocialTextContentForPreview: string;
    /** Get the social templates for an outreach circle */
    socialTemplatesByOutreachCircle?: SocialTemplateList | null;
    /** Returns true if the social template name is uniqueErrors thrown:SOCIAL_TEMPLATE_WITH_SAME_NAME_EXISTS */
    validateSocialTemplateName?: boolean | null;
    /** Get the social templates for an organization */
    socialTemplatesByOrganization?: SocialTemplateForOrganizationList | null;
    /** Returns true if the organization social template name is uniqueErrors thrown:SOCIAL_TEMPLATE_WITH_SAME_NAME_EXISTS */
    validateOrganizationSocialTemplateName?: boolean | null;
    /** Get organization social template by idErrors thrown:SOCIAL_TEMPLATE_DOES_NOT_EXIST */
    socialTemplateByIdForOrganization: SocialTemplateForOrganization;
    /** Returns default HTML for recruitment link for organization social templates */
    defaultHtmlForRecruitmentLinkForOrgSocialText: string;
    /** Get social template by idErrors thrown:SOCIAL_TEMPLATE_DOES_NOT_EXIST */
    socialTemplate: SocialTemplate;
    /** Returns the preview html for the given editor content */
    getOrganizationSocialTextContentForPreview: string;
    /** Get Sourcing Link for a given outreach circle. Default sort is by name */
    getSourcingLinkForOutreachCircle: SourcingLinkList;
    /** Returns the content with the link text replacedErrors thrown:ACTION_NOT_FOUND - Action was not found */
    getUpdatedReminderContent: string;
    /** Get the supporter template for the outreach circle */
    getSupporterTemplatesForOutreachCircle?: SupporterEmailTemplateList | null;
    /** Get the defalt editor content to be inserted into supporter invitation template */
    getDefaultEditorContentForSupporterRecruitmentLink: string;
    /** Get editor content for preview when the are not yet saved to database for outreach circle supporter email template */
    getContentForUIPreviewByUIEditorContentForOutreachCircleSupporterEmailTemplate: string;
    /** Returns HTML with updated recruitment link text */
    getUpdatedEditorContentForSupporterRecruitmentLink: string;
    /** Returns true if the email template name is uniqueErrors thrown:EMAIL_TEMPLATE_WITH_SAME_NAME_EXISTS */
    validateSupporterEmailTemplateName?: boolean | null;
    /** Returns Default Email template for supporter notify on live */
    getDefaultContentForActionEmailNotification: SupporterEmailTemplate;
    /** Get all the supporter forms of the outreach circle */
    supporterFormsByOutreachCircle?: SupporterFormList | null;
    /** Get the preview data of a supporter form questionErrors thrown:SUPPORTER_FORM_QUESTION_NOT_FOUND */
    getSupporterPreviewForSupporterFormQuestion: SupporterFormQuestion;
    /** Get the preview data for supporter formErrors thrown:SUPPORTER_FORM_NOT_FOUND */
    getSupporterPreviewForSupporterForm: SupporterForm;
    /** Get the supporter form by idErrors thrown:SUPPORTER_FORM_NOT_FOUND */
    getSupporterFormById: SupporterForm;
    /** Returns true if the email template name is uniqueErrors thrown:SUPPORTER_FORM_WITH_SAME_NAME_EXISTS */
    validateSupporterFormName?: boolean | null;
    /** Get supporter forms from all the outreachcircles that belong to organization */
    getSupporterFormsForOrganization: SupporterFormList;
    /** Get default content/template of push notification for action */
    getDefaultContentForActionPushNotification: SupporterPushNotificationTemplate;
    /** Get saved supporter filters for the admin */
    getSupporterViewFilterStates: SupporterViewFilterStateList;
    /** Does supporter view filter with same name exists */
    doesSupporterViewFilterStateExists: boolean;
    /** gets a supporter if exists if the logged in user is a supporter.Must be AuthorizedErrorsALIAS_DOES_NOT_EXIST - There is no alias by the key */
    getSupporterByOutreachCircleAlias?: Supporter | null;
    /** gets a supporter if exists by supporterId.ErrorsSUPPORTER_NOT_FOUND - The supporterId provided does not match a supporter */
    getSupporterById: Supporter;
    /** get supporter's detailed summary */
    getSupporterSummaryList?: SupporterSummaryList | null;
    /** Get filtered supporter view */
    getFilteredSupporterView: SupporterViewList;
    /** Get signed url to upload file to s3 for invited supporter */
    getInvitedSupporterFileUploadUrl: Json;
    /** Get Total number of invited supporters */
    getTotalInvitedSupportersByOutreachCircle: number;
    /** Get invited supporter information from invitedSupporterId and outreachCircleIdErrors thrown:INVITED_SUPPORTER_INFORMATION_NOT_FOUND: When either invitedSupporterId oroutreachCircleId is invalid or not found in supporter table */
    getInvitedSupporterInformation?: InvitedSupporterInformation | null;
    /** Get total number of text message sent by logged in user */
    getTotalTextMessagesSentByLoggedInUser: number;
    /** Count of actions taken by logged in user in all outreach circles */
    getTotalActionsTakenByLoggedInUser: number;
    /** Supporter email summary for all outreach circles */
    supporterEmailSummary: EmailSummaryData;
    /** Get email summary data for supporter for particular action */
    getActionEmailSummaryForSupporter: ActionEmailSummaryForSupporterData;
    /** Get email recipients for supporter for particular action */
    getEmailRecipientsForAction: ActionEmailRecipientsLists;
    /** Get only email summary data for supporter for particular action */
    getEmailSummaryForAction: EmailSummaryData;
    /** Get text message summary data for supporter for particular action */
    getActionTextMessageSummaryForSupporter: ActionTextMessageSummaryForSupporterData;
    /** Get count of all eligible supporters for sending push notification based on the filter provided by user */
    getEligibleSupporterCountForSendingPushNotification: number;
    /** Get count of all eligible supporters for sending email notification based on the filter provided by admin */
    getEligibleSupporterCountForSendingEmailNotification: number;
    /** Get number of supporters who can be blocked */
    getNumberOfSupportersWhoCanBeBlocked: number;
    /** Get outreach circle sharable link uniquely generated for the supporter */
    getOutreachCircleSharableLink: string;
    /** Check if the given email is a supporter of the outreach circle */
    isSupportingOutreachCircle: boolean;
    /** Get most recent invite supporter mapping. Also get all custom fields added in all the previous invites in same order. */
    getRecentInviteSupporterMappingWithAllCustomFields?: RecentInviteSupporterMappingWithAllCustomFields | null;
    /** Get all tags for an outreachCircle */
    getAllTagsForOutreachCircle: TagList;
    /** Get tags for a public action */
    getTagsForPublicAction: PublicTagList;
    /** Get tag info with respect to an actionErrors thrown:TAG_NOT_FOUND: When not able to find tag */
    getTagInfoForAction: Tag;
    /** Get list of canned response linked to a tag */
    getCannedResponsesForTag: CannedResponseList;
    /** Get tags eligible for linking to action */
    getTagsEligibleToBeLinkedToAction: TagList;

    testDelay: boolean;
    /** Get original action text template content by template id and supporter idErrors thrown:TEXT_TEMPLATE_NOT_FOUND */
    getOriginalActionTextTemplateContentForSupporter: string;
    /** Get text template by idErrors thrown:TEXT_TEMPLATE_NOT_FOUND */
    textTemplate: TextTemplate;
    /** Get the text templates for an outreach circle */
    textTemplatesByOutreachCircle?: TextTemplateList | null;
    /** Get organization text template by idErrors thrown:TEXT_TEMPLATE_NOT_FOUND */
    textTemplateByIdForOrganization: TextTemplateForOrganization;
    /** Get the text templates for an organization */
    textTemplatesByOrganization?: TextTemplateForOrganizationList | null;
    /** Returns default HTML for recruitment link for organization text templates */
    defaultHtmlForRecruitmentLinkForOrgTextTemplate: string;
    /** Returns true if the organization text template name is uniqueErrors thrown:TEXT_TEMPLATE_WITH_SAME_NAME_EXISTS */
    validateOrganizationTextTemplateName?: boolean | null;
    /** Get the supporter text templates for an outreach circle */
    supporterTextTemplatesByOutreachCircle?: TextTemplateList | null;
    /** Returns default HTML for recruitment link for text templates */
    defaultEditHtmlForRecruitmentLinkForText: string;
    /** Returns default HTML for recipient first name for text templates */
    defaultEditHtmlForRecipientFirstNameForText: string;
    /** Returns default HTML for supporter first name for text templates */
    defaultEditHtmlForSupporterFirstNameForText: string;
    /** Returns default HTML for supporter last name for text templates */
    defaultEditHtmlForSupporterLastNameForText: string;
    /** Returns default HTML for recipient last name for text templates */
    defaultEditHtmlForRecipientLastNameForText: string;
    /** Returns the preview html for the given editor content */
    getTextContentForPreview: string;
    /** Returns true if the text template name is uniqueErrors thrown:TEXT_TEMPLATE_WITH_SAME_NAME_EXISTS */
    validateTextTemplateName?: boolean | null;
    /** Returns the preview html for the given editor content in context of organization */
    getOrganizationTextContentForPreview: string;
    /** Checks whether a username (email) exists.Returns Boolean */
    usernameExists: boolean;
    /** When user clicks on the reset password link,we will validate if the resetcode is valid for the user,because, we change the reset code everytime user tries to reset passwordErrors thrown:USER_NOT_FOUND - User id in the request does not belong to any user */
    validateResetCode?: boolean | null;
    /** Get the user object by auth tokenErrorsINVALID_AUTH_TOKEN - Token passed in the request is invalid */
    userByToken: User;
    /** validate auth token */
    validateToken: boolean;
    /** validate auth token and return User id */
    validateTokenAndReturnUserId?: string | null;
    /** Get outreachCircles for which the logged in user is the adminOf */
    outreachCirclesByLoggedInUser: OutreachCircleList;
    /** Get outreachCircles for which the logged in user is the adminOf */
    archivedOutreachCirclesByLoggedInUser: OutreachCircleList;
    /** Get outreachCircles which the logged in user is supporting */
    supportingOutreachCirclesByLoggedInUser: SupporterList;
    /** Check if user existsCheck if user supports the outreach circle */
    verifyNewSupporterEmail: boolean;
    /** verify new email for embedded actionError thrown: USER_NAME_EXISTS - if user already existsSUPPORTER_ALREADY_EXISTS - if user exists and supports the outreach circleSUPPORTER_IS_BLOCKED_FOR_OUTREACH_CIRCLE - if user exists and blocked for the outreach circle */
    verifyNewSupporterEmailForEmbeddedAction: boolean;
}

export interface GroCanvassSummary {
    summary: GroCanvassChannelSummary[];

    totalCanvassed: number;
}

export interface GroCanvassChannelSummary {
    count: number;

    outreachChannel: OutreachChannel;
}

export interface SupporterViewList {
    total: number;

    items: (SupporterView | null)[];

    activeAndBlockedSupportersCount: number;

    filteredSupporterCount: number;
}

export interface SupporterView {
    supporterId: string;

    outreachCircleId: string;

    fullName?: string | null;

    phoneNumber?: string | null;

    email?: string | null;

    origin: string;

    actionsCompleted: number;

    messagesSentBySupporter: number;

    recruitmentLink?: string | null;

    statusOfLastEmailSentToSupporter?: LastEmailStatus | null;

    joinedOn?: Date | null;

    zip?: string | null;

    location?: string | null;

    isUnsubscribed?: boolean | null;

    optInForText?: boolean | null;

    emailMessagesSent?: number | null;

    emailOpenedCount?: number | null;

    groups?: (GroupSupporter | null)[] | null;

    recruitedBySupporter?: string | null;

    nativeAppUser?: boolean | null;

    pushNotificationsEnabled?: boolean | null;

    numberOfAppInstalls?: number | null;

    inactiveAppUser?: boolean | null;

    nativeAppPlatform?: string | null;

    currentSupporter?: SupporterStatus | null;

    firstName?: string | null;

    lastName?: string | null;

    isAssignedToAction: boolean;

    blockedOn?: Date | null;

    blockedBy?: User | null;

    isEmailBounced?: boolean | null;
}

export interface GroupSupporter {
    id: string;

    name: string;

    isManualAssignment?: boolean | null;
}

export interface User {
    id: string;

    username?: string | null;

    firstName?: string | null;

    lastName?: string | null;

    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;

    phoneNumber?: string | null;

    isVerified: boolean;

    uiPreferences: Json;

    optInForText?: boolean | null;

    outreachCircleCodes?: string[] | null;

    isRapidlyOnboarded?: boolean | null;

    isPasswordSet?: boolean | null;

    allowAccessToOrganization?: boolean | null;
}

export interface AssignedMemberList {
    items: (AssignedMember | null)[];

    total: number;
}

export interface AssignedMember {
    contact: AssignedContact;

    assignedMemberCanvassedInfo?: AssignedMemberCanvassedInfo | null;

    searchCustomFields?: (CustomField | null)[] | null;

    surveyCustomFields?: (CustomField | null)[] | null;

    customFields?: (CustomField | null)[] | null;
}

export interface AssignedContact {
    id?: string | null;

    member_id: string;

    display_member_id: string;

    first_name?: string | null;

    middle_name?: string | null;

    last_name?: string | null;

    emails?: (ContactEmail | null)[] | null;

    mobiles?: (ContactMobile | null)[] | null;

    apt_number?: string | null;

    street_name?: string | null;

    street_number?: string | null;

    street_type?: string | null;

    full_address?: string | null;

    city?: string | null;

    state?: string | null;

    zip?: string | null;

    location?: Location | null;
}

export interface ContactEmail {
    type: ContactEmailTypeEnum;

    value?: string | null;

    isInvalid?: boolean | null;
}

export interface ContactMobile {
    type: ContactMobileTypeEnum;

    value?: string | null;
}

export interface Location {
    lat?: number | null;

    lon?: number | null;
}

export interface AssignedMemberCanvassedInfo {
    canvassedDate?: Date | null;

    contactedChannels?: OutreachChannel[] | null;
}

export interface CustomField {
    key: string;

    value?: string | null;
}

export interface MemberFormFieldValidations {
    name: string;

    maxLength: number;

    type: string;

    editable: boolean;
}

export interface PublicAction {
    id: string;

    type: string;

    title: string;

    description?: string | null;

    outreachChannels: (OutreachChannel | null)[];

    link?: string | null;

    completed: boolean;

    taken?: boolean | null;

    totalCompletions: number;

    totalTakenCount: number;

    liveAt?: Date | null;

    status?: ActionStatus | null;

    created?: Date | null;

    updated?: Date | null;

    emailTemplate?: EmailTemplateForSupporter | null;

    textTemplate?: TextTemplateForSupporter | null;

    socialTemplate?: SocialTemplateForSupporter | null;

    callTemplate?: string | null;

    visitTemplate?: string | null;

    callToActionText?: string | null;

    postActionText?: string | null;

    additionalDetails?: Json | null;

    isOutreachMode?: boolean | null;

    allowNonMappedContacts?: boolean | null;

    audienceActions?: (string | null)[] | null;

    position?: number | null;

    media?: Media | null;

    outreachCircle: PublicOutreachCircleDetail;

    emailsSentCountForAction: number;

    textsSentCountForAction: number;

    emailsSentCountByLoggedInUser: number;

    textsSentCountByLoggedInUser: number;

    textSupporterSetCount: number;

    canTakeAction?: boolean | null;

    facebookData?: PublicFacebookData | null;

    supporterForm?: PublicSupporterForm | null;

    searchAndSurveyForm?: PublicSearchAndSurveyForm | null;

    groSurveyForm?: PublicGroSurveyForm | null;

    totalP2PConversations: number;

    totalP2PRepliesPending: number;

    totalP2PInitalTextSent: number;

    canSendP2PReply: boolean;

    takenConfirmationText?: string | null;

    canSkipTakenConfirmation: boolean;

    assignedMemberData?: AssignedMemberData | null;

    canEditGROMember: boolean;

    linkedTags?: PublicTagList | null;

    hasExistingPdiOnTheGoAssignment: boolean;

    organizationTag?: OrganizationTag | null;
}

export interface EmailTemplateForSupporter {
    id: string;

    subject: string;

    created: Date;

    updated?: Date | null;

    contentForEditor: string;

    contentForPreview: string;

    contentForSending?: string | null;
}

export interface TextTemplateForSupporter {
    id: string;

    created: Date;

    updated?: Date | null;

    contentForEditor: string;

    contentForPreview: string;

    contentForSending?: string | null;
}

export interface SocialTemplateForSupporter {
    id: string;

    contentForSharing?: SocialTextContentForSharing | null;
}

export interface SocialTextContentForSharing {
    text: string;
}

export interface Media {
    id: string;

    url: string;

    fileName: string;

    fileSize: number;

    created: Date;

    updated?: Date | null;

    thumbnail: string;
}

export interface PublicOutreachCircleDetail {
    id: string;

    name: string;

    city?: string | null;

    state?: string | null;

    stateName?: string | null;

    country?: string | null;

    zip?: string | null;

    phoneNumber?: string | null;

    introduction: string;

    introductionPlainText?: string | null;

    logo?: Media | null;

    code?: Alias | null;

    supporting?: boolean | null;

    supporterReplyToEmail?: string | null;

    archived?: boolean | null;

    additionalDetails?: OutreachCircleAdditionalDetails | null;
}

export interface Alias {
    id: string;

    value?: string | null;

    created?: Date | null;

    isCode?: boolean | null;

    name?: string | null;

    description?: string | null;

    supporterCount?: number | null;

    groupCount?: number | null;

    isDefault?: boolean | null;

    isRapidOnboardingEnabled?: boolean | null;

    groups?: (Group | null)[] | null;

    isLandingPage?: boolean | null;

    logo?: Media | null;

    sharableUrl?: string | null;

    isAppOnly?: boolean | null;

    languagePreference?: LanguagePreferenceType | null;

    additionalDetails?: AliasAdditionalDetails | null;

    longURL?: string | null;

    shortURL?: string | null;
}

export interface Group {
    id: string;

    name: string;

    created: Date;

    updated?: Date | null;

    supporterCount: number;

    actionCount: number;

    aliasCount?: number | null;

    actions?: ActionList | null;

    aliases?: (Alias | null)[] | null;

    isAssignedToAction?: boolean | null;

    isDeleted: boolean;
}

export interface ActionList {
    items: (Action | null)[];

    total: number;
}

export interface Action {
    id: string;

    type: ActionType;

    name: string;

    alias: string;

    title?: string | null;

    description?: string | null;

    outreachCircleId?: string | null;

    outreachChannels: (OutreachChannel | null)[];

    status: ActionStatus;

    callToActionText?: string | null;

    startDate?: Date | null;

    endDate?: Date | null;

    created?: Date | null;

    updated?: Date | null;

    link?: string | null;

    totalCompletions: number;

    totalTakenCount: number;

    liveAt?: Date | null;

    expiredAt?: Date | null;

    emailTemplate?: EmailTemplate | null;

    textTemplate?: TextTemplate | null;

    totalReminders: number;

    allReminders?: (SupporterEmailMessage | null)[] | null;

    lastReminder?: SupporterEmailMessage | null;

    impression?: number | null;

    postActionText?: string | null;

    engagementId?: string | null;

    additionalDetails?: ActionAdditionalDetails | null;

    isOutreachMode?: boolean | null;

    matchWithSearchAndSurveyLists?: boolean | null;

    allowNonMappedContacts?: boolean | null;

    audienceActions?: (AudienceAction | null)[] | null;

    searchAndSurveyAudienceActions?: (AudienceAction | null)[] | null;

    filterCount?: number | null;

    position?: number | null;

    media?: Media | null;

    statusLogs?: (ActionStatusLog | null)[] | null;

    isEngagementRequired?: boolean | null;

    groups?: (Group | null)[] | null;

    groupsCount?: number | null;

    textSupporterSetCount: number;

    embedCode?: string | null;

    socialTemplate?: SocialTemplate | null;

    supporterForm?: SupporterForm | null;

    isVoterFileSetupRequired?: boolean | null;

    isVoterFileSetupComplete?: boolean | null;

    campaign?: Campaign | null;

    engagement?: Engagement | null;

    integrationType?: AllowedIntegrationDatabaseType | null;

    linkedTags?: TagList | null;

    canToggleOutreachMode?: boolean | null;

    canChangeListDatabase?: boolean | null;

    canAssignToSupporters?: boolean | null;

    canAssignToGroups?: boolean | null;

    p2pWorkspace?: P2PWorkspace | null;

    broadcastTextingScript?: BroadcastTextingScript | null;

    assignedSupportersCount: number;

    isSupporterListAssignmentComplete?: boolean | null;

    p2pListProgress?: P2PListProgress | null;

    searchAndSurveyNewContactsAudienceAction?: AudienceAction | null;

    searchAndSurveyForm?: SearchAndSurveyForm | null;

    groSurveyForm?: GroSurveyForm | null;

    uniqueSelectedAudienceCustomFieldsCount: number;

    selectedAudienceCustomFieldsForSearch?: (AudienceCustomField | null)[] | null;

    selectedAudienceCustomFieldsForSurvey?: (AudienceCustomField | null)[] | null;

    isArchived: boolean;

    deactivatedAt?: Date | null;

    terminatedAt?: Date | null;

    takenConfirmationText?: string | null;

    canSkipTakenConfirmation: boolean;

    turfingActionData?: TurfingActionData | null;

    initialPushNotificationTemplate?: SupporterPushNotificationTemplate | null;

    reminderPushNotificationTemplate?: SupporterPushNotificationTemplate | null;

    initialEmailNotificationTemplate?: SupporterEmailTemplate | null;

    reminderEmailNotificationTemplate?: SupporterEmailTemplate | null;

    notificationLogs?: (ActionNotificationLog | null)[] | null;

    syndicatedActionInfo?: SyndicatedActionInfo | null;

    p2pPhoneNumberInfoList?: (P2PPhoneNumberInfo | null)[] | null;

    sharableLink?: string | null;

    organizationTag?: OrganizationTag | null;
}

export interface EmailTemplate {
    id: string;

    name: string;

    subject: string;

    created: Date;

    updated?: Date | null;

    contentForEditor: string;

    contentForPreview: string;

    isOutreachCircleBrandExist: boolean;

    fromNameAlias?: string | null;
}

export interface TextTemplate {
    id: string;

    name: string;

    created: Date;

    updated?: Date | null;

    contentForEditor: string;

    contentForPreview: string;
}

export interface SupporterEmailMessage {
    sentBy: string;

    created: Date;

    supportersCount: number;
}

export interface ActionAdditionalDetails {
    isTreatmentEnabled?: boolean | null;

    treatment?: number | null;

    everyActionFormId?: string | null;

    everyActionFormHasRedirect?: boolean | null;

    eventLink?: string | null;

    allowContactImport?: boolean | null;

    openUrl?: string | null;

    eventName?: string | null;

    isEmbeddable?: boolean | null;

    phone2ActionUrl?: string | null;

    playVideoInAppEnabled?: boolean | null;

    videoId?: string | null;

    videoSource?: string | null;

    previousStatus?: string | null;

    audienceFilter?: string | null;

    isSharingEnabled?: boolean | null;

    shareButtonText?: string | null;

    isSyndicatedAction?: boolean | null;

    reviewWarningInfo?: ReviewWarningInfo | null;

    requiredIntegrationType?: AllowedIntegrationDatabaseType | null;

    p2pTextingInfo?: P2PTextingInfo | null;

    broadcastTextingInfo?: BroadcastTextingInfo | null;

    callTemplate?: string | null;

    visitTemplate?: string | null;

    facebookConfig?: FacebookConfig | null;

    groConfig?: ActionGroConfig | null;

    contactTypeLabel?: ContactTypeLabel | null;

    addressBasedCanvassingConfig?: AddressBasedCanvassingActionConfig | null;

    pdiOnTheGoCanvassingConfig?: PdiOnTheGoCanvassingConfig | null;

    isAnonymousSearchAndSurveyEnabled?: boolean | null;
}

export interface ReviewWarningInfo {
    emailTemplate?: boolean | null;

    textTemplate?: boolean | null;

    socialTextTemplate?: boolean | null;
}

export interface P2PTextingInfo {
    preferredAreaCodes?: (number | null)[] | null;

    p2pSchedule?: P2PSchedule | null;

    p2pError?: P2PError | null;

    allowUninterruptedTexting?: boolean | null;

    disableManageReplies?: boolean | null;

    disableEditMessage?: boolean | null;
}

export interface P2PSchedule {
    startTime: P2PTime;

    endTime: P2PTime;
}

export interface P2PTime {
    hour: number;

    minute: number;

    timezone: string;
}

export interface P2PError {
    oldAreaCodes?: (number | null)[] | null;

    pauseReason?: P2PPauseReason | null;
}

export interface BroadcastTextingInfo {
    isDeliverySetupComplete?: boolean | null;

    broadcastTextingError?: BroadcastTextingError | null;
}

export interface BroadcastTextingError {
    message?: string | null;
}

export interface FacebookConfig {
    pageUrl?: string | null;

    postId?: string | null;
}

export interface ActionGroConfig {
    turfingStrategy?: TurfingStrategyEnum | null;

    supporterIdFieldInList?: string | null;

    supporterEmailFieldInList?: string | null;
}

export interface ContactTypeLabel {
    matched?: ContactTypeLabelInfo | null;

    unmatched?: ContactTypeLabelInfo | null;

    ambiguous?: ContactTypeLabelInfo | null;
}

export interface ContactTypeLabelInfo {
    title?: string | null;

    description?: string | null;

    position?: number | null;
}

export interface AddressBasedCanvassingActionConfig {
    maxMemberAssignmentForSupporter?: number | null;

    turfingRangeInMiles?: number | null;
}

export interface PdiOnTheGoCanvassingConfig {
    pdiProject?: PdiProject | null;

    allowAddingMembers?: boolean | null;

    allowCensusBlocks?: boolean | null;
}

export interface PdiProject {
    pdiProjectId?: string | null;

    pdiProjectName?: string | null;
}

export interface AudienceAction {
    id: string;

    status: string;

    count?: number | null;

    created?: Date | null;

    createdBy?: string | null;

    failureReason?: string | null;

    displayName: string;

    database: AudienceActionDatabase;

    source?: AudienceActionSource | null;

    integrationType?: IntegrationType | null;

    transaction: AudienceActionTransaction;

    format: AudienceActionFormat;

    listType: ListType;

    isEnabled: boolean;

    additionalDetails?: AudienceActionAdditionalDetails | null;

    mapping?: AudienceActionMapping | null;
}

export interface AudienceActionAdditionalDetails {
    schedule?: SoqlSchedule | null;
}

export interface SoqlSchedule {
    frequency: Frequency;

    dayOfWeek?: number | null;

    dayOfMonth?: number | null;
}

export interface AudienceActionMapping {
    id: string;

    name: string;

    mappingData: Json;
}

export interface ActionStatusLog {
    fromStatus?: string | null;

    toStatus?: string | null;

    created?: Date | null;
}

export interface SocialTemplate {
    id: string;

    name: string;

    created: Date;

    updated?: Date | null;

    contentForEditor: string;

    contentForPreview: string;
}

export interface SupporterForm {
    id: string;

    name: string;

    supporterFormQuestions?: SupporterFormQuestion[] | null;

    copyOf?: string | null;

    created: Date;

    updated?: Date | null;

    supporterFormIntegrationType?: SupporterFormIntegrationType | null;

    supporterSubmissionsCount?: number | null;

    outreachCircle: OutreachCircle;
}

export interface SupporterFormQuestion {
    id: string;

    supporterFormId: string;

    questionText: string;

    questionType: SupporterFormQuestionType;

    isMandatory: boolean;

    position: number;

    options: SupporterFormOption[];

    ngpSurveyQuestionId?: number | null;

    ngpSurveyQuestion?: NgpSurveyQuestion | null;

    questionIntegrationType?: SupporterFormQuestionIntegrationType | null;

    totalUniqueSupportersResponded: number;
}

export interface SupporterFormOption {
    id: string;

    optionText: string;

    position: number;

    optionType: SupporterFormOptionType;

    ngpSurveyResponseId?: number | null;

    ngpActivistCode?: NgpActivistCode | null;

    assignedGroupId?: string | null;

    totalUniqueSupportersResponded: number;
}

export interface NgpActivistCode {
    activistCodeId?: number | null;

    type?: string | null;

    name?: string | null;

    mediumName?: string | null;

    shortName?: string | null;

    description?: string | null;

    scriptQuestion?: string | null;

    status?: string | null;

    isMultiAssign?: boolean | null;
}

export interface NgpSurveyQuestion {
    surveyQuestionId: number;

    type: string;

    cycle: number;

    name: string;

    mediumName: string;

    shortName: string;

    scriptQuestion: string;

    status: string;

    responses?: NgpSurveyResponse[] | null;
}

export interface NgpSurveyResponse {
    surveyResponseId: number;

    name: string;

    mediumName: string;

    shortName: string;
}

export interface OutreachCircle {
    id: string;

    name: string;

    city?: string | null;

    state?: string | null;

    stateName?: string | null;

    country?: string | null;

    zip?: string | null;

    phoneNumber?: string | null;

    industry: string;

    introduction?: string | null;

    category?: string | null;

    logo?: Media | null;

    code?: Alias | null;

    defaultAlias?: Alias | null;

    audience?: Audience | null;

    admins?: (OutreachCircleUser | null)[] | null;

    activeAdminCount: number;

    currentAdminInfo?: OutreachCircleUser | null;

    candidate?: Candidate | null;

    status?: OutreachCircleStatus | null;

    supporterCount: number;

    supporting: boolean;

    actionCount: number;

    blockedDomains?: string[] | null;

    disclaimer?: string | null;

    referredBy?: string | null;

    emailTemplates: EmailTemplateList;

    textTemplates: TextTemplateList;

    supporterTextTemplates: TextTemplateList;

    isPublic?: boolean | null;

    product: string;

    plan: string;

    impressions?: number | null;

    trialDaysLeft: number;

    productPlanInfo?: ProductPlanInfo | null;

    supporterReplyToEmail?: string | null;

    archived?: boolean | null;

    archivedOn?: Date | null;

    groups?: GroupList | null;

    groupsCount?: number | null;

    aliasCount?: number | null;

    activeSupportersCount?: number | null;

    liveActionsCount?: number | null;

    additionalDetails?: OutreachCircleAdditionalDetails | null;

    facebookPixelCode?: string | null;

    integrations?: IntegrationList | null;

    tags?: TagList | null;

    created?: Date | null;

    hasMovedToMonthlyPlanFromOriginial?: boolean | null;

    hasAnyTagBeenApplied: boolean;

    keyDates?: KeyDate[] | null;

    totalUniqueSupportersRespondedToForms: number;

    totalUniqueRecipientsRespondedToSurvey: number;

    totalUniqueRecipientsRespondedToSearchAndSurvey: number;

    totalUniqueRecipientsRespondedToGroSurvey: number;

    isEligibleForRecruitingInfluencers: boolean;

    isActionTagEnabled?: boolean | null;
}

export interface Audience {
    id: string;

    customfields?: (AudienceCustomField | null)[] | null;

    created: Date;

    updated?: Date | null;

    audienceActionInProgress?: AudienceAction | null;
}

export interface AudienceCustomField {
    id: string;

    name?: string | null;

    created?: Date | null;

    position: number;
}

export interface OutreachCircleUser {
    id: string;

    userRole?: string | null;

    additionalDetails?: OutreachCircleUserAdditionalDetails | null;

    created: Date;

    invitedOn?: Date | null;

    firstName?: string | null;

    lastName?: string | null;

    email?: string | null;

    joinedOn?: Date | null;

    invitedBy?: string | null;

    isExistingUser?: boolean | null;

    phoneNumber?: string | null;

    isOwner?: boolean | null;

    isAddedByOrganization: boolean;

    isAddedByOutreachCircle: boolean;

    hasReadOnlyAccessToOutreachCircle: boolean;

    organizations?: (Organization | null)[] | null;

    isEmailBounced?: boolean | null;
}

export interface OutreachCircleUserAdditionalDetails {
    invitationDetails?: OutreachCircleUserInvitationDetails | null;
}

export interface OutreachCircleUserInvitationDetails {
    email: string;

    firstName: string;

    lastName: string;
}

export interface Organization {
    id: string;

    name: string;

    defaultAlias: OrganizationAlias;

    totalOutreachCircles: number;

    totalSupporters: number;

    totalAdminCount: number;

    totalActionCount: number;

    currentAdminInfo?: OrganizationUser | null;

    orgUrl?: string | null;

    mainOutreachCircle?: OutreachCircle | null;

    mainOCButtonText?: string | null;

    logo?: Media | null;

    introduction?: string | null;

    emailTemplates: EmailTemplateList;

    textTemplates: TextTemplateList;

    disclaimer?: string | null;

    additionalDetails?: OrganizationAdditionalDetails | null;

    totalUniqueSupportersRespondedToForms: number;

    totalUniqueRecipientsRespondedToSurvey: number;

    totalUniqueRecipientsRespondedToSearchAndSurvey: number;

    totalUniqueRecipientsRespondedToGroSurvey: number;

    totalActionTagCount: number;
}

export interface OrganizationAlias {
    id: string;

    value: string;

    isDefault?: boolean | null;
}

export interface OrganizationUser {
    id: string;

    additionalDetails?: OrganizationUserAdditionalDetails | null;

    created?: Date;

    invitedOn?: Date | null;

    firstName?: string | null;

    lastName?: string | null;

    email?: string | null;

    joinedOn?: Date | null;

    invitedBy?: string | null;

    isExistingUser?: boolean | null;

    phoneNumber?: string | null;

    isOwner: boolean;

    hasReadOnlyAccessToOutreachCircle: boolean;
}

export interface OrganizationUserAdditionalDetails {
    invitationDetails?: OrganizationUserInvitationDetails | null;

    uiPreferences?: Json | null;
}

export interface OrganizationUserInvitationDetails {
    email: string;

    firstName: string;

    lastName: string;
}

export interface EmailTemplateList {
    total?: number | null;

    items?: (EmailTemplate | null)[] | null;
}

export interface TextTemplateList {
    total?: number | null;

    items?: (TextTemplate | null)[] | null;
}

export interface OrganizationAdditionalDetails {
    whileLabelInfo?: OrganizationWhileLabelInfo | null;

    tagEnabled?: boolean | null;
}

export interface OrganizationWhileLabelInfo {
    isWhiteLabeled?: boolean | null;

    appDownloadUrl?: OrganizationAppDownloadUrl | null;

    deepLinkUrl?: string | null;
}

export interface OrganizationAppDownloadUrl {
    android?: string | null;

    iOS?: string | null;
}

export interface Candidate {
    id: string;

    firstName?: string | null;

    lastName?: string | null;

    enabled?: boolean | null;

    image?: Media | null;
}

export interface OutreachCircleStatus {
    createdAndActivate?: boolean | null;

    setup?: OutreachCircleSetup | null;
}

export interface OutreachCircleSetup {
    isAudienceCreated?: boolean | null;

    isActionCreated?: boolean | null;

    hasSupporter?: boolean | null;
}

export interface ProductPlanInfo {
    canChangeVisibility: boolean;

    canIntegrateVAN: boolean;

    hasOneWayVANIntegration: boolean;

    hasTwoWayVANIntegration: boolean;

    canCreateSurveys: boolean;

    canGenerateReports: boolean;

    canScheduleActions: boolean;

    canCreateAliasNameOnReminders: boolean;

    canRemoveBranding: boolean;

    canImportVoterFile: boolean;

    canAddUniqueTrackingLinks: boolean;

    voterFileLimit: number;

    uniqueTrackingLinksLimit: number;

    invitedSupportersLimit: number;

    canFilterVoter: boolean;

    canTextAList: boolean;

    canIntegrateEveryAction: boolean;

    canIntegrateNationBuilder: boolean;

    canIntegratePDI: boolean;

    canIntegrateTCR: boolean;

    canCreateGroup: boolean;

    canIntegratePhone2ActionForm: boolean;

    canIntegrateGoogleBigQuery: boolean;

    canRapidlyOnboard: boolean;

    canCreateSupporterForms: boolean;

    canIntegrateFacebookPixel: boolean;

    canLinkActionTags: boolean;

    canCreateP2PAction: boolean;

    canCreateSearchAndSurveyAction: boolean;

    canAssignSupportersToAnyAction: boolean;

    canIntegrateSalesforce: boolean;

    canCreateGrassRootOrganizingAction: boolean;

    canCustomizeActionNotification: boolean;

    canCreateGRORelationalAction: boolean;

    canPurchaseOutreachCirclePhoneNumber: boolean;
}

export interface GroupList {
    items: (Group | null)[];

    total: number;
}

export interface OutreachCircleAdditionalDetails {
    whileLabelInfo?: OutreachCircleWhileLabelInfo | null;

    allowContactImport?: boolean | null;

    supporterSettings?: OutreachCircleSupporterSettings | null;

    allowCampaigns?: boolean | null;

    headquarterInfo?: HeadquarterInfo | null;

    p2pConfig?: P2PConfig | null;

    broadcastTextingConfig?: BroadcastTextingConfig | null;

    canIntegrateSalesforce?: boolean | null;

    grassRootOrganizingConfig?: GrassRootOrganizingConfig | null;

    groRelationalConfig?: GroRelationalConfig | null;

    specialActionsAllowed?: (ActionType | null)[] | null;
}

export interface OutreachCircleWhileLabelInfo {
    isWhiteLabeled?: boolean | null;

    appDownloadUrl?: OutreachCircleAppDownloadUrl | null;

    contactTypeLabelPosition?: OutreachCircleContactTypeLabelPosition | null;

    deepLinkUrl?: string | null;

    mobileAppBundleId?: string | null;

    appName?: string | null;

    appLogoURL?: string | null;

    faviconURL?: string | null;

    isWhiteLabeledOrg?: boolean | null;
}

export interface OutreachCircleAppDownloadUrl {
    android?: string | null;

    iOS?: string | null;
}

export interface OutreachCircleContactTypeLabelPosition {
    matched?: number | null;

    unmatched?: number | null;

    ambiguous?: number | null;
}

export interface OutreachCircleSupporterSettings {
    suppressSupporterWelcomeEmails?: boolean | null;

    suppressActionLiveEmails?: boolean | null;

    suppressThankYouOnFirstActionTakenEmails?: boolean | null;

    suppressSupporterWeeklyDigestEmail?: boolean | null;

    suppressTemporaryPasswordAndMagicLinkEmail?: boolean | null;

    supporterAutoEmailsFromName?: string | null;
}

export interface HeadquarterInfo {
    latitude: number;

    longitude: number;
}

export interface P2PConfig {
    isP2PActionEnabled?: boolean | null;

    isA2P10DLCRegistrationComplete?: boolean | null;

    architecture?: P2PMessagingServiceArchitecture | null;
}

export interface BroadcastTextingConfig {
    isBroadcastTextingActionEnabled?: boolean | null;
}

export interface GrassRootOrganizingConfig {
    isEnabled?: boolean | null;
}

export interface GroRelationalConfig {
    isEnabled?: boolean | null;
}

export interface IntegrationList {
    total: number;

    aggregateTotal: number;

    items?: (Integration | null)[] | null;
}

export interface Integration {
    id: string;

    data: Json;

    type: IntegrationType;

    created: Date;

    updated?: Date | null;
}

export interface TagList {
    total: number;

    items: (Tag | null)[];
}

export interface Tag {
    id: string;

    name: string;

    outreachCircleId: string;

    isDefault: boolean;

    linkedCannedResponse?: CannedResponse | null;

    actions?: ActionList | null;

    integrations?: (TagIntegrations | null)[] | null;

    type: TagType;
}

export interface CannedResponse {
    id: string;

    response: string;
}

export interface TagIntegrations {
    type?: IntegrationType | null;

    data?: TagIntegrationData | null;
}

export interface TagIntegrationData {
    ngpActivistCodes?: (NgpActivistCode | null)[] | null;

    pdiFlagIds?: (PdiFlagId | null)[] | null;
}

export interface PdiFlagId {
    id: string;

    flagId: string;

    flagIdDescription: string;

    compile: string;

    isDefault?: boolean | null;
}

export interface KeyDate {
    id: string;

    date?: Date | null;

    name: string;

    isApplicable: boolean;

    isSystemAdded: boolean;
}

export interface Campaign {
    id: string;

    name: string;
}

export interface Engagement {
    id: string;

    name: string;

    type: EngagementType;

    url?: string | null;

    description?: string | null;

    outreachCircleId: string;

    questions?: (EngagementQuestion | null)[] | null;

    created: Date;

    message?: string | null;

    additionalDetails?: Json | null;

    recipientSubmissionsCount?: number | null;

    copyOf?: string | null;

    integrationType?: AllowedIntegrationDatabaseType | null;

    outreachCircle: OutreachCircle;
}

export interface EngagementQuestion {
    id: string;

    questionText: string;

    engagementId: string;

    options: EngagementOption[];

    isMandatory: boolean;

    ngpSurveyQuestionId?: number | null;

    pdiQuestionId?: string | null;

    position?: number | null;

    type?: EngagementQuestionType | null;

    hasResponseLogic?: boolean | null;

    ngpSurveyQuestion?: NgpSurveyQuestion | null;

    pdiQuestion?: PdiQuestion | null;

    isMultipleOptionsAllowed?: boolean | null;

    additionalDetails?: Json | null;

    totalUniqueRecipientsResponded: number;
}

export interface EngagementOption {
    id: string;

    engagementQuestionId: string;

    optionText: string;

    linkedEngagement?: Engagement | null;

    linkedEngagementId?: string | null;

    ngpSurveyResponseId?: number | null;

    pdiAnswerId?: string | null;

    additionalDetails?: Json | null;

    totalResponseCount?: number | null;

    position: number;

    type: EngagementOptionType;

    ngpActivistCode?: NgpActivistCode | null;

    linkedEngagementQuestionId?: string | null;

    totalUniqueRecipientsResponded: number;
}

export interface PdiQuestion {
    id: string;

    organizationName: string;

    question: string;

    questionLabel?: string | null;

    questionDescription?: string | null;

    type?: string | null;

    category?: string | null;

    candidate?: string | null;

    default?: boolean | null;

    answerOptions: (PdiAnswerOption | null)[];
}

export interface PdiAnswerOption {
    id?: string | null;

    flagId: string;

    flagIdDescription?: string | null;

    displayCode?: string | null;
}

export interface P2PWorkspace {
    id: string;

    name: string;

    outreachCircleId: string;

    integrationType: AllowedIntegrationDatabaseType;

    p2pScripts: P2PScript[];

    tags?: P2PWorkspaceTag[] | null;

    linkedP2PScripts?: LinkedP2PScript[] | null;

    firstP2PScriptId: string;

    created?: Date | null;
}

export interface P2PScript {
    id: string;

    p2pWorkspaceId: string;

    name: string;

    p2pScriptSurveyQuestionId?: string | null;

    p2pScriptSurveyQuestion?: P2PScriptSurveyQuestion | null;

    message: string;

    p2pScriptType: P2PScriptType;

    attachments?: Media[] | null;
}

export interface P2PScriptSurveyQuestion {
    id: string;

    name: string;

    outreachCircleId: string;

    questionText: string;

    options: P2PScriptSurveyQuestionOption[];

    ngpSurveyQuestionId?: number | null;

    pdiQuestionId?: string | null;

    integrationType?: AllowedIntegrationDatabaseType | null;

    ngpSurveyQuestion?: NgpSurveyQuestion | null;

    pdiQuestion?: PdiQuestion | null;

    p2pScriptSurveyQuestionType: P2PScriptSurveyQuestionType;

    created?: Date | null;

    updated?: Date | null;
}

export interface P2PScriptSurveyQuestionOption {
    id: string;

    optionText: string;

    position: number;

    ngpSurveyResponseId?: number | null;

    pdiAnswerId?: string | null;

    ngpActivistCode?: NgpActivistCode | null;

    type: EngagementOptionType;
}

export interface P2PWorkspaceTag {
    p2pWorkspaceId: string;

    tagId: string;

    p2pScriptId?: string | null;

    name: string;

    cannedResponseText?: string | null;

    isDefault: boolean;

    position?: number | null;
}

export interface LinkedP2PScript {
    p2pScriptId: string;

    p2pScriptSurveyQuestionOptionId: string;

    nextP2PScriptId: string;
}

export interface BroadcastTextingScript {
    id: string;

    outreachCircleId: string;

    name: string;

    body: string;

    attachments?: Media[] | null;

    created: Date;

    updated?: Date | null;
}

export interface P2PListProgress {
    totalInitialTextSent: number;

    totalListSize: number;
}

export interface SearchAndSurveyForm {
    id: string;

    name: string;

    searchAndSurveyFormQuestions?: SearchAndSurveyFormQuestion[] | null;

    copyOf?: string | null;

    created: Date;

    updated?: Date | null;

    searchAndSurveyFormIntegrationType?: SearchAndSurveyFormIntegrationType | null;

    outreachCircle: OutreachCircle;

    totalUniqueResponses?: number | null;
}

export interface SearchAndSurveyFormQuestion {
    id: string;

    searchAndSurveyFormId: string;

    questionText: string;

    questionType: SearchAndSurveyFormQuestionType;

    isMandatory: boolean;

    position: number;

    options: SearchAndSurveyFormOption[];

    ngpSurveyQuestionId?: number | null;

    ngpSurveyQuestion?: NgpSurveyQuestion | null;

    questionIntegrationType?: SearchAndSurveyFormQuestionIntegrationType | null;

    totalUniqueResponses?: number | null;

    pdiQuestion?: PdiQuestion | null;
}

export interface SearchAndSurveyFormOption {
    id: string;

    optionText: string;

    position: number;

    optionType: SearchAndSurveyFormOptionType;

    ngpSurveyResponseId?: number | null;

    ngpActivistCode?: NgpActivistCode | null;

    totalUniqueResponses?: number | null;

    pdiAnswerId?: string | null;
}

export interface GroSurveyForm {
    id: string;

    name: string;

    groSurveyFormQuestions?: GroSurveyFormQuestion[] | null;

    copyOf?: string | null;

    created: Date;

    updated?: Date | null;

    groSurveyFormIntegrationType?: GroSurveyFormIntegrationType | null;

    outreachCircle: OutreachCircle;

    totalUniqueResponses?: number | null;
}

export interface GroSurveyFormQuestion {
    id: string;

    groSurveyFormId: string;

    questionText: string;

    questionType: GroSurveyFormQuestionType;

    isMandatory: boolean;

    position: number;

    options: GroSurveyFormOption[];

    questionIntegrationType?: GroSurveyFormQuestionIntegrationType | null;

    totalUniqueResponses?: number | null;

    pdiQuestion?: PdiQuestion | null;

    ngpSurveyQuestion?: NgpSurveyQuestion | null;
}

export interface GroSurveyFormOption {
    id: string;

    optionText: string;

    position: number;

    optionType: GroSurveyFormOptionType;

    totalUniqueResponses?: number | null;

    pdiAnswerId?: string | null;

    ngpSurveyResponseId?: number | null;

    ngpActivistCode?: NgpActivistCode | null;
}

export interface TurfingActionData {
    isTurfingComplete: boolean;

    isInitialTurfingComplete: boolean;

    latestTurfingLog?: TurfingLog | null;
}

export interface TurfingLog {
    id: string;

    unassignedCount?: number | null;

    unassignedListLink?: string | null;

    completedAt?: Date | null;

    created: Date;
}

export interface SupporterPushNotificationTemplate {
    id: string;

    code: SupporterPushNotificationTemplateCode;

    pushNotificationTemplate: PushNotificationTemplate;
}

export interface PushNotificationTemplate {
    id: string;

    title: string;

    body: string;

    created: Date;

    updated?: Date | null;
}

export interface SupporterEmailTemplate {
    id: string;

    emailTemplateId: string;

    outreachCircleId: string;

    code: SupporterEmailTemplateCode;

    name: string;

    fromNameAlias?: string | null;

    subject: string;

    created: Date;

    updated?: Date | null;

    contentForEditor?: string | null;

    contentForPreview?: string | null;
}

export interface EmailNotificationLog {
    created?: Date | null;

    code: SupporterEmailTemplateCode;

    count: number;
}

export interface PushNotificationLog {
    created?: Date | null;

    code: SupporterPushNotificationTemplateCode;

    count: number;
}

export interface SyndicatedActionInfo {
    organizationName: string;
}

export interface P2PPhoneNumberInfo {
    id: string;

    phoneNumber: string;

    areaCode: number;

    status: PurchasedPhoneNumberStatus;

    purchaseDate: Date;
}

export interface OrganizationTag {
    id: string;

    name: string;

    organizationId: string;

    linkedActionCount: number;
}

export interface AliasAdditionalDetails {
    applyNationBuilderTagsToAllCustomAliases?: boolean | null;

    nationBuilderPeopleTags?: (NationBuilderPeopleTags | null)[] | null;

    applyNgpActivistCodeToAllCustomAliases?: boolean | null;

    pdiFlags?: (PdiFlagId | null)[] | null;

    ngpActivistCodes?: (NgpActivistCode | null)[] | null;

    applyPDIFlagsToAllCustomAliases?: boolean | null;
}

export interface NationBuilderPeopleTags {
    name: string;
}

export interface PublicFacebookData {
    page?: Json | null;

    post?: Json | null;
}

export interface PublicSupporterForm {
    id: string;

    name: string;

    supporterFormQuestions: SupporterFormQuestion[];
}

export interface PublicSearchAndSurveyForm {
    id: string;

    name: string;

    searchAndSurveyFormQuestions: SearchAndSurveyFormQuestion[];
}

export interface PublicGroSurveyForm {
    id: string;

    name: string;

    groSurveyFormQuestions: GroSurveyFormQuestion[];
}

export interface AssignedMemberData {
    assignedMemberCount?: number | null;

    contactedMemberCount?: number | null;
}

export interface PublicTagList {
    items: PublicTag[];

    total: number;
}

export interface PublicTag {
    id: string;

    name: string;

    cannedResponse?: CannedResponse | null;

    type: TagType;
}

export interface PublicActionList {
    items: (PublicAction | null)[];

    total: number;
}

export interface SupporterActionStatus {
    supporterId: string;

    actionId: string;

    contactImportInProgress?: boolean | null;

    matchingJobInProgress?: boolean | null;

    additionalDetails?: SupporterActionAdditionalDetails | null;

    complete?: boolean | null;

    matchingJobId?: string | null;
}

export interface SupporterActionAdditionalDetails {
    importContactsCompleted?: boolean | null;

    importContactsCompleted_updatedOn?: Date | null;

    manageRecipientsCompleted?: boolean | null;

    manageRecipientsCompleted_updatedOn?: Date | null;

    p2pNUXCompletedForText?: boolean | null;

    p2pNUXCompletedForText_updatedOn?: Date | null;

    manageRecipientsCompletedForText?: boolean | null;

    manageRecipientsCompletedForText_updatedOn?: Date | null;

    importContactsCompletedForText?: boolean | null;

    importContactsCompletedForText_updatedOn?: Date | null;

    personalizeMessageCompleted?: boolean | null;

    personalizeMessageCompleted_updatedOn?: Date | null;

    personalizeMessageCompletedForText?: boolean | null;

    personalizeMessageCompletedForText_updatedOn?: Date | null;

    nuxCompletedForActionTagForText?: boolean | null;

    nuxCompletedForActionTagForText_updatedOn?: Date | null;
}

export interface TextingContactsList {
    items?: (TextingContact | null)[] | null;

    total?: number | null;
}

export interface TextingContact {
    id?: string | null;

    member_id: string;

    first_name?: string | null;

    last_name?: string | null;

    middle_name?: string | null;

    street_name?: string | null;

    street_type?: string | null;

    age_range?: string | null;

    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;

    gender?: string | null;

    isContacted?: boolean | null;

    primary_phone?: string | null;

    text_content?: string | null;

    applied_tags?: (PublicTag | null)[] | null;
}

export interface TextSupporterSetList {
    total?: number | null;

    items?: (TextSupporterSet | null)[] | null;
}

export interface TextSupporterSet {
    supporterId: string;

    fullName?: string | null;

    phoneNumber?: string | null;

    email?: string | null;

    zip?: string | null;

    location?: string | null;

    isUnsubscribed?: boolean | null;

    optInForText?: boolean | null;

    textSentOn?: Date | null;

    hasTextSent?: boolean | null;
}

export interface ActionAudienceActionList {
    total: number;

    items: ActionAudienceAction[];
}

export interface ActionAudienceAction {
    supporterView?: SupporterView | null;

    audienceAction?: AudienceAction | null;

    group?: Group | null;
}

export interface ActionSupporterList {
    total: number;

    filteredTotal: number;

    items: ActionSupporter[];
}

export interface ActionSupporter {
    supporterView: SupporterView;

    supporterId: string;

    actionId: string;

    disabled: boolean;

    p2pActionData?: P2PActionData | null;

    groActionData?: GroActionData | null;

    baseActionData?: BaseActionData | null;

    groRelationalActionData?: GroRelationalActionData | null;

    baseGroActionData?: BaseGroActionData | null;
}

export interface P2PActionData {
    totalP2PInitialTextSent: number;

    totalP2PConversations: number;

    totalP2PRepliesPending: number;

    replyReassignedTo?: SupporterView | null;
}

export interface GroActionData {
    assignedContactsCount?: number | null;
}

export interface BaseActionData {
    emailsSentCount?: number | null;

    textsSentCount?: number | null;
}

export interface GroRelationalActionData {
    contactsImported: number;

    matchedCount: number;

    ambiguousCount: number;

    unmatchedCount: number;
}

export interface BaseGroActionData {
    emailCount?: number | null;

    textCount?: number | null;

    callCount?: number | null;

    visitCount?: number | null;

    canvassedCount?: number | null;
}

export interface ActionEstimatedCostAck {
    acceptedOn: Date;

    acceptedBy: string;
}

export interface ActionGroupList {
    total: number;

    items: ActionGroup[];
}

export interface ActionGroup {
    group: Group;

    groupId: string;

    actionId: string;

    disabled: boolean;

    actionsTakenCount?: number | null;

    emailsSentCount?: number | null;

    textsSentCount?: number | null;
}

export interface MemberNoteList {
    total: number;

    items: MemberNote[];
}

export interface MemberNote {
    id: string;

    note: string;

    recordedBy: string;

    created: Date;
}

export interface AddressBasedCanvassingHouseHold {
    id: string;

    houseNumber?: string | null;

    apt?: string | null;

    streetName?: string | null;

    streetNumber?: string | null;

    streetType?: string | null;

    oddEven?: string | null;

    fullAddress?: string | null;

    city?: string | null;

    state?: string | null;

    zipcode?: string | null;

    location?: Location | null;

    members: SearchAndSurveyMember[];

    canvassStatus?: AddressBasedCanvassStatus | null;
}

export interface SearchAndSurveyMember {
    contact: SearchAndSurveyContact;

    customFields: SearchAndSurveyMemberCustomField[];

    canvassStatus?: AddressBasedCanvassStatus | null;

    addedByMe?: boolean | null;

    notInVoterfile?: boolean | null;
}

export interface SearchAndSurveyContact {
    first_name?: string | null;

    middle_name?: string | null;

    last_name?: string | null;

    emails?: (ContactEmail | null)[] | null;

    mobiles?: (ContactMobile | null)[] | null;

    street_number?: string | null;

    street_name?: string | null;

    street_type?: string | null;

    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;

    id?: string | null;

    member_id: string;

    age_range?: string | null;

    full_address?: string | null;

    gender?: string | null;

    political_party?: string | null;

    dob?: Date | null;

    apt_number?: string | null;
}

export interface SearchAndSurveyMemberCustomField {
    key: string;

    value?: string | null;
}

export interface SearchAndSurveyMemberList {
    items: (SearchAndSurveyMember | null)[];

    total: number;
}

export interface AudienceActionFileUploadUrl {
    result: Json;

    audienceActionId: string;
}

export interface MemberSearchResult {
    items: Json;

    total: number;
}

export interface AudienceInfo {
    outreachCircleId: string;

    totalSize?: number | null;

    listType: ListType;

    audienceId?: string | null;

    activeAudienceActions: AudienceActionList;

    inactiveAudienceActions: AudienceActionList;

    listTypeLimit?: number | null;
}

export interface AudienceActionList {
    total: number;

    items: AudienceAction[];
}

export interface AudienceMappingList {
    total: number;

    items: AudienceMapping[];
}

export interface AudienceMapping {
    name: string;

    mappingData: Json;

    created: Date;
}

export interface BlackbaudConstituentList {
    id?: string | null;

    name?: string | null;

    record_count?: number | null;

    date_modified?: string | null;

    last_modified_by_user_name?: string | null;

    last_modified_by_user_id?: string | null;

    is_public?: boolean | null;
}

export interface BroadcastTextingDetails {
    status: BroadcastTextingStatus;

    script: DeliveredBroadcastTextingScript;

    stats: BroadcastTextingStats;

    phoneNumbers?: string[] | null;
}

export interface DeliveredBroadcastTextingScript {
    body: string;

    mediaUrls?: (string | null)[] | null;
}

export interface BroadcastTextingStats {
    inFlight: number;

    sent: number;

    delivered: number;

    optedOut: number;

    skipped: number;

    errored: number;

    unknown: number;
}

export interface DeliveryRecipientsResponse {
    items: DeliveryRecipient[];

    total: number;
}

export interface DeliveryRecipient {
    id?: string | null;

    firstName?: string | null;

    lastName?: string | null;

    phoneNumber?: string | null;

    status?: string | null;
}

export interface SupporterContact {
    contact: Contact;

    supporter?: Supporter | null;

    matchingRuleDescription?: string | null;

    rule?: MatchingRule | null;

    score?: number | null;

    members?: (Member | null)[] | null;

    isEmailRecipient?: boolean | null;

    isTextRecipient?: boolean | null;

    isDomainBlocked?: boolean | null;

    isUnsubscribed?: boolean | null;

    isBlocked?: boolean | null;

    isOutsidePrecinct?: boolean | null;

    isTextOutsidePrecinct?: boolean | null;

    isAmbiguousResolved?: boolean | null;

    isAudienceFiltered?: boolean | null;

    isTreatmentFiltered?: boolean | null;

    isTextOptOut?: boolean | null;

    isWrongPhoneNumber?: boolean | null;

    isEmailSuppressed?: boolean | null;

    isEmailBounced?: boolean | null;

    lastEmailedDate?: Date | null;

    lastTextedDate?: Date | null;
}

export interface Contact {
    id?: string | null;

    firstName?: string | null;

    middleName?: string | null;

    lastName?: string | null;

    primaryEmail?: string | null;

    primaryPhone?: string | null;

    emails?: (ContactEmail | null)[] | null;

    mobiles?: (ContactMobile | null)[] | null;

    normalizedName?: string | null;

    photo?: string | null;

    sources?: (ContactSource | null)[] | null;

    created?: Date | null;

    streetNumber?: string | null;

    streetName?: string | null;

    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;

    duplicateEmailStatus?: DuplicateStatus | null;
}

export interface ContactSource {
    id?: string | null;

    name?: string | null;

    mapping?: Json | null;

    platform?: ContactSourcePlatform | null;

    userId?: string | null;

    type?: string | null;

    created?: Date | null;

    count?: number | null;

    importComplete?: boolean | null;
}

export interface Supporter {
    id: string;

    origin: Origin;

    created: Date;

    rerunMatching: boolean;

    outreachCircle: PublicOutreachCircle;

    isInactive?: boolean | null;

    isBlocked?: boolean | null;

    isSuspiciousMatching: boolean;

    actionForCurrentMatchingJob?: PublicAction | null;

    email?: string | null;

    additionalDetails?: SupporterAdditionalDetails | null;
}

export interface PublicOutreachCircle {
    id: string;

    name: string;

    city?: string | null;

    state?: string | null;

    stateName?: string | null;

    country?: string | null;

    zip?: string | null;

    phoneNumber?: string | null;

    introduction: string;

    logo?: Media | null;

    code?: Alias | null;

    candidate?: Candidate | null;

    supporterCount: number;

    actions: PublicActionList;

    supporting: boolean;

    isPublic?: boolean | null;

    disclaimer?: string | null;

    liveActionCount: number;

    introductionPlainText: string;

    archived?: boolean | null;

    archivedOn?: Date | null;

    additionalDetails?: OutreachCircleAdditionalDetails | null;

    supporterReplyToEmail?: string | null;

    facebookPixelCode?: string | null;
}

export interface SupporterAdditionalDetails {
    first_name?: string | null;

    last_name?: string | null;

    mobile_number?: string | null;

    zip?: string | null;

    externalId?: string | null;

    addressLine1?: string | null;

    city?: string | null;

    state?: string | null;

    primaryLanguage?: string | null;

    customFields?: Json | null;
}

export interface MatchingRule {
    id: string;

    name: string;

    description: string;

    score: string;
}

export interface Member {
    id?: string | null;

    member_id: string;

    first_name?: string | null;

    last_name?: string | null;

    middle_name?: string | null;

    street_name?: string | null;

    street_type?: string | null;

    age_range?: string | null;

    age?: number | null;

    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;

    gender?: string | null;

    is_email_recipient?: boolean | null;

    is_text_recipient?: boolean | null;

    primary_phone?: string | null;

    applied_tags?: (PublicTag | null)[] | null;

    full_address?: string | null;

    political_party?: string | null;
}

export interface MappedContactsList {
    total: number;

    items: (MappedContact | null)[];
}

export interface MappedContact {
    id: string;

    name?: string | null;

    email?: string | null;

    emailCount?: number | null;

    phoneNumber?: string | null;

    contactId: string;

    memberId: string;

    isEmailRecipient?: boolean | null;

    isTextRecipient?: boolean | null;

    mobiles?: Json | null;

    appliedTags?: (PublicTag | null)[] | null;

    address?: string | null;

    matchingDescription?: string | null;
}

export interface AmbiguousMappedContactList {
    total?: number | null;

    items?: (AmbiguousMappedContact | null)[] | null;
}

export interface AmbiguousMappedContact {
    contact: Contact;

    rule: MatchingRule;

    score: number;

    totalMatches: number;

    created: Date;

    members?: (Member | null)[] | null;

    matchingRuleDescription: string;

    isA1CRecipient?: boolean | null;
}

export interface MappedContactsCountResponse {
    mappedContactsCount: number;

    emailRecipientsCount: number;

    ambiguousContactsCount: number;

    unmappedContactsCount: number;

    contactsCount: number;

    selectedNonMappedContactsCount: number;
}

export interface MappedContactsCountResponseForText {
    mappedContactsCount: number;

    ambiguousContactsCount: number;

    unmappedContactsCount: number;

    contactsCount: number;

    selectedNonMappedContactsCount: number;
}

export interface MappedContactsCountResponseForOutreachMode {
    mappedContactsCount: number;

    emailRecipientsCount: number;

    contactsCount: number;
}

export interface MappedContactsCountResponseForTextOutreachMode {
    contactsCount: number;

    mappedContactsCount: number;
}

export interface MatchingJob {
    id: string;

    totalContacts?: number | null;

    completedContacts?: number | null;

    status: MatchingJobStatusEnum;

    actionId?: string | null;

    completed?: Date | null;

    failureReason?: string | null;

    created: Date;
}

export interface ContactEmailRecipientList {
    total?: number | null;

    items?: (ContactEmailRecipient | null)[] | null;
}

export interface ContactEmailRecipient {
    id?: string | null;

    contact?: Contact | null;

    isEmailRecipient?: boolean | null;

    appliedTags?: (PublicTag | null)[] | null;
}

export interface ContactTextRecipientList {
    total?: number | null;

    items?: (ContactTextRecipient | null)[] | null;
}

export interface ContactTextRecipient {
    contact?: Contact | null;

    isTextRecipient?: boolean | null;

    appliedTags?: (PublicTag | null)[] | null;
}

export interface ContactList {
    total?: number | null;

    items?: (Contact | null)[] | null;
}

export interface MappedContactsListForAction {
    total: number;

    items: (MappedContactForAction | null)[];
}

export interface MappedContactForAction {
    id: string;

    name?: string | null;

    address?: string | null;

    matchingDescription?: string | null;

    matchingLabel?: string | null;

    score?: number | null;

    memberId?: string | null;

    isA1CRecipient?: boolean | null;

    contact?: Contact | null;

    contactCanvassedInfo?: ContactCanvassedInfo | null;
}

export interface ContactCanvassedInfo {
    canvassedDate?: Date | null;

    contactedChannels?: OutreachChannel[] | null;
}

export interface NonMappedContactList {
    total?: number | null;

    items?: (NonMappedContact | null)[] | null;
}

export interface NonMappedContact {
    id?: string | null;

    contact?: Contact | null;

    isA1CRecipient?: boolean | null;
}

export interface DuplicateEmailRecipientList {
    total: number;

    items?: DuplicateEmailRecipient[] | null;
}

export interface DuplicateEmailRecipient {
    email: string;

    totalMatches: number;

    contacts?: Contact[] | null;
}

export interface MemberList {
    items: (Member | null)[];

    total: number;

    isAmbiguous: boolean;
}

export interface SupporterCountByRecruitmentLink {
    lastRequested?: Date | null;

    data: (SupporterCountByRecruitmentLinkData | null)[];
}

export interface SupporterCountByRecruitmentLinkData {
    name: string;

    value: string;

    count: number;
}

export interface MostEngagedSupportersResponse {
    lastRequested?: Date | null;

    data: (MostEngagedSupportersData | null)[];
}

export interface MostEngagedSupportersData {
    supporterFirstName?: string | null;

    supporterLastName?: string | null;

    recruitmentLinkName: string;

    recruitmentLinkValue: string;

    actionsTaken: number;
}

export interface ActionsTakenBySupportersResponse {
    lastRequested?: Date | null;

    data: (ActionsTakenBySupportersData | null)[];
}

export interface ActionsTakenBySupportersData {
    actionName: string;

    actionType: string;

    actionsTaken: number;
}

export interface EmailSummaryResponse {
    lastRequested?: Date | null;

    data: EmailSummaryData;
}

export interface EmailSummaryData {
    sent: number;

    delivered: number;

    opened: number;

    bounced: number;
}

export interface ActionsByTypeResponse {
    lastRequested?: Date | null;

    data: (ActionsByTypeData | null)[];
}

export interface ActionsByTypeData {
    type: string;

    ready: number;

    live: number;

    total: number;

    inactiveOrExpired: number;
}

export interface SurveyResponseSummary {
    lastRequested?: Date | null;

    data: (SurveyResponseSummaryData | null)[];
}

export interface SurveyResponseSummaryData {
    optionText: string;

    responseCount: number;
}

export interface EmailTemplateForOrganizationList {
    total?: number | null;

    items?: (EmailTemplateForOrganization | null)[] | null;
}

export interface EmailTemplateForOrganization {
    id?: string | null;

    name: string;

    subject: string;

    created: Date;

    updated?: Date | null;

    contentForPreview?: string | null;

    contentForEditor?: string | null;

    fromNameAlias?: string | null;
}

export interface ExternalLinkList {
    items: (Engagement | null)[];

    total?: number | null;
}

export interface PublicEngagement {
    id: string;

    name: string;

    type: EngagementType;

    url?: string | null;

    description?: string | null;

    questions: PublicEngagementQuestion[];

    message?: string | null;

    outreachCircle: PublicOutreachCircle;
}

export interface PublicEngagementQuestion {
    id: string;

    questionText: string;

    type?: EngagementQuestionType | null;

    options: PublicEngagementOption[];

    isMultipleOptionsAllowed?: boolean | null;

    position?: number | null;

    isMandatory: boolean;
}

export interface PublicEngagementOption {
    id: string;

    optionText: string;

    linkedEngagement?: PublicEngagement | null;

    linkedEngagementId?: string | null;

    linkedEngagementQuestionId?: string | null;

    type: EngagementOptionType;
}

export interface EngagementList {
    items: Engagement[];

    total: number;
}

export interface GroSurveyFormList {
    total: number;

    items: (GroSurveyForm | null)[];
}

export interface GroSurveyFormResponse {
    groSurveyFormQuestionId: string;

    selectedOptions: (GroSurveySelectedOption | null)[];
}

export interface GroSurveySelectedOption {
    groSurveyFormOptionId: string;

    response: GroSurveyOptionResponse;
}

export interface GroSurveyOptionResponse {
    text?: string | null;

    addressField?: OptionAddressFields | null;
}

export interface OptionAddressFields {
    address: string;

    cityAndState: string;

    zip: string;
}

export interface GroSurveyFormResponseList {
    total: number;

    items: PastGroSurveyFormResponse[];
}

export interface PastGroSurveyFormResponse {
    id: string;

    questionText: string;

    responseText: string;

    recordedBy: string;

    recordedAt: Date;
}

export interface NationBuilderPeopleTagsList {
    items: (NationBuilderPeopleTags | null)[];

    total: number;
}

export interface TestNgpResponse {
    success?: boolean | null;

    errors?: string | null;
}

export interface NgpLists {
    total: number;

    items: (NgpList | null)[];
}

export interface NgpList {
    savedListId: number;

    name: string;

    description?: string | null;

    listCount: number;

    doorCount: number;

    lastUploadedOn?: Date | null;
}

export interface NgpActivistCodeList {
    total: number;

    items: (NgpActivistCode | null)[];
}

export interface NgpSurveyList {
    total: number;

    items: (NgpSurveyQuestion | null)[];
}

export interface PdiAssignmentResponse {
    id: number;

    households: AddressBasedCanvassingHouseHold[];
}

export interface PdiAssignmentZone {
    id: number;

    name: string;
}

export interface PdiQuestionList {
    total: number;

    items: PdiQuestion[];
}

export interface PdiProjectInfo {
    id: string;

    name: string;
}

export interface GetTcrRegistrationDetailsOutput {
    brand?: TcrBrand | null;

    vetting?: TcrBrandVetting | null;

    campaign?: TcrCampaign | null;

    optInUrl?: string | null;
}

export interface TcrBrand {
    organizationType: TcrBrandOrganizationType;

    brandId: string;

    companyName: string;

    ein: string;

    phone: string;

    street: string;

    city: string;

    state: string;

    postalCode: string;

    country: string;

    email: string;

    website: string;

    vertical: TcrBrandVertical;

    referenceId: string;

    identityStatus: TcrBrandIdentityStatus;

    createDate: string;
}

export interface TcrBrandVetting {
    evpId: string;

    vettingId: string;

    vettingToken?: string | null;

    vettingScore?: number | null;

    vettingClass: string;

    vettingStatus: TcrVettingStatus;

    vettedDate: string;

    createDate: string;
}

export interface TcrCampaign {
    campaignId: string;

    status: TcrCampaignStatus;

    createDate: string;

    usecase: TcrCampaignUsecase;

    subUsecases?: (TcrCampaignUsecase | null)[] | null;

    description: string;

    sample1: string;

    sample2: string;
}

export interface TcrBrandApplicableUsecase {
    usecase: string;

    displayName: string;

    minSubUsecases: number;

    maxSubUsecases: number;
}

export interface MemberSurveyList {
    total: number;

    items: MemberSurvey[];
}

export interface NativeAppVersion {
    version: string;

    buildNumber: number;

    isMandatory: boolean;

    isUpToDate: boolean;

    appDownloadUrl: string;
}

export interface PublicOrganizationAction {
    id: string;

    type: string;

    name: string;

    title?: string | null;

    description?: string | null;

    status: OrganizationActionStatus;

    callToActionText?: string | null;

    created?: Date | null;

    updated?: Date | null;

    link?: string | null;

    postActionText?: string | null;

    additionalDetails?: OrganizationActionAdditionalDetails | null;

    isOutreachMode?: boolean | null;

    allowNonMappedContacts?: boolean | null;

    media?: Media | null;

    facebookData?: PublicFacebookData | null;

    totalTakenCount: number;

    firstOutreachCircle?: PublicOutreachCircle | null;

    emailsSentCountForAction?: number | null;

    textsSentCountForAction?: number | null;
}

export interface OrganizationActionAdditionalDetails {
    playVideoInAppEnabled?: boolean | null;

    videoId?: string | null;

    videoSource?: string | null;

    eventLink?: string | null;

    eventName?: string | null;

    isSharingEnabled?: boolean | null;

    shareButtonText?: string | null;

    facebookConfig?: FacebookConfig | null;
}

export interface OrganizationAction {
    id: string;

    type: string;

    name: string;

    title?: string | null;

    description?: string | null;

    status: OrganizationActionStatus;

    callToActionText?: string | null;

    created?: Date | null;

    updated?: Date | null;

    link?: string | null;

    adminsNotifiedOn?: Date | null;

    notifyAdmins?: boolean | null;

    publishedAt?: Date | null;

    terminatedAt?: Date | null;

    postActionText?: string | null;

    additionalDetails?: OrganizationActionAdditionalDetails | null;

    isOutreachMode?: boolean | null;

    allowNonMappedContacts?: boolean | null;

    media?: Media | null;

    facebookData?: PublicFacebookData | null;

    outreachChannels?: (OutreachChannel | null)[] | null;

    integrationType?: AllowedIntegrationDatabaseType | null;

    emailTemplate?: EmailTemplateForOrganization | null;

    textTemplate?: TextTemplateForOrganization | null;

    socialTemplate?: SocialTemplateForOrganization | null;

    outreachCircleActionStatusesCount?: OutreachCircleActionStatusesCount | null;

    isHidden: boolean;

    totalTakenCount: number;

    isVoterFileSetupRequired: boolean;

    takenConfirmationText?: string | null;

    canSkipTakenConfirmation: boolean;
}

export interface TextTemplateForOrganization {
    id?: string | null;

    name: string;

    created: Date;

    updated?: Date | null;

    contentForEditor?: string | null;

    contentForPreview?: string | null;
}

export interface SocialTemplateForOrganization {
    id: string;

    name: string;

    created: Date;

    updated?: Date | null;

    contentForEditor: string;

    contentForPreview: string;
}

export interface OutreachCircleActionStatusesCount {
    active?: number | null;

    ready?: number | null;

    incomplete?: number | null;

    inactive?: number | null;
}

export interface OrganizationActionList {
    items: (OrganizationAction | null)[];

    total: number;
}

export interface OrganizationTagList {
    total: number;

    items: (OrganizationTag | null)[];
}

export interface OrganizationList {
    total: number;

    items: Organization[];
}

export interface PublicOrganization {
    id: string;

    name: string;

    defaultAlias: OrganizationAlias;

    orgUrl?: string | null;

    mainOutreachCircle?: PublicOutreachCircle | null;

    mainOCButtonText?: string | null;

    logo?: Media | null;

    introduction?: string | null;

    disclaimer?: string | null;

    additionalDetails?: OrganizationAdditionalDetails | null;
}

export interface OutreachCircleDataList {
    total: number;

    items: (OutreachCircleData | null)[];
}

export interface OutreachCircleData {
    id: string;

    name: string;

    city?: string | null;

    state?: string | null;

    stateName?: string | null;

    country?: string | null;

    zip?: string | null;

    admins?: (OutreachCircleUser | null)[] | null;

    supporterCount: number;

    defaultAlias?: Alias | null;

    archived?: boolean | null;

    created: Date;
}

export interface OrganizationDashboardFilter {
    id: string;

    name: string;

    outreachCircleIds?: string[] | null;
}

export interface ActionsTakenCountByOutreachcircleForOrganization {
    count: number;

    outreachCircleName: string;
}

export interface MostEngagedSupportersForOrganization {
    supporterFullName?: string | null;

    actionTakenCount: number;

    outreachCircleName: string;
}

export interface SupporterCountByOutreachcircleForOrganization {
    count: number;

    outreachCircleName: string;
}

export interface PublicOutreachCircleList {
    items: (PublicOutreachCircle | null)[];

    total?: number | null;
}

export interface OutreachCircleUserEmailTemplateList {
    total: number;

    items: OutreachCircleUserEmailTemplate[];
}

export interface OutreachCircleUserEmailTemplate {
    id: string;

    emailTemplate: EmailTemplateForOutreachCircleUser;

    code: OutreachCircleUserEmailTemplateCode;
}

export interface EmailTemplateForOutreachCircleUser {
    id?: string | null;

    name: string;

    subject?: string | null;

    contentForPreview?: string | null;

    contentForEditor?: string | null;

    fromNameAlias?: string | null;

    created?: Date | null;
}

export interface PublicOutreachCircleSearchResultList {
    items: (PublicOutreachCircleSearchResult | null)[];

    total?: number | null;
}

export interface PublicOutreachCircleSearchResult {
    id: string;

    name: string;

    city?: string | null;

    state?: string | null;

    stateName?: string | null;

    country?: string | null;

    zip?: string | null;

    phoneNumber?: string | null;

    introduction: string;

    logo?: Media | null;

    code?: Alias | null;

    candidate?: Candidate | null;

    supporterCount: number;

    actions: PublicActionList;

    supporting: boolean;

    isPublic?: boolean | null;

    disclaimer?: string | null;

    liveActionCount: number;

    introductionPlainText: string;

    archived?: boolean | null;

    archivedOn?: Date | null;
}

export interface AliasList {
    total: number;

    items: (Alias | null)[];
}

export interface OutreachCircleEmailAlias {
    id: string;

    name: string;

    outreachCircleId: string;
}

export interface OutreachCircleAccessInfo {
    hasAccess: boolean;

    outreachCircleReplyToEmail: string;
}

export interface PublicAlias {
    id: string;

    value: string;

    name: string;

    description?: string | null;

    logo?: Media | null;

    isRapidOnboardingEnabled?: boolean | null;

    isLandingPage: boolean;

    isDefault: boolean;

    languagePreference?: LanguagePreferenceType | null;

    isAppOnly: boolean;

    longURL: string;

    shortURL: string;
}

export interface ArchivedPublicOutreachCircle {
    id: string;

    name: string;

    city?: string | null;

    state?: string | null;

    country?: string | null;

    zip?: string | null;

    logo?: Media | null;

    archived?: boolean | null;
}

export interface OutreachCirclePhoneNumber {
    id: string;

    phoneNumber: string;

    areaCode: number;

    status: PurchasedPhoneNumberStatus;

    linkedAction?: LinkedActionDetails | null;
}

export interface LinkedActionDetails {
    actionId: string;

    actionName: string;
}

export interface OutreachCirclePhoneNumberLogs {
    actionName: string;

    date: Date;
}

export interface BillingCardDetails {
    id: string;

    brand: string;

    country: string;

    expiryMonth: number;

    expiryYear: number;

    funding: string;

    last4: string;

    isDefault: boolean;
}

export interface OutreachCircleUpcomingInvoiceDetails {
    invoice: OutreachCircleUpcomingInvoice;

    subscriptionEndDate?: Date | null;
}

export interface OutreachCircleUpcomingInvoice {
    amountDue?: number | null;

    daysRemainingTillRenewal?: number | null;

    outreachCircleId: string;

    renewalDate?: Date | null;

    subscriptionStatus?: SubscriptionStatus | null;
}

export interface OutreachCircleInvoice {
    id: string;

    invoiceNumber: string;

    receiptNumber: string;

    invoicePdfUrl: string;

    receiptPdfUrl: string;

    couponCode?: string | null;

    couponDiscount?: number | null;

    product?: string | null;

    plan?: string | null;

    planAmount: number;

    created: Date;

    periodStartDate: Date;

    periodEndDate: Date;

    amountPaid: number;

    cardLast4: string;

    cardBrand: string;

    outreachCircleId: string;
}

export interface P2PInbox {
    items: P2PInboxItem[];

    total: number;

    getTotalUnreadCount: number;
}

export interface P2PInboxItem {
    actionId: string;

    hasUnreadReply: boolean;

    latestMessage: string;

    updated: Date;

    recipientName: string;

    memberId: string;

    conversationId: string;

    isUnsubscribed: boolean;
}

export interface P2PConversation {
    id: string;

    recipientName: string;

    memberId: string;

    items: P2PConversationItem[];

    questions: PublicP2PScriptSurveyQuestion[];

    tags: P2PWorkspaceTag[];

    supporter?: SupporterView | null;

    linkedP2PScripts?: LinkedP2PScript[] | null;

    p2pScripts: PublicP2PScript[];

    recordedTags: PublicP2PConversationLogTag[];

    recordedQuestionResponses: PublicP2PConversationLogQuestionResponse[];

    nextConversationId?: string | null;

    previousConversationId?: string | null;

    isUnsubscribed: boolean;
}

export interface P2PConversationItem {
    id: string;

    sentBy: P2PConversationLogSentBy;

    message?: PublicP2PConversationLogMessage | null;

    questionResponses?: (PublicP2PConversationLogQuestionResponse | null)[] | null;

    tags?: (PublicP2PConversationLogTag | null)[] | null;

    closure?: PublicP2PConversationLogClosure | null;

    created?: Date | null;

    supporter?: PublicSupporter | null;

    p2pScriptId: string;

    isUnsubscribed: boolean;

    isFirstReply?: boolean | null;
}

export interface PublicP2PConversationLogMessage {
    body: string;

    mediaUrls?: string[] | null;
}

export interface PublicP2PConversationLogQuestionResponse {
    p2pScriptSurveyQuestionId: string;

    p2pScriptSurveyQuestionOptionId: string;
}

export interface PublicP2PConversationLogTag {
    tagId: string;
}

export interface PublicP2PConversationLogClosure {
    supporter: PublicSupporter;
}

export interface PublicSupporter {
    supporterId: string;

    firstName?: string | null;

    lastName?: string | null;

    fullName?: string | null;
}

export interface PublicP2PScriptSurveyQuestion {
    id: string;

    name: string;

    questionText: string;

    options: PublicP2PScriptSurveyQuestionOption[];
}

export interface PublicP2PScriptSurveyQuestionOption {
    optionText: string;

    id: string;
}

export interface PublicP2PScript {
    id: string;

    name?: string | null;

    message?: string | null;

    p2pScriptSurveyQuestionId?: string | null;

    attachments?: Media[] | null;
}

export interface P2PScriptSurveyQuestionList {
    total: number;

    items: P2PScriptSurveyQuestion[];
}

export interface P2PRecipientsForTexting {
    recipientList: P2PRecipientList;

    listCompleted: boolean;
}

export interface P2PRecipientList {
    total: number;

    items: (P2PRecipient | null)[];
}

export interface P2PRecipient {
    id: string;

    firstName?: string | null;

    lastName?: string | null;

    memberId: string;

    textBody?: string | null;
}

export interface InitialP2PItem {
    message: string;

    attachments?: Media[] | null;
}

export interface P2PWorkspaceList {
    total: number;

    items: P2PWorkspace[];
}

export interface ReportInfo {
    id: string;

    name: string;

    description?: string | null;

    code: ReportCode;

    lastCreated?: Date | null;

    applicableActions?: (ActionType | null)[] | null;

    reportLink?: string | null;

    position: number;

    isActionFilterAllowed: boolean;
}

export interface SearchAndSurveyFormList {
    total: number;

    items: (SearchAndSurveyForm | null)[];
}

export interface SocialTemplateList {
    total?: number | null;

    items?: (SocialTemplate | null)[] | null;
}

export interface SocialTemplateForOrganizationList {
    total?: number | null;

    items?: (SocialTemplateForOrganization | null)[] | null;
}

export interface SourcingLinkList {
    total: number;

    items: SourcingLink[];
}

export interface SourcingLink {
    id: string;

    name: string;

    link: string;

    updated?: string | null;

    created: string;

    useShortLink: boolean;
}

export interface SupporterEmailTemplateList {
    total: number;

    items: (SupporterEmailTemplate | null)[];
}

export interface SupporterFormList {
    total: number;

    items: (SupporterForm | null)[];
}

export interface SupporterViewFilterStateList {
    items: SupporterViewFilterState[];

    total: number;
}

export interface SupporterViewFilterState {
    id: string;

    name: string;

    state: SupporterViewFilter;
}

export interface SupporterViewFilter {
    actionTakenFilter?: SupporterActionTakenFilter | null;

    supporterJoinedDateFilter?: SupporterJoinedFilter | null;

    actionFilter?: SupporterActionFilter | null;

    groupFilter?: SupporterGroupFilter | null;

    appNotificationFilter?: SupporterAppNotificationFilter | null;

    aliasFilter?: SupporterAliasFilter | null;

    supporterStatusFilter?: SupporterStatusFilter | null;

    lastEmailStatusFilter?: SupporterLastEmailStatusFilter | null;

    supporterEmailSubscriptionFilter?: SupporterEmailSubscriptionFilter | null;
}

export interface SupporterActionTakenFilter {
    minimum?: number | null;

    maximum?: number | null;
}

export interface SupporterJoinedFilter {
    from: Date;

    to: Date;

    isExclude: boolean;
}

export interface SupporterActionFilter {
    all: boolean;

    actionIds?: string[] | null;

    isExclude: boolean;
}

export interface SupporterGroupFilter {
    all: boolean;

    groupIds?: string[] | null;

    isExclude: boolean;
}

export interface SupporterAppNotificationFilter {
    appNotificationEnabled: boolean;
}

export interface SupporterAliasFilter {
    all: boolean;

    aliasIds?: string[] | null;

    isExclude: boolean;
}

export interface SupporterStatusFilter {
    isExclude: boolean;

    currentSupporter?: SupporterStatus[] | null;
}

export interface SupporterLastEmailStatusFilter {
    emailStatusList: LastEmailStatus[];

    isExclude: boolean;
}

export interface SupporterEmailSubscriptionFilter {
    isUnsubscribed?: boolean | null;
}

export interface SupporterSummaryList {
    total: number;

    items: (SupporterSummary | null)[];
}

export interface SupporterSummary {
    id: string;

    fullName?: string | null;

    email: string;

    phoneNumber?: string | null;

    zipCode?: string | null;

    joinLink: string;

    location?: string | null;

    origin: Origin;

    invitedOn?: Date | null;

    joinedOn?: Date | null;

    totalActionCompleted: number;

    totalActionInProgress: number;

    totalUniqueContactsInvited: number;

    totalUniqueContactsJoined: number;
}

export interface InvitedSupporterInformation {
    invitedSupporterId: string;

    firstName?: string | null;

    lastName?: string | null;

    email: string;

    isJoined?: boolean | null;
}

export interface ActionEmailSummaryForSupporterData {
    actionEmailsCountSummary: EmailSummaryData;

    emailRecipientsList: (ActionEmailRecipientsList | null)[];
}

export interface ActionEmailRecipientsList {
    recipientName?: string | null;

    email: string;

    status: string;

    statusDate: Date;

    hasRespondedToSurvey: boolean;

    created: Date;
}

export interface ActionEmailRecipientsLists {
    total: number;

    items: ActionEmailRecipientsList[];
}

export interface ActionTextMessageSummaryForSupporterData {
    actionTextMessagesCount: number;

    textRecipientsList: (ActionTextRecipientsList | null)[];
}

export interface ActionTextRecipientsList {
    recipientName: string;

    phoneNumber: string;

    created: Date;

    hasRespondedToSurvey: boolean;
}

export interface RecentInviteSupporterMappingWithAllCustomFields {
    mapping?: Json | null;

    customFields?: (string | null)[] | null;
}

export interface CannedResponseList {
    total: number;

    items: CannedResponse[];
}

export interface TextTemplateForOrganizationList {
    total?: number | null;

    items?: (TextTemplateForOrganization | null)[] | null;
}

export interface OutreachCircleList {
    items: (OutreachCircle | null)[];

    total: number;

    filteredTotal: number;
}

export interface SupporterList {
    total: number;

    items: (Supporter | null)[];
}

export interface Mutation {
    /** Create Action View Filter state */
    createActionViewFilter: ActionViewFilterState;
    /** Update Action View Filter state */
    updateActionViewFilter: ActionViewFilterState;
    /** Delete Action View Filter State */
    deleteActionViewFilter: boolean;
    /** Get Action View Filter State */
    getActionViewFilterStates: ActionViewFilterStateList;
    /** Delete all supporter assignments for an action */
    deleteAllSupporterAssignments: Action;
    /** Mark assigned member as contacted */
    markAssignedMemberAsContacted?: boolean | null;
    /** Mark assigned contact as contactedErrors Thrown:ACTION_NOT_IN_LIVE_STATEACTION_INVALID_TYPE: When action type is not GROSUPPORTER_NOT_FOUND: When supporter not found */
    markAssignedContactAsContacted?: boolean | null;
    /** Save GRO supporter personalized email templateErrors Thrown:ACTION_NOT_IN_LIVE_STATEACTION_INVALID_TYPE: When action type is not GROSUPPORTER_NOT_FOUND: When supporter not foundINVALID_MERGE_FIELDS_IN_TEMPLATE: When invalid merge fields exist in the template body */
    saveGROSupporterEmailTemplate: EmailTemplateForSupporter;
    /** Save GRO supporter personalized text templateErrors Thrown:ACTION_NOT_IN_LIVE_STATEACTION_INVALID_TYPE: When action type is not GROSUPPORTER_NOT_FOUND: When supporter not foundINVALID_MERGE_FIELDS_IN_TEMPLATE: When invalid merge fields exist in the template body */
    saveGROSupporterTextTemplate: TextTemplateForSupporter;
    /** Save GRO supporter personalized call templateErrors Thrown:ACTION_NOT_IN_LIVE_STATEACTION_INVALID_TYPE: When action type is not GROSUPPORTER_NOT_FOUND: When supporter not foundINVALID_MERGE_FIELDS_IN_TEMPLATE: When invalid merge fields exist in the template body */
    saveGROSupporterCallTemplate: boolean;
    /** Save GRO supporter personalized visit templateErrors Thrown:ACTION_NOT_IN_LIVE_STATEACTION_INVALID_TYPE: When action type is not GROSUPPORTER_NOT_FOUND: When supporter not foundINVALID_MERGE_FIELDS_IN_TEMPLATE: When invalid merge fields exist in the template body */
    saveGROSupporterVisitTemplate: boolean;
    /** Update GRO member Errors Thrown: INTEGRATION_NOT_FOUND: salesforce integration is not present even though the list type is salesforce */
    updateGROMember: AssignedMember;
    /** Assign action to supporter */
    assignPublicActionToSupporter: boolean;
    /** Assign supporter to an actionThrows error:ACTION_ASSIGNMENT_ERROR - When assigning action to supporter who is either inactive or blockedSUPPORTER_NOT_FOUND - When supporter being assigned is not found */
    assignSupporterToAction: Action;
    /** Delete action assigned to a supporter */
    deleteActionAssignment: Action;
    /** Archive actionErrors thrown:ACTION_CANNOT_BE_ARCHIVED - When status of action is not INACTIVE/TERMINATED */
    archiveAction: Action;
    /** Create an actionthrows error:OUTREACH_CIRCLE_NOT_FOUND - When outreach circle is not foundACTION_ALREADY_EXISTS - When action with given name already existsINVALID_ACTION_NAME - When action name is empty or it has more than 50 charactersINVALID_ACTION_TYPE - When action type is invalidINVALID_END_DATE - End date of the action should always be in the future while creationEND_DATE_BEFORE_START_DATE - End date of the action is earlier than the start dateINVALID_ACTION_TITLE - Empty string for title in the inputINVALID_ACTION_DESCRIPTION - Empty string for description in the inputINVALID_ACTION_LINK - link field should be a valid urlUPGRADE_PLAN - Based on the product plan to upgrade plan */
    createAction: Action;
    /** Update action start date and end dateBoth start date and end date are optionalIf either of them is not passed, that particular field will be set to NULLthrows error:INVALID_END_DATE - End date of the action should always be in the future while creationEND_DATE_BEFORE_START_DATE - End date of the action is earlier than the start dateACTION_NOT_FOUNDACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is ARCHIVED StateUPGRADE_PLAN - Based on the product plan to upgrade plan */
    updateActionDates: Action;
    /** Link email template to actionthrows error:EMAIL_TEMPLATE_NOT_FOUNDACTION_NOT_FOUNDACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is LIVE/ARCHIVED StateOUTREACH_CIRCLES_MISMATCH - emailTemplate and action belongs to different outreach circles */
    linkEmailTemplateToAction: Action;
    /** Link text template to actionthrows error:TEXT_TEMPLATE_NOT_FOUNDACTION_NOT_FOUNDACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is LIVE/ARCHIVED StateOUTREACH_CIRCLES_MISMATCH - textTemplate and action belongs to different outreach circles */
    linkTextTemplateToAction: Action;
    /** Link a social share template with an actionthrows error:ACTION_NOT_FOUND - invalid actionIdSOCIAL_TEMPLATE_DOES_NOT_EXIST - invalid socialTemplateIdACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is LIVE/ARCHIVED StateOUTREACH_CIRCLES_MISMATCH - socialTemplate and action belongs to different outreach circles */
    linkSocialTemplateToAction: boolean;
    /** Update title and descriptionthrows errors:ACTION_NOT_FOUND - Invalid actionId in the inputINVALID_ACTION_TITLE - Empty string for title in the inputACTION_CANNOT_BE_UPDATED - action is in invalid status */
    updateActionTitleAndDescription: Action;
    /** Update link for the actionthrows errors:INVALID_ACTION_LINK - link field should be a valid urlACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid status */
    updateActionLink?: boolean | null;
    /** Update the action status to LIVEthrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid status */
    activateAction: Action;
    /** Update the action namethrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid statusINVALID_ACTION_NAME - Invalid action name */
    updateActionName: Action;
    /** Duplicate an existing action with a new namethrows errors:INVALID_ACTION_NAME - invalid input for the action nameACTION_ALREADY_EXISTS - if the given action name already exists */
    duplicateAction: Action;
    /** Send action emailErrors thrown:PENDING_SEND_EMAIL_JOB_EXISTSACTION_NOT_FOUNDEMAIL_OUTREACH_CHANNEL_NOT_FOUNDNO_EMAIL_TEMPLATE_LINKED_TO_ACTIONACTION_NOT_IN_LIVE_STATESUSPICIOUS_MATCHING_FOUND */
    sendActionEmail?: boolean | null;
    /** Send action email as perview to adminErrors thrown:ACTION_NOT_FOUNDACTION_NOT_IN_LIVE_STATENO_EMAIL_TEMPLATE_LINKED_TO_ACTIONEMAIL_OUTREACH_CHANNEL_NOT_FOUND */
    sendActionPreviewEmail?: boolean | null;
    /** Update outreach circle channelsErrors thrown:ACTION_NOT_FOUND - given actionId does not exist in the database */
    updateOutreachChannelsForAction: Action;
    /** Update audience actionsErrors thrown:ACTION_NOT_FOUND - given actionId does not exist in the database */
    updateAudienceActionsForAction: Action;
    /** Mark the action as completed by the supporterNote: This creates a supporter entry if the user is not yetsupporting the outreach circle of the actionErrors thrown:ACTION_NOT_FOUND - Action id in the input is invalid */
    markActionAsCompleted: Supporter;
    /** Increment Action ImpressionErrors thrown:ACTION_NOT_FOUND - Action id in the input is invalid */
    incrementActionImpressionV1?: boolean | null;
    /** Increment Action ImpressionErrors thrown:ACTION_NOT_FOUND - Action id in the input is invalid */
    incrementActionImpression?: boolean | null;
    /** Update personalize message as completed for actionErrors thrown: */
    personalizeMessageCompletedForAction?: boolean | null;
    /** Update nux display completed for recipient screen for that action by supporter */
    nuxCompletedForActionTag?: boolean | null;
    /** Update import contacts as completed for actionErrors thrown: */
    importContactsCompletedForAction?: boolean | null;
    /** Update manage recipients as completed for actionErrors thrown: */
    manageRecipientsCompletedForAction?: boolean | null;
    /** Update manage recipients as completed for actionErrors thrown: */
    updateP2PNUXCompletedForAction?: boolean | null;
    /** Update the action namethrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid statusINVALID_CALL_TO_ACTION_TEXT - Invalid call to action text */
    updateCallToActionText: Action;
    /** Update the action namethrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid statusINVALID_POST_ACTION_TEXT - Invalid call to action text */
    updatePostActionText: Action;
    /** Update the action namethrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid status */
    updateActionOutreachMode: Action;
    /** Update the action namethrows errors:ACTION_CANNOT_BE_UPDATED - action is in invalid statusCANNOT_TOGGLE_ALLOW_NON_MAPPED_CONTACTS - cannot toggle allowNonMappedContacts if outreach_mode is true */
    updateAllowNonMappedContacts: Action;
    /** Link a survey with an actionthrows error:SURVEY_NOT_FOUND - invalid surveyIdACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is LIVE/EXPIRED StateOUTREACH_CIRCLES_MISMATCH - survey and action belongs to different outreach circles */
    linkSurveyToAction: Action;
    /** unLink the survey with an actionthrows error:SURVEY_NOT_FOUND - invalid surveyIdACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is LIVE/EXPIRED State */
    unlinkSurveyToAction: Action;
    /** Update position of an actionthrows error:INVALID_ACTION_POSITION - If position is < 1 or more than the total count of actions */
    updateActionPosition: Action;
    /** Update image for an action */
    updateImageForAction: Action;
    /** Pause an actionErrors thrown:ACTION_CANNOT_BE_PAUSED - Action is in a state which cannot be pausedINVALID_ACTION_TYPE - When trying to pause action other than p2p */
    pauseAction: Action;
    /** Deactivate an actionErrors thrown:ACTION_CANNOT_BE_DEACTIVATED - Action is in a state which cannot be deactivated */
    deactivateAction: Action;
    /** Update isEngagementRequired falg for actionErrors thrown:ACTION_CANNOT_BE_UPDATED - Action can not be updated */
    updateIsEngagementRequired: Action;
    /** Mark the affinity contact as sentErrors thrown:INVALID_TEXT_RECIPIENT - Invalid text recipient */
    markAffinityTextContactAsSent: boolean;
    /** Mark the affinity contact as sentErrors thrown:TEXT_SUPPORTER_SET_NOT_FOUND - text supporter set not foundACTION_TEXT_ALREADY_SENT_TO_SUPPORTER - action text already sent to supporter */
    markTextSentToSupporter: boolean;
    /** Update treatment and isTreatmentEnabled for an actionErrors thrown:ACTION_CANNOT_BE_UPDATED - Action can not be updatedACTION_TREATMENT_IS_MANDATORY - When isTreatmentEnabled is true and no value is passed for treatment */
    updateTreatmentForAction: Action;
    /** Update permission to import contacts by supporter for an actionErrors thrown:ACTION_CANNOT_BE_UPDATED - Action can not be updated */
    updateContactsImportPermissionForSupporter: Action;
    /** Supporter acknowledgement for importing contact for an Action to his address bookErrors thrown:ACTION_ALLOW_CONTACT_IMPORT_DISABLED - Action allow contact import disabled */
    acknowledgeContactImportForAction: boolean;
    /** Set campaign for given action */
    setCampaignForAction: boolean;
    /** Update the share action button textthrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid statusINVALID_SHARE_BUTTON_TEXT - Invalid share action button text */
    updateShareActionButtonText: Action;
    /** Update the share action button textthrows errors:ACTION_NOT_FOUND - given actionId does not exist in the database */
    removeActionReviewWarning: Action;
    /** Assign Supporter to the P2P and GRO Actionthrows errors:SUPPORTER_NOT_FOUND - Supporter Id is invalid */
    assignSupportersToAction: Action;
    /** Assign all supporter linked to invited supporter source id to the P2P Actionthrows errors:INVITED_SUPPORTER_SOURCE_NOT_FOUND - When invited supporter source id is invalid */
    assignSupportersFromInvitedSupporterSourceToAction: Action;
    /** Unassign supporter from p2p actionthrows errors:SUPPORTER_NOT_FOUND - Supporter Id is invalidUNABLE_TO_UNASSIGN_P2P_SUPPORTER_FROM_ACTION - When there are replies pending for p2p action by supporter */
    unassignSupporterFromAction: Action;
    /** Update the action status to TERMINATEDthrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid status */
    terminateAction: Action;
    /** Acknowledge estimated cost for p2p actionthrows errors:ACTION_CANNOT_BE_UPDATED - action is in invalid status */
    acknowledgeEstimatedCostForP2PAction: Action;
    /** Assign supporters from group to action */
    assignSupportersFromGroupToAction: Action;
    /** Update search and survey audience actions for action */
    updateSearchAndSurveyAudienceActionsForAction: Action;
    /** Update search and survey new contacts list for actionThrows errors:INVALID_AUDIENCE_ACTION - When the list type is invalidINVALID_ACTION - When trying to update new contacts list for action type other than search and survey */
    updateSearchAndSurveyNewContactsListForAction: Action;
    /** Select audience custom field to be displayed for an action either in search or surveythrows errors:ACTION_MAXIMUM_CUSTOM_FIELD_LIMIT_REACHED - Maximum custom field limit reached for action */
    addCustomFieldForSearchAndSurveyAction?: AudienceCustomField | null;
    /** Deselect audience custom field to be displayed for an action either in search or survey */
    removeCustomFieldForSearchAndSurveyAction: boolean;
    /** Update action confirmationErrors thrown:INVALID_ACTION_CONFIRMATION_TEXTINVALID_ACTION_TYPE */
    updateActionConfirmation: Action;
    /** Update call or visit templateErrors thrown:INVALID_ACTION_TYPE - When trying to update call or visit template for action other than GROINVALID_OUTREACH_CHANNEL_TEMPLATE_TEXT - When call or visit template text is invalidINVALID_MERGE_FIELDS_IN_TEMPLATE - When it contains an invalid merge field */
    updateCallOrVisitTemplate: Action;
    /** Unlink/Remove template from action for outreachChannelErrors thrown:ACTION_CANNOT_BE_UPDATED - When trying to remove template from action with invalid status */
    removeTemplateFromActionForOutreachChannel: Action;
    /** Send email notification for actionErrors thrown:NO_ELIGIBLE_SUPPORTERS_AVAILABLE_FOR_NOTIFICATION - When no eligible supporters are found to send notification */
    sendEmailNotificationForAction: EmailNotificationLog;
    /** Send push notification for actionErrors thrown:NO_ELIGIBLE_SUPPORTERS_AVAILABLE_FOR_NOTIFICATION - When no eligible supporters are found to send notification */
    sendPushNotificationForAction: PushNotificationLog;
    /** Reassign unassigned supporter back to P2P actionErrors thrown:ACTION_NOT_ASSIGNED_TO_SUPPORTER - When action hasn't been assigned to supporterACTION_ALREADY_ASSIGNED_TO_SUPPORTER - When action has already been assigned to supporter */
    reassignUnassignedSupporterForP2PAction: boolean;
    /** Reset reply reassignment back to original supporter for P2P actionErrors thrown:ACTION_NOT_ASSIGNED_TO_SUPPORTER - When action hasn't been assigned to supporterACTION_ALREADY_ASSIGNED_TO_SUPPORTER - When action has already been assigned to supporter */
    resetReplyReassignmentForP2PAction: boolean;
    /** Assign selected and remove unselected groups from action */
    assignGroupToAction: ActionGroupList;
    /** Update GRO config for action */
    updateGroConfig: Action;
    /** Update address based config for action */
    updateAddressBasedCanvassingConfig: Action;
    /** Update on the go canvassing config for action */
    updatePdiOnTheGoCanvassingConfig: Action;
    /** Update Contact Type Labels */
    updateContactTypeLabel: Action;
    /** Create Member Notes */
    createMemberNote: MemberNote;
    /** Assign phone number to action */
    assignOutreachCirclePhoneNumberToAction: boolean;
    /** Unassign phone number from action */
    unassignOutreachCirclePhoneNumberFromAction: boolean;
    /** Update p2p configuration for actionerrors:ACTION_CANNOT_BE_UPDATED */
    updateP2PConfigForAction: Action;
    /** Purchase a phone number based on area code provided for p2p actionthrows errors:INVALID_AREA_CODE - When any areaCode is not of length 3ACTION_CANNOT_BE_UPDATED - When action cannot be updatedNO_PHONE_NUMBER_FOUND_FOR_AREA_CODE - When either any areaCode is invalid or does not have phone numberP2P_MAXIMUM_PHONE_NUMBER_CAMPAIGN_REGISTRATION_LIMIT_REACHED - P2P Maximum phone number registration limit reachedP2P_SCRIPT_MISSING - P2P script is missing. Please link/create a texting script */
    purchasePhoneNumberForP2PAction: Action;
    /** Update the P2P action available timingsthrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid status */
    updateP2PActionAvailableTimings: Action;
    /** Update IsAnonymousSearchAndSurveyEnabled for action */
    updateIsAnonymousSearchAndSurveyForAction: Action;
    /** Create a member for address based canvasing */
    addMemberForAddressBasedCanvassing: SearchAndSurveyContact;
    /** Add member to the household */
    addMemberToHouseHold: boolean;
    /** Record tag for household */
    recordTagForHousehold: boolean;
    /** Record tag for search and survey member */
    recordTagForSearchAndSurveyMember: boolean;
    /** Creating new search and survey audience actionThrows error:AUDIENCE_ACTION_WITH_SAME_NAME_ALREADY_EXISTS - When another search and survey list with same name exists. */
    createSearchAndSurveyList: AudienceAction;
    /** Delete audience actionThrows error:INVALID_AUDIENCE_ACTION - When trying to delete audience action other than type SALESFORCE_LISTUNABLE_TO_DELETE_AUDIENCE_ACTION - When trying to delete audience action linked to non terminated action */
    deleteAudienceAction: boolean;
    /** Add audience membersErrors thrown:AUDIENCE_NOT_FOUND -  When outreachcircle doesn't have audienceINVALID_AUDIENCE_MAPPING_NAME - When the audience mapping name already exist in db */
    addMembers?: AudienceAction | null;
    /** Update members of audienceErrors thrown:AUDIENCE_NOT_FOUND - When outreachcircle doesn't have audience */
    updateMembers?: AudienceAction | null;
    /** Delete members from audienceErrors thrown:AUDIENCE_NOT_FOUND - When outreachcircle doesn't have audience */
    deleteMembers?: AudienceAction | null;
    /** Delete all audience and it's related data for an outreach circle */
    createAudience: Audience;
    /** Delete all audience and it's related data for an outreach circle */
    deleteAudienceByListType?: boolean | null;
    /** Block a member from the audience */
    blockAudienceMember?: boolean | null;
    /** unBlock a member from the audience */
    unBlockAudienceMember?: boolean | null;
    /** Update audience action */
    updateAudienceAction: AudienceAction;
    /** Create single search and survey list contact */
    createSearchAndSurveyContact: SearchAndSurveyContact;
    /** Add members from saved list of blackbaud */
    addMembersFromBlackbaudImport: AudienceAction;
    /** Update members from saved list of blackbaud */
    updateMembersFromBlackbaudImport: AudienceAction;
    /** Delete members from saved list of blackbaud */
    deleteMembersFromBlackbaudImport: AudienceAction;
    /** Creates broadcast texting script for the outreach circle */
    createBroadcastTextingScript: BroadcastTextingScript;
    /** Updates broadcast texting script for the outreach circle */
    updateBroadcastTextingScript: BroadcastTextingScript;
    /** Updates broadcast texting script for the outreach circle */
    duplicateBroadcastTextingScript: BroadcastTextingScript;
    /** Links broadcast texting script to action */
    linkBroadcastTextingScriptToAction: boolean;
    /** Unlinks broadcast texting script from action */
    unlinkBroadcastTextingScriptFromAction: boolean;
    /** Send sample text */
    sendSampleText: string;
    /** "Update the existing candidatethrows error:CANDIDATE_DOES_NOT_EXIST - If a candidate does not exist for the outreach circlebut still trying to update */
    updateCandidate?: Candidate | null;
    /** "Create a new candidatethrows error:CANDIDATE_ALREADY_EXISTS - If a candidate already exists for the campaign */
    addCandidate?: Candidate | null;
    /** Add candidate image for an outreach circlethrows error:CANDIDATE_IMAGE_ALREADY_EXISTS - If the candidate image already exists for the candidateCANDIDATE_DOES_NOT_EXIST - If a candidate does not exist for the outreach circlebut still trying to update */
    addCandidateImage: Candidate;
    /** "Delete the candidate logo for a outreach circleCANDIDATE_DOES_NOT_EXIST - If a candidate does not exist for the outreach circlebut still trying to update */
    deleteCandidateImage?: boolean | null;
    /** "Update candidate image of the outreach circlethrows error:INVALID_CANDIDATE_IMAGE - When trying to update a wrong candidate imageCANDIDATE_DOES_NOT_EXIST - If a candidate does not exist for the outreach circlebut still trying to update */
    updateCandidateImage: Candidate;
    /** Mark a mapped contact as an email / don't email recipientErrors Thrown:MAPPED_CONTACT_NOT_FOUND: no mapped contact exists for atleast one of the given input */
    setEmailRecipientV1?: (MappedContact | null)[] | null;
    /** Mark a mapped contact as an email / don't email recipientErrors Thrown:MAPPED_CONTACT_NOT_FOUND: no mapped contact exists for atleast one of the given input */
    setEmailRecipient?: boolean | null;
    /** Set all contacts as email recipientsErrors thrown:ACTION_NOT_FOUND */
    setAllEmailRecipients?: boolean | null;
    /** Unset all contacts as email recipientsErrors thrown:ACTION_NOT_FOUND */
    unsetAllEmailRecipients?: boolean | null;
    /** Resolve the ambiguity of an ambiguous mapped contact */
    resolveAmbiguousMappedContact?: boolean | null;
    /** Create matching job for supporterReturns matching job idErrors Thrown:SUPPORTER_NOT_FOUND: supporter in the input does not exist */
    createMatchingJob: MatchingJob;
    /** Start matching jobErrors Thrown:MATCHING_JOB_NOT_FOUND */
    startMatchingJob: boolean;
    /** Mark text recipient as sentErrors thrown:INVALID_TEXT_RECIPIENT - Invalid text recipient */
    markTextRecipientAsSent?: boolean | null;
    /** Errors thrown:INVALID_ACTION - If actionId in input is not VFM with NVFM enabled */
    toggleEligibleContactAsEmailRecipient: boolean;
    /** Set or Unset Mapped Contact as A1C Recipient */
    toggleA1CRecipientMapped: boolean;
    /** Set or Unset all mapped contact as A1C Recipient */
    toggleAllA1CRecipientMapped: boolean;
    /** Set or Unset Non-mapped Contact as A1C Recipient */
    toggleA1CRecipientNonMapped: boolean;
    /** Set or Unset all non-mapped contact as A1C Recipient */
    toggleAllA1CRecipientNonMapped: boolean;
    /** Set Ambiguous Contact as Matched or unmatched and toggle it as A1C Recipient */
    toggleAmbiguousA1CRecipient: boolean;
    /** Delete Mapped contact */
    deleteMappedContact: boolean;
    /** Sends contact-us email to outreach circle support teamThrows - OUTREACH_CIRCLE_NOT_FOUND for invalid outreachCircleId- INVALID_EMAIL_ID for invalid email id */
    contactUs: boolean;

    importContactFile?: boolean | null;

    deleteContactSource?: boolean | null;
    /** Create single contactErrors Thrown:CONTACT_WITH_EMAIL_ALREADY_EXISTS - There is a contact with the same emailCONTACT_WITH_PHONE_NUMBER_ALREADY_EXISTS - There is a contact with same phone numberEMAIL_OR_PHONE_IS_MANDATORY - Either primary email or primary phone number must be providedINVALID_NAME_INPUT - When first name or last name is more than 25 charactersINVALID_ZIP_CODE - When zip code is more than 10 characters */
    createContact: Contact;
    /** Create Contact With Matching */
    createContactWithMatching: Contact;
    /** Update single contactErrors Thrown:CONTACT_WITH_EMAIL_ALREADY_EXISTS - There is a contact with the same emailCONTACT_WITH_PHONE_NUMBER_ALREADY_EXISTS - There is a contact with same phone numberEMAIL_OR_PHONE_IS_MANDATORY - Either primary email or primary phone number must be providedINVALID_NAME_INPUT - When first name or last name is more than 25 charactersINVALID_ZIP_CODE - When zip code is more than 10 characters */
    updateContact: Contact;
    /** Update Contact With Matching */
    updateContactWithMatching: Contact;
    /** Update priamry email for the contactErrors thrown:INVALID_EMAIL_INPUT */
    updatePrimaryEmailForContact: Contact;
    /** Delete single contactErrors Thrown:CONTACT_NOT_FOUND */
    deleteContact: boolean;
    /** Resolve Duplicate Email Recipient */
    resolveDuplicateEmailContact: boolean;
    /** Create new email templateErrors thrown:EMAIL_TEMPLATE_WITH_SAME_NAME_EXISTS */
    createEmailTemplate: EmailTemplate;
    /** Duplicate email templateErrors thrown:EMAIL_TEMPLATE_WITH_SAME_NAME_EXISTS */
    duplicateEmailTemplate: EmailTemplate;
    /** Update email templateErrors thrown:EMAIL_TEMPLATE_NOT_FOUND - Email template not found */
    updateEmailTemplate: EmailTemplate;
    /** Update email template for supporterErrors thrown:EMAIL_TEMPLATE_NOT_FOUND - Email template not found */
    updateEmailTemplateForSupporter: EmailTemplateForSupporter;
    /** Send edited email preview */
    sendEditedEmailPreview?: boolean | null;
    /** Send preview email for supporterErrors thrown:ACTION_NOT_IN_LIVE_STATE */
    sendPreviewEmailForSupporter: boolean;
    /** Create new email template for organizationErrors thrown:EMAIL_TEMPLATE_WITH_SAME_NAME_EXISTS */
    createOrganizationEmailTemplate: EmailTemplateForOrganization;
    /** Update email template for organizationErrors thrown:EMAIL_TEMPLATE_NOT_FOUND - Email template not found */
    updateOrganizationEmailTemplate: EmailTemplateForOrganization;
    /** Returns HTML with updated recruitment link text */
    updateEmailTemplateForOrgWithRecruitmentLink: string;
    /** Send edited organization template email preview */
    sendEditedOrganizationTemplateEmailPreview?: boolean | null;
    /** Creates an survey engagementthrows error:INVALID_ENGAGEMENT_INPUT - Invalid engagement input if any of the required feild is missing or not provided correctlyENGAGEMENT_NAME_ALREADY_EXIST - Survey engagement with given name already exist */
    createSurveyEngagement: Engagement;
    /** Updates an survey engagementthrows error:INVALID_ENGAGEMENT_INPUT - Invalid engagement input if any of the required feild is missing or not provided correctlySURVEY_ENGAGEMENT_NOT_FOUND - When survey engagement is not foundENGAGEMENT_NAME_ALREADY_EXIST - Survey engagement with given name already existPDI_QUESTION_NOT_FOUND - When trying to link a PDI question that does not exist */
    updateSurveyEngagement: Engagement;
    /** Deletes engagements */
    deleteEngagements: boolean;
    /** Deletes survey by id */
    deleteSurvey: boolean;
    /** Save Survey responsethrows error:ENGAGEMENT_OPTION_NOT_FOUND - When survey engagement option is not foundINVALID_SURVEY_RESPONSE_INPUT - When invalid emailRecipient or textRecipient id is assigned */
    saveSurveyResponse?: PublicEngagement | null;
    /** Create a duplicate survey from given survey */
    duplicateSurvey: Engagement;
    /** Update gro survey formErrors thrown:GRO_SURVEY_FORM_NOT_FOUNDINVALID_GRO_SURVEY_FORM_QUESTION_TYPEGRO_SURVEY_FORM_WITH_SAME_NAME_EXISTSINVALID_OPTIONS_INPUT_FOR_GRO_SURVEY_FORM_QUESTIONINVALID_QUESTION_TYPE_FOR_GRO_SURVEY_FORM_QUESTION_INTEGRATIONGRO_SURVEY_FORM_QUESTION_TEXT_LENGTH_EXCEEDED */
    updateGroSurveyForm?: GroSurveyForm | null;
    /** Create gro survey formErrors thrown:GRO_SURVEY_FORM_WITH_SAME_NAME_EXISTS */
    createGroSurveyForm?: GroSurveyForm | null;
    /** Link the gro survey form to an action */
    linkGroSurveyFormToAction: Action;
    /** Unlink the gro survey form from an action */
    unlinkGroSurveyFormFromAction: Action;
    /** Duplicate a gro survey form with a new name */
    duplicateGroSurveyForm: GroSurveyForm;
    /** Submit response for gro survey formErrors Thrown:GRO_SURVEY_FORM_QUESTION_NOT_FOUNDINVALID_OPTION_SELECTED_FOR_QUESTIONINVALID_RESPONSE_FOR_MANDATORY_QUESTIONINVALID_GRO_SURVEY_FORM_QUESTIONGRO_SURVEY_FORM_OPTION_NOT_FOUNDGRO_SURVEY_FORM_NOT_FOUNDACTION_NOT_IN_LIVE_STATE */
    submitGroSurveyFormQuestionResponse: boolean;
    /** Submit response of gro survey form for contactsErrors Thrown:GRO_SURVEY_FORM_QUESTION_NOT_FOUNDINVALID_OPTION_SELECTED_FOR_QUESTIONINVALID_RESPONSE_FOR_MANDATORY_QUESTIONINVALID_GRO_SURVEY_FORM_QUESTIONGRO_SURVEY_FORM_OPTION_NOT_FOUNDGRO_SURVEY_FORM_NOT_FOUNDACTION_NOT_IN_LIVE_STATE */
    submitGroSurveyFormQuestionResponseForContact: boolean;
    /** Delete gro survey form */
    deleteGroSurveyForm: boolean;
    /** Create GroupErrors thrown:GROUP_NAME_ALREADY_EXISTS - Group with the same name already exists */
    createGroup: Group;
    /** Update GroupErrors thrown:GROUP_NAME_ALREADY_EXISTS - Group with the same name already exists */
    updateGroup: Group;
    /** Delete groupErrors thrown:GROUP_CANNOT_BE_DELETED - Group cannot be deleted if supporter form action with group linking is live */
    deleteGroup: boolean;
    /** Assign an action to a groupErrors thrown:EXPIRED_ACTION_CANNOT_BE_LINKED_ACTION */
    assignActionToGroup: Group;
    /** Assign an alias to a groupErrors thrown:DEFAULT_ALIAS_CANNOT_BE_LINKED_TO_GROUP */
    assignAliasToGroup: Group;
    /** UnAssign an action to a group */
    unAssignActionFromGroup: Group;
    /** UnAssign an alias to a group */
    unAssignAliasFromGroup: Group;
    /** Assign an supporter to a group */
    assignSupportersToGroups: boolean;
    /** UnAssign an supporter to a group */
    unAssignSupporterFromGroup: boolean;
    /** Integrates FacebookPixel to OutreachCircle */
    createOrUpdateFacebookPixelIntegration: boolean;
    /** Enable phone2Action integration */
    enablePhone2ActionIntegration: boolean;
    /** Enable EveryAction integration */
    enableEveryActionIntegration: boolean;
    /** Create or update NationBuilder IntegrationErrors thrown:INVALID_SLUG_FOR_NATION_BUILDER_INTEGRATION - When the slug is invalidINVALID_API_TOKEN_FOR_NATION_BUILDER_INTEGRATION - When the API Token in invalid */
    createOrUpdateNationBuilderIntegration?: Integration | null;
    /** Sync supporters to NationBuilderErrors thrown:NATION_BUILDER_INTEGRATION_NOT_FOUND - When the OutreachCircle doesnot have a NationBuilder integration */
    updateSyncSupportersToNationBuilder?: boolean | null;
    /** Add or update NationBuilder People Tags for a recruitment linkErrors thrown:NATION_BUILDER_INTEGRATION_NOT_FOUND - When the OutreachCircle doesnot have a NationBuilder integrationALIAS_DOES_NOT_EXIST - When the alias does not existINVALID_APPLY_TO_ALL_CUSTOM_ALIASES_OPTION - When applyToAllCustomAliasesis selected for an alias which is not default */
    addOrUpdateNationBuilderTagsForAlias?: boolean | null;
    /** Save ngp configuration for an outreach circleErrors thrown:UPGRADE_PLAN - Based on the product plan to upgrade plan */
    saveNgpConfiguration?: boolean | null;
    /** Add audience members using NGPErrors thrown:NGP_CREDENTIALS_NOT_FOUND - NGP credentials not foundAUDIENCE_NOT_FOUND - Audience not foundINVALID_NGP_SAVED_LIST_ID - Invalid saved list idUPGRADE_PLAN - Based on the product plan to upgrade planINVALID_AUDIENCE_MAPPING_NAME - Invalid Audience Mapping NameAFFINITY_VOTER_FILE_LIMIT_EXCEEDED - If voter file record size for affinity texting exceedsP2P_CONTACT_FILE_LIMIT_EXCEEDED, - If voter file record size for p2p texting exceeds */
    addMembersFromNGP: AudienceAction;
    /** Update audience members using NGPErrors thrown:NGP_CREDENTIALS_NOT_FOUND - NGP credentials not foundAUDIENCE_NOT_FOUND - Audience not foundINVALID_NGP_SAVED_LIST_ID - Invalid saved list id */
    updateMembersFromNGP: AudienceAction;
    /** Delete audience members using NGPErrors thrown:NGP_CREDENTIALS_NOT_FOUND - NGP credentials not foundAUDIENCE_NOT_FOUND - Audience not foundINVALID_NGP_SAVED_LIST_ID - Invalid saved list id */
    deleteMembersFromNGP: AudienceAction;
    /** Sync supporters to NGP MyCampaignErrors thrown:NGP_CREDENTIALS_NOT_FOUND - When the OutreachCircle doesnot have a NGP MyCampaign integration */
    updateSyncSupportersToNgpMyCampaign?: boolean | null;
    /** Add activistCodes for an aliasErrors thrown:NGP_MY_CAMPAIGN_INTEGRATION_NOT_FOUND - When the OutreachCircle doesnot have a NGP MyCampaign integrationALIAS_DOES_NOT_EXIST - When the alias does not exist */
    addNgpActivistCodesForAlias?: boolean | null;
    /** Add activistCodes for an aliasErrors thrown:NGP_MY_CAMPAIGN_INTEGRATION_NOT_FOUND - When the OutreachCircle doesnot have a NGP MyCampaign integrationALIAS_DOES_NOT_EXIST - When the alias does not exist */
    removeNgpActivistCodesForAlias?: boolean | null;
    /** Update applyToAllCustomAliases for ngp activistCodesErrors thrown:NGP_MY_CAMPAIGN_INTEGRATION_NOT_FOUND - When the OutreachCircle doesnot have a NGP MyCampaign integrationINVALID_APPLY_TO_ALL_CUSTOM_ALIASES_OPTION - When applyToAllCustomAliasesis selected for an alias which is not default */
    updateApplyToAllCustomAliasesForNgpActivistCode?: boolean | null;
    /** Create a member in PDI */
    addPDIMember: SearchAndSurveyContact;
    /** Assign zones to supporters */
    assignAreaInPDIAssignmentZone: boolean;
    /** Release PDI assignment */
    releasePdiAssignment: boolean;
    /** Create or update PDI IntegrationErrors thrown:UPGRADE_PLAN - Based on the product plan to upgrade planINVALID_PDI_CREDENTIALS - When either username or password or API Token is invalid */
    createOrUpdatePDIIntegration?: Integration | null;
    /** Sync supporters to PDIErrors thrown:PDI_INTEGRATION_NOT_FOUND - When the OutreachCircle doesnot have a PDI integration */
    updateSyncSupportersToPDI?: boolean | null;
    /** Add PDI flags for recruitment link */
    addPDIFlagsForAlias: Alias;
    /** Remove PDI flags for recruitment link */
    removePDIFlagsForAlias: Alias;
    /** Update apply globally field for default recruitment link */
    updateApplyPDIFlagsGlobally: boolean;
    /** Register TCR Brand */
    registerTCRBrand: RegisterTcrBrandOutput;
    /** Create TCR Brand Vetting */
    createTCRBrandPoliticalVetting: TcrBrandVetting;
    /** Register TCR Campaign */
    registerTCRCampaign: RegisterTcrCampaignOutput;
    /** Get the presigned request fields for uploading outreach circle landing page logo to S3 */
    presignedLogoUploadRequest?: PreSignedUploadUrl | null;
    /** Get the presigned request fields for uploading organization logo to S3 */
    presignedOrgLogoUploadRequest?: PreSignedUploadUrl | null;
    /** Get the presigned request fields for uploading candidate image to S3 */
    presignedCandidateImageUploadRequest?: PreSignedUploadUrl | null;
    /** Get the presigned request fields for uploading p2p script media to S3 */
    presignedP2PScriptMediaUploadRequest?: PreSignedUploadUrl[] | null;
    /** Get the presigned request fields for uploading social share image to S3 */
    presignedSocialImageUploadRequest?: PreSignedUploadUrl | null;
    /** Get the presigned request fields for uploading social share image to S3 */
    presignedActionImageUploadRequest?: PreSignedUploadUrl | null;
    /** Get the presigned request fields for uploading social share image to S3 */
    presignedOrganizationActionImageUploadRequest?: PreSignedUploadUrl | null;
    /** Get the presigned request fields for uploading editor image to S3 for outreach circle */
    presignedEditorImageUploadRequest?: PreSignedUploadUrl | null;
    /** Get the presigned request fields for uploading editor image to S3 for organization */
    presignedOrgEditorImageUploadRequest?: PreSignedUploadUrl | null;
    /** Get the presigned request fields for uploading broadcast texting script media to S3 */
    presignedBroadcastTextingScriptMediaUploadRequest?: PreSignedUploadUrl[] | null;
    /** Create an organization action */
    createOrganizationAction: OrganizationAction;
    /** Update name for organization actionthrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseINVALID_ACTION_NAME - the name is not validACTION_ALREADY_EXISTS - when action with same name exists */
    updateOrganizationActionName: OrganizationAction;
    /** Update link for the actionthrows errors:INVALID_ACTION_LINK - link field should be a valid urlACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid status */
    updateOrganizationActionLink?: OrganizationAction | null;
    /** Update title and descriptionthrows errors:ACTION_NOT_FOUND - Invalid actionId in the inputINVALID_ACTION_TITLE - Empty string for title in the inputACTION_CANNOT_BE_UPDATED - action is in invalid status */
    updateOrganizationActionTitleAndDescription?: OrganizationAction | null;
    /** Update the action call to action textthrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid statusINVALID_CALL_TO_ACTION_TEXT - Invalid call to action text */
    updateCallToActionTextForOrganizationAction: OrganizationAction;
    /** Update the share action button textthrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid statusINVALID_SHARE_BUTTON_TEXT - Invalid share action button text */
    updateShareActionButtonTextForOrganizationAction: OrganizationAction;
    /** Update the action namethrows errors:ACTION_NOT_FOUND - given actionId does not exist in the databaseACTION_CANNOT_BE_UPDATED - action is in invalid statusINVALID_POST_ACTION_TEXT - Invalid call to action text */
    updatePostActionTextForOrganizationAction: OrganizationAction;
    /** Update image for an organization action */
    updateImageForOrganizationAction: OrganizationAction;
    /** Duplicate an existing organization action with a new namethrows errors:ACTION_NOT_FOUND - if organizationAction with input id does not exist in the database */
    duplicateOrganizationAction: OrganizationAction;
    /** Link email template to organization actionthrows error:EMAIL_TEMPLATE_NOT_FOUNDACTION_NOT_FOUNDACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is terminated/published State */
    linkEmailTemplateToOrganizationAction: OrganizationAction;
    /** Unlink email template to organization actionthrows error:EMAIL_TEMPLATE_NOT_FOUNDACTION_NOT_FOUNDACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is terminated/published StateEMAIL_TEMPLATE_NOT_LINKED - When the given email template is not linked to given action */
    unlinkEmailTemplateFromOrganizationAction: OrganizationAction;
    /** Link text template to organization actionthrows error:TEXT_TEMPLATE_NOT_FOUNDACTION_NOT_FOUNDACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is LIVE/ARCHIVED State */
    linkTextTemplateToOrganizationAction: OrganizationAction;
    /** Unlink text template to organization actionthrows error:TEXT_TEMPLATE_NOT_FOUNDACTION_NOT_FOUNDACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is LIVE/ARCHIVED StateTEXT_TEMPLATE_NOT_LINKED - When the given text template is not linked to given action */
    unlinkTextTemplateFromOrganizationAction: OrganizationAction;
    /** Link a social share template with an organization actionthrows error:ACTION_NOT_FOUND - invalid actionIdSOCIAL_TEMPLATE_DOES_NOT_EXIST - invalid socialTemplateIdACTION_CANNOT_BE_UPDATED - Action cannot be updated as it is LIVE/ARCHIVED State */
    linkSocialTemplateToOrganizationAction: OrganizationAction;
    /** Unlink a social template from an organization action (which will not delete the social template)throws errors:ACTION_NOT_FOUND - invalid actionIdSOCIAL_TEMPLATE_DOES_NOT_EXIST - invalid socialTemplateIdSOCIAL_TEMPLATE_NOT_LINKED - social template is not linked to the given action */
    unlinkSocialTemplateFromOrganizationAction: OrganizationAction;
    /** Publish action to outreachCirclesthrows erros:ORGANIZATION_ACTION_CANNOT_BE_PUBLISHED */
    publishOrganizationAction: OrganizationAction;
    /** Terminate organization action */
    terminateOrganizationAction?: OrganizationAction | null;
    /** Update organization action allowNonMappedContactsthrows errors:ACTION_CANNOT_BE_UPDATED - action is in invalid statusCANNOT_TOGGLE_ALLOW_NON_MAPPED_CONTACTS - cannot toggle allowNonMappedContacts if outreach_mode is true */
    updateOrganizationActionAllowNonMappedContacts: OrganizationAction;
    /** Hide organization actionErrors thrown:ACTION_NOT_FOUND - given actionId does not exist in the database */
    hideOrganizationAction: OrganizationAction;
    /** Update outreach channelsErrors thrown:ACTION_NOT_FOUND - given actionId does not exist in the database */
    updateOutreachChannelsForOrganizationAction: OrganizationAction;
    /** Update organization action's integration typeThis will automatically update isOutreachMode to- true, if value is passed for integration type- false, if value is not passed for integration typeErrors thrown:ACTION_CANNOT_BE_UPDATED - when action status is either TERMINATED or PUBLISHED */
    updateOrganizationActionIntegrationType: OrganizationAction;
    /** Update action confirmationErrors thrown:INVALID_ACTION_CONFIRMATION_TEXTINVALID_ACTION_TYPE */
    updateOrganizationActionConfirmation: OrganizationAction;
    /** Create tag for an organizationErrors thrown:INVALID_TAG_INPUT - When tag with name and database combination exists */
    createOrganizationTag: OrganizationTag;
    /** Update tag for an organizationErrors thrown:INVALID_TAG_INPUT - When tag with name and database combination exists */
    updateOrganizationTag: OrganizationTag;
    /** Links Tag to action */
    linkOrganizationTagToAction: OrganizationTag;
    /** Invite to become an orzanization userErrors thrown:INVALID_EMAIL_INPUT - Invalid email in the inputINVALID_NAME_INPUT - Invalid name in the inputINVITE_ALREADY_EXISTS - There is an existing invite with the same email */
    inviteOrganizationUser: OrganizationUser;
    /** Delete an orzanization userErrors thrown:INVALID_ORGANIZATION_USER - Invalid orzanization userCANT_REMOVE_LAST_ORGANIZATION_USER - Cant remove last orzanization user */
    deleteOrganizationUser: boolean;
    /** Resend invite */
    resendInviteToOrganizationUser: boolean;
    /** Join an orzanization user to the orzanizationErrors thrown:ONBOARD_ORGANIZATION_USER_ALREADY_ONBOARDED - Invite has already been onboardedDELETED_ORGANIZATION_USER_CANNOT_ONBOARD_WITH_OLD_INVITE - User is deleted and trying to onboard */
    onboardOrganizationUser: boolean;
    /** Update organization user details before he has joinedErrors thrown:INVALID_ORGANIZATION_USER - Organization user with the given id not foundCANNOT_UPDATE_ORGANIZATION_USER - Organization user cannot be updated, as he has already onboarded */
    updateOrganizationUser?: OrganizationUser | null;
    /** Update organization user's outreach circle accessErrors thrown:INVALID_ORGANIZATION_USER - Organization user with the given id not found */
    updateReadOnlyAccessToOutreachCircleForOrgUser: boolean;
    /** Update UI preference for organization user */
    updateUIPreferenceForOrganizationUser: OrganizationUser;
    /** Create an organizationErrors thrown:INVALID_ORGANIZATION_NAME - If name is empty or name has more than 50 characters */
    createOrganization: Organization;
    /** Update an organizationErrors thrown:INVALID_ORGANIZATION_NAME - If name is empty or name has more than 50 characters */
    updateOrganization: Organization;
    /** Save organization filterErrors thrown:INVALID_ORGANIZATION_FILTER_NAMEOUTREACH_CIRCLES_CANNOT_BE_EMPTYORGANIZATION_FILTER_WITH_SAME_NAME_EXISTS */
    saveOrganizationDashboardFilter: OrganizationDashboardFilter;
    /** Update organization filterErrors thrown:OUTREACH_CIRCLES_CANNOT_BE_EMPTY */
    updateOrganizationDashboardFilter: OrganizationDashboardFilter;
    /** Delete a saved organization dashboard filter */
    deleteOrganizationDashboardFilter: boolean;
    /** Set main outreach circle for an organizationErrors thrown:ORGANIZATION_NOT_FOUND - Organization not foundOUTREACH_CIRCLE_IS_NOT_PRESENT_IN_ORGANIZATION - organization does not have given outreach circle */
    setMainOutreachCircleForOrganization: boolean;
    /** Set introduction text for an organizationErrors thrown:ORGANIZATION_NOT_FOUND - Organization not found */
    setIntroductionForOrganization: boolean;
    /** Add logo for an organizationErrors thrown:ORGANIZATION_NOT_FOUND - Organization not found */
    addOrganizationLogo: boolean;
    /** Update logo for an organizationErrors thrown:ORGANIZATION_NOT_FOUND - Organization not found */
    updateOrganizationLogo: Organization;
    /** Delete logo for an organizationErrors thrown:ORGANIZATION_NOT_FOUND - Organization not foundORGANIZATION_LOGO_DOES_NOT_EXIST - Organization Logo does not exist */
    deleteOrganizationLogo: boolean;
    /** Update disclaimer for organizationthrows error:ORGANIZATION_NOT_FOUND - Organization not found */
    updateDisclaimerForOrganization: boolean;
    /** Update an organization aliasErrors thrown:INVALID_ORGANIZATION_ALIAS_VALUE - If name is empty or name has spacesORGANIZATION_ALIAS_ALREADY_EXIST - Organization alias already exist */
    updateOrganizationAlias: OrganizationAlias;
    /** Create organization email templates for sendingfrom Organization to Outreach circle adminsErrors thrown:OUTREACH_CIRCLE_USER_EMAIL_TEMPALTE_ALREADY_EXISTS */
    createOutreachCircleUserEmailTemplate: OutreachCircleUserEmailTemplate;
    /** Update organization email templates for sendingfrom Organization to Outreach circle adminsErrors thrown:OUTREACH_CIRCLE_USER_EMAIL_TEMPALTE_ALREADY_EXISTS */
    updateOutreachCircleUserEmailTemplate: OutreachCircleUserEmailTemplate;
    /** Duplicate organization email templates for outreach circle adminsErrors thrown:OUTREACH_CIRCLE_USER_EMAIL_TEMPALTE_ALREADY_EXISTS */
    duplicateOutreachCircleUserEmailTemplate: OutreachCircleUserEmailTemplate;
    /** Send organization action notification email to outreach circle adminsErrors thrown:INVALID_OUTREACH_CIRCLE_USER_EMAIL_TEMPLATE - When invalid template id is passed in input */
    notifyOutreachCircleAdminsForOrganizationAction: boolean;
    /** Send emails oc admins from organizationErrors thrown:INVALID_OUTREACH_CIRCLE_USER_EMAIL_TEMPLATE - When invalid template id is passed in input */
    notifyOutreachCircleAdminsForOrganization: boolean;
    /** Invite to become an outreach circle userErrors thrown:INVALID_EMAIL_INPUT - Invalid email in the inputINVALID_NAME_INPUT - Invalid name in the inputINVITE_ALREADY_EXISTS - There is an existing invite with the same email */
    inviteOutreachCircleUser?: OutreachCircleUser | null;
    /** Update outreach circle user details before he has joinedErrors thrown:INVALID_OUTREACH_CIRCLE_USER - Outreach circle user with the given id not foundCANNOT_UPDATE_OUTREACH_CIRCLE_USER - Outreach circle user cannot be updated, as he has already onboarded */
    updateOutreachCircleUser?: OutreachCircleUser | null;
    /** Delete an outreach circle userErrors thrown:INVALID_OUTREACH_CIRCLE_USER - Invalid outreach circle userCANT_REMOVE_LAST_OUTREACH_CIRCLE_USER - Cant remove last outreach circle user */
    deleteOutreachCircleUser?: boolean | null;
    /** Resend invite */
    resendInvite?: boolean | null;
    /** Join an outreach circle user to the outreach circleErrors thrown:OUTREACH_CIRCLE_USER_ALREADY_ONBOARDED - Invite has already been onboardedDELETED_OUTREACH_CIRCLE_USER_CANNOT_ONBOARD_WITH_OLD_INVITE - User is deleted and trying to onboard */
    onboardOutreachCircleUser?: boolean | null;
    /** Unsubscribe email for specific email template by outreach circle admin.throws error:EMAIL_RECIPIENT_NOT_FOUND - Email recipient not foundEMAIL_TEMPLATE_NOT_FOUND - Email template not found */
    unsubcribeEmailByOutreachCircleAdmin?: OutreachCircleAdminEmailUnsubscribeOutput | null;
    /** Create a new outreach circleErrors thrown:INVALID_NAME_INPUT - When name is invalid (Min 3 chars and Max 50 chars)INVALID_INDUSTRY_INPUT - When industry is empty string */
    createOutreachCircle: OutreachCircle;
    /** Update the outreach circle basic information: name, industry and categoryErrors thrown:INVALID_NAME_INPUT - When name is invalid (Min 3 chars and Max 50 chars)INVALID_INDUSTRY_INPUT - When industry is empty stringALIAS_NAME_ALREADY_EXISTS - When an alias with same name already exists */
    updateOutreachCircleBasicInfo: OutreachCircle;
    /** Update a outreach circleErrors thrown:OUTREACH_CIRCLE_NOT_FOUND - Outreach circle not foundINVALID_EMAIL_INPUT - Invalid email in the input */
    updateOutreachCircleContactAndLocation: OutreachCircle;
    /** Add a user role to an admin */
    updateOutreachCircleUserRole: OutreachCircleUser;
    /** Add logo to default alias of outreachCirclethrows error:OUTREACH_CIRCLE_DEFAULT_ALIAS_LOGO_EXISTS - Outreach circle default alias logo already exists */
    addLogoForDefaultAliasOfOutreachCircle?: boolean | null;
    /** Update logo of default alias of outreachCircle */
    updateLogoForDefaultAliasOfOutreachCircle?: Alias | null;
    /** Delete logo of default alias of outreachCirclethrows error:OUTREACH_CIRCLE_DEFAULT_ALIAS_LOGO_DOES_NOT_EXIST - Outreach circle default alias logo does not exist */
    deleteLogoForDefaultAliasOfOutreachCircle?: boolean | null;
    /** Update blocked domains for the outreach circlethrows error:INVALID_DOMAIN - One of the domain in the input is invalidDUPLICATES_IN_BLOCK_DOMAINS - When input has one or more duplicates in them */
    updateBlockedDomains?: boolean | null;
    /** Update disclaimer for outreach circlethrows error:OUTREACH_CIRCLE_NOT_FOUND - Outreach circle not found */
    updateDisclaimerForOutreachCircle?: boolean | null;
    /** Unsubscribe all email from an Outreach Circle.throws error:EMAIL_RECIPIENT_NOT_FOUND - Email recipient not foundOUTREACH_CIRCLE_NOT_FOUND - Outreach circle not found */
    unsubcribeAllEmailFromOutreachCircle?: OutreachCircleEmailUnsubscribeOutput | null;
    /** Update referred by for outreach circlethrows error:OUTREACH_CIRCLE_NOT_FOUND - Outreach circle not found */
    updateReferredByForOutreachCircle?: boolean | null;
    /** Update visibility for outreach circle.When isVisible is true, Outreach circle is public otherwise its private.Private Outreach circle can only be accessed by Outreach Circle code.throws error:OUTREACH_CIRCLE_NOT_FOUND - Outreach circle not foundUPGRADE_PLAN - Based on the product plan to upgrade plan */
    updateVisibilityForOutreachCircle?: boolean | null;
    /** Add new outreachcircle aliasthrows error:UPGRADE_PLAN - when create alias not allowed or its has reached to the limit based on the product plan to upgrade planALIAS_NAME_ALREADY_EXISTSINVALID_ALIAS_DESCRIPTION - when description for alias is invalid */
    createNewAlias?: Alias | null;
    /** Edit outreachcircle aliasthrows error:ALIAS_NAME_ALREADY_EXISTSINVALID_ALIAS_NAMEINVALID_ALIAS_DESCRIPTION - when description for alias is invalidUPGRADE_PLAN - Based on the product plan to upgrade plan */
    updateAlias: Alias;
    /** Increment outreach circle impression */
    incrementOutreachCircleImpression: boolean;
    /** Add new outreachcircle email aliasthrows error:UPGRADE_PLAN - when create alias not allowed or its has reached to the limit based on the product plan to upgrade planOUTREACH_CIRCLE_EMAIL_ALIAS_EXISTS - When email alias already exists */
    createEmailAlias: OutreachCircleEmailAlias;
    /** Update referred by for outreach circlethrows error:OUTREACH_CIRCLE_NOT_FOUND - Outreach circle not found */
    updateSupporterReplyToEmailForOutreachCircle?: boolean | null;
    /** Update referred by for outreach circlethrows error:OUTREACH_CIRCLE_NOT_FOUND - Outreach circle not found */
    updateSupporterAutoEmailsFromNameForOutreachCircle: OutreachCircle;
    /** Archive outreach circlethrows error:OUTREACH_CIRCLE_ALREADY_ARCHIVED - When Outreach Circle is already archived */
    archiveOutreachCircle?: boolean | null;
    /** Collect response from outreach circle user on archiving the outreach circlethrows error:ARCHIVE_FEEDBACK_TEXT_EXCEEDS_ALLOWED_LENGTH_LIMIT - Any text field in response should not have more than 500 chars */
    collectSurveyResponseOnArchiveOutreachCircle?: boolean | null;
    /** Update dates for outreach circlethrows error:INVALID_KEY_DATENAME_CANNOT_BE_EMPTY_FOR_KEY_DATENAME_CANNOT_BE_UPDATED_FOR_SYSTEM_ADDED_KEY_DATEDATE_CANNOT_BE_NULL_FOR_KEY_DATE */
    updateKeyDates?: KeyDate[] | null;
    /** Purchase phone number for outreachCircle */
    purchasePhoneNumberForOutreachCircle: OutreachCirclePhoneNumber;
    /** Add billing card for given outreachCircleId */
    addBillingCard: boolean;
    /** Remove billing card for given outreachCircleIdthrows error:REMOVE_CARD_FAILED - If trying to delete default card or providing wrong card or customer id */
    removeBillingCard: boolean;
    /** Set default card for given outreachCircleId */
    defaultPaymentSource: boolean;
    /** Update card for given outreachCircleId */
    updatePaymentSource: boolean;
    /** Change planthrows error:INVALID_PLAN - If trying to downgrade from one paid plan to another paidplan. Not applicable to downgrade from any plan to free plan. */
    changePlan: boolean;
    /** Cancel auto renew of outreach circle product planthrows error:INVALID_CANCEL_AUTO_RENEW_CONFIRMATION: Throws when all the required confirmation is accepted by end user */
    cancelAutoRenewForOutreachCircle: boolean;
    /** Request Outreach circle Invoice email to logged in OC admin */
    requestOutreachCircleInvoice: boolean;
    /** create conversation item(s), based on data it will apply tag, create surveyresponse(sync activist code if applicable), add message */
    createP2PConversationItem: P2PConversationItem;
    /** End p2p conversation */
    endP2PConversation: P2PConversationItem;
    /** Assign conversations of one supporter to anotherErrors thrown:P2P_REPLIES_ALREADY_REASSIGNEDP2P_REPLIES_CANNOT_BE_REASSIGNED - Target supporter is not eligible to get replies assigned */
    reassignP2PConversations: boolean;
    /** Un-tag p2p conversation */
    unTagP2PConversation: P2PConversation;
    /** Create p2p script survey questionErrors thrown:INVALID_P2P_SCRIPT_SURVEY_QUESTION_INPUTP2P_SCRIPT_SURVEY_QUESTION_HAS_INVALID_NAMEP2P_SCRIPT_SURVEY_QUESTION_HAS_INVALID_QUESTION_TEXTP2P_SCRIPT_SURVEY_QUESTION_NAME_ALREADY_EXISTSP2P_SCRIPT_SURVEY_QUESTION_OPTION_HAS_INVALID_OPTION_TEXT */
    createP2PScriptSurveyQuestion: P2PScriptSurveyQuestion;
    /** Update p2p script survey questionErrors thrown:INVALID_P2P_SCRIPT_SURVEY_QUESTION_INPUTP2P_SCRIPT_SURVEY_QUESTION_HAS_INVALID_NAMEP2P_SCRIPT_SURVEY_QUESTION_HAS_INVALID_QUESTION_TEXTP2P_SCRIPT_SURVEY_QUESTION_NAME_ALREADY_EXISTSP2P_SCRIPT_SURVEY_QUESTION_OPTION_HAS_INVALID_OPTION_TEXT */
    updateP2PScriptSurveyQuestion: P2PScriptSurveyQuestion;
    /** Delete p2p script survey question */
    deleteP2PScriptSurveyQuestion: boolean;
    /** send initial p2p text */
    sendInitialP2PText: boolean;
    /** save updated initial p2p text, will be useful for re-sending to new recipients */
    updateInitialP2PText: Action;
    /** send bulk initial p2p texts */
    sendBulkInitialP2PTexts: boolean;
    /** Create new p2p workspace along with initial scriptErrors thrown:P2P_WORKSPACE_WITH_SAME_NAME_EXISTSP2P_WORKSPACE_INVALID_INITIAL_SCRIPTP2P_WORKSPACE_HAS_INVALID_NAMEP2P_WORKSPACE_INVALID_INITIAL_SCRIPT_MESSAGEP2P_WORKSPACE_TAG_HAS_INVALID_POSITIONP2P_SCRIPT_INVALID_OPTOUT_TEXT */
    createP2PWorkspace: P2PWorkspace;
    /** Update p2p workspaceErrors thrown:P2P_WORKSPACE_WITH_SAME_NAME_EXISTSP2P_WORKSPACE_EMPTY_INITIAL_SCRIPTP2P_WORKSPACE_HAS_INVALID_NAMEP2P_WORKSPACE_INVALID_INITIAL_SCRIPT_MESSAGEP2P_WORKSPACE_TAG_HAS_INVALID_POSITIONP2P_SCRIPT_INVALID_OPTOUT_TEXT */
    updateP2PWorkspace: P2PWorkspace;
    /** Duplicate p2p workspaceErrors thrown:P2P_WORKSPACE_WITH_SAME_NAME_EXISTSP2P_WORKSPACE_NOT_FOUNDP2P_WORKSPACE_HAS_INVALID_NAMEP2P_WORKSPACE_INVALID_INITIAL_SCRIPT_MESSAGEP2P_SCRIPT_INVALID_OPTOUT_TEXT */
    duplicateP2PWorkspace: P2PWorkspace;
    /** Link P2P Workspace to an action */
    linkP2PWorkspaceToAction: Action;
    /** UnLink P2P Workspace from an action */
    unlinkP2PWorkspaceFromAction: Action;
    /** Mark all the push notification as READ to the give registration token */
    markAllPushNotificationsAsRead: boolean;
    /** Generate a report and send an email to the adminthrows error:NOT_ABLE_TO_REQUEST_REPORT - Not able to generate reportUPGRADE_PLAN - Based on the product plan to upgrade plan */
    requestReportForOutreachCircle: Date;
    /** Generate a report and send an email to the admin */
    requestReportForOrganization: Date;
    /** Generate a report for the requested outreachcircle and send an email to the oc adminthrows error:NOT_ABLE_TO_REQUEST_REPORT - Not able to generate report */
    sendOutreachCircleReportToOCAdmin: boolean;
    /** Update search and survey formErrors thrown:SEARCH_AND_SURVEY_FORM_WITH_GIVEN_NAME_ALREADY_EXISTINVALID_OPTIONS_INPUT_FOR_SEARCH_AND_SURVEY_FORM_QUESTION */
    updateSearchAndSurveyForm?: SearchAndSurveyForm | null;
    /** Create search and survey formErrors thrown:SEARCH_AND_SURVEY_FORM_WITH_GIVEN_NAME_ALREADY_EXIST */
    createSearchAndSurveyForm?: SearchAndSurveyForm | null;
    /** Link the search and survey form to an action */
    linkSearchAndSurveyFormToAction: Action;
    /** Unlink the search and survey form from an action */
    unlinkSearchAndSurveyFormFromAction: Action;
    /** Duplicate a search and survey form with a new name */
    duplicateSearchAndSurveyForm: SearchAndSurveyForm;
    /** Submit response for search and survey formErrors Thrown:INVALID_RESPONSE_FOR_MANDATORY_QUESTIONINVALID_SEARCH_AND_SURVEY_FORM_QUESTIONSEARCH_AND_SURVEY_FORM_NOT_FOUNDACTION_NOT_IN_LIVE_STATE */
    submitSearchAndSurveyFormQuestionResponse: boolean;
    /** Delete search and survey form */
    deleteSearchAndSurveyForm: boolean;
    /** Create a social share template */
    createSocialTemplate: SocialTemplate;
    /** Update a social share templatethrows error:SOCIAL_TEMPLATE_DOES_NOT_EXIST - invalid socialTemplateId */
    updateSocialTemplate: SocialTemplate;
    /** Create organization social share template */
    createOrganizationSocialTemplate: SocialTemplateForOrganization;
    /** Update organization social share templatethrows error:SOCIAL_TEMPLATE_DOES_NOT_EXIST - invalid socialTemplateId */
    updateOrganizationSocialTemplate: SocialTemplateForOrganization;
    /** Add new sourcing linkthrows error:SourcingLinkWithSameNameExists - When there is already a sourcing link with the same name for the same outreach circle */
    addSourcingLink: SourcingLink;
    /** Archive Sourcing Link */
    archiveSourcingLink: boolean;
    /** Create supporter email template for outreach circle */
    createSupporterEmailTemplateForOutreachCircle: SupporterEmailTemplate;
    /** Update supporter email template for outreach circle */
    updateSupporterEmailTemplateForOutreachCircle: SupporterEmailTemplate;
    /** Duplicate supporter email template */
    duplicateSupporterEmailTemplate: SupporterEmailTemplate;
    /** Update SupporterFormErrors thrown:SUPPORTER_FORM_WITH_GIVEN_NAME_ALREADY_EXISTINVALID_GROUP_IDINVALID_OPTIONS_INPUT_FOR_SUPPORTER_FORM_QUESTION */
    updateSupporterForm?: SupporterForm | null;
    /** Create SupporterFormErrors thrown:SUPPORTER_FORM_WITH_GIVEN_NAME_ALREADY_EXIST */
    createSupporterForm?: SupporterForm | null;
    /** Submit the responses for the supporter form */
    submitSupporterFormQuestionResponse: boolean;
    /** Link the supporter form to an action */
    linkSupporterFormToAction: Action;
    /** Unlink the supporter form from an action */
    unlinkSupporterFormFromAction: Action;
    /** Duplicate a supporter form with a new name */
    duplicateSupporterForm: SupporterForm;
    /** Delete supporter forms */
    deleteSupporterForm: boolean;
    /** Create supporter push notification template */
    createSupporterPushNotificationTemplate: SupporterPushNotificationTemplate;
    /** Update supporter push notification template */
    updateSupporterPushNotificationTemplate: SupporterPushNotificationTemplate;
    /** Create a new supporter filter state for the admin */
    createSupporterViewFilterState: SupporterViewFilterState;
    /** Update the existing supporter filter state for the admin */
    updateSupporterViewFilterState: SupporterViewFilterState;
    /** Delete saved supporter filter state */
    deleteSupporterViewFilterState: boolean;
    /** Create a supporter entry to keep a map ofthe outreach circles supported by a userthrows error:SUPPORTER_ALREADY_EXISTS: If the user in the input is already supporting the outreach circleINVALID_ORIGIN: When origin is invalidOUTREACH_CIRCLE_NOT_FOUND - Outreach circle not foundINVALID_SOURCE_ALIAS - Invalid source alias */
    supportOutreachCircle: Supporter;
    /** create supporter contact sourceErrors thrown:EMAIL_TEMPLATE_NOT_FOUND: When email template is not available for the specified outreach circle */
    createInvitedSupporterSource?: InvitedSupporterSource | null;
    /** Imports Supporter invite fileErrors thrown:INVITED_SUPPORTER_SOURCE_NOT_FOUND: When invited supporter source id is not foundINVITED_SUPPORTERS_IMPORT_IN_PROGRESS: When import for supporter source id is already in progress */
    startImportingInvitedSupporterFromFile?: boolean | null;
    /** Invite to supporter to join outreach circleErrors thrown:NO_SUPPORTER_CONTACT_FOUND - No supporter contact found to send emailINVITED_SUPPORTER_SOURCE_NOT_FOUND: When invited supporter source id is not foundINVITED_USER_CONSENT: when user does not have permission for sending emails to the imported contacts */
    sendSupporterInviteToImportedInvitedSupporters?: boolean | null;
    /** Invite a single supporter */
    inviteSupporters: Supporter[];
    /** Update a single supporterErrors thrown:SUPPORTER_NOT_FOUND - The supporterId provided does not match a supporter */
    updateSupporter: Supporter;
    /** Cancel import of Invited supproter fileErrors thrown:INVITED_SUPPORTER_SOURCE_NOT_FOUND: When invited supporter source id is not found */
    cancelInvitedSupporterImportFromFile?: boolean | null;
    /** Send selected email to all supporters based on the filterErrors thrown:EMAIL_TEMPLATE_NOT_FOUND: When email template is not available for the specified outreach circleINVITED_USER_CONSENT: when user does not have permission for sending emails to the imported contacts */
    sendSupporterEmailToFilteredSupporter?: boolean | null;
    /** Send push notification to all supporters based on the filterErrors thrown:INVALID_PUSH_NOTIFICATION_TITLE: When notification title is invalidINVALID_PUSH_NOTIFICATION_DESCRIPTION: When notification description is invalidNO_ELIGIBLE_SUPPORTERS_FOR_PUSH_NOTIFICATION: When there are zero supporters to receive the push notification */
    sendPushNotificationToFilteredSupporter?: boolean | null;
    /** Block filtered supporter(s) */
    blockFilteredSupporters: boolean;
    /** Unblock supporterErrors thrown:SUPPORTER_NOT_FOUND: When supporter is not found */
    unblockSupporter?: Supporter | null;
    /** Unsupport outreachCircleErrors thrown:SUPPORTER_NOT_FOUND: When supporter is not found */
    unsupportOutreachCircle?: Supporter | null;
    /** Handle recruitment link for supporter */
    supporterVisitedRecruitmentLink: boolean;
    /** Tag/Untag recipientErrors thrown:INVALID_TAG_INPUT - When input is invalid for tagging the selected tagResourceINVALID_TAG_APPLICATION - When the selected tag cannot be applied for the outreachChannel */
    tagRecipient: boolean;
    /** Create tag for an outreachCircleErrors thrown:INVALID_TAG_INPUT - When tag with name and database combination existsNGP_CREDENTIALS_NOT_FOUND - When saving source as NGP but no credentials are foundCANNOT_CREATE_NEW_TAG - When 100 tags exists or when database for default tags is not updated */
    createTag: Tag;
    /** Update a tagErrors thrown:TAG_NOT_FOUND - When tag being updated is not found.DEFAULT_TAG_NAME_UPDATE_ERROR - Default tag's name cannot be updated. */
    updateTag: Tag;
    /** Apply tag to affinity text recipient */
    applyTagToAffinityTextRecipient: boolean;
    /** Apply tag to relational text recipient */
    applyTagToRelationalTextRecipient: boolean;
    /** Apply tag to relational text recipient */
    applyTagToAmbiguousTextRecipient: boolean;
    /** Apply tag to affinity text recipient */
    removeTagToAffinityTextRecipient: boolean;
    /** Apply tag to relational text recipient */
    removeTagToRelationalTextRecipient: boolean;
    /** Link Tag to an Action with optional CannedResponse ID or textErrors thrown:INVALID_CANNED_RESPONSE_FOR_TAG - When passed canned response id is invalidTAG_ALREADY_LINKED_TO_ACTION - When tag is already linked to the action */
    linkTagToAction: Tag;
    /** Remove tag link to an Action */
    unLinkTagToAction: boolean;
    /** Update Canned Response for a tag */
    updateCannedResponseForActionTag?: CannedResponse | null;
    /** Delete a tagErrors thrown:TAG_NOT_FOUND - When tag is not foundDEFAULT_TAG_CANNOT_BE_DELETED - When trying to delete a default tagTAG_LINKED_TO_LIVE_ACTION_CANNOT_BE_DELETED - When deleting a tag which is linked to a live action */
    deleteTag: boolean;
    /** Create new text templateErrors thrown:TEXT_TEMPLATE_WITH_SAME_NAME_EXISTS */
    createTextTemplate: TextTemplate;
    /** Update text templateErrors thrown:TEXT_TEMPLATE_NOT_FOUND - Text template not found */
    updateTextTemplate: TextTemplate;
    /** Update text template for supporterErrors thrown:TEXT_TEMPLATE_NOT_FOUND - Text template not found */
    updateTextTemplateForSupporter: TextTemplateForSupporter;
    /** Create new organization text templateErrors thrown:TEXT_TEMPLATE_WITH_SAME_NAME_EXISTS */
    createOrganizationTextTemplate: TextTemplateForOrganization;
    /** Update organization text templateErrors thrown:TEXT_TEMPLATE_NOT_FOUND - Text template not found */
    updateOrganizationTextTemplate: TextTemplateForOrganization;
    /** Create a new user and return token and user objectErrors thrown:INVALID_PASSWORD - When password is emptyINVALID_USERNAME - When username is an invalid emailUSERNAME_EXISTS - When we already have the user with the same email id */
    signupUser: LoginResponse;
    /** Login an existing userErrors thrown:USE_SOCIAL_LOGIN - User had registered through social loginINVALID_PASSWORD - User exists, but password is incorrectUSER_NOT_FOUND - No user exists with the email idINVALID_NEW_PASSWORD - User is using an invalid password after the password update */
    login: LoginResponse;
    /** Logout API to remove cookies from client */
    logout: boolean;
    /** Create user and login for rapid onboarding flowErrors thrown:USE_SOCIAL_LOGIN - User had registered through social loginUSERNAME_EXISTS - When we already have the user with the same email idRAPID_ONBOARDING_NOT_ALLOWED -  Rapid onboarding not allowedINVALID_EMAIL_ID - Email in the input is not valid */
    loginForRapidOnboarding: LoginResponse;
    /** Create user and login for rapid onboarding flowErrors thrown:USE_SOCIAL_LOGIN - User had registered through social loginUSERNAME_EXISTS - When we already have the user with the same email idRAPID_ONBOARDING_NOT_ALLOWED -  Rapid onboarding not allowedINVALID_EMAIL_ID - Email in the input is not valid */
    loginForRapidOnboardingForEmbeddedActions: EmbeddedLoginResponse;
    /** Update name for logged in userErrors thrown:INVALID_NAME_INPUT - Invalid first name or Invalid last name (Max 25 characters) */
    updateNameForLoggedInUser: User;
    /** Update preferences for logged in user */
    updatePreferencesForLoggedInUser: User;
    /** Update contact details for logged in userErrors thrown:INVALID_LOCATION_DETAILS - Invalid location details (when either of city, state, country or zip is not provided )INVALID_PHONE_NUMBER - Invalid phone number (when phone number is not provided) */
    updateContactDetailsForLoggedInUser: User;
    /** Send a email to supporter with reset password linkErrors thrown:RESET_PASSWORD_FAILED - Failed to send the emailUSER_NOT_FOUND - email given in the input does not belong to any user */
    resetPasswordForSupporter?: boolean | null;
    /** Send a email to client with reset password linkErrors thrown:RESET_PASSWORD_FAILED - Failed to send the emailUSER_NOT_FOUND - email given in the input does not belong to any user */
    resetPasswordForClient?: boolean | null;
    /** Update passwordErrors thrown:INVALID_PASSWORD_RESET_CODE - User is using an invalid or used link */
    updatePassword?: boolean | null;
    /** Update logged in user passwordErrors thrown:INVALID_PASSWORD - When password is empty or less than 5 char */
    updatePasswordForLoggedInUser?: boolean | null;
    /** New Client registrationErrors thrown:INVALID_PASSWORD - When password is emptyINVALID_USERNAME - When username is an invalid emailUSERNAME_EXISTS - When we already have the user with the same email id */
    signupUserWithDetails: LoginResponse;
    /** New Client registration coming from our adsErrors thrown:INVALID_PASSWORD - When password is emptyINVALID_USERNAME - When username is an invalid emailUSERNAME_EXISTS - When we already have the user with the same email id */
    signupUserWithDetailsFromAds: LoginResponse;
    /** Mark user as verified if card token is valid. */
    verifyUserWithValidCard: boolean;
    /** Resend the verification mail for the userErrors thrown:USER_NOT_FOUND - Token in the header does not belong to any userUSER_ALREADY_VERIFIED - User is already verified, no need to send verification mailUSER_VERIFICATION_SENDING_FAILED - Not able to send user verification mail */
    resendVerificationEmail: boolean;
    /** When user clicks on the verification link, mark the user as verifiedErrors thrown:USER_NOT_FOUND - User id in the input does not belong to any userUSER_ALREADY_VERIFIED - User is clicking on the verification link even when he is already verified */
    verifyEmail: boolean;
    /** Update the email of the userErrors thrown:INVALID_EMAIL_ID - When username is an invalid emailUSER_NOT_FOUND - email given in the input does not belong to any userUSERNAME_EXISTS - When we already have the user with the same email id */
    updateUsername: User;
    /** Update the opt-in text of the user */
    updateOptInForText: User;
    /** Email support team to include the logged in user for demo/training invite */
    sendTrainingInvite: boolean;
    /** subscribe to newletter */
    subscribeToNewsletter: boolean;
    /** Unsubscribe email for specific email template.throws error:EMAIL_RECIPIENT_NOT_FOUND - Email recipient not foundEMAIL_TEMPLATE_NOT_FOUND - Email template not found */
    unsubcribeEmailFromEmailTemplate?: UnsubscribeEmailOutput | null;
    /** Upsert the push notification and device info for the user */
    updatePushNotificationToken: boolean;
    /** Update name and contact details for logged in userUpdate password if providedErrors thrown:INVALID_NAME_INPUT - Invalid first name or Invalid last name (Max 25 characters)INVALID_LOCATION_DETAILS - Invalid location details (when either of city, state, country or zip is not provided )INVALID_PHONE_NUMBER - Invalid phone number (when phone number is not provided)INVALID_PASSWORD - When password is empty or less than 5 char */
    updateNameAndContactDetailsForLoggedInUser: User;
    /** Send support email for leads from ad-landing screen */
    sendSupportEmailForLeadFromAdLandingScreen?: boolean | null;
    /** Used only in embed flowCreate a new user and return token and user objectErrors thrown:INVALID_PASSWORD - When password is emptyINVALID_USERNAME - When username is an invalid emailUSERNAME_EXISTS - When we already have the user with the same email id */
    signupUserForEmbed: LoginResponse;
    /** Used only in embed flowLogin an existing userErrors thrown:USE_SOCIAL_LOGIN - User had registered through social loginINVALID_PASSWORD - User exists, but password is incorrectUSER_NOT_FOUND - No user exists with the email idINVALID_NEW_PASSWORD - User is using an invalid password after the password update */
    loginForEmbed: LoginResponse;
    /** Used only in embed flowCreate user and login for rapid onboarding flowErrors thrown:USE_SOCIAL_LOGIN - User had registered through social loginUSERNAME_EXISTS - When we already have the user with the same email idRAPID_ONBOARDING_NOT_ALLOWED -  Rapid onboarding not allowedINVALID_EMAIL_ID - Email in the input is not valid */
    loginForRapidOnboardingForEmbed: LoginResponse;
    /** Request for user data deletion */
    requestForUserDataDeletion: boolean;
}

export interface ActionViewFilterState {
    id: string;

    name: string;

    state: ActionViewFilter;
}

export interface ActionViewFilter {
    actionStatusFilter?: ActionStatusFilter | null;

    searchFilter?: ActionSearchFilter | null;

    typeFilter?: ActionTypeFilter | null;

    groupFilter?: ActionGroupFilter | null;

    actionOrganizationTagFilter?: ActionOrganizationTagFilter | null;
}

export interface ActionStatusFilter {
    status?: ActionStatus[] | null;

    isExclude: boolean;
}

export interface ActionSearchFilter {
    name?: string | null;

    title?: string | null;
}

export interface ActionTypeFilter {
    actionType?: ActionType[] | null;

    isExclude: boolean;
}

export interface ActionGroupFilter {
    groupIds?: string[] | null;

    isExclude: boolean;
}

export interface ActionOrganizationTagFilter {
    ids?: string[] | null;

    isExclude: boolean;
}

export interface ActionViewFilterStateList {
    items?: ActionViewFilterState[] | null;

    total: number;
}

export interface RegisterTcrBrandOutput {
    organizationType: TcrBrandOrganizationType;

    cspId: string;

    brandId: string;

    displayName: string;

    companyName: string;

    ein: string;

    einIssuingCountry: string;

    phone: string;

    street: string;

    city: string;

    state: string;

    postalCode: string;

    country: string;

    email: string;

    website: string;

    brandRelationship: string;

    vertical: TcrBrandVertical;

    referenceId: string;

    identityStatus: TcrBrandIdentityStatus;

    createDate: string;

    mock: boolean;
}

export interface RegisterTcrCampaignOutput {
    campaignId: string;
}

export interface PreSignedUploadUrl {
    result: Json;

    mediaId: string;
}

export interface OutreachCircleAdminEmailUnsubscribeOutput {
    userEmail: string;

    emailTemplateName: string;

    outreachCircleName: string;
}

export interface OutreachCircleEmailUnsubscribeOutput {
    userEmail: string;

    outreachCircleName: string;

    appName?: string | null;
}

export interface InvitedSupporterSource {
    id: string;

    outreachCircleId: string;

    fileName?: string | null;

    fileType?: string | null;

    mapping?: Json | null;

    supporterEmailTemplateId: string;

    created?: Date | null;

    updated?: Date | null;

    importComplete?: boolean | null;

    supporterEmailTemplate?: SupporterEmailTemplate | null;
}

export interface LoginResponse {
    token: string;

    user: User;
}

export interface EmbeddedLoginResponse {
    embeddedToken: string;

    user: User;
}

export interface UnsubscribeEmailOutput {
    userEmail: string;

    emailTemplateName: string;
}

export interface Subscription {
    action: ActionSubscriptionResponse;

    publicAction: PublicActionSubscriptionResponse;

    audienceImportStatus?: AudienceImportStatus | null;

    contactImportStatus?: ContactImportStatus | null;

    tcrIntegrationStatus: IntegrationSubscriptionResponse;
    /** outreach circle subscription to update client for some data update */
    outreachCircle: OutreachCircleSubscriptionResponse;
    /** Status of match contacts */
    supporter: SupporterSubscriptionResponse;
    /** Supporter subscription v2 */
    supporterV2: SupporterSubscriptionV2Response;
    /** Subscribe and receive update on the progress of Invited Supporter import */
    invitedSupporterImport: InvitedSupporterImportSubscriptionResponse;

    clientVersion?: number | null;

    supporterVersion?: number | null;
}

export interface ActionSubscriptionResponse {
    actionId: string;

    useCase: ActionUpdateUseCase;
}

export interface PublicActionSubscriptionResponse {
    actionId: string;

    useCase: PublicActionUpdateUseCase;

    data?: Json | null;
}

export interface AudienceImportStatus {
    event: AudienceImportStatusEvent;

    audienceAction: AudienceAction;
}

export interface ContactImportStatus {
    contactSourceId?: string | null;

    count?: number | null;

    completed?: boolean | null;

    error?: boolean | null;
}

export interface IntegrationSubscriptionResponse {
    outreachCircleId: string;

    entityType: TcrEntityType;

    status?: TcrCurrentStatus | null;

    entityId: string;
}

export interface OutreachCircleSubscriptionResponse {
    outreachCircleId: string;

    responseType: OutreachCircleUpdateResponseType;
}

export interface SupporterSubscriptionResponse {
    supporterId: string;

    contactImportInProgress?: boolean | null;

    matchingJob?: MatchingJob | null;

    rerunMatching?: boolean | null;
}

export interface SupporterSubscriptionV2Response {
    supporterId: string;

    event: SupporterSubscriptionResponseEvent;

    data?: SupporterSubscriptionData | null;
}

export interface P2PConversationSubscriptionResponse {
    conversationItem?: P2PConversationItem | null;

    inboxItem?: P2PInboxItem | null;
}

export interface InvitedSupporterImportSubscriptionResponse {
    invitedSupporterSourceId: string;

    hasCompleted?: boolean | null;

    hasFailed?: boolean | null;

    failureReason?: string | null;

    totalImportedInvitedSupporterCount?: number | null;

    totalExistingSupporterCount?: number | null;

    currentState?: InvitedSupporterImportProgressState | null;
}

export interface DashboardFilter {
    outreachCircleIds?: (string | null)[] | null;

    organizationFilterId?: string | null;

    organizationId?: string | null;

    startDate?: Date | null;

    endDate?: Date | null;

    outreachCircleJoinRequired?: boolean | null;

    skip?: number | null;

    limit?: number | null;
}

export interface PhoneNumberHistory {
    actionName: string;

    date: Date;
}

export interface SearchAndSurveyMemberData {
    key: string;

    value?: string | null;
}

export interface SupporterContactList {
    total: number;

    items: (SupporterContact | null)[];
}

export interface SupporterSearchFilter {
    firstName?: string | null;

    lastName?: string | null;

    emailAddress?: string | null;

    phoneNumber?: string | null;

    nameOrEmail?: string | null;
}

// ====================================================
// Arguments
// ====================================================

export interface GetGroCanvassSummaryQueryArgs {
    actionId: string;
}
export interface GetSupportersForActionAssignmentQueryArgs {
    input: GetSupportersForActionAssignmentInput;
}
export interface GetAssignedMembersQueryArgs {
    input?: GetAssignedMembersForActionInput | null;
}
export interface GetCanvassedMembersQueryArgs {
    input?: GetAssignedMembersForActionInput | null;
}
export interface GetContentForSendingToRecipientBySupporterQueryArgs {
    input: ContentForSendingToRecipientBySupporterInput;
}
export interface GetMemberFormFieldValidationsQueryArgs {
    input: MemberFormFieldValidationsInput;
}
export interface DoesActionExistsQueryArgs {
    input: ActionExistsInput;
}
export interface GetActionForPreviewQueryArgs {
    id: string;
}
export interface GetActionsForPreviewByGroupQueryArgs {
    input: GetActionPreviewByGroupInput;
}
export interface GetActionsForPreviewForSupporterQueryArgs {
    input: GetActionsPreviewForSupporterInput;
}
export interface GetActionsForOutreachCircleQueryArgs {
    input: ActionsForOutreachCircleInput;
}
export interface GetActionsForOrganizationActionQueryArgs {
    input: ActionsForOrgActionInput;
}
export interface GetCurrentActionsForOutreachCircleQueryArgs {
    input: ActionsForOutreachCircleInput;
}
export interface GetP2PActionsWhereInitialTextIsSentQueryArgs {
    input: ActionsForOutreachCircleInput;
}
export interface GetInactiveUnarchivedActionsForOutreachCircleQueryArgs {
    input: ActionsForOutreachCircleInput;
}
export interface GetArchivedActionsForOutreachCircleQueryArgs {
    input: ActionsForOutreachCircleInput;
}
export interface GetPublicActionsForEmbedQueryArgs {
    input: PublicActionForEmbedInput;
}
export interface GetPublicActionsForOutreachCircleQueryArgs {
    input: PublicActionForOutreachCircleInput;
}
export interface GetPublicActionsForSupporterQueryArgs {
    input: PublicActionForSupporterInput;
}
export interface GetPublicActionQueryArgs {
    id: string;
}
export interface GetActionQueryArgs {
    id: string;
}
export interface GetSupporterActionStatusQueryArgs {
    input: SupporterActionInput;
}
export interface GetFacebookDataQueryArgs {
    input: FacebookRequestInput;
}
export interface GetContactsForAffinityTextingQueryArgs {
    input: GetContactsForAffinityTextingInput;
}
export interface GetContactsForAffinityTextingV1QueryArgs {
    input: GetContactsForAffinityTextingInput;
}
export interface GetTextContentForAffinityTextingQueryArgs {
    input: GetTextContentForAffinityTextingInput;
}
export interface GetSupporterTextContentForTextingSupporterQueryArgs {
    input: SupporterTextContentForTextingSupporterInput;
}
export interface GetActionsForWhichEmailsSentBySupporterQueryArgs {
    input: PublicActionForSupporterInput;
}
export interface GetActionsForWhichTextMessagesSentBySupporterQueryArgs {
    input: PublicActionForSupporterInput;
}
export interface GetActionsTakenBySupporterQueryArgs {
    input: PublicActionForSupporterInput;
}
export interface GetTextSupporterSetListQueryArgs {
    input: TextSupporterSetInput;
}
export interface GetEligibleSupporterCountForSupporterTextingQueryArgs {
    input: EligibleSupporterForSupporterTextingInput;
}
export interface GetEligibleActionsForAssigningToGroupQueryArgs {
    input: GetEligibleActionForAssigningToGroupInput;
}
export interface GetEmbedActionQueryArgs {
    actionId: string;
}
export interface GetAssignedSupportersForActionQueryArgs {
    input: GetAssignedSupportersForActionInput;
}
export interface FetchAssignedSupportersToActionQueryArgs {
    input: FetchAssignedSupportersToActionInput;
}
export interface GetEstimatedCostAcceptanceInfoForActionQueryArgs {
    actionId: string;
}
export interface GetAudienceCustomFieldListForActionQueryArgs {
    actionId: string;
}
export interface HasSmsSentToAllEligibleRecipientsQueryArgs {
    actionId: string;
}
export interface PublicActionByAliasQueryArgs {
    input: PublicActionByAliasInput;
}
export interface GetActionsLinkedToAudienceActionQueryArgs {
    input: GetActionsLinkedToAudienceActionInput;
}
export interface SendActionEmailNotificationPreviewQueryArgs {
    input: ActionEmailNotificationPreviewInput;
}
export interface GetOriginalActionCallTemplateForSupporterQueryArgs {
    actionId: string;
}
export interface GetOriginalActionVisitTemplateForSupporterQueryArgs {
    actionId: string;
}
export interface FetchGroupsAssignedToActionQueryArgs {
    input: FetchGroupsAssignedToActionInput;
}
export interface GetMemberNotesQueryArgs {
    input?: GetMemberNotesInput | null;
}
export interface GetHouseholdsBasedonCurrentLocationQueryArgs {
    input: GetHouseholdsBasedonCurrentLocationInput;
}
export interface GetMatchedMembersForAddressBasedCanvassingQueryArgs {
    input: CreateSearchAndSurveyContactInput;
}
export interface GetAudienceActionQueryArgs {
    id: string;
}
export interface PresignedAudienceActionUploadUrlQueryArgs {
    input?: AudienceActionUrlRequestInput | null;
}
export interface AudienceMemberByNameQueryArgs {
    input?: MemberSearchByNameInput | null;
}
export interface DoesAudienceMappingNameExistQueryArgs {
    input: MemberSearchByNameInput;
}
export interface GetAudienceActionsForOutreachCircleByIntegrationTypeQueryArgs {
    input: GetAudienceActionsForOutreachCircleByIntegrationTypeInput;
}
export interface GetAudienceActionsForActionByIntegrationTypeQueryArgs {
    input: GetAudienceActionsForActionByIntegrationTypeInput;
}
export interface GetAudienceInfoByListTypeQueryArgs {
    input: GetAudienceInfoByListTypeInput;
}
export interface GetLiveActionsByAudienceActionQueryArgs {
    input: GetLiveActionsByAudienceActionInput;
}
export interface GetMappingsByAudienceIdQueryArgs {
    input: GetMappingsByAudienceIdInput;
}
export interface GetSearchAndSurveyMemberByIdQueryArgs {
    input: GetSearchAndSurveyMemberInput;
}
export interface GetMatchedMembersForSearchAndSurveyActionQueryArgs {
    input: SearchAndSurveyMemberInput;
}
export interface GetBlackbaudConstituentListsQueryArgs {
    outreachCircleId: string;
}
export interface GetBroadcastTextingScriptsQueryArgs {
    outreachCircleId: string;
}
export interface GetBroadcastTextingScriptByIdQueryArgs {
    id: string;
}
export interface CheckOutreachCircleReadyForBroadcastTextingQueryArgs {
    outreachCircleId: string;
}
export interface GetBroadcastTextingDetailsQueryArgs {
    actionId: string;
}
export interface GetBroadcastTextingDeliveryRecipientsQueryArgs {
    input: GetBroadcastTextingDeliveryRecipientsInput;
}
export interface SupporterContactQueryArgs {
    input?: SupporterContactInput | null;
}
export interface MappedContactsQueryArgs {
    input: MappedContactsInput;
}
export interface MappedContactsForTextQueryArgs {
    input: MappedContactsInput;
}
export interface EmailRecipientsQueryArgs {
    input: MappedContactsInput;
}
export interface AmbiguousMappedContactsQueryArgs {
    input: MappedContactsInput;
}
export interface AmbiguousMappedContactsForTextQueryArgs {
    input: MappedContactsInput;
}
export interface GetContentForTextRecipientQueryArgs {
    input: TextRecipientInput;
}
export interface MarkTextRecipientAsSentQueryArgs {
    input: TextRecipientInput;
}
export interface MappedContactsCountQueryArgs {
    input: SupporterActionInput;
}
export interface MappedContactsCountForTextQueryArgs {
    input: SupporterActionInput;
}
export interface MappedContactsCountForOutreachModeQueryArgs {
    input: SupporterActionInput;
}
export interface MappedContactsCountForTextOutreachModeQueryArgs {
    input: SupporterActionInput;
}
export interface MatchingJobQueryArgs {
    id: string;
}
export interface ContactSourcesWithMappedContactCountQueryArgs {
    input: SupporterActionInput;
}
export interface ContactSourcesWithAmbiguousMappedContactCountQueryArgs {
    input: SupporterActionInput;
}
export interface ContactSourcesWithMappedContactCountForTextQueryArgs {
    input: SupporterActionInput;
}
export interface ContactSourcesWithAmbiguousMappedContactCountForTextQueryArgs {
    input: SupporterActionInput;
}
export interface GetSelectedNonMappedContactsForEmailQueryArgs {
    input: MappedContactsInput;
}
export interface GetSelectedNonMappedContactsForTextQueryArgs {
    input: MappedContactsInput;
}
export interface GetEligibleOutreachModeRecipientsForEmailQueryArgs {
    input: MappedContactsInput;
}
export interface GetEligibleOutreachModeRecipientsForTextQueryArgs {
    input: MappedContactsInput;
}
export interface GetUnavailableContactsForEmailOutreachModeQueryArgs {
    input: MappedContactsInput;
}
export interface GetUnavailableContactsForTextOutreachModeQueryArgs {
    input: MappedContactsInput;
}
export interface GetMappedContactsForActionQueryArgs {
    input: GetContactsForActionInput;
}
export interface GetNonMappedContactsForActionQueryArgs {
    input: GetContactsForActionInput;
}
export interface GetAmbiguousContactsForActionQueryArgs {
    input: GetContactsForActionInput;
}
export interface GetA1CRecipientsQueryArgs {
    input: GetContactsForActionInput;
}
export interface GetDuplicateEmailRecipientsQueryArgs {
    input: DuplicateEmailRecipientInput;
}
export interface GetMatchesForContactQueryArgs {
    input: GetMatchesForContactInput;
}
export interface GetContactFileUploadUrlQueryArgs {
    input: ContactFileUrlInput;
}
export interface DoesContactExistsForEmailQueryArgs {
    email: string;
}
export interface DoesContactExistsForPhoneNumberQueryArgs {
    phoneNumber: string;
}
export interface GetContactsQueryArgs {
    input: ContactQueryInput;
}
export interface GetContactsWithEmailQueryArgs {
    input: ContactQueryForOutreachMode;
}
export interface GetContactsWithPhoneQueryArgs {
    input: ContactQueryForOutreachMode;
}
export interface GetContactByIdQueryArgs {
    id: string;
}
export interface GetTotalSupportersByRecruitmentLinkQueryArgs {
    input: OutreachCircleDashboardFilterInput;
}
export interface TotalActionsTakenQueryArgs {
    input: OutreachCircleDashboardFilterInput;
}
export interface TotalSupportersQueryArgs {
    input: OutreachCircleDashboardFilterInput;
}
export interface TotalActionImpressionsQueryArgs {
    input: OutreachCircleDashboardFilterInput;
}
export interface MostEngagedSupportersQueryArgs {
    input: OutreachCircleDashboardFilterInput;
}
export interface ActionsTakenBySupportersQueryArgs {
    input: OutreachCircleDashboardFilterInput;
}
export interface EmailSummaryQueryArgs {
    input: OutreachCircleDashboardFilterInput;
}
export interface TextMessagesSentQueryArgs {
    input: OutreachCircleDashboardFilterInput;
}
export interface ActionsByTypeQueryArgs {
    input: OutreachCircleDashboardFilterInput;
}
export interface SurveyResponseSummaryQueryArgs {
    engagementId: string;
}
export interface GetOriginalActionEmailTemplateSubjectForSupporterQueryArgs {
    input: SupporterEmailTemplateInput;
}
export interface GetOriginalActionEmailTemplateContentForSupporterQueryArgs {
    input: SupporterEmailTemplateInput;
}
export interface EditHtmlForEngagementByIdQueryArgs {
    engagementId: string;
}
export interface GetContentForPreviewQueryArgs {
    editorContent: string;

    emailTemplateId: string;

    actionId: string;
}
export interface EmailTemplateQueryArgs {
    id: string;
}
export interface EmailTemplatesByOutreachCircleQueryArgs {
    input: EmailTemplateForOutreachCircleInput;
}
export interface DefaultEditHtmlForRecruitmentLinkQueryArgs {
    emailTemplateId: string;

    outreachcircleCode?: string | null;

    linkText?: string | null;
}
export interface GetDefaultEditorContentForActionLinkQueryArgs {
    actionId: string;
}
export interface UpdatedEmailTemplateWithRecruitmentLinkQueryArgs {
    input: UpdateEmailTemplateWithRecruitmentLinkInput;
}
export interface UpdatedEmailTemplateWithOutreachCircleBrandingQueryArgs {
    content: string;

    hasBranding: boolean;
}
export interface EditHtmlForDisclaimerQueryArgs {
    disclaimerText: string;
}
export interface UpdatedEmailTemplateWithDisclaimerQueryArgs {
    content: string;

    disclaimerText: string;
}
export interface GetEmailContentForUiEditorWithUpdatedSurveyQueryArgs {
    input: UpdateEmailContentWithSurveyDetailsInput;
}
export interface ValidateEmailTemplateNameForActionQueryArgs {
    input?: ValidateEmailTemplateNameForActionInput | null;
}
export interface EmailTemplatesByOrganizationQueryArgs {
    input: EmailTemplatesForOrganization;
}
export interface DefaultHtmlForRecruitmentLinkForOrgEmailTemplateQueryArgs {
    emailTemplateId: string;

    linkText?: string | null;
}
export interface DefaultHtmlForDisclaimerForOrgEmailTemplateQueryArgs {
    emailTemplateId: string;
}
export interface ValidateOrganizationEmailTemplateNameQueryArgs {
    input?: ValidateOrganizationEmailTemplateNameInput | null;
}
export interface GetContentForUiPreviewByUiEditorContentForOrganizationQueryArgs {
    editorContent: string;

    emailTemplateId: string;
}
export interface SurveyByIdQueryArgs {
    surveyId: string;
}
export interface SurveysByOutreachCircleIdQueryArgs {
    input: SurveysByOutreachCircleIdInput;
}
export interface GetSurveysEligibleForForActionByIntegrationQueryArgs {
    input: GetSurveysEligibleForForActionByIntegrationInput;
}
export interface SearchExternalLinksByOutreachCircleIdQueryArgs {
    input: SearchExternalLinkInput;
}
export interface SurveyByIdForTextRecipientQueryArgs {
    engagementId: string;

    textRecipientId: string;
}
export interface SurveyByIdForEmailRecipientQueryArgs {
    engagementId: string;

    emailRecipientId: string;
}
export interface SurveyEngagementForPreviewQueryArgs {
    engagementId: string;
}
export interface GetSupporterPreviewForSurveyQuestionQueryArgs {
    surveyQuestionId: string;
}
export interface GetSupporterPreviewForSurveyQueryArgs {
    surveyId: string;
}
export interface DoesSurveyByNameAndOutreachCircleIdExistQueryArgs {
    input: SurveyExistsInput;
}
export interface GetSurveysForOrganizationQueryArgs {
    input: SurveysForOrganizationInput;
}
export interface GroSurveyFormsByOutreachCircleQueryArgs {
    input: GroSurveyFormsByOutreachCircleInput;
}
export interface GetSupporterPreviewForGroSurveyFormQuestionQueryArgs {
    groSurveyFormQuestionId: string;
}
export interface GetSupporterPreviewForGroSurveyFormQueryArgs {
    groSurveyFormId: string;
}
export interface GetGroSurveyFormByIdQueryArgs {
    groSurveyFormId: string;
}
export interface ValidateGroSurveyFormNameQueryArgs {
    input?: ValidateGroSurveyFormNameInput | null;
}
export interface GetGroSurveyResponseForMemberQueryArgs {
    input: GetGroSurveyResponseForMemberInput;
}
export interface GetPastGroSurveyResponsesForMemberQueryArgs {
    input: GetPastGroSurveyResponseInput;
}
export interface GetGroupsByOutreachCircleQueryArgs {
    input: GetGroupsInput;
}
export interface GetActionsForGroupQueryArgs {
    input: GetActionsForGroupInput;
}
export interface GroupQueryArgs {
    id: string;
}
export interface GetEligibleGroupsForActionQueryArgs {
    actionId: string;
}
export interface GetAllGroupsForActionQueryArgs {
    input: GetAllGroupsForActionInput;
}
export interface FetchIntegrationsQueryArgs {
    outreachCircleId: string;
}
export interface FetchNationBuilderPeopleTagsQueryArgs {
    outreachCircleId: string;
}
export interface TestNgpIntegrationQueryArgs {
    input: TestNgpIntegrationInput;
}
export interface FetchNgpListsQueryArgs {
    outreachCircleId: string;

    database: AudienceActionDatabase;
}
export interface FetchNgpActivistCodesQueryArgs {
    outreachCircleId: string;

    integrationType: NgpIntegrationType;
}
export interface FetchNgpSurveyListQueryArgs {
    outreachCircleId: string;

    integrationType: NgpIntegrationType;
}
export interface FetchNgpSurveyByIdQueryArgs {
    outreachCircleId: string;

    ngpSurveyId: number;

    database: AudienceActionDatabase;
}
export interface GetPdiOnTheGoAssignmentsQueryArgs {
    input: OnTheGoAssignmentsInput;
}
export interface GetPdiAssignmentZonesQueryArgs {
    actionId: string;
}
export interface GetMatchedPdiMembersQueryArgs {
    input: CreateSearchAndSurveyContactInput;
}
export interface GetPdiQuestionsQueryArgs {
    input: GetQuestionsFromPdiInput;
}
export interface GetPdiFlagIdsQueryArgs {
    outreachCircleId: string;
}
export interface GetPdiProjectsForOutreachcircleQueryArgs {
    outreachCircleId: string;
}
export interface ValidateSoqlQueryArgs {
    input?: ValidateSoqlInput | null;
}
export interface GetTcrRegistrationDetailsQueryArgs {
    outreachCircleId: string;
}
export interface GetTcrBrandApplicableUsecasesQueryArgs {
    input: GetTcrBrandApplicableUsecasesInput;
}
export interface GetBase64ForAnImageQueryArgs {
    mediaId: string;
}
export interface MemberSurveysByOutreachCircleIdQueryArgs {
    input: SurveysByOutreachCircleIdInput;
}
export interface MemberSurveysByOrganizationIdQueryArgs {
    input: SurveysForOrganizationInput;
}
export interface GetLatestNativeAppVersionQueryArgs {
    input: GetLatestNativeAppVersionInput;
}
export interface GetOrganizationActionForPreviewQueryArgs {
    id: string;
}
export interface GetOrganizationActionQueryArgs {
    id: string;
}
export interface GetActionsForOrganizationQueryArgs {
    input: ActionsForOrganizationInput;
}
export interface GetOutreachCirclesByOrganizationActionPublishedQueryArgs {
    organizationActionId: string;
}
export interface GetTerminatedAndHiddenOrganizationActionsQueryArgs {
    input: ActionsForOrganizationInput;
}
export interface GetCurrentOrganizationActionsQueryArgs {
    input: ActionsForOrganizationInput;
}
export interface DoesOrganizationActionWithSameNameExistQueryArgs {
    input: DoesOrganizationActionWithSameNameExistInput;
}
export interface GetActionOrganizationTagsForOutreachCircleQueryArgs {
    outreachCircleId: string;
}
export interface GetActionOrganizationTagsForOrganizationQueryArgs {
    organizationId: string;
}
export interface GetAllOrganizationUsersQueryArgs {
    organizationId: string;
}
export interface OrganizationByIdQueryArgs {
    id: string;
}
export interface PublicOrganizationByAliasQueryArgs {
    alias: string;
}
export interface GetOutreachCirclesByOrganizationQueryArgs {
    input: GetOutreachCirclesByOrganizationInput;
}
export interface GetActiveOutreachCirclesByOrganizationQueryArgs {
    input: GetOutreachCirclesByOrganizationInput;
}
export interface GetFiltersByOrganizationQueryArgs {
    organizationId: string;
}
export interface TotalActionsTakenForOrganizationQueryArgs {
    filter: GetOrganizationDashboardDataInput;
}
export interface ActionsTakenCountByOutreachcircleForOrganizationQueryArgs {
    filter: GetOrganizationDashboardDataInput;
}
export interface MostEngagedSupportersForOrganizationQueryArgs {
    filter: GetOrganizationDashboardDataInput;
}
export interface GetSupporterCountByOutreachcircleForOrganizationQueryArgs {
    filter: GetOrganizationDashboardDataInput;
}
export interface ActionsByTypeForOrganizationQueryArgs {
    filter: GetOrganizationDashboardDataInput;
}
export interface EmailSummaryForOrganizationQueryArgs {
    filter: GetOrganizationDashboardDataInput;
}
export interface TextMessagesSentForOrganizationQueryArgs {
    filter: GetOrganizationDashboardDataInput;
}
export interface EmailOpenRateForOrganizationQueryArgs {
    filter: GetOrganizationDashboardDataInput;
}
export interface TotalSupportersCountForOrganizationQueryArgs {
    filter: GetOrganizationDashboardDataInput;
}
export interface GetOutreachCirclesForUserByOrganizationQueryArgs {
    userId: string;

    organizationId: string;
}
export interface PublicOrganizationQueryArgs {
    organizationId: string;
}
export interface GetPublicOutreachCirclesByOrganizationQueryArgs {
    input: PublicOutreachCircleByOrganizationInput;
}
export interface DoesOutreachCircleUserEmailTemplateExistsQueryArgs {
    input: DoesOutreachCircleUserEmailTemplateExistsInput;
}
export interface GetAllEmailAliasesForOrganizationQueryArgs {
    organizationId: string;
}
export interface GetOutreachCircleUserEmailTemplatesForOrganizationQueryArgs {
    input: GetOutreachCircleUserEmailTemplatesForOrganizationInput;
}
export interface GetPreviewForOutreachCircleUserEmailTemplateQueryArgs {
    input: GetPreviewForOutreachCircleUserEmailTemplateInput;
}
export interface GetUpdatedContentForOutreachCircleUserEmailTemplateWithActionLinkTextQueryArgs {
    input: GetUpdatedContentForOutreachCircleUserEmailTemplateWithActionLinkTextInput;
}
export interface GetEmailTemplateForOrganizationActionQueryArgs {
    organizationActionId: string;

    code: OutreachCircleUserEmailTemplateCode;
}
export interface GetEligibleCountForOrganizationActionNotificationQueryArgs {
    input: GetEligibleCountForOrganizationSendActionNotificationInput;
}
export interface GetEligibleCountForNotifyOcAdminsForOrganizationQueryArgs {
    input: GetEligibleCountForNotifyOcAdminsForOrganizationInput;
}
export interface OutreachCircleUserQueryArgs {
    id: string;
}
export interface PublicOutreachCircleByAliasQueryArgs {
    alias: string;
}
export interface PublicOutreachCircleByAliasOrNameQueryArgs {
    input: PublicOutreachCircleByAliasOrNameInput;
}
export interface PublicOutreachCircleForEmbedQueryArgs {
    alias: string;
}
export interface SearchPublicOutreachCircleQueryArgs {
    input: SearchPublicOutreachCircleInput;
}
export interface OutreachCircleByAliasQueryArgs {
    alias: string;
}
export interface OutreachCircleByIdQueryArgs {
    id: string;
}
export interface AllPublicOutreachCirclesQueryArgs {
    input: AllPublicOutreachCirclesInput;
}
export interface AllAliasesForOutreachCircleQueryArgs {
    outreachCircleId: string;
}
export interface AllEmailAliasesForOutreachCircleQueryArgs {
    outreachCircleId: string;
}
export interface GetAllCampaignsForOutreachCircleQueryArgs {
    outreachCircleId: string;
}
export interface GetOutreachCircleAccessInfoQueryArgs {
    outreachCircleId: string;
}
export interface GetPublicAliasDetailsQueryArgs {
    aliasValue: string;
}
export interface GetAppLogoByAliasQueryArgs {
    aliasValue: string;
}
export interface GetArchivedPublicOutreachCircleQueryArgs {
    id: string;
}
export interface GetOutreachCirclePhoneNumberListQueryArgs {
    input: GetOutreachCirclePhoneNumberList;
}
export interface RefreshOutreachCirclePhoneNumbersStatusQueryArgs {
    outreachCircleId: string;
}
export interface GetAreaCodesOfPhoneNumbersQueryArgs {
    input: GetAreaCodesOfPhoneNumbersInput;
}
export interface GetOutreachCirclePhoneNumberLogsQueryArgs {
    input?: GetOutreachCirclePhoneNumberLogsInput | null;
}
export interface BillingCardsByOutreachCircleIdQueryArgs {
    outreachCircleId: string;
}
export interface CouponDiscountedAmountQueryArgs {
    plan: string;

    coupon: string;

    outreachCircleId?: string | null;
}
export interface UpcomingInvoiceDetailsOfOutreachCircleQueryArgs {
    outreachCircleId: string;
}
export interface OldInvoicesOfOutreachCircleQueryArgs {
    outreachCircleId: string;
}
export interface GetFilteredP2PInboxQueryArgs {
    input: P2PInboxFilterInput;
}
export interface GetP2PConversationQueryArgs {
    conversationId: string;
}
export interface GetEligibleSupporterForP2PReplyAssignmentQueryArgs {
    input: EligibleSupporterForP2PReplyAssignmentInput;
}
export interface GetP2PScriptSurveyQuestionsByOutreachCircleQueryArgs {
    input: P2PScriptSurveyQuestionsByOutreachCircleInput;
}
export interface GetP2PScriptSurveyQuestionByIdQueryArgs {
    p2pScriptSurveyQuestionId: string;
}
export interface IsValidP2PScriptSurveyQuestionNameQueryArgs {
    input: ValidateP2PScriptSurveyQuestionNameInput;
}
export interface GetRecipientsForP2PTextingQueryArgs {
    input: RecipientsForP2PTextingInput;
}
export interface GetNumberOfRecipientsP2PTextedQueryArgs {
    actionId: string;
}
export interface GetInitialP2PItemQueryArgs {
    actionId: string;
}
export interface GetInitialP2PTextForRestoreQueryArgs {
    actionId: string;
}
export interface CanSendP2PTextMessageQueryArgs {
    actionId: string;
}
export interface GetP2PWorkspacesByOutreachCircleQueryArgs {
    input: P2PWorkspacesByOutreachCircleInput;
}
export interface GetP2PWorkspaceByIdQueryArgs {
    p2pWorkspaceId: string;
}
export interface IsValidP2PWorkspaceNameQueryArgs {
    input: ValidateP2PWorkspaceNameInput;
}
export interface IsP2PWorkspaceLinkedToActionAndAcknowledgedCostQueryArgs {
    p2pWorkspaceId: string;
}
export interface GetReportsByOutreachCircleQueryArgs {
    outreachCircleId: string;

    reportType?: ReportType | null;
}
export interface GetReportsByOrganizationQueryArgs {
    organizationId: string;
}
export interface SearchAndSurveyFormsByOutreachCircleQueryArgs {
    input: SearchAndSurveyFormsByOutreachCircleInput;
}
export interface GetSupporterPreviewForSearchAndSurveyFormQuestionQueryArgs {
    searchAndSurveyFormQuestionId: string;
}
export interface GetSupporterPreviewForSearchAndSurveyFormQueryArgs {
    searchAndSurveyFormId: string;
}
export interface GetSearchAndSurveyFormByIdQueryArgs {
    searchAndSurveyFormId: string;
}
export interface ValidateSearchAndSurveyFormNameQueryArgs {
    input?: ValidateSearchAndSurveyFormNameInput | null;
}
export interface DefaultEditHtmlForRecruitmentLinkForSocialTextQueryArgs {
    outreachCircleId: string;

    actionId: string;

    outreachcircleCode?: string | null;
}
export interface GetSocialTextContentForPreviewQueryArgs {
    input: GetSocialTextContentForPreviewInput;
}
export interface SocialTemplatesByOutreachCircleQueryArgs {
    outreachCircleId: string;

    searchKey?: string | null;
}
export interface ValidateSocialTemplateNameQueryArgs {
    input?: ValidateSocialTemplateNameInput | null;
}
export interface SocialTemplatesByOrganizationQueryArgs {
    organizationId: string;

    searchKey?: string | null;
}
export interface ValidateOrganizationSocialTemplateNameQueryArgs {
    input?: ValidateOrganizationSocialTemplateNameInput | null;
}
export interface SocialTemplateByIdForOrganizationQueryArgs {
    id: string;
}
export interface SocialTemplateQueryArgs {
    id: string;
}
export interface GetOrganizationSocialTextContentForPreviewQueryArgs {
    input: GetOrganizationSocialTextContentForPreviewInput;
}
export interface GetSourcingLinkForOutreachCircleQueryArgs {
    input: GetSourcingLinkInput;
}
export interface GetUpdatedReminderContentQueryArgs {
    input: UpdateReminderContentInput;
}
export interface GetSupporterTemplatesForOutreachCircleQueryArgs {
    input: SupporterEmailTemplateForOutreachCircle;
}
export interface GetDefaultEditorContentForSupporterRecruitmentLinkQueryArgs {
    outreachCircleId: string;

    outreachCircleCode?: string | null;

    linkText?: string | null;
}
export interface GetContentForUiPreviewByUiEditorContentForOutreachCircleSupporterEmailTemplateQueryArgs {
    editorContent: string;

    supporterEmailTemplateId: string;
}
export interface GetUpdatedEditorContentForSupporterRecruitmentLinkQueryArgs {
    input: UpdateSupporterEmailTemplateWithRecruitmentLinkInput;
}
export interface ValidateSupporterEmailTemplateNameQueryArgs {
    input?: ValidateSupporterEmailTemplateNameInput | null;
}
export interface GetDefaultContentForActionEmailNotificationQueryArgs {
    input: DefaultSupporterEmailTemplateInput;
}
export interface SupporterFormsByOutreachCircleQueryArgs {
    input: SupporterFormsByOutreachCircleInput;
}
export interface GetSupporterPreviewForSupporterFormQuestionQueryArgs {
    supporterFormQuestionId: string;
}
export interface GetSupporterPreviewForSupporterFormQueryArgs {
    supporterFormId: string;
}
export interface GetSupporterFormByIdQueryArgs {
    supporterFormId: string;
}
export interface ValidateSupporterFormNameQueryArgs {
    input?: ValidateSupporterFormNameInput | null;
}
export interface GetSupporterFormsForOrganizationQueryArgs {
    input: GetSupporterFormsForOrganizationInput;
}
export interface GetDefaultContentForActionPushNotificationQueryArgs {
    code: SupporterPushNotificationTemplateCode;
}
export interface GetSupporterViewFilterStatesQueryArgs {
    input: GetSupporterViewFilterStatesInput;
}
export interface DoesSupporterViewFilterStateExistsQueryArgs {
    input: DoesSupporterViewFilterStateExistsInput;
}
export interface GetSupporterByOutreachCircleAliasQueryArgs {
    alias: string;
}
export interface GetSupporterByIdQueryArgs {
    supporterId: string;
}
export interface GetSupporterSummaryListQueryArgs {
    input: SupporterListInput;
}
export interface GetFilteredSupporterViewQueryArgs {
    input: GetSupporterViewFilterInput;
}
export interface GetInvitedSupporterFileUploadUrlQueryArgs {
    input: InvitedSupporterFileUrlInput;
}
export interface GetTotalInvitedSupportersByOutreachCircleQueryArgs {
    outreachCircleId: string;
}
export interface GetInvitedSupporterInformationQueryArgs {
    input?: InvitedSupporterInformationInput | null;
}
export interface GetTotalTextMessagesSentByLoggedInUserQueryArgs {
    appCode?: string | null;

    organizationId?: string | null;
}
export interface GetTotalActionsTakenByLoggedInUserQueryArgs {
    appCode?: string | null;
}
export interface SupporterEmailSummaryQueryArgs {
    appCode?: string | null;

    organizationId?: string | null;
}
export interface GetActionEmailSummaryForSupporterQueryArgs {
    actionId: string;

    organizationId?: string | null;
}
export interface GetEmailRecipientsForActionQueryArgs {
    input: ActionSummaryInput;
}
export interface GetEmailSummaryForActionQueryArgs {
    actionId: string;
}
export interface GetActionTextMessageSummaryForSupporterQueryArgs {
    actionId: string;

    skip?: number | null;

    limit?: number | null;

    organizationId?: string | null;
}
export interface GetEligibleSupporterCountForSendingPushNotificationQueryArgs {
    input: SupporterFilterForPushNotificationInput;
}
export interface GetEligibleSupporterCountForSendingEmailNotificationQueryArgs {
    input: SupporterEmailFilterInput;
}
export interface GetNumberOfSupportersWhoCanBeBlockedQueryArgs {
    input: BlockFilteredSupportersInput;
}
export interface GetOutreachCircleSharableLinkQueryArgs {
    outreachCircleId: string;

    outreachcircleCode?: string | null;
}
export interface IsSupportingOutreachCircleQueryArgs {
    input: IsSupportingOutreachCircleInput;
}
export interface GetRecentInviteSupporterMappingWithAllCustomFieldsQueryArgs {
    outreachCircleId: string;
}
export interface GetAllTagsForOutreachCircleQueryArgs {
    outreachCircleId: string;
}
export interface GetTagsForPublicActionQueryArgs {
    actionId: string;

    outreachChannel?: OutreachChannel | null;
}
export interface GetTagInfoForActionQueryArgs {
    actionId: string;

    tagId: string;
}
export interface GetCannedResponsesForTagQueryArgs {
    tagId: string;
}
export interface GetTagsEligibleToBeLinkedToActionQueryArgs {
    actionId: string;
}
export interface TestDelayQueryArgs {
    message: string;

    delay: string;
}
export interface GetOriginalActionTextTemplateContentForSupporterQueryArgs {
    input: SupporterTextTemplateInput;
}
export interface TextTemplateQueryArgs {
    id: string;
}
export interface TextTemplatesByOutreachCircleQueryArgs {
    input: TextTemplateForOutreachCircleInput;
}
export interface TextTemplateByIdForOrganizationQueryArgs {
    id: string;
}
export interface TextTemplatesByOrganizationQueryArgs {
    organizationId: string;

    searchKey?: string | null;
}
export interface DefaultHtmlForRecruitmentLinkForOrgTextTemplateQueryArgs {
    textTemplateId: string;
}
export interface ValidateOrganizationTextTemplateNameQueryArgs {
    input?: ValidateOrganizationTextTemplateNameInput | null;
}
export interface SupporterTextTemplatesByOutreachCircleQueryArgs {
    outreachCircleId: string;

    actionId: string;

    searchKey?: string | null;
}
export interface DefaultEditHtmlForRecruitmentLinkForTextQueryArgs {
    outreachCircleId: string;

    outreachcircleCode?: string | null;
}
export interface GetTextContentForPreviewQueryArgs {
    input: GetTextContentForPreviewInput;
}
export interface ValidateTextTemplateNameQueryArgs {
    input?: ValidateTextTemplateNameInput | null;
}
export interface GetOrganizationTextContentForPreviewQueryArgs {
    input: GetOrganizationTextContentForPreviewInput;
}
export interface UsernameExistsQueryArgs {
    username: string;
}
export interface ValidateResetCodeQueryArgs {
    validateResetCodeInput: ValidateResetCodeInput;
}
export interface UserByTokenQueryArgs {
    token: string;
}
export interface ValidateTokenQueryArgs {
    token: string;
}
export interface ValidateTokenAndReturnUserIdQueryArgs {
    token: string;
}
export interface OutreachCirclesByLoggedInUserQueryArgs {
    input?: AllOutreachCirclesInput | null;
}
export interface ArchivedOutreachCirclesByLoggedInUserQueryArgs {
    skip?: number | null;

    limit?: number | null;
}
export interface SupportingOutreachCirclesByLoggedInUserQueryArgs {
    skip?: number | null;

    limit?: number | null;

    appCode?: string | null;

    organizationId?: string | null;
}
export interface VerifyNewSupporterEmailQueryArgs {
    email: string;

    alias?: string | null;
}
export interface VerifyNewSupporterEmailForEmbeddedActionQueryArgs {
    email: string;

    alias?: string | null;
}
export interface IsAssignedToActionSupporterViewArgs {
    actionId: string;
}
export interface ContentForEditorEmailTemplateForSupporterArgs {
    actionId: string;
}
export interface ContentForPreviewEmailTemplateForSupporterArgs {
    actionId: string;
}
export interface ContentForSendingEmailTemplateForSupporterArgs {
    actionId: string;
}
export interface ContentForEditorTextTemplateForSupporterArgs {
    actionId?: string | null;
}
export interface ContentForPreviewTextTemplateForSupporterArgs {
    actionId?: string | null;
}
export interface ContentForSendingTextTemplateForSupporterArgs {
    actionId?: string | null;
}
export interface ContentForEditorEmailTemplateArgs {
    actionId: string;
}
export interface ContentForPreviewEmailTemplateArgs {
    actionId: string;
}
export interface ContentForEditorTextTemplateArgs {
    actionId?: string | null;
}
export interface ContentForPreviewTextTemplateArgs {
    actionId?: string | null;
}
export interface ContentForEditorSocialTemplateArgs {
    actionId?: string | null;
}
export interface ContentForPreviewSocialTemplateArgs {
    actionId?: string | null;
}
export interface SupporterSubmissionsCountSupporterFormArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueSupportersRespondedSupporterFormQuestionArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueSupportersRespondedSupporterFormOptionArgs {
    dateFilter?: DateFilter | null;
}
export interface EmailTemplatesOutreachCircleArgs {
    actionId: string;
}
export interface TextTemplatesOutreachCircleArgs {
    actionId: string;
}
export interface SupporterTextTemplatesOutreachCircleArgs {
    actionId: string;
}
export interface TotalUniqueSupportersRespondedToFormsOutreachCircleArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueRecipientsRespondedToSurveyOutreachCircleArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueRecipientsRespondedToSearchAndSurveyOutreachCircleArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueRecipientsRespondedToGroSurveyOutreachCircleArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueSupportersRespondedToFormsOrganizationArgs {
    dateFilter?: DateFilter | null;

    organizationFilter?: OrganizationFilterInput | null;
}
export interface TotalUniqueRecipientsRespondedToSurveyOrganizationArgs {
    dateFilter?: DateFilter | null;

    organizationFilter?: OrganizationFilterInput | null;
}
export interface TotalUniqueRecipientsRespondedToSearchAndSurveyOrganizationArgs {
    dateFilter?: DateFilter | null;

    organizationFilter?: OrganizationFilterInput | null;
}
export interface TotalUniqueRecipientsRespondedToGroSurveyOrganizationArgs {
    dateFilter?: DateFilter | null;

    organizationFilter?: OrganizationFilterInput | null;
}
export interface LinkedCannedResponseTagArgs {
    actionId: string;
}
export interface RecipientSubmissionsCountEngagementArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueRecipientsRespondedEngagementQuestionArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueRecipientsRespondedEngagementOptionArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueResponsesSearchAndSurveyFormArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueResponsesSearchAndSurveyFormQuestionArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueResponsesSearchAndSurveyFormOptionArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueResponsesGroSurveyFormArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueResponsesGroSurveyFormQuestionArgs {
    dateFilter?: DateFilter | null;
}
export interface TotalUniqueResponsesGroSurveyFormOptionArgs {
    dateFilter?: DateFilter | null;
}
export interface ActiveAudienceActionsAudienceInfoArgs {
    skip: number;

    limit: number;
}
export interface InactiveAudienceActionsAudienceInfoArgs {
    skip: number;

    limit: number;
}
export interface ActionsPublicOutreachCircleArgs {
    skip?: number | null;

    limit?: number | null;
}
export interface ContentForPreviewEmailTemplateForOutreachCircleUserArgs {
    organizationActionId?: string | null;
}
export interface ContentForEditorEmailTemplateForOutreachCircleUserArgs {
    organizationActionId?: string | null;
}
export interface ActionsPublicOutreachCircleSearchResultArgs {
    skip?: number | null;

    limit?: number | null;
}
export interface NextConversationIdP2PConversationArgs {
    showUnreadOnly?: boolean | null;
}
export interface PreviousConversationIdP2PConversationArgs {
    showUnreadOnly?: boolean | null;
}
export interface CreateActionViewFilterMutationArgs {
    input: CreateActionViewFilterStateInput;
}
export interface UpdateActionViewFilterMutationArgs {
    input: UpdateActionViewFilterStateInput;
}
export interface DeleteActionViewFilterMutationArgs {
    id: string;
}
export interface GetActionViewFilterStatesMutationArgs {
    input: GetActionViewFilterStateInput;
}
export interface DeleteAllSupporterAssignmentsMutationArgs {
    actionId: string;
}
export interface MarkAssignedMemberAsContactedMutationArgs {
    input?: MarkAssignedMemberAsContactedInput | null;
}
export interface MarkAssignedContactAsContactedMutationArgs {
    input: MarkAssignedContactAsContactedInput;
}
export interface SaveGroSupporterEmailTemplateMutationArgs {
    input: SaveGroSupporterEmailTemplateInput;
}
export interface SaveGroSupporterTextTemplateMutationArgs {
    input: SaveGroSupporterTextTemplateInput;
}
export interface SaveGroSupporterCallTemplateMutationArgs {
    input: SaveGroSupporterCallOrVisitTemplateInput;
}
export interface SaveGroSupporterVisitTemplateMutationArgs {
    input: SaveGroSupporterCallOrVisitTemplateInput;
}
export interface UpdateGroMemberMutationArgs {
    input: UpdateGroMemberInput;
}
export interface AssignPublicActionToSupporterMutationArgs {
    actionId: string;
}
export interface AssignSupporterToActionMutationArgs {
    input: AssignSupporterToActionInput;
}
export interface DeleteActionAssignmentMutationArgs {
    input: AssignSupporterToActionInput;
}
export interface ArchiveActionMutationArgs {
    actionId: string;
}
export interface CreateActionMutationArgs {
    input: ActionInput;
}
export interface UpdateActionDatesMutationArgs {
    input?: ActionDatesUpdateInput | null;
}
export interface LinkEmailTemplateToActionMutationArgs {
    input?: ActionEmailTemplateInput | null;
}
export interface LinkTextTemplateToActionMutationArgs {
    input: ActionTextTemplateInput;
}
export interface LinkSocialTemplateToActionMutationArgs {
    socialTemplateId: string;

    actionId: string;
}
export interface UpdateActionTitleAndDescriptionMutationArgs {
    input?: UpdateActionTitleAndDescription | null;
}
export interface UpdateActionLinkMutationArgs {
    input?: UpdateActionLinkInput | null;
}
export interface ActivateActionMutationArgs {
    actionId: string;
}
export interface UpdateActionNameMutationArgs {
    input: UpdateActionNameInput;
}
export interface DuplicateActionMutationArgs {
    actionId: string;
}
export interface SendActionEmailMutationArgs {
    input?: SendActionEmailInput | null;
}
export interface SendActionPreviewEmailMutationArgs {
    actionId?: string | null;
}
export interface UpdateOutreachChannelsForActionMutationArgs {
    input: UpdateOutreachChannelsInput;
}
export interface UpdateAudienceActionsForActionMutationArgs {
    input: AudienceActionFilterUpdateInput;
}
export interface MarkActionAsCompletedMutationArgs {
    actionId: string;

    isSocialShare?: boolean | null;
}
export interface IncrementActionImpressionV1MutationArgs {
    input: ActionImpressionInput;
}
export interface IncrementActionImpressionMutationArgs {
    actionId: string;
}
export interface PersonalizeMessageCompletedForActionMutationArgs {
    input: ActionStatusUpdateInput;
}
export interface NuxCompletedForActionTagMutationArgs {
    input: ActionStatusUpdateInput;
}
export interface ImportContactsCompletedForActionMutationArgs {
    input: ActionStatusUpdateInput;
}
export interface ManageRecipientsCompletedForActionMutationArgs {
    input: ActionStatusUpdateInput;
}
export interface UpdateP2PnuxCompletedForActionMutationArgs {
    input: ActionStatusUpdateInput;
}
export interface UpdateCallToActionTextMutationArgs {
    input: UpdateCallToActionTextInput;
}
export interface UpdatePostActionTextMutationArgs {
    input: UpdatePostActionTextInput;
}
export interface UpdateActionOutreachModeMutationArgs {
    input: UpdateActionOutreachModeInput;
}
export interface UpdateAllowNonMappedContactsMutationArgs {
    input: UpdateAllowNonMappedContactsInput;
}
export interface LinkSurveyToActionMutationArgs {
    input: ActionSurveyLinkInput;
}
export interface UnlinkSurveyToActionMutationArgs {
    actionId: string;
}
export interface UpdateActionPositionMutationArgs {
    input: UpdateActionPositionInput;
}
export interface UpdateImageForActionMutationArgs {
    input: ActionImageInput;
}
export interface PauseActionMutationArgs {
    actionId: string;
}
export interface DeactivateActionMutationArgs {
    actionId: string;
}
export interface UpdateIsEngagementRequiredMutationArgs {
    input?: UpdateIsEngagementRequiredInput | null;
}
export interface MarkAffinityTextContactAsSentMutationArgs {
    input: GetTextContentForAffinityTextingInput;
}
export interface MarkTextSentToSupporterMutationArgs {
    input: TextSentToSupporterInput;
}
export interface UpdateTreatmentForActionMutationArgs {
    input: UpdateTreatmentForActionInput;
}
export interface UpdateContactsImportPermissionForSupporterMutationArgs {
    input: UpdateContactImportPermissionInput;
}
export interface AcknowledgeContactImportForActionMutationArgs {
    actionId?: string | null;
}
export interface SetCampaignForActionMutationArgs {
    input: ActionCampaignInput;
}
export interface UpdateShareActionButtonTextMutationArgs {
    input: UpdateShareActionButtonTextInput;
}
export interface RemoveActionReviewWarningMutationArgs {
    input: RemoveReviewWarningInput;
}
export interface AssignSupportersToActionMutationArgs {
    input: AssignSupportersToActionInput;
}
export interface AssignSupportersFromInvitedSupporterSourceToActionMutationArgs {
    actionId: string;

    invitedSupporterSourceId: string;
}
export interface UnassignSupporterFromActionMutationArgs {
    actionId: string;

    supporterId: string;
}
export interface TerminateActionMutationArgs {
    actionId: string;
}
export interface AcknowledgeEstimatedCostForP2PActionMutationArgs {
    actionId: string;
}
export interface AssignSupportersFromGroupToActionMutationArgs {
    input: AssignSupportersFromGroupToActionInput;
}
export interface UpdateSearchAndSurveyAudienceActionsForActionMutationArgs {
    input: SearchAndSurveyAudienceActionFilterUpdateInput;
}
export interface UpdateSearchAndSurveyNewContactsListForActionMutationArgs {
    input: UpdateSearchAndSurveyNewContactsListForActionInput;
}
export interface AddCustomFieldForSearchAndSurveyActionMutationArgs {
    input?: CustomFieldForSearchAndSurveyActionInput | null;
}
export interface RemoveCustomFieldForSearchAndSurveyActionMutationArgs {
    input?: CustomFieldForSearchAndSurveyActionInput | null;
}
export interface UpdateActionConfirmationMutationArgs {
    input: UpdateActionConfirmationInput;
}
export interface UpdateCallOrVisitTemplateMutationArgs {
    input: UpdateCallOrVisitTemplate;
}
export interface RemoveTemplateFromActionForOutreachChannelMutationArgs {
    input: RemoveTemplateFromActionForOutreachChannelInput;
}
export interface SendEmailNotificationForActionMutationArgs {
    input?: SendEmailNotificationForActionInput | null;
}
export interface SendPushNotificationForActionMutationArgs {
    input?: SendPushNotificationForActionInput | null;
}
export interface ReassignUnassignedSupporterForP2PActionMutationArgs {
    actionId: string;

    supporterId: string;
}
export interface ResetReplyReassignmentForP2PActionMutationArgs {
    actionId: string;

    supporterId: string;
}
export interface AssignGroupToActionMutationArgs {
    input: AssignGroupToActionInput;
}
export interface UpdateGroConfigMutationArgs {
    input: UpdateGroConfigInput;
}
export interface UpdateAddressBasedCanvassingConfigMutationArgs {
    input: UpdateAddressBasedCanvassingConfigInput;
}
export interface UpdatePdiOnTheGoCanvassingConfigMutationArgs {
    input: UpdatePdiOnTheGoCanvassingConfigInput;
}
export interface UpdateContactTypeLabelMutationArgs {
    input: UpdateContactTypeLabelInput;
}
export interface CreateMemberNoteMutationArgs {
    input: CreateMemberNoteInput;
}
export interface AssignOutreachCirclePhoneNumberToActionMutationArgs {
    input: AssignOutreachCirclePhoneNumberToActionInput;
}
export interface UnassignOutreachCirclePhoneNumberFromActionMutationArgs {
    input: UnassignOutreachCirclePhoneNumberFromActionInput;
}
export interface UpdateP2PConfigForActionMutationArgs {
    input: UpdateP2PConfigForActionInput;
}
export interface PurchasePhoneNumberForP2PActionMutationArgs {
    input: PurchasePhoneNumberForP2PActionInput;
}
export interface UpdateP2PActionAvailableTimingsMutationArgs {
    input: P2PScheduleInput;
}
export interface UpdateIsAnonymousSearchAndSurveyForActionMutationArgs {
    input: UpdateIsAnonymousSearchAndSurveyForActionInput;
}
export interface AddMemberForAddressBasedCanvassingMutationArgs {
    input: CreateSearchAndSurveyContactInput;
}
export interface AddMemberToHouseHoldMutationArgs {
    input: AddMemberToHouseHoldInput;
}
export interface RecordTagForHouseholdMutationArgs {
    input: RecordTagForHouseholdInput;
}
export interface RecordTagForSearchAndSurveyMemberMutationArgs {
    input: RecordTagForSearchAndSurveyMemberInput;
}
export interface CreateSearchAndSurveyListMutationArgs {
    input: CreateSearchAndSurveyListInput;
}
export interface DeleteAudienceActionMutationArgs {
    audienceActionId: string;
}
export interface AddMembersMutationArgs {
    input?: AudienceActionInput | null;
}
export interface UpdateMembersMutationArgs {
    input?: AudienceActionInput | null;
}
export interface DeleteMembersMutationArgs {
    input?: AudienceActionInput | null;
}
export interface CreateAudienceMutationArgs {
    outreachCircleId?: string | null;
}
export interface DeleteAudienceByListTypeMutationArgs {
    input: DeleteAudienceByListTypeInput;
}
export interface BlockAudienceMemberMutationArgs {
    input?: BlockMemberInput | null;
}
export interface UnBlockAudienceMemberMutationArgs {
    input?: BlockMemberInput | null;
}
export interface UpdateAudienceActionMutationArgs {
    input: UpdateAudienceActionInput;
}
export interface CreateSearchAndSurveyContactMutationArgs {
    input: CreateSearchAndSurveyContactInput;
}
export interface AddMembersFromBlackbaudImportMutationArgs {
    input: ActionOnMembersFromBlackbaudImportInput;
}
export interface UpdateMembersFromBlackbaudImportMutationArgs {
    input: ActionOnMembersFromBlackbaudImportInput;
}
export interface DeleteMembersFromBlackbaudImportMutationArgs {
    input: ActionOnMembersFromBlackbaudImportInput;
}
export interface CreateBroadcastTextingScriptMutationArgs {
    input: CreateBroadcastTextingScriptInput;
}
export interface UpdateBroadcastTextingScriptMutationArgs {
    input: UpdateBroadcastTextingScriptInput;
}
export interface DuplicateBroadcastTextingScriptMutationArgs {
    input: DuplicateBroadcastTextingScriptInput;
}
export interface LinkBroadcastTextingScriptToActionMutationArgs {
    actionId: string;

    broadcastScriptId: string;
}
export interface UnlinkBroadcastTextingScriptFromActionMutationArgs {
    actionId: string;
}
export interface SendSampleTextMutationArgs {
    input?: SendSampleTextInput | null;
}
export interface UpdateCandidateMutationArgs {
    input?: UpdateCandidateInput | null;
}
export interface AddCandidateMutationArgs {
    input?: AddCandidateInput | null;
}
export interface AddCandidateImageMutationArgs {
    input?: CandidateImageInput | null;
}
export interface DeleteCandidateImageMutationArgs {
    candidateId?: string | null;
}
export interface UpdateCandidateImageMutationArgs {
    input?: CandidateImageInput | null;
}
export interface SetEmailRecipientV1MutationArgs {
    input: SetEmailRecipientInput[];
}
export interface SetEmailRecipientMutationArgs {
    input: SetEmailRecipientInput[];
}
export interface SetAllEmailRecipientsMutationArgs {
    input: SupporterActionInput;
}
export interface UnsetAllEmailRecipientsMutationArgs {
    input: SupporterActionInput;
}
export interface ResolveAmbiguousMappedContactMutationArgs {
    input?: ResolveAmbiguousMappedContactInput | null;
}
export interface CreateMatchingJobMutationArgs {
    input: CreateMatchingJobInput;
}
export interface StartMatchingJobMutationArgs {
    matchingJobId: string;
}
export interface MarkTextRecipientAsSentMutationArgs {
    input: TextRecipientInput;
}
export interface ToggleEligibleContactAsEmailRecipientMutationArgs {
    input: MarkEligibleContactAsEmailRecipientInput;
}
export interface ToggleA1CRecipientMappedMutationArgs {
    input: ToggleA1CRecipientMappedInput;
}
export interface ToggleAllA1CRecipientMappedMutationArgs {
    input?: ToggleAllA1CRecipientInput | null;
}
export interface ToggleA1CRecipientNonMappedMutationArgs {
    input: ToggleA1CRecipientNonMappedInput;
}
export interface ToggleAllA1CRecipientNonMappedMutationArgs {
    input?: ToggleAllA1CRecipientInput | null;
}
export interface ToggleAmbiguousA1CRecipientMutationArgs {
    input: ToggleAmbiguousA1CRecipientInput;
}
export interface DeleteMappedContactMutationArgs {
    input: DeleteMappedContactInput;
}
export interface ContactUsMutationArgs {
    input?: ContactUsInput | null;
}
export interface ImportContactFileMutationArgs {
    input: ContactFileImportInput;
}
export interface DeleteContactSourceMutationArgs {
    contactSourceId: string;
}
export interface CreateContactMutationArgs {
    input: CreateContactInput;
}
export interface CreateContactWithMatchingMutationArgs {
    input: CreateContactInput;
}
export interface UpdateContactMutationArgs {
    input: UpdateContactInput;
}
export interface UpdateContactWithMatchingMutationArgs {
    input: UpdateContactInput;
}
export interface UpdatePrimaryEmailForContactMutationArgs {
    input: UpdatePrimaryEmailInput;
}
export interface DeleteContactMutationArgs {
    id: string;
}
export interface ResolveDuplicateEmailContactMutationArgs {
    input: ResolveDuplicateEmailContactInput;
}
export interface CreateEmailTemplateMutationArgs {
    input: CreateEmailTemplateInput;
}
export interface DuplicateEmailTemplateMutationArgs {
    input: DuplicateEmailTemplateInput;
}
export interface UpdateEmailTemplateMutationArgs {
    input: UpdateEmailTemplateInput;
}
export interface UpdateEmailTemplateForSupporterMutationArgs {
    input: UpdateEmailTemplateForSupporterInput;
}
export interface SendEditedEmailPreviewMutationArgs {
    input: EditedEmailPreviewInput;
}
export interface SendPreviewEmailForSupporterMutationArgs {
    actionId: string;
}
export interface CreateOrganizationEmailTemplateMutationArgs {
    input: CreateOrganizationEmailTemplateInput;
}
export interface UpdateOrganizationEmailTemplateMutationArgs {
    input: UpdateOrganizationEmailTemplateInput;
}
export interface UpdateEmailTemplateForOrgWithRecruitmentLinkMutationArgs {
    input: UpdateEmailTemplateForOrgWithRecruitmentLinkInput;
}
export interface SendEditedOrganizationTemplateEmailPreviewMutationArgs {
    input: EditedOrganizationTemplateEmailPreviewInput;
}
export interface CreateSurveyEngagementMutationArgs {
    surveyEngagementInput: SurveyEngagementInput;
}
export interface UpdateSurveyEngagementMutationArgs {
    updateSurveyEngagementInput: SurveyEngagementInput;
}
export interface DeleteEngagementsMutationArgs {
    engagementIds: string[];
}
export interface DeleteSurveyMutationArgs {
    surveyId: string;
}
export interface SaveSurveyResponseMutationArgs {
    input: SaveSurveyResponseInput;
}
export interface DuplicateSurveyMutationArgs {
    input: DuplicateSurveyEngagementInput;
}
export interface UpdateGroSurveyFormMutationArgs {
    input?: UpdateGroSurveyFormInput | null;
}
export interface CreateGroSurveyFormMutationArgs {
    input: CreateGroSurveyFormInput;
}
export interface LinkGroSurveyFormToActionMutationArgs {
    input: GroSurveyFormActionInput;
}
export interface UnlinkGroSurveyFormFromActionMutationArgs {
    actionId: string;
}
export interface DuplicateGroSurveyFormMutationArgs {
    input: DuplicateGroSurveyFormInput;
}
export interface SubmitGroSurveyFormQuestionResponseMutationArgs {
    input: SubmitGroSurveyFormQuestionResponseInput;
}
export interface SubmitGroSurveyFormQuestionResponseForContactMutationArgs {
    input: SubmitGroSurveyFormQuestionResponseForContactInput;
}
export interface DeleteGroSurveyFormMutationArgs {
    groSurveyFormId: string;
}
export interface CreateGroupMutationArgs {
    input: CreateGroupInput;
}
export interface UpdateGroupMutationArgs {
    input: UpdateGroupInput;
}
export interface DeleteGroupMutationArgs {
    id: string;
}
export interface AssignActionToGroupMutationArgs {
    input: AssignActionToGroupInput;
}
export interface AssignAliasToGroupMutationArgs {
    input: AssignAliasToGroupInput;
}
export interface UnAssignActionFromGroupMutationArgs {
    input: UnAssignActionFromGroupInput;
}
export interface UnAssignAliasFromGroupMutationArgs {
    input: UnAssignAliasForGroupInput;
}
export interface AssignSupportersToGroupsMutationArgs {
    input: AssignSupportersToGroupsInput;
}
export interface UnAssignSupporterFromGroupMutationArgs {
    input: UnAssignSupporterFromGroupInput;
}
export interface CreateOrUpdateFacebookPixelIntegrationMutationArgs {
    input: FacebookPixelIntegrationInput;
}
export interface EnablePhone2ActionIntegrationMutationArgs {
    outreachCircleId: string;
}
export interface EnableEveryActionIntegrationMutationArgs {
    outreachCircleId: string;
}
export interface CreateOrUpdateNationBuilderIntegrationMutationArgs {
    input: CreateOrUpdateNationBuilderIntegrationInput;
}
export interface UpdateSyncSupportersToNationBuilderMutationArgs {
    outreachCircleId: string;

    sync: boolean;
}
export interface AddOrUpdateNationBuilderTagsForAliasMutationArgs {
    input?: AddOrUpdateNationBuilderTagsForAliasInput | null;
}
export interface SaveNgpConfigurationMutationArgs {
    input: SaveNgpIntegrationInput;
}
export interface AddMembersFromNgpMutationArgs {
    input: ActionOnNgpMembersInput;
}
export interface UpdateMembersFromNgpMutationArgs {
    input: ActionOnNgpMembersInput;
}
export interface DeleteMembersFromNgpMutationArgs {
    input: ActionOnNgpMembersInput;
}
export interface UpdateSyncSupportersToNgpMyCampaignMutationArgs {
    outreachCircleId: string;

    sync: boolean;
}
export interface AddNgpActivistCodesForAliasMutationArgs {
    input?: AddNgpActivistCodesForAliasInput | null;
}
export interface RemoveNgpActivistCodesForAliasMutationArgs {
    input?: RemoveNgpActivistCodesForAliasInput | null;
}
export interface UpdateApplyToAllCustomAliasesForNgpActivistCodeMutationArgs {
    input?: UpdateApplyToAllCustomAliasesForNgpActivistCodeInput | null;
}
export interface AddPdiMemberMutationArgs {
    input: CreateSearchAndSurveyContactInput;
}
export interface AssignAreaInPdiAssignmentZoneMutationArgs {
    input: AssignPdiZoneInput;
}
export interface ReleasePdiAssignmentMutationArgs {
    actionId: string;
}
export interface CreateOrUpdatePdiIntegrationMutationArgs {
    input: CreateOrUpdatePdiIntegrationInput;
}
export interface UpdateSyncSupportersToPdiMutationArgs {
    outreachCircleId: string;

    sync: boolean;
}
export interface AddPdiFlagsForAliasMutationArgs {
    input?: AddPdiFlagIdForAliasInput | null;
}
export interface RemovePdiFlagsForAliasMutationArgs {
    input?: RemovePdiFlagIdForAliasInput | null;
}
export interface UpdateApplyPdiFlagsGloballyMutationArgs {
    input: UpdateApplyPdiFlagsGloballyInput;
}
export interface RegisterTcrBrandMutationArgs {
    input: RegisterTcrBrandInput;
}
export interface CreateTcrBrandPoliticalVettingMutationArgs {
    input: CreateTcrBrandPoliticalVettingInput;
}
export interface RegisterTcrCampaignMutationArgs {
    input: RegisterTcrCampaignInput;
}
export interface PresignedLogoUploadRequestMutationArgs {
    input?: MediaInputType | null;
}
export interface PresignedOrgLogoUploadRequestMutationArgs {
    input?: OrgMediaInputType | null;
}
export interface PresignedCandidateImageUploadRequestMutationArgs {
    input?: MediaInputType | null;
}
export interface PresignedP2PScriptMediaUploadRequestMutationArgs {
    input?: PresignedP2PScriptMediaUploadRequestInput | null;
}
export interface PresignedSocialImageUploadRequestMutationArgs {
    input?: MediaInputType | null;
}
export interface PresignedActionImageUploadRequestMutationArgs {
    input?: MediaInputType | null;
}
export interface PresignedOrganizationActionImageUploadRequestMutationArgs {
    input?: OrganizationActionMediaInputType | null;
}
export interface PresignedEditorImageUploadRequestMutationArgs {
    input?: EditorMediaInputType | null;
}
export interface PresignedOrgEditorImageUploadRequestMutationArgs {
    input?: OrgEditorMediaInputType | null;
}
export interface PresignedBroadcastTextingScriptMediaUploadRequestMutationArgs {
    input?: PresignedP2PScriptMediaUploadRequestInput | null;
}
export interface CreateOrganizationActionMutationArgs {
    input: OrganizationActionInput;
}
export interface UpdateOrganizationActionNameMutationArgs {
    input: UpdateOrganizationActionNameInput;
}
export interface UpdateOrganizationActionLinkMutationArgs {
    input?: UpdateOrganizationActionLinkInput | null;
}
export interface UpdateOrganizationActionTitleAndDescriptionMutationArgs {
    input?: UpdateOrganizationActionTitleAndDescriptionInput | null;
}
export interface UpdateCallToActionTextForOrganizationActionMutationArgs {
    input: UpdateCallToActionTextForOrganizationActionInput;
}
export interface UpdateShareActionButtonTextForOrganizationActionMutationArgs {
    input: UpdateShareActionButtonTextForOrgActionInput;
}
export interface UpdatePostActionTextForOrganizationActionMutationArgs {
    input: UpdatePostActionTextForOrganizationActionInput;
}
export interface UpdateImageForOrganizationActionMutationArgs {
    input: ActionImageInput;
}
export interface DuplicateOrganizationActionMutationArgs {
    organizationActionId: string;
}
export interface LinkEmailTemplateToOrganizationActionMutationArgs {
    input?: OrganizationActionEmailTemplateInput | null;
}
export interface UnlinkEmailTemplateFromOrganizationActionMutationArgs {
    input?: OrganizationActionEmailTemplateInput | null;
}
export interface LinkTextTemplateToOrganizationActionMutationArgs {
    input: OrganizationActionTextTemplateInput;
}
export interface UnlinkTextTemplateFromOrganizationActionMutationArgs {
    organizationActionId: string;
}
export interface LinkSocialTemplateToOrganizationActionMutationArgs {
    organizationSocialTemplateId: string;

    organizationActionId: string;
}
export interface UnlinkSocialTemplateFromOrganizationActionMutationArgs {
    organizationSocialTemplateId: string;

    organizationActionId: string;
}
export interface PublishOrganizationActionMutationArgs {
    input: PublishOrganizationActionInput;
}
export interface TerminateOrganizationActionMutationArgs {
    organizationActionId: string;
}
export interface UpdateOrganizationActionAllowNonMappedContactsMutationArgs {
    input: UpdateOrganizationActionAllowNonMappedContactsInput;
}
export interface HideOrganizationActionMutationArgs {
    organizationActionId: string;
}
export interface UpdateOutreachChannelsForOrganizationActionMutationArgs {
    input: UpdateOrganizationActionOutreachChannelsInput;
}
export interface UpdateOrganizationActionIntegrationTypeMutationArgs {
    input: UpdateOrganizationActionIntegrationTypeInput;
}
export interface UpdateOrganizationActionConfirmationMutationArgs {
    input: UpdateOrganizationActionConfirmationInput;
}
export interface CreateOrganizationTagMutationArgs {
    input: CreateOrganizationTagInput;
}
export interface UpdateOrganizationTagMutationArgs {
    input: UpdateOrganizationTagInput;
}
export interface LinkOrganizationTagToActionMutationArgs {
    input: ActionOrganizationTagLinkInput;
}
export interface InviteOrganizationUserMutationArgs {
    input?: InviteOrganizationUserInput | null;
}
export interface DeleteOrganizationUserMutationArgs {
    organizationUserId: string;
}
export interface ResendInviteToOrganizationUserMutationArgs {
    input: ResendInviteToOrgUserInput;
}
export interface OnboardOrganizationUserMutationArgs {
    organizationUserId: string;
}
export interface UpdateOrganizationUserMutationArgs {
    input: UpdateOrganizationUserInput;
}
export interface UpdateReadOnlyAccessToOutreachCircleForOrgUserMutationArgs {
    input: UpdateOcAccessForOrgUserInput;
}
export interface UpdateUiPreferenceForOrganizationUserMutationArgs {
    input: UpdateOrganizationUserUiPreferenceInput;
}
export interface CreateOrganizationMutationArgs {
    name: string;
}
export interface UpdateOrganizationMutationArgs {
    input: UpdateOrganizationInput;
}
export interface SaveOrganizationDashboardFilterMutationArgs {
    input: OrganizationDashboardFilterInput;
}
export interface UpdateOrganizationDashboardFilterMutationArgs {
    input: UpdateOrganizationDashboardFilterInput;
}
export interface DeleteOrganizationDashboardFilterMutationArgs {
    organizationFilterId: string;
}
export interface SetMainOutreachCircleForOrganizationMutationArgs {
    input: MainOutreachCircleInput;
}
export interface SetIntroductionForOrganizationMutationArgs {
    input: OrgIntroductionInput;
}
export interface AddOrganizationLogoMutationArgs {
    input: OrgLogoInput;
}
export interface UpdateOrganizationLogoMutationArgs {
    input: OrgLogoInput;
}
export interface DeleteOrganizationLogoMutationArgs {
    organizationId: string;
}
export interface UpdateDisclaimerForOrganizationMutationArgs {
    input: OrgDisclaimerInput;
}
export interface UpdateOrganizationAliasMutationArgs {
    input: UpdateOrganizationAliasInput;
}
export interface CreateOutreachCircleUserEmailTemplateMutationArgs {
    input: CreateOutreachCircleUserEmailTemplateInput;
}
export interface UpdateOutreachCircleUserEmailTemplateMutationArgs {
    input: UpdateOutreachCircleUserEmailTemplateInput;
}
export interface DuplicateOutreachCircleUserEmailTemplateMutationArgs {
    input: DuplicateOutreachCircleUserEmailTemplateInput;
}
export interface NotifyOutreachCircleAdminsForOrganizationActionMutationArgs {
    input: NotifyOutreachCircleAdminsForOrganizationActionInput;
}
export interface NotifyOutreachCircleAdminsForOrganizationMutationArgs {
    input: NotifyOutreachCircleAdminsForOrganizationInput;
}
export interface InviteOutreachCircleUserMutationArgs {
    input: OutreachCircleUserInput;
}
export interface UpdateOutreachCircleUserMutationArgs {
    input: UpdateOutreachCircleUserInput;
}
export interface DeleteOutreachCircleUserMutationArgs {
    outreachCircleUserId: string;
}
export interface ResendInviteMutationArgs {
    outreachCircleUserId: string;
}
export interface OnboardOutreachCircleUserMutationArgs {
    outreachCircleUserId: string;
}
export interface UnsubcribeEmailByOutreachCircleAdminMutationArgs {
    input: OutreachCircleAdminEmailUnsubscribeInput;
}
export interface CreateOutreachCircleMutationArgs {
    outreachCircleInput: OutreachCircleInput;
}
export interface UpdateOutreachCircleBasicInfoMutationArgs {
    outreachCircleInput: UpdateOutreachCircleBasicInfoInput;
}
export interface UpdateOutreachCircleContactAndLocationMutationArgs {
    outreachCircleInput: UpdateOutreachCircleContactAndLocationInput;
}
export interface UpdateOutreachCircleUserRoleMutationArgs {
    outreachCircleId?: string | null;

    userRole?: string | null;
}
export interface AddLogoForDefaultAliasOfOutreachCircleMutationArgs {
    input?: OutreachCircleLogoInput | null;
}
export interface UpdateLogoForDefaultAliasOfOutreachCircleMutationArgs {
    input?: OutreachCircleLogoInput | null;
}
export interface DeleteLogoForDefaultAliasOfOutreachCircleMutationArgs {
    outreachCircleId: string;
}
export interface UpdateBlockedDomainsMutationArgs {
    input?: BlockedDomainsInput | null;
}
export interface UpdateDisclaimerForOutreachCircleMutationArgs {
    input: DisclaimerOutreachCircleInput;
}
export interface UnsubcribeAllEmailFromOutreachCircleMutationArgs {
    input: OutreachCircleEmailUnsubscribeInput;
}
export interface UpdateReferredByForOutreachCircleMutationArgs {
    input: ReferredByOutreachCircleInput;
}
export interface UpdateVisibilityForOutreachCircleMutationArgs {
    input: VisibilityOutreachCircleInput;
}
export interface CreateNewAliasMutationArgs {
    input?: OutreachCircleAliasInput | null;
}
export interface UpdateAliasMutationArgs {
    input: EditOutreachCircleAliasInput;
}
export interface IncrementOutreachCircleImpressionMutationArgs {
    input: IncrementOutreachCircleImpressionsInput;
}
export interface CreateEmailAliasMutationArgs {
    input?: OutreachCircleEmailAliasInput | null;
}
export interface UpdateSupporterReplyToEmailForOutreachCircleMutationArgs {
    input: SupporterReplyToEmailOutreachCircleInput;
}
export interface UpdateSupporterAutoEmailsFromNameForOutreachCircleMutationArgs {
    input: SupporterFromNameEmailOutreachCircleInput;
}
export interface ArchiveOutreachCircleMutationArgs {
    outreachCircleId: string;
}
export interface CollectSurveyResponseOnArchiveOutreachCircleMutationArgs {
    input: ArchiveSurveyResponseInput;
}
export interface UpdateKeyDatesMutationArgs {
    input: UpdateKeyDateInput;
}
export interface PurchasePhoneNumberForOutreachCircleMutationArgs {
    input: PurchasePhoneNumberForOutreachCircleInput;
}
export interface AddBillingCardMutationArgs {
    outreachCircleId: string;

    cardToken: string;
}
export interface RemoveBillingCardMutationArgs {
    outreachCircleId: string;

    cardId: string;
}
export interface DefaultPaymentSourceMutationArgs {
    outreachCircleId: string;

    sourceId: string;
}
export interface UpdatePaymentSourceMutationArgs {
    input: UpdatePaymentSourceInput;
}
export interface ChangePlanMutationArgs {
    input?: ChangePlanInput | null;
}
export interface CancelAutoRenewForOutreachCircleMutationArgs {
    input: CancelAutoRenewForOutreachCircleInput;
}
export interface RequestOutreachCircleInvoiceMutationArgs {
    outreachCircleInvoiceId: string;
}
export interface CreateP2PConversationItemMutationArgs {
    input: CreateP2PConversationItemInput;
}
export interface EndP2PConversationMutationArgs {
    conversationId: string;
}
export interface ReassignP2PConversationsMutationArgs {
    input: ReassignP2PConversationsInput;
}
export interface UnTagP2PConversationMutationArgs {
    input: UnTagP2PConversationInput;
}
export interface CreateP2PScriptSurveyQuestionMutationArgs {
    input: P2PScriptSurveyQuestionInput;
}
export interface UpdateP2PScriptSurveyQuestionMutationArgs {
    input: P2PScriptSurveyQuestionInput;
}
export interface DeleteP2PScriptSurveyQuestionMutationArgs {
    p2pScriptSurveyQuestionId: string;
}
export interface SendInitialP2PTextMutationArgs {
    input: SendInitialP2PTextInput;
}
export interface UpdateInitialP2PTextMutationArgs {
    input: UpdateInitialP2PTextInput;
}
export interface SendBulkInitialP2PTextsMutationArgs {
    input: SendBulkInitialP2PTextsInput;
}
export interface CreateP2PWorkspaceMutationArgs {
    input: P2PWorkspaceInput;
}
export interface UpdateP2PWorkspaceMutationArgs {
    input: P2PWorkspaceInput;
}
export interface DuplicateP2PWorkspaceMutationArgs {
    input: DuplicateP2PWorkspaceInput;
}
export interface LinkP2PWorkspaceToActionMutationArgs {
    actionId: string;

    p2pWorkspaceId: string;
}
export interface UnlinkP2PWorkspaceFromActionMutationArgs {
    actionId: string;
}
export interface MarkAllPushNotificationsAsReadMutationArgs {
    registrationToken: string;
}
export interface RequestReportForOutreachCircleMutationArgs {
    input: RequestReport;
}
export interface RequestReportForOrganizationMutationArgs {
    input: OrganizationReportInput;
}
export interface SendOutreachCircleReportToOcAdminMutationArgs {
    outreachCircleId: string;

    reportCode: ReportCode;
}
export interface UpdateSearchAndSurveyFormMutationArgs {
    input?: UpdateSearchAndSurveyFormInput | null;
}
export interface CreateSearchAndSurveyFormMutationArgs {
    input: CreateSearchAndSurveyFormInput;
}
export interface LinkSearchAndSurveyFormToActionMutationArgs {
    input: SearchAndSurveyFormActionInput;
}
export interface UnlinkSearchAndSurveyFormFromActionMutationArgs {
    actionId: string;
}
export interface DuplicateSearchAndSurveyFormMutationArgs {
    input: DuplicateSearchAndSurveyFormInput;
}
export interface SubmitSearchAndSurveyFormQuestionResponseMutationArgs {
    input: SubmitSearchAndSurveyFormQuestionResponseInput;
}
export interface DeleteSearchAndSurveyFormMutationArgs {
    searchAndSurveyFormId: string;
}
export interface CreateSocialTemplateMutationArgs {
    input: CreateSocialTemplateInput;
}
export interface UpdateSocialTemplateMutationArgs {
    input: UpdateSocialTemplateInput;
}
export interface CreateOrganizationSocialTemplateMutationArgs {
    input: CreateOrganizationSocialTemplateInput;
}
export interface UpdateOrganizationSocialTemplateMutationArgs {
    input: UpdateOrganizationSocialTemplateInput;
}
export interface AddSourcingLinkMutationArgs {
    input: SourcingLinkInput;
}
export interface ArchiveSourcingLinkMutationArgs {
    sourcingLinkId: string;
}
export interface CreateSupporterEmailTemplateForOutreachCircleMutationArgs {
    input: CreateSupporterEmailTemplateInput;
}
export interface UpdateSupporterEmailTemplateForOutreachCircleMutationArgs {
    input: UpdateSupporterEmailTemplateInput;
}
export interface DuplicateSupporterEmailTemplateMutationArgs {
    input: DuplicateSupporterEmailTemplateInput;
}
export interface UpdateSupporterFormMutationArgs {
    input?: UpdateSupporterFormInput | null;
}
export interface CreateSupporterFormMutationArgs {
    input: CreateSupporterFormInput;
}
export interface SubmitSupporterFormQuestionResponseMutationArgs {
    input: SubmitSupporterFormQuestionResponseInput;
}
export interface LinkSupporterFormToActionMutationArgs {
    input: SupporterFormActionInput;
}
export interface UnlinkSupporterFormFromActionMutationArgs {
    actionId: string;
}
export interface DuplicateSupporterFormMutationArgs {
    input: DuplicateSupporterFormInput;
}
export interface DeleteSupporterFormMutationArgs {
    supporterFormId: string;
}
export interface CreateSupporterPushNotificationTemplateMutationArgs {
    input: CreateSupporterPushNotificationTemplateInput;
}
export interface UpdateSupporterPushNotificationTemplateMutationArgs {
    input: UpdateSupporterPushNotificationTemplateInput;
}
export interface CreateSupporterViewFilterStateMutationArgs {
    input: CreateSupporterViewFilterStateInput;
}
export interface UpdateSupporterViewFilterStateMutationArgs {
    input: UpdateSupporterViewFilterStateInput;
}
export interface DeleteSupporterViewFilterStateMutationArgs {
    filterId: string;
}
export interface SupportOutreachCircleMutationArgs {
    input: SupportOutreachCircleInput;
}
export interface CreateInvitedSupporterSourceMutationArgs {
    input?: CreateInvitedSupporterSourceInput | null;
}
export interface StartImportingInvitedSupporterFromFileMutationArgs {
    input: ImportInvitedSupporterFromFileInput;
}
export interface SendSupporterInviteToImportedInvitedSupportersMutationArgs {
    invitedSupporterSourceId: string;

    hasEmailConsent: boolean;

    dontSendEmail?: boolean | null;
}
export interface InviteSupportersMutationArgs {
    input: InviteSupporterInput;
}
export interface UpdateSupporterMutationArgs {
    input: UpdateSupporterInput;
}
export interface CancelInvitedSupporterImportFromFileMutationArgs {
    invitedSupporterSourceId: string;
}
export interface SendSupporterEmailToFilteredSupporterMutationArgs {
    input: SupporterEmailFilterInput;

    hasEmailConsent: boolean;
}
export interface SendPushNotificationToFilteredSupporterMutationArgs {
    input: EligibleSupporterForSendingPushNotificationInput;
}
export interface BlockFilteredSupportersMutationArgs {
    input: BlockFilteredSupportersInput;
}
export interface UnblockSupporterMutationArgs {
    supporterId: string;
}
export interface UnsupportOutreachCircleMutationArgs {
    outreachCircleId: string;
}
export interface SupporterVisitedRecruitmentLinkMutationArgs {
    alias: string;
}
export interface TagRecipientMutationArgs {
    input?: (TagRecipientInput | null)[] | null;
}
export interface CreateTagMutationArgs {
    input: CreateTagInput;
}
export interface UpdateTagMutationArgs {
    input: UpdateTagInput;
}
export interface ApplyTagToAffinityTextRecipientMutationArgs {
    input: ApplyTagToAffinityTextRecipient;
}
export interface ApplyTagToRelationalTextRecipientMutationArgs {
    input: ApplyTagToRelationalTextRecipient;
}
export interface ApplyTagToAmbiguousTextRecipientMutationArgs {
    input: ApplyTagToAmbiguousTextRecipient;
}
export interface RemoveTagToAffinityTextRecipientMutationArgs {
    input: ApplyTagToAffinityTextRecipient;
}
export interface RemoveTagToRelationalTextRecipientMutationArgs {
    input: ApplyTagToRelationalTextRecipient;
}
export interface LinkTagToActionMutationArgs {
    input: ActionTagLinkInput;
}
export interface UnLinkTagToActionMutationArgs {
    input: ActionTagLinkInput;
}
export interface UpdateCannedResponseForActionTagMutationArgs {
    input: CannedResponseInput;
}
export interface DeleteTagMutationArgs {
    tagId: string;
}
export interface CreateTextTemplateMutationArgs {
    input: CreateTextTemplateInput;
}
export interface UpdateTextTemplateMutationArgs {
    input: UpdateTextTemplateInput;
}
export interface UpdateTextTemplateForSupporterMutationArgs {
    input: UpdateTextTemplateForSupporterInput;
}
export interface CreateOrganizationTextTemplateMutationArgs {
    input: CreateOrganizationTextTemplateInput;
}
export interface UpdateOrganizationTextTemplateMutationArgs {
    input: UpdateOrganizationTextTemplateInput;
}
export interface SignupUserMutationArgs {
    user: SignupOrLoginInput;
}
export interface LoginMutationArgs {
    user: SignupOrLoginInput;
}
export interface LoginForRapidOnboardingMutationArgs {
    input: RapidOnboardingLoginInput;
}
export interface LoginForRapidOnboardingForEmbeddedActionsMutationArgs {
    input: RapidOnboardingLoginInput;
}
export interface UpdateNameForLoggedInUserMutationArgs {
    nameInput?: NameInput | null;
}
export interface UpdatePreferencesForLoggedInUserMutationArgs {
    preferenceInput?: PreferenceInput | null;
}
export interface UpdateContactDetailsForLoggedInUserMutationArgs {
    contactDetailsInput?: ContactDetailsInput | null;
}
export interface ResetPasswordForSupporterMutationArgs {
    username: string;

    outreachCircleId?: string | null;
}
export interface ResetPasswordForClientMutationArgs {
    username: string;
}
export interface UpdatePasswordMutationArgs {
    updatePasswordInput: UpdatePasswordInput;
}
export interface UpdatePasswordForLoggedInUserMutationArgs {
    password: string;
}
export interface SignupUserWithDetailsMutationArgs {
    clientSignupInput: SignupWithDetailsInput;
}
export interface SignupUserWithDetailsFromAdsMutationArgs {
    input: SignupWithDetailsFromAdsInput;
}
export interface VerifyUserWithValidCardMutationArgs {
    input?: VerifyUserWithCardOrCouponInput | null;
}
export interface VerifyEmailMutationArgs {
    emailVerificationInput?: EmailVerificationInput | null;
}
export interface UpdateUsernameMutationArgs {
    username: string;
}
export interface UpdateOptInForTextMutationArgs {
    optInForText: boolean;
}
export interface SubscribeToNewsletterMutationArgs {
    email: string;
}
export interface UnsubcribeEmailFromEmailTemplateMutationArgs {
    input: UserEmailUnsubscribeInput;
}
export interface UpdatePushNotificationTokenMutationArgs {
    input: PushNotificationTokenInput;
}
export interface UpdateNameAndContactDetailsForLoggedInUserMutationArgs {
    input: UserNameAndContactDetailsInput;
}
export interface SendSupportEmailForLeadFromAdLandingScreenMutationArgs {
    input: SendSupportEmailForLeadFromAdLandingScreenInput;
}
export interface SignupUserForEmbedMutationArgs {
    user: SignupOrLoginInput;
}
export interface LoginForEmbedMutationArgs {
    user: SignupOrLoginInput;
}
export interface LoginForRapidOnboardingForEmbedMutationArgs {
    input: RapidOnboardingLoginInput;
}
export interface ActionSubscriptionArgs {
    id: string;
}
export interface PublicActionSubscriptionArgs {
    id: string;
}
export interface AudienceImportStatusSubscriptionArgs {
    audienceId: string;
}
export interface ContactImportStatusSubscriptionArgs {
    userId: string;
}
export interface TcrIntegrationStatusSubscriptionArgs {
    outreachCircleId: string;
}
export interface OutreachCircleSubscriptionArgs {
    id: string;
}
export interface SupporterSubscriptionArgs {
    id: string;
}
export interface SupporterV2SubscriptionArgs {
    id: string;
}
export interface InvitedSupporterImportSubscriptionArgs {
    id: string;
}

// ====================================================
// Unions
// ====================================================

export type ActionNotificationLog = EmailNotificationLog | PushNotificationLog;

export type MemberSurvey = Engagement | SearchAndSurveyForm | GroSurveyForm;

export type SupporterSubscriptionData =
    | MatchingJob
    | P2PConversationSubscriptionResponse
    | P2PInboxItem;
